webpackJsonp([24],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularCookies = __webpack_require__(8);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularUiRouter = __webpack_require__(9);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _constants = __webpack_require__(5);

var _constants2 = _interopRequireDefault(_constants);

var _models = __webpack_require__(15);

var _models2 = _interopRequireDefault(_models);

var _slideshow = __webpack_require__(14);

var _slideshow2 = _interopRequireDefault(_slideshow);

var _account_activation_modal = __webpack_require__(182);

var _account_activation_modal2 = _interopRequireDefault(_account_activation_modal);

var _autocomplete_service = __webpack_require__(183);

var _autocomplete_service2 = _interopRequireDefault(_autocomplete_service);

var _activate_guide_account = __webpack_require__(184);

var _activate_guide_account2 = _interopRequireDefault(_activate_guide_account);

var _admin = __webpack_require__(185);

var _admin2 = _interopRequireDefault(_admin);

var _alert = __webpack_require__(186);

var _alert2 = _interopRequireDefault(_alert);

var _analytics = __webpack_require__(187);

var _analytics2 = _interopRequireDefault(_analytics);

var _analytics_sa = __webpack_require__(188);

var _analytics_sa2 = _interopRequireDefault(_analytics_sa);

var _auth = __webpack_require__(189);

var _auth2 = _interopRequireDefault(_auth);

var _auth_interceptor = __webpack_require__(190);

var _auth_interceptor2 = _interopRequireDefault(_auth_interceptor);

var _become_guide = __webpack_require__(191);

var _become_guide2 = _interopRequireDefault(_become_guide);

var _body_element = __webpack_require__(192);

var _body_element2 = _interopRequireDefault(_body_element);

var _breakpoint = __webpack_require__(193);

var _breakpoint2 = _interopRequireDefault(_breakpoint);

var _calendar = __webpack_require__(194);

var _calendar2 = _interopRequireDefault(_calendar);

var _config = __webpack_require__(195);

var _config2 = _interopRequireDefault(_config);

var _contact = __webpack_require__(198);

var _contact2 = _interopRequireDefault(_contact);

var _cookie_storage = __webpack_require__(199);

var _cookie_storage2 = _interopRequireDefault(_cookie_storage);

var _body_scroll = __webpack_require__(200);

var _body_scroll2 = _interopRequireDefault(_body_scroll);

var _development = __webpack_require__(201);

var _development2 = _interopRequireDefault(_development);

var _device_capabilities = __webpack_require__(202);

var _device_capabilities2 = _interopRequireDefault(_device_capabilities);

var _facebook = __webpack_require__(203);

var _facebook2 = _interopRequireDefault(_facebook);

var _favicon = __webpack_require__(204);

var _favicon2 = _interopRequireDefault(_favicon);

var _featured_guides = __webpack_require__(205);

var _featured_guides2 = _interopRequireDefault(_featured_guides);

var _fetch_profile = __webpack_require__(206);

var _fetch_profile2 = _interopRequireDefault(_fetch_profile);

var _generation_time = __webpack_require__(207);

var _generation_time2 = _interopRequireDefault(_generation_time);

var _google_maps_loader = __webpack_require__(208);

var _google_maps_loader2 = _interopRequireDefault(_google_maps_loader);

var _guide_search_filters = __webpack_require__(209);

var _guide_search_filters2 = _interopRequireDefault(_guide_search_filters);

var _guide_status = __webpack_require__(210);

var _guide_status2 = _interopRequireDefault(_guide_status);

var _imgix_helpers = __webpack_require__(211);

var _imgix_helpers2 = _interopRequireDefault(_imgix_helpers);

var _join = __webpack_require__(212);

var _join2 = _interopRequireDefault(_join);

var _join_fb_landing = __webpack_require__(213);

var _join_fb_landing2 = _interopRequireDefault(_join_fb_landing);

var _js_loader = __webpack_require__(214);

var _js_loader2 = _interopRequireDefault(_js_loader);

var _last_booking_info = __webpack_require__(215);

var _last_booking_info2 = _interopRequireDefault(_last_booking_info);

var _lazysizes = __webpack_require__(216);

var _lazysizes2 = _interopRequireDefault(_lazysizes);

var _local_storage = __webpack_require__(219);

var _local_storage2 = _interopRequireDefault(_local_storage);

var _logout = __webpack_require__(220);

var _logout2 = _interopRequireDefault(_logout);

var _marketing_id = __webpack_require__(221);

var _marketing_id2 = _interopRequireDefault(_marketing_id);

var _membership = __webpack_require__(222);

var _membership2 = _interopRequireDefault(_membership);

var _messenger = __webpack_require__(223);

var _messenger2 = _interopRequireDefault(_messenger);

var _modal = __webpack_require__(224);

var _modal2 = _interopRequireDefault(_modal);

var _object_to_array = __webpack_require__(225);

var _object_to_array2 = _interopRequireDefault(_object_to_array);

var _navigation = __webpack_require__(226);

var _navigation2 = _interopRequireDefault(_navigation);

var _notification = __webpack_require__(227);

var _notification2 = _interopRequireDefault(_notification);

var _password = __webpack_require__(228);

var _password2 = _interopRequireDefault(_password);

var _payments = __webpack_require__(229);

var _payments2 = _interopRequireDefault(_payments);

var _payments_subscription = __webpack_require__(230);

var _payments_subscription2 = _interopRequireDefault(_payments_subscription);

var _payments_booking = __webpack_require__(231);

var _payments_booking2 = _interopRequireDefault(_payments_booking);

var _places_service = __webpack_require__(232);

var _places_service2 = _interopRequireDefault(_places_service);

var _prevent_click = __webpack_require__(233);

var _prevent_click2 = _interopRequireDefault(_prevent_click);

var _rate_service = __webpack_require__(234);

var _rate_service2 = _interopRequireDefault(_rate_service);

var _realtime = __webpack_require__(235);

var _realtime2 = _interopRequireDefault(_realtime);

var _reload_page = __webpack_require__(264);

var _reload_page2 = _interopRequireDefault(_reload_page);

var _resolve_template = __webpack_require__(265);

var _resolve_template2 = _interopRequireDefault(_resolve_template);

var _resource = __webpack_require__(266);

var _resource2 = _interopRequireDefault(_resource);

var _reviews = __webpack_require__(267);

var _reviews2 = _interopRequireDefault(_reviews);

var _scroll_top = __webpack_require__(268);

var _scroll_top2 = _interopRequireDefault(_scroll_top);

var _scrollbar_width = __webpack_require__(269);

var _scrollbar_width2 = _interopRequireDefault(_scrollbar_width);

var _session = __webpack_require__(270);

var _session2 = _interopRequireDefault(_session);

var _settings = __webpack_require__(271);

var _settings2 = _interopRequireDefault(_settings);

var _settings_layout_config = __webpack_require__(272);

var _settings_layout_config2 = _interopRequireDefault(_settings_layout_config);

var _shuffle = __webpack_require__(273);

var _shuffle2 = _interopRequireDefault(_shuffle);

var _social_share = __webpack_require__(274);

var _social_share2 = _interopRequireDefault(_social_share);

var _sounds = __webpack_require__(275);

var _sounds2 = _interopRequireDefault(_sounds);

var _social = __webpack_require__(276);

var _social2 = _interopRequireDefault(_social);

var _special_currencies = __webpack_require__(277);

var _special_currencies2 = _interopRequireDefault(_special_currencies);

var _stop_remarketing = __webpack_require__(278);

var _stop_remarketing2 = _interopRequireDefault(_stop_remarketing);

var _storage = __webpack_require__(279);

var _storage2 = _interopRequireDefault(_storage);

var _temporary_user = __webpack_require__(280);

var _temporary_user2 = _interopRequireDefault(_temporary_user);

var _test_users = __webpack_require__(281);

var _test_users2 = _interopRequireDefault(_test_users);

var _throttle = __webpack_require__(282);

var _throttle2 = _interopRequireDefault(_throttle);

var _tracking = __webpack_require__(283);

var _tracking2 = _interopRequireDefault(_tracking);

var _title = __webpack_require__(284);

var _title2 = _interopRequireDefault(_title);

var _unread_conversation_ids = __webpack_require__(285);

var _unread_conversation_ids2 = _interopRequireDefault(_unread_conversation_ids);

var _upload_photo = __webpack_require__(286);

var _upload_photo2 = _interopRequireDefault(_upload_photo);

var _user_interaction = __webpack_require__(287);

var _user_interaction2 = _interopRequireDefault(_user_interaction);

var _utils = __webpack_require__(288);

var _utils2 = _interopRequireDefault(_utils);

var _vk = __webpack_require__(289);

var _vk2 = _interopRequireDefault(_vk);

var _reference_check = __webpack_require__(290);

var _reference_check2 = _interopRequireDefault(_reference_check);

var _conversations_fetching = __webpack_require__(291);

var _conversations_fetching2 = _interopRequireDefault(_conversations_fetching);

var _report = __webpack_require__(292);

var _report2 = _interopRequireDefault(_report);

var _listing_price = __webpack_require__(293);

var _listing_price2 = _interopRequireDefault(_listing_price);

var _app_become_guide_banner = __webpack_require__(294);

var _app_become_guide_banner2 = _interopRequireDefault(_app_become_guide_banner);

var _meta = __webpack_require__(295);

var _meta2 = _interopRequireDefault(_meta);

var _deslug = __webpack_require__(296);

var _deslug2 = _interopRequireDefault(_deslug);

var _slug = __webpack_require__(297);

var _slug2 = _interopRequireDefault(_slug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import appBanner from './app_banner';

//import recurringMessenger from './recurring_messenger';
var dependencies = [_angularCookies2.default, _angularUiRouter2.default, _constants2.default, _models2.default, _slideshow2.default];
// import ravenM from './raven_m';


// import angularRaven from 'exports-loader?\'ngRaven\'!angular-raven';

exports.default = _angular2.default.module('services', dependencies).factory('autocompleteService', _autocomplete_service2.default).factory('accountActivationModal', _account_activation_modal2.default).factory('activateGuideAccount', _activate_guide_account2.default).factory('admin', _admin2.default).factory('alert', _alert2.default).factory('analytics', _analytics2.default).factory('analyticsSa', _analytics_sa2.default).factory('auth', _auth2.default).factory('authInterceptor', _auth_interceptor2.default).factory('becomeGuide', _become_guide2.default).factory('bodyElement', _body_element2.default).factory('breakpoint', _breakpoint2.default).factory('calendar', _calendar2.default).constant('config', _config2.default).factory('contact', _contact2.default).factory('cookieStorage', _cookie_storage2.default).factory('bodyScroll', _body_scroll2.default).factory('development', _development2.default).factory('deviceCapabilities', _device_capabilities2.default).factory('facebook', _facebook2.default).factory('favicon', _favicon2.default).factory('featuredGuides', _featured_guides2.default).factory('fetchProfile', _fetch_profile2.default).factory('generationTime', _generation_time2.default).factory('googleMapsLoader', _google_maps_loader2.default).service('guideSearchFilters', _guide_search_filters2.default).factory('guideStatus', _guide_status2.default).factory('imgixHelpers', _imgix_helpers2.default).factory('join', _join2.default).factory('joinFbLanding', _join_fb_landing2.default).factory('jsLoader', _js_loader2.default).factory('lastBookingInfo', _last_booking_info2.default).factory('lazysizes', _lazysizes2.default).factory('localStorage', _local_storage2.default).factory('logout', _logout2.default).factory('marketingId', _marketing_id2.default).factory('membership', _membership2.default).factory('messenger', _messenger2.default).factory('modal', _modal2.default).factory('objectToArray', _object_to_array2.default).factory('navigation', _navigation2.default).factory('notification', _notification2.default).factory('password', _password2.default).factory('payments', _payments2.default).factory('paymentsSubscription', _payments_subscription2.default).factory('paymentsBooking', _payments_booking2.default).service('placesService', _places_service2.default).factory('preventClick', _prevent_click2.default).factory('rateService', _rate_service2.default).factory('realtime', _realtime2.default)
//.factory('recurringMessenger', recurringMessenger)
.factory('reloadPage', _reload_page2.default).factory('resolveTemplate', _resolve_template2.default).provider('resource', _resource2.default).factory('reviews', _reviews2.default).factory('scrollTop', _scroll_top2.default).factory('scrollbarWidth', _scrollbar_width2.default).factory('session', _session2.default).factory('settings', _settings2.default).factory('settingsLayoutConfig', _settings_layout_config2.default).factory('shuffle', _shuffle2.default).factory('socialShare', _social_share2.default).factory('sounds', _sounds2.default).factory('social', _social2.default).value('specialCurrencies', _special_currencies2.default).factory('stopRemarketing', _stop_remarketing2.default).factory('Storage', _storage2.default).factory('temporaryUser', _temporary_user2.default).factory('testUsers', _test_users2.default).factory('throttle', _throttle2.default).factory('tracking', _tracking2.default).factory('title', _title2.default).factory('unreadConversationIds', _unread_conversation_ids2.default).factory('uploadPhoto', _upload_photo2.default).factory('userInteraction', _user_interaction2.default).factory('utils', _utils2.default).factory('vk', _vk2.default).factory('referenceCheck', _reference_check2.default)
// .factory('ravenM', ravenM)
.value('conversationsFetching', _conversations_fetching2.default).factory('report', _report2.default).value('listingPrice', _listing_price2.default)
//.factory('appBanner', appBanner)
.factory('appBecomeGuideBanner', _app_become_guide_banner2.default).factory('meta', _meta2.default).factory('deslug', _deslug2.default).factory('slug', _slug2.default).name;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _translate = __webpack_require__(32);

var _translate2 = _interopRequireDefault(_translate);

var _activities = __webpack_require__(112);

var _activities2 = _interopRequireDefault(_activities);

var _activity_icons = __webpack_require__(114);

var _activity_icons2 = _interopRequireDefault(_activity_icons);

var _countries = __webpack_require__(115);

var _countries2 = _interopRequireDefault(_countries);

var _key_codes = __webpack_require__(116);

var _key_codes2 = _interopRequireDefault(_key_codes);

var _languages = __webpack_require__(117);

var _languages2 = _interopRequireDefault(_languages);

var _meeting_time_options = __webpack_require__(119);

var _meeting_time_options2 = _interopRequireDefault(_meeting_time_options);

var _messenger_modal_types = __webpack_require__(121);

var _messenger_modal_types2 = _interopRequireDefault(_messenger_modal_types);

var _number_of_people = __webpack_require__(122);

var _number_of_people2 = _interopRequireDefault(_number_of_people);

var _patterns = __webpack_require__(124);

var _patterns2 = _interopRequireDefault(_patterns);

var _payment_types = __webpack_require__(125);

var _payment_types2 = _interopRequireDefault(_payment_types);

var _photo_sizes = __webpack_require__(126);

var _photo_sizes2 = _interopRequireDefault(_photo_sizes);

var _social_networks = __webpack_require__(127);

var _social_networks2 = _interopRequireDefault(_social_networks);

var _videos = __webpack_require__(128);

var _videos2 = _interopRequireDefault(_videos);

var _currencies = __webpack_require__(173);

var _currencies2 = _interopRequireDefault(_currencies);

var _seo_activities = __webpack_require__(174);

var _seo_activities2 = _interopRequireDefault(_seo_activities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('constants', [_translate2.default]).constant('activities', _activities2.default).constant('activityIcons', _activity_icons2.default).constant('countries', _countries2.default).constant('keyCodes', _key_codes2.default).constant('languages', _languages2.default).constant('meetingTimeOptions', _meeting_time_options2.default).constant('messengerModalTypes', _messenger_modal_types2.default).constant('numberOfPeople', _number_of_people2.default).constant('patterns', _patterns2.default).constant('paymentTypes', _payment_types2.default).constant('photoSizes', _photo_sizes2.default).constant('socialNetworks', _social_networks2.default).constant('videos', _videos2.default).constant('currencies', _currencies2.default).constant('seoActivities', _seo_activities2.default).name;

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ = __webpack_require__(15);

var _2 = _interopRequireDefault(_);

var _services = __webpack_require__(4);

var _services2 = _interopRequireDefault(_services);

var _constants = __webpack_require__(5);

var _constants2 = _interopRequireDefault(_constants);

var _currency_resource = __webpack_require__(315);

var _currency_resource2 = _interopRequireDefault(_currency_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var localStorageKey = 'currency';
var defaultCurrency = 'EUR';
var currencyModelFactory = function currencyModelFactory($q, $window, userModel, localStorage, currencyResource, countries) {
  'ngInject';

  var isLoggedIn = function isLoggedIn() {
    return Boolean(userModel.item.name);
  };
  var getFromStorage = function getFromStorage() {
    return localStorage.get(localStorageKey);
  };
  var saveToStorage = function saveToStorage(value) {
    return localStorage.set(localStorageKey, value);
  };
  var getCountryCurrency = function getCountryCurrency(country) {
    return countries[country] ? countries[country].currency : 'USD';
  };

  return {
    getValue: function getValue() {
      var value = isLoggedIn() ? userModel.getCurrency() : getFromStorage();
      if (!value && !isLoggedIn()) {
        $window.SA = $window.SA || {};
        var currencyByIp = getCountryCurrency($window.SA.country);
        saveToStorage(currencyByIp);
        return currencyByIp;
      }

      return value || defaultCurrency;
    },

    saveValue: function saveValue(value) {
      var userId = userModel.item.id;
      $q.resolve(isLoggedIn() && currencyResource.saveCurrency(userId, value)).then(function () {
        saveToStorage(value);
        $window.location.reload();
      });
    }
  };
};

currencyModelFactory.$inject = ['$q', '$window', 'userModel', 'localStorage', 'currencyResource', 'countries'];
var dependencies = [_2.default, _constants2.default, _services2.default, _currency_resource2.default];

exports.default = _angular2.default.module('services.currencyModel', dependencies).factory('currencyModel', currencyModelFactory).name;

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _slideshow = __webpack_require__(105);

var _slideshow2 = _interopRequireDefault(_slideshow);

var _slideshow_video = __webpack_require__(108);

var _slideshow_video2 = _interopRequireDefault(_slideshow_video);

var _slideshow3 = __webpack_require__(111);

var _slideshow4 = _interopRequireDefault(_slideshow3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.slideshow', []).directive('slideshow', _slideshow2.default).directive('saSlideshowVideo', _slideshow_video2.default).factory('slideshow', _slideshow4.default).name;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _resources = __webpack_require__(38);

var _resources2 = _interopRequireDefault(_resources);

var _user_model = __webpack_require__(181);

var _user_model2 = _interopRequireDefault(_user_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_resources2.default];

exports.default = _angular2.default.module('models', dependencies).service('userModel', _user_model2.default).name;

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _currency_model = __webpack_require__(7);

var _currency_model2 = _interopRequireDefault(_currency_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencyInputDirective = function currencyInputDirective(currencyModel) {
  'ngInject';

  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link($scope, $element, $attr, ngModel) {
      $element.on('change', function () {
        $scope.$apply(function () {
          currencyModel.saveValue(ngModel.$modelValue);
        });
      });
    }
  };
};

currencyInputDirective.$inject = ['currencyModel'];
var dependencies = [_currency_model2.default];

exports.default = _angular2.default.module('directives.currencyInput', dependencies).directive('saCurrencyInput', currencyInputDirective).name;

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _currency_options = __webpack_require__(314);

var _currency_options2 = _interopRequireDefault(_currency_options);

var _currency_input = __webpack_require__(20);

var _currency_input2 = _interopRequireDefault(_currency_input);

var _currency_select = __webpack_require__(316);

var _currency_select2 = _interopRequireDefault(_currency_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_currency_options2.default, _currency_input2.default];

exports.default = _angular2.default.module('common.currencySelect', dependencies).directive('saCurrencySelect', _currency_select2.default).name;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/c56b9775d8644e1f88fed0016d65a415.png";

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var angular = __webpack_require__(0);

/*
 * @license
 * angular-socket-io v0.7.0
 * (c) 2014 Brian Ford http://briantford.com
 * License: MIT
 */

angular.module('btford.socket-io', []).
  provider('socketFactory', function () {

    'use strict';

    // when forwarding events, prefix the event name
    var defaultPrefix = 'socket:',
      ioSocket;

    // expose to provider
    this.$get = ['$rootScope', '$timeout', function ($rootScope, $timeout) {

      var asyncAngularify = function (socket, callback) {
        return callback ? function () {
          var args = arguments;
          $timeout(function () {
            callback.apply(socket, args);
          }, 0);
        } : angular.noop;
      };

      return function socketFactory (options) {
        options = options || {};
        var socket = options.ioSocket || io.connect();
        var prefix = options.prefix === undefined ? defaultPrefix : options.prefix ;
        var defaultScope = options.scope || $rootScope;

        var addListener = function (eventName, callback) {
          socket.on(eventName, callback.__ng = asyncAngularify(socket, callback));
        };

        var addOnceListener = function (eventName, callback) {
          socket.once(eventName, callback.__ng = asyncAngularify(socket, callback));
        };

        var wrappedSocket = {
          on: addListener,
          addListener: addListener,
          once: addOnceListener,

          emit: function (eventName, data, callback) {
            var lastIndex = arguments.length - 1;
            var callback = arguments[lastIndex];
            if(typeof callback == 'function') {
              callback = asyncAngularify(socket, callback);
              arguments[lastIndex] = callback;
            }
            return socket.emit.apply(socket, arguments);
          },

          removeListener: function (ev, fn) {
            if (fn && fn.__ng) {
              arguments[1] = fn.__ng;
            }
            return socket.removeListener.apply(socket, arguments);
          },

          removeAllListeners: function() {
            return socket.removeAllListeners.apply(socket, arguments);
          },

          disconnect: function (close) {
            return socket.disconnect(close);
          },

          connect: function() {
            return socket.connect();
          },

          // when socket.on('someEvent', fn (data) { ... }),
          // call scope.$broadcast('someEvent', data)
          forward: function (events, scope) {
            if (events instanceof Array === false) {
              events = [events];
            }
            if (!scope) {
              scope = defaultScope;
            }
            events.forEach(function (eventName) {
              var prefixedEvent = prefix + eventName;
              var forwardBroadcast = asyncAngularify(socket, function () {
                Array.prototype.unshift.call(arguments, prefixedEvent);
                scope.$broadcast.apply(scope, arguments);
              });
              scope.$on('$destroy', function () {
                socket.removeListener(eventName, forwardBroadcast);
              });
              socket.on(eventName, forwardBroadcast);
            });
          }
        };

        return wrappedSocket;
      };
    }];
  });



/*** EXPORTS FROM exports-loader ***/
module.exports = 'btford.socket-io';

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('translate', []).provider('translationLoader', [function () {
  this.$get = ['$q', '$rootScope', 'translations', function ($q, $rootScope, translations) {
    var service = function service() {
      var deferred = $q.defer();

      deferred.resolve(translations);
      return deferred.promise;
    };

    /**
     * Extends `translations` service.
     * @param {Object} partial
     */
    service.addTranslationPartial = function (partial) {
      _angular2.default.extend(translations, partial);
      $rootScope.$emit('translationLoader:refresh');
    };

    return service;
  }];
}]).value('translations', {}).name;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _carousel = __webpack_require__(87);

var _carousel2 = _interopRequireDefault(_carousel);

var _carousel_container = __webpack_require__(88);

var _carousel_container2 = _interopRequireDefault(_carousel_container);

var _carousel_control = __webpack_require__(89);

var _carousel_control2 = _interopRequireDefault(_carousel_control);

var _carousel_item = __webpack_require__(90);

var _carousel_item2 = _interopRequireDefault(_carousel_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.carousel', []).directive('saCarousel', _carousel2.default).directive('saCarouselContainer', _carousel_container2.default).directive('saCarouselControl', _carousel_control2.default).directive('saCarouselItem', _carousel_item2.default).name;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _carousel = __webpack_require__(33);

var _carousel2 = _interopRequireDefault(_carousel);

var _how_it_works = __webpack_require__(99);

var _how_it_works2 = _interopRequireDefault(_how_it_works);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_carousel2.default];

exports.default = _angular2.default.module('common.howItWorks', dependencies).directive('saHowItWorks', _how_it_works2.default).name;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/f5b965f85d0858ec13cc2e7acc268217.png";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/d331490e887b6a63f83000a5f0835350.png";

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/8f9d80fd6d09a5d4232d83e26f760308.png";

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _booking_suggestion = __webpack_require__(175);

var _booking_suggestion2 = _interopRequireDefault(_booking_suggestion);

var _conversation = __webpack_require__(176);

var _conversation2 = _interopRequireDefault(_conversation);

var _trip = __webpack_require__(177);

var _trip2 = _interopRequireDefault(_trip);

var _guide = __webpack_require__(178);

var _guide2 = _interopRequireDefault(_guide);

var _message = __webpack_require__(179);

var _message2 = _interopRequireDefault(_message);

var _user = __webpack_require__(180);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('resources', []).service('bookingSuggestionResource', _booking_suggestion2.default).factory('Conversation', _conversation2.default).factory('Trip', _trip2.default).factory('Guide', _guide2.default).factory('Message', _message2.default).service('userResource', _user2.default).name;

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/9de56c6c48e6e7f4e348b988bde38c2e.png";

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popover = __webpack_require__(60);

var _popover2 = _interopRequireDefault(_popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saPopover = ['$window', function ($window) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: _popover2.default,
    link: function link($scope, $element) {
      var body = angular.element($element.children()[1]);

      $element.css({
        position: 'relative'
      });

      function bindHide() {
        angular.element($window).on('click', hidePopover);
        angular.element($window).on('resize', hidePopover);
      }

      function unbindHide() {
        angular.element($window).off('click', hidePopover);
        angular.element($window).off('resize', hidePopover);
      }

      function bindShow() {
        $element.on('click', showPopover);
      }

      function unbindShow() {
        $element.off('click', showPopover);
      }

      function showPopover(e) {
        e.stopPropagation();

        body.css('display', 'block');
        bindHide();
        unbindShow();
      }

      function hidePopover() {
        body.css('display', 'none');
        bindShow();
        unbindHide();
      }

      hidePopover();

      $scope.$on('$destroy', unbindHide);
    }
  };
}];

exports.default = saPopover;

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _currency_symbol = __webpack_require__(353);

var _currency_symbol2 = _interopRequireDefault(_currency_symbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var priceFilter = function priceFilter($filter, currencySymbol) {
  'ngInject';

  var currencyFilter = $filter('currency');

  return function (amount, currency) {
    var decimalPoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

    return currencyFilter(amount, currencySymbol(currency), decimalPoints);
  };
};

priceFilter.$inject = ['$filter', 'currencySymbol'];
var dependencies = [_currency_symbol2.default];

exports.default = _angular2.default.module('filters.membershipPrice', dependencies).filter('price', priceFilter).name;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _tetherTooltip = __webpack_require__(56);

var _tetherTooltip2 = _interopRequireDefault(_tetherTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

saTooltip.$inject = ['$timeout'];


function saTooltip($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    link: function link($scope, $element, $attr) {
      var TOOLTIP_DELAY = 500;

      var tooltip = new _tetherTooltip2.default({
        target: $element[0],
        position: $attr.position,
        content: $attr.saTooltip,
        openOn: '',
        constrainToWindow: true,
        constrainToScrollParent: false,
        classes: 'Tooltip tooltip-theme-twipsy',
        tetherOptions: {
          offset: $attr.offset
        }
      });

      // Delay tooltip showing
      $timeout(function () {
        var open = true;
        $element.on('mouseover', function () {
          open = true;
          $timeout(function () {
            if (open) {
              tooltip.open();
            }
          }, TOOLTIP_DELAY);
        });

        $element.on('mouseleave', function () {
          tooltip.close();
          open = false;
        });

        $element.on('click', function () {
          tooltip.open();
        });
      });

      $element.on('$destroy', function () {
        tooltip.destroy();
      });
    }
  };
}

exports.default = _angular2.default.module('directives.tooltip', []).directive('saTooltip', saTooltip).name;

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/6ff5f06f720322f77d89d9425e452e4f.jpg";

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _photo_resource = __webpack_require__(508);

var _photo_resource2 = _interopRequireDefault(_photo_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var maxPhotos = 5;
var errors = {
  'min-image-dimensions-320x320': 'DIMENSIONS',
  'invalid-image-format': 'FORMAT'
};

var PhotoModel = function () {
  PhotoModel.$inject = ['photoResource', 'userModel', 'settings'];

  function PhotoModel(photoResource, userModel, settings) {
    'ngInject';

    _classCallCheck(this, PhotoModel);

    this.photoResource = photoResource;
    this.userModel = userModel;
    this.settings = settings;

    this.collection = [];
  }

  _createClass(PhotoModel, [{
    key: 'initCollection',
    value: function initCollection(photos) {
      this.collection = [].concat(photos || []);
      this._updateCollectionData();
      this._sortCollection();
    }
  }, {
    key: 'getValidPhotos',
    value: function getValidPhotos() {
      return this.collection.filter(function (photo) {
        return !photo.$error;
      });
    }
  }, {
    key: 'getByPhotoId',
    value: function getByPhotoId(photoId) {
      return this.collection.filter(function (photo) {
        return photo.id === photoId;
      })[0];
    }
  }, {
    key: 'uploadFromSocialNetwork',
    value: function uploadFromSocialNetwork(socialNetwork, photoData) {
      var _this = this;

      var photo = {
        social: {
          network: socialNetwork,
          albumId: photoData.albumId,
          photoId: photoData.id,
          url: photoData.src
        }
      };

      photo.$isUploading = true;
      this.collection.push(photo);

      this._updateCollectionData();

      this.photoResource.uploadFromSocialNetwork(photo).then(function (photoData) {
        if (_this._hasMainPhoto()) {
          delete photoData.main;
        }
        _angular2.default.extend(photo, photoData);
      }).catch(function (response) {
        var responseData = response.data || {};

        if (errors[responseData.error]) {
          photo.$error = errors[responseData.error];
        } else {
          photo.$error = 'DEFAULT';
        }
      }).finally(function () {
        delete photo.$isUploading;
        _this._updateCollectionData();
        _this._updateMainPhoto();
        _this._updateSettingsModel();
      });
    }
  }, {
    key: 'makeMain',
    value: function makeMain(photo) {
      var _this2 = this;

      return this.photoResource.makeMain(photo.id).then(function () {
        var mainPhoto = _this2.collection.filter(function (photo) {
          return photo.main;
        })[0];
        if (mainPhoto) {
          delete mainPhoto.main;
        }

        photo.main = true;

        _this2._sortCollection();
        _this2._updateMainPhoto();
      });
    }
  }, {
    key: 'rotatePhoto',
    value: function rotatePhoto(photo, angle) {
      var _this3 = this;

      var postData = {
        id: photo.id,
        url: photo.url
      };
      var crop = void 0;
      var width = void 0;
      var height = void 0;

      if ([90, 270].indexOf(angle) === -1) {
        width = photo.width;
        height = photo.height;
      } else {
        width = photo.height;
        height = photo.width;
      }

      if (width > height) {

        // Landscape photo
        crop = {
          x1: Math.floor((width - height) / 2),
          y1: 0,
          y2: height
        };
        crop.x2 = crop.x1 + height;
      } else {

        // Portrait photo
        crop = {
          x1: 0,
          y1: 0,
          x2: width,
          y2: width
        };
      }

      postData.angle = angle;
      postData.crop = crop;

      return this.photoResource.rotatePhoto(postData).then(function () {
        photo.angle = angle;
        photo.crop = postData.crop;
        _this3._updateMainPhoto();
      });
    }
  }, {
    key: 'cropPhoto',
    value: function cropPhoto(photo, cropData) {
      var _this4 = this;

      var postData = {
        id: photo.id,
        url: photo.url,
        crop: cropData
      };

      return this.photoResource.cropPhoto(postData).then(function (newPhotoData) {
        _angular2.default.extend(photo, newPhotoData);
        _this4._updateMainPhoto();
      });
    }
  }, {
    key: 'deletePhoto',
    value: function deletePhoto(photo) {
      this.collection.splice(this.collection.indexOf(photo), 1);
      this._updateCollectionData();
      this._updateSettingsModel();

      return this.photoResource.deletePhoto(photo.id);
    }
  }, {
    key: 'handleUpload',
    value: function handleUpload(promises) {
      var _this5 = this;

      promises.forEach(function (promise) {
        var photo = {
          $isUploading: true
        };

        _this5.collection.push(photo);
        _this5._updateCollectionData();

        promise.then(function (photoData) {
          if (_this5._hasMainPhoto()) {
            delete photoData.main;
          }
          _angular2.default.extend(photo, photoData);
          _this5._updateMainPhoto();
        }).catch(function (response) {
          var responseData = response.data || {};

          if (errors[responseData.error]) {
            photo.$error = errors[responseData.error];
          } else {
            photo.$error = 'DEFAULT';
          }
        }).finally(function () {
          delete photo.$isUploading;
          _this5._updateCollectionData();
          _this5._updateSettingsModel();
        });
      });
    }
  }, {
    key: '_getValidPhotoCount',
    value: function _getValidPhotoCount() {
      return this.getValidPhotos().length;
    }
  }, {
    key: '_updateCollectionData',
    value: function _updateCollectionData() {
      this._updateHasPhotos();
      this._updatePhotosLeft();
    }
  }, {
    key: '_updateHasPhotos',
    value: function _updateHasPhotos() {
      this.hasPhotos = Boolean(this._getValidPhotoCount());
    }
  }, {
    key: '_updatePhotosLeft',
    value: function _updatePhotosLeft() {
      this.photosLeft = maxPhotos - this._getValidPhotoCount();
    }
  }, {
    key: '_sortCollection',
    value: function _sortCollection() {
      this.collection.sort(function (a, b) {
        return Boolean(b.main) - Boolean(a.main);
      });
    }
  }, {
    key: '_updateMainPhoto',
    value: function _updateMainPhoto() {
      this.userModel.item.profilePhoto = this.collection.filter(function (photo) {
        return photo.main;
      })[0];
    }
  }, {
    key: '_updateSettingsModel',
    value: function _updateSettingsModel() {
      this.settings.data.photos.value = this.getValidPhotos().filter(function (photo) {
        return !photo.$isUploading;
      });
    }
  }, {
    key: '_hasMainPhoto',
    value: function _hasMainPhoto() {
      return Boolean(this.collection.filter(function (photo) {
        return photo.main;
      }).length);
    }
  }]);

  return PhotoModel;
}();

var dependencies = [_photo_resource2.default];

exports.default = _angular2.default.module('models.photoModel', dependencies).service('photoModel', PhotoModel).name;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// var req = require.context('../images', true, /^(.*\.(jpg|png$))[^.]*$/igm);
// req.keys().forEach(function(key){
//   req(key);
// });

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(68);

__webpack_require__(69);

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularSanitize = __webpack_require__(24);

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularMessages = __webpack_require__(25);

var _angularMessages2 = _interopRequireDefault(_angularMessages);

var _angularCookies = __webpack_require__(8);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularAnimate = __webpack_require__(26);

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularUiRouter = __webpack_require__(9);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _oclazyload = __webpack_require__(27);

var _oclazyload2 = _interopRequireDefault(_oclazyload);

var _angularTranslate = __webpack_require__(28);

var _angularTranslate2 = _interopRequireDefault(_angularTranslate);

__webpack_require__(29);

var _angularElastic = __webpack_require__(30);

var _angularElastic2 = _interopRequireDefault(_angularElastic);

var _importsLoaderAngularExportsLoaderCtUiRouter = __webpack_require__(78);

var _importsLoaderAngularExportsLoaderCtUiRouter2 = _interopRequireDefault(_importsLoaderAngularExportsLoaderCtUiRouter);

var _exportsLoaderBtford = __webpack_require__(31);

var _exportsLoaderBtford2 = _interopRequireDefault(_exportsLoaderBtford);

var _exportsLoaderNgScrollbarNgScrollbar = __webpack_require__(79);

var _exportsLoaderNgScrollbarNgScrollbar2 = _interopRequireDefault(_exportsLoaderNgScrollbarNgScrollbar);

var _translate = __webpack_require__(32);

var _translate2 = _interopRequireDefault(_translate);

__webpack_require__(80);

var _carousel = __webpack_require__(33);

var _carousel2 = _interopRequireDefault(_carousel);

var _contact_form = __webpack_require__(91);

var _contact_form2 = _interopRequireDefault(_contact_form);

var _fetch_error_message = __webpack_require__(95);

var _fetch_error_message2 = _interopRequireDefault(_fetch_error_message);

var _how_it_works = __webpack_require__(34);

var _how_it_works2 = _interopRequireDefault(_how_it_works);

var _intro_videos = __webpack_require__(104);

var _intro_videos2 = _interopRequireDefault(_intro_videos);

var _location_search = __webpack_require__(305);

var _location_search2 = _interopRequireDefault(_location_search);

var _navigation = __webpack_require__(313);

var _navigation2 = _interopRequireDefault(_navigation);

var _recent_bookings = __webpack_require__(328);

var _recent_bookings2 = _interopRequireDefault(_recent_bookings);

var _slideshow = __webpack_require__(14);

var _slideshow2 = _interopRequireDefault(_slideshow);

var _social_links = __webpack_require__(332);

var _social_links2 = _interopRequireDefault(_social_links);

var _support_email = __webpack_require__(337);

var _support_email2 = _interopRequireDefault(_support_email);

var _top_panel = __webpack_require__(341);

var _top_panel2 = _interopRequireDefault(_top_panel);

var _get_started = __webpack_require__(345);

var _get_started2 = _interopRequireDefault(_get_started);

var _tooltip = __webpack_require__(63);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _common = __webpack_require__(350);

var _common2 = _interopRequireDefault(_common);

var _remarketing = __webpack_require__(354);

var _remarketing2 = _interopRequireDefault(_remarketing);

var _fb_campaign_handler = __webpack_require__(355);

var _fb_campaign_handler2 = _interopRequireDefault(_fb_campaign_handler);

var _constants = __webpack_require__(5);

var _constants2 = _interopRequireDefault(_constants);

var _filters = __webpack_require__(356);

var _filters2 = _interopRequireDefault(_filters);

var _components = __webpack_require__(382);

var _components2 = _interopRequireDefault(_components);

var _directives = __webpack_require__(435);

var _directives2 = _interopRequireDefault(_directives);

var _models = __webpack_require__(15);

var _models2 = _interopRequireDefault(_models);

var _resources = __webpack_require__(38);

var _resources2 = _interopRequireDefault(_resources);

var _services = __webpack_require__(4);

var _services2 = _interopRequireDefault(_services);

var _photo_model = __webpack_require__(66);

var _photo_model2 = _interopRequireDefault(_photo_model);

var _trips = __webpack_require__(509);

var _trips2 = _interopRequireDefault(_trips);

var _dashboard = __webpack_require__(510);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _notification_settings = __webpack_require__(511);

var _notification_settings2 = _interopRequireDefault(_notification_settings);

var _activation = __webpack_require__(512);

var _activation2 = _interopRequireDefault(_activation);

var _autologin = __webpack_require__(514);

var _autologin2 = _interopRequireDefault(_autologin);

var _become_guide = __webpack_require__(521);

var _become_guide2 = _interopRequireDefault(_become_guide);

var _forgot_password = __webpack_require__(524);

var _forgot_password2 = _interopRequireDefault(_forgot_password);

var _join = __webpack_require__(527);

var _join2 = _interopRequireDefault(_join);

var _mailing = __webpack_require__(543);

var _mailing2 = _interopRequireDefault(_mailing);

var _membership = __webpack_require__(546);

var _membership2 = _interopRequireDefault(_membership);

var _password_form = __webpack_require__(555);

var _password_form2 = _interopRequireDefault(_password_form);

var _login_history = __webpack_require__(558);

var _login_history2 = _interopRequireDefault(_login_history);

var _user_id = __webpack_require__(561);

var _user_id2 = _interopRequireDefault(_user_id);

var _vk_login = __webpack_require__(564);

var _vk_login2 = _interopRequireDefault(_vk_login);

var _info_box = __webpack_require__(567);

var _info_box2 = _interopRequireDefault(_info_box);

var _overflow = __webpack_require__(571);

var _overflow2 = _interopRequireDefault(_overflow);

var _app = __webpack_require__(575);

var _app2 = _interopRequireDefault(_app);

var _app3 = __webpack_require__(577);

var _app4 = _interopRequireDefault(_app3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './raven';

//Services


// problematic
// import angularRaven from 'exports-loader?\'ngRaven\'!angular-raven';
exports.default = _angular2.default.module('app', [

// 3rd party modules
_angularSanitize2.default, _angularMessages2.default, _angularCookies2.default, _angularAnimate2.default, _angularUiRouter2.default, _importsLoaderAngularExportsLoaderCtUiRouter2.default, _exportsLoaderBtford2.default, _angularTranslate2.default, _angularElastic2.default, _oclazyload2.default, _exportsLoaderNgScrollbarNgScrollbar2.default, _remarketing2.default, _fb_campaign_handler2.default,

// TODO: refactor
_constants2.default, _components2.default, _directives2.default, _filters2.default, _models2.default, _photo_model2.default, _trips2.default, _dashboard2.default, _notification_settings2.default, _resources2.default, _services2.default, _translate2.default,

// Common modules
_common2.default, _carousel2.default, _contact_form2.default, _fetch_error_message2.default, _how_it_works2.default, _intro_videos2.default, _location_search2.default, _navigation2.default, _recent_bookings2.default, _slideshow2.default, _social_links2.default, _support_email2.default, _top_panel2.default, _get_started2.default, _tooltip2.default, _info_box2.default, _overflow2.default,

// Feature modules
_activation2.default, _autologin2.default, _become_guide2.default, _forgot_password2.default, _join2.default, _mailing2.default, _membership2.default, _password_form2.default, _login_history2.default, _user_id2.default, _vk_login2.default]).config(_app2.default).run(_app4.default).name;

// Feature modules


// Common modules


// Translations

_angular2.default.element(document).ready(function () {
  _angular2.default.bootstrap(document, ['app'], { strictDi: true });
});

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var methods = ['assert', 'cd', 'clear', 'count', 'countReset', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd', 'select', 'table', 'time', 'timeEnd', 'timeStamp', 'timeline', 'timelineEnd', 'trace', 'warn'];

if (!window.console) {
  window.console = {};
  methods.forEach(function (methodName) {
    return window.console[methodName] = function () {};
  });
}

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
var angular = __webpack_require__(0);

/**
 * UI-Router Extras: Sticky states, Future States, Deep State Redirect, Transition promise
 * Monolithic build (all modules)
 * @version 0.1.3
 * @link http://christopherthielen.github.io/ui-router-extras/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function (root, factory) {
    'use strict';

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
            factory(angular);
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        factory(require('angular'));
    } else {
        factory(root.angular);
    }
}(this, function (angular, undefined) {
    var mod_core = angular.module("ct.ui.router.extras.core", [ "ui.router" ]);

var internalStates = {}, stateRegisteredCallbacks = [];
mod_core.config([ '$stateProvider', '$injector', function ($stateProvider, $injector) {
  // Decorate any state attribute in order to get access to the internal state representation.
  $stateProvider.decorator('parent', function (state, parentFn) {
    // Capture each internal UI-Router state representations as opposed to the user-defined state object.
    // The internal state is, e.g., the state returned by $state.$current as opposed to $state.current
    internalStates[state.self.name] = state;
    // Add an accessor for the internal state from the user defined state
    state.self.$$state = function () {
      return internalStates[state.self.name];
    };

    angular.forEach(stateRegisteredCallbacks, function(callback) { callback(state); });
    return parentFn(state);
  });
}]);

var DEBUG = false;

var forEach = angular.forEach;
var extend = angular.extend;
var isArray = angular.isArray;

var map = function (collection, callback) {
  "use strict";
  var result = [];
  forEach(collection, function (item, index) {
    result.push(callback(item, index));
  });
  return result;
};

var keys = function (collection) {
  "use strict";
  return map(collection, function (collection, key) {
    return key;
  });
};

var filter = function (collection, callback) {
  "use strict";
  var result = [];
  forEach(collection, function (item, index) {
    if (callback(item, index)) {
      result.push(item);
    }
  });
  return result;
};

var filterObj = function (collection, callback) {
  "use strict";
  var result = {};
  forEach(collection, function (item, index) {
    if (callback(item, index)) {
      result[index] = item;
    }
  });
  return result;
};

// Duplicates code in UI-Router common.js
function ancestors(first, second) {
  var path = [];

  for (var n in first.path) {
    if (first.path[n] !== second.path[n]) break;
    path.push(first.path[n]);
  }
  return path;
}

// Duplicates code in UI-Router common.js
function objectKeys(object) {
  if (Object.keys) {
    return Object.keys(object);
  }
  var result = [];

  angular.forEach(object, function (val, key) {
    result.push(key);
  });
  return result;
}

/**
 * like objectKeys, but includes keys from prototype chain.
 * @param object the object whose prototypal keys will be returned
 * @param ignoreKeys an array of keys to ignore
 */
// Duplicates code in UI-Router common.js
function protoKeys(object, ignoreKeys) {
  var result = [];
  for (var key in object) {
    if (!ignoreKeys || ignoreKeys.indexOf(key) === -1)
      result.push(key);
  }
  return result;
}

// Duplicates code in UI-Router common.js
function arraySearch(array, value) {
  if (Array.prototype.indexOf) {
    return array.indexOf(value, Number(arguments[2]) || 0);
  }
  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
  from = (from < 0) ? Math.ceil(from) : Math.floor(from);

  if (from < 0) from += len;

  for (; from < len; from++) {
    if (from in array && array[from] === value) return from;
  }
  return -1;
}

// Duplicates code in UI-Router common.js
// Added compatibility code  (isArray check) to support both 0.2.x and 0.3.x series of UI-Router.
function inheritParams(currentParams, newParams, $current, $to) {
  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];

  for (var i in parents) {
    if (!parents[i].params) continue;
    // This test allows compatibility with 0.2.x and 0.3.x (optional and object params)
    parentParams = isArray(parents[i].params) ? parents[i].params : objectKeys(parents[i].params);
    if (!parentParams.length) continue;

    for (var j in parentParams) {
      if (arraySearch(inheritList, parentParams[j]) >= 0) continue;
      inheritList.push(parentParams[j]);
      inherited[parentParams[j]] = currentParams[parentParams[j]];
    }
  }
  return extend({}, inherited, newParams);
}

function inherit(parent, extra) {
  return extend(new (extend(function () { }, {prototype: parent}))(), extra);
}

function onStateRegistered(callback) { stateRegisteredCallbacks.push(callback); }

mod_core.provider("uirextras_core", function() {
  var core = {
    internalStates: internalStates,
    onStateRegistered: onStateRegistered,
    forEach: forEach,
    extend: extend,
    isArray: isArray,
    map: map,
    keys: keys,
    filter: filter,
    filterObj: filterObj,
    ancestors: ancestors,
    objectKeys: objectKeys,
    protoKeys: protoKeys,
    arraySearch: arraySearch,
    inheritParams: inheritParams,
    inherit: inherit
  };

  angular.extend(this, core);

  this.$get = function() {
    return core;
  };
});


var ignoreDsr;
function resetIgnoreDsr() {
  ignoreDsr = undefined;
}

// Decorate $state.transitionTo to gain access to the last transition.options variable.
// This is used to process the options.ignoreDsr option
angular.module('ct.ui.router.extras.dsr', [ 'ct.ui.router.extras.core' ]).config([ "$provide", function ($provide) {
  var $state_transitionTo;
  $provide.decorator("$state", ['$delegate', '$q', function ($state, $q) {
    $state_transitionTo = $state.transitionTo;
    $state.transitionTo = function (to, toParams, options) {
      if (options && options.ignoreDsr) {
        ignoreDsr = options.ignoreDsr;
      }

      return $state_transitionTo.apply($state, arguments).then(
        function (result) {
          resetIgnoreDsr();
          return result;
        },
        function (err) {
          resetIgnoreDsr();
          return $q.reject(err);
        }
      );
    };
    return $state;
  }]);
}]);

angular.module('ct.ui.router.extras.dsr').service("$deepStateRedirect", [ '$rootScope', '$state', '$injector', function ($rootScope, $state, $injector) {
  var lastSubstate = {};
  var deepStateRedirectsByName = {};

  var REDIRECT = "Redirect", ANCESTOR_REDIRECT = "AncestorRedirect";

  function computeDeepStateStatus(state) {
    var name = state.name;
    if (deepStateRedirectsByName.hasOwnProperty(name))
      return deepStateRedirectsByName[name];
    recordDeepStateRedirectStatus(name);
  }

  function getConfig(state) {
    var declaration = state.deepStateRedirect || state.dsr;
    if (!declaration) return { dsr: false };
    var dsrCfg = { dsr: true };

    if (angular.isFunction(declaration)) {
      dsrCfg.fn = declaration;
    } else if (angular.isObject(declaration)) {
      dsrCfg = angular.extend(dsrCfg, declaration);
    }

    if (angular.isString(dsrCfg['default'])) {
      dsrCfg['default'] = { state: dsrCfg['default'] };
    }

    if (!dsrCfg.fn) {
      dsrCfg.fn = [ '$dsr$', function($dsr$) {
        return $dsr$.redirect.state != $dsr$.to.state;
      } ];
    }
    return dsrCfg;
  }

  function recordDeepStateRedirectStatus(stateName) {
    var state = $state.get(stateName);
    if (!state) return false;
    var cfg = getConfig(state);
    if (cfg.dsr) {
      deepStateRedirectsByName[state.name] = REDIRECT;
      if (lastSubstate[stateName] === undefined)
        lastSubstate[stateName] = {};
    }

    var parent = state.$$state && state.$$state().parent;
    if (parent) {
      var parentStatus = recordDeepStateRedirectStatus(parent.self.name);
      if (parentStatus && deepStateRedirectsByName[state.name] === undefined) {
        deepStateRedirectsByName[state.name] = ANCESTOR_REDIRECT;
      }
    }
    return deepStateRedirectsByName[state.name] || false;
  }

  function getMatchParams(params, dsrParams) {
    if (dsrParams === true) dsrParams = Object.keys(params);
    if (dsrParams === null || dsrParams === undefined) dsrParams = [];

    var matchParams = {};
    angular.forEach(dsrParams.sort(), function(name) { matchParams[name] = params[name]; });
    return matchParams;
  }

  function getParamsString(params, dsrParams) {
    var matchParams = getMatchParams(params, dsrParams);
    function safeString(input) { return !input ? input : input.toString(); }
    var paramsToString = {};
    angular.forEach(matchParams, function(val, name) { paramsToString[name] = safeString(val); });
    return angular.toJson(paramsToString);
  }

  $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
    var cfg = getConfig(toState);
    if (ignoreDsr || (computeDeepStateStatus(toState) !== REDIRECT) && !cfg['default']) return;
    // We're changing directly to one of the redirect (tab) states.
    // Get the DSR key for this state by calculating the DSRParams option
    var key = getParamsString(toParams, cfg.params);
    var redirect = lastSubstate[toState.name][key] || cfg['default'];
    if (!redirect) return;

    // we have a last substate recorded
    var $dsr$ = { redirect: { state: redirect.state, params: redirect.params}, to: { state: toState.name, params: toParams } };
    var result = $injector.invoke(cfg.fn, toState, { $dsr$: $dsr$ });
    if (!result) return;
    if (result.state) redirect = result;
    event.preventDefault();
    var redirectParams = getMatchParams(toParams, cfg.params);
    $state.go(redirect.state, angular.extend(redirectParams, redirect.params));
  });

  $rootScope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {
    var deepStateStatus = computeDeepStateStatus(toState);
    if (deepStateStatus) {
      var name = toState.name;
      angular.forEach(lastSubstate, function (redirect, dsrState) {
        // update Last-SubState&params for each DSR that this transition matches.
        var cfg = getConfig($state.get(dsrState));
        var key = getParamsString(toParams, cfg.params);
        if (toState.$$state().includes[dsrState]) {
          lastSubstate[dsrState][key] = { state: name, params: angular.copy(toParams) };
        }
      });
    }
  });

  return {
    getRedirect: function(dsrState, params) {
      var state = $state.get(dsrState);
      computeDeepStateStatus(state)
      var cfg = getConfig(state);
      var key = getParamsString(params, cfg.params);
      var redirect = lastSubstate[state.name];
      if (redirect && redirect[key]) {
        redirect = redirect[key];
      } else {
        redirect = cfg['default'];
      }
      return redirect;
    },
    reset: function(stateOrName, params) {
      if (!stateOrName) {
        angular.forEach(lastSubstate, function(redirect, dsrState) { lastSubstate[dsrState] = {}; });
      } else {
        var state = $state.get(stateOrName);
        if (!state) throw new Error("Unknown state: " + stateOrName);
        if (lastSubstate[state.name]) {
          if (params) {
            var key = getParamsString(params, getConfig(state).params);
            delete lastSubstate[state.name][key];
          } else {
            lastSubstate[state.name] = {};
          }
        }
      }
    }
  };
}]);

angular.module('ct.ui.router.extras.dsr').run(['$deepStateRedirect', function ($deepStateRedirect) {
  // Make sure $deepStateRedirect is instantiated
}]);

angular.module("ct.ui.router.extras.sticky", [ 'ct.ui.router.extras.core' ]);

var mod_sticky = angular.module("ct.ui.router.extras.sticky");

$StickyStateProvider.$inject = [ '$stateProvider', 'uirextras_coreProvider' ];
function $StickyStateProvider($stateProvider, uirextras_coreProvider) {
  var core = uirextras_coreProvider;
  var inheritParams = core.inheritParams;
  var objectKeys = core.objectKeys;
  var protoKeys = core.protoKeys;
  var forEach = core.forEach;
  var map = core.map;

  // Holds all the states which are inactivated.  Inactivated states can be either sticky states, or descendants of sticky states.
  var inactiveStates = {}; // state.name -> (state)
  var stickyStates = {}; // state.name -> true
  var $state;
  var DEBUG = false;

  // Called by $stateProvider.registerState();
  // registers a sticky state with $stickyStateProvider
  this.registerStickyState = function (state) {
    stickyStates[state.name] = state;
    // console.log("Registered sticky state: ", state);
  };

  this.enableDebug = this.debugMode = function (enabled) {
    if (angular.isDefined(enabled))
      DEBUG = enabled;
    return DEBUG;
  };

  this.$get = [  '$rootScope', '$state', '$stateParams', '$injector', '$log',
    function ($rootScope, $state, $stateParams, $injector, $log) {
      // Each inactive states is either a sticky state, or a child of a sticky state.
      // This function finds the closest ancestor sticky state, then find that state's parent.
      // Map all inactive states to their closest parent-to-sticky state.
      function mapInactives() {
        var mappedStates = {};
        angular.forEach(inactiveStates, function (state, name) {
          var stickyAncestors = getStickyStateStack(state);
          for (var i = 0; i < stickyAncestors.length; i++) {
            var parent = stickyAncestors[i].parent;
            mappedStates[parent.name] = mappedStates[parent.name] || [];
            mappedStates[parent.name].push(state);
          }
          if (mappedStates['']) {
            // This is necessary to compute Transition.inactives when there are sticky states are children to root state.
            mappedStates['__inactives'] = mappedStates[''];  // jshint ignore:line
          }
        });
        return mappedStates;
      }

      function mapInactivesByImmediateParent() {
        var inactivesByAllParents ={};
        forEach(inactiveStates, function(state) {
          forEach(state.path, function(ancestor) {
            if (ancestor === state) return;
            inactivesByAllParents[ancestor.name] = inactivesByAllParents[ancestor.name] || [];
            inactivesByAllParents[ancestor.name].push(state);
          });
        });
        return inactivesByAllParents;
      }

      // Given a state, returns all ancestor states which are sticky.
      // Walks up the view's state's ancestry tree and locates each ancestor state which is marked as sticky.
      // Returns an array populated with only those ancestor sticky states.
      function getStickyStateStack(state) {
        var stack = [];
        if (!state) return stack;
        do {
          if (state.sticky) stack.push(state);
          state = state.parent;
        } while (state);
        stack.reverse();
        return stack;
      }

      // Returns a sticky transition type necessary to enter the state.
      // Transition can be: reactivate, reload, or enter

      // Note: if a state is being reactivated but params dont match, we treat
      // it as a Exit/Enter, thus the special "reload" transition.
      // If a parent inactivated state has "reload" transition type, then
      // all descendant states must also be exit/entered, thus the first line of this function.
      function getEnterTransition(state, stateParams, reloadStateTree, ancestorReloaded) {
        if (ancestorReloaded) return "reload";
        var inactiveState = inactiveStates[state.self.name];
        if (!inactiveState) return "enter";
        if (state.self === reloadStateTree) return "reload";
        var paramsMatch = paramsEqualForState(state.ownParams, stateParams, inactiveState.locals.globals.$stateParams);
        return paramsMatch ? "reactivate" : "reload";
      }

      // Given a state and (optional) stateParams, returns the inactivated state from the inactive sticky state registry.
      function getInactivatedState(state, stateParams) {
        var inactiveState = inactiveStates[state.name];
        if (!inactiveState) return null;
        if (!stateParams) return inactiveState;
        var paramsMatch = paramsEqualForState(state.ownParams, stateParams, inactiveState.locals.globals.$stateParams);
        return paramsMatch ? inactiveState : null;
      }

      function paramsEqualForState(ownParams, stateParams, stateParams2) {
        if (typeof ownParams.$$equals === 'function')
          return ownParams.$$equals(stateParams, stateParams2);
        return equalForKeys(stateParams, stateParams2, ownParams);
      }

      // Duplicates logic in $state.transitionTo, primarily to find the pivot state (i.e., the "keep" value)
      function equalForKeys(a, b, keys) {
        if (!angular.isArray(keys) && angular.isObject(keys)) {
          keys = protoKeys(keys, ["$$keys", "$$values", "$$equals", "$$validates", "$$new", "$$parent"]);
        }
        if (!keys) {
          keys = [];
          for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
        }

        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
        }
        return true;
      }

      function calcTreeChanges(transition) {
        var fromPath = transition.fromState.path;
        var toPath = transition.toState.path;
        var toParams = transition.toParams;
        var keep = 0, state = toPath[keep];

        if (transition.options && transition.options.inherit) {
          toParams = transition.toParams =
              inheritParams($stateParams, toParams || {}, $state.$current, transition.toState);
        }

        while (state && state === fromPath[keep] && paramsEqualForState(state.ownParams, toParams, transition.fromParams)) {
          // We're "keeping" this state. bump keep var and get the next state in toPath for the next iteration.
          state = toPath[++keep];
        }

        return {
          keep: keep,
          retained: fromPath.slice(0, keep),
          exiting: fromPath.slice(keep),
          entering: toPath.slice(keep)
        };
      }

      function sortByStateDepth(a,b) {
        return a.name.split(".").length - b.name.split(".").length;
      }

      var stickySupport = {
        getInactiveStates: function () {
          return map(inactiveStates, angular.identity).sort(sortByStateDepth);
        },
        getInactiveStatesByParent: function () {
          return mapInactives();
        },
        // Main API for $stickyState, used by $state.
        // Processes a potential transition, returns an object with the following attributes:
        // {
        //    keep: The number of states being "kept"
        //    inactives: Array of all states which will be inactive if the transition is completed.
        //    reactivatingStates: Array of all states which will be reactivated if the transition is completed.
        //    orphans: Array of previously inactive states, which are being orphaned by the transition
        //        Note: Transitioning directly to an inactive state with inactive children will reactivate the state, but exit all the inactive children.
        //    enter: Enter transition type for all added states.  This is a parallel array to "toStates" array in $state.transitionTo.
        //    exit: Exit transition type for all removed states.  This is a parallel array to "fromStates" array in $state.transitionTo.
        // }
        processTransition: function (transition) {
          var treeChanges = calcTreeChanges(transition);
          var currentInactives = stickySupport.getInactiveStates();
          var futureInactives, exitingTypes, enteringTypes;
          var keep = treeChanges.keep;


          /////////////////////////////////////////
          // helper functions
          function notIn(array) { return function (elem) { return array.indexOf(elem) === -1; }; }
          function flattenReduce(memo, list) { return memo.concat(list); }
          function uniqReduce(memo, orphan) { if (notIn(memo)(orphan)) memo.push(orphan); return memo; }
          function prop(attr) { return function(obj) { return obj[attr]; } }
          function typeIs(type) { return function(obj) { return obj.type === type; } }
          function isChildOf(state) { return function(other) { return other.parent === state; }; }
          var notEntering = notIn(treeChanges.entering);
          function notSticky(state) { return !state.sticky; }
          ////////////////////////////////////


          // Calculate the "exit" transition types for states being exited in fromPath
          // Exit types will be either "inactivate" or "exit"
          // Two things must be satisfied in order to inactivate the "exiting" states (instead of exit them):
          // - The first element of the exiting path must be sticky
          // - We must be entering any sibling state of the sticky (we can check this using entering.length)
          var shouldInactivate = treeChanges.exiting[0] && treeChanges.exiting[0].sticky && treeChanges.entering.length > 0;
          exitingTypes = treeChanges.exiting.map(function (state) {
              var stateRentering = treeChanges.entering.indexOf(state) !== -1;
              var type = shouldInactivate && !stateRentering ? "inactivate" : "exit";
              return { type: type, state: state };
          });


          // Calculate the "enter" transition types for states being entered in toPath
          // Enter types will be either "enter", "reactivate", or "reload" where:
          //   enter: full resolve, no special logic
          //   reactivate: use previous locals
          //   reload: like 'enter', except exit the inactive state before entering it.
          var reloaded = transition.options && !!transition.options.reload;
          enteringTypes = treeChanges.entering.map(function(state) {
            var type = getEnterTransition(state, transition.toParams, transition.reloadStateTree, reloaded);
            reloaded = reloaded || type === 'reload';
            return { type: type, state: state };
          });

          // Find all the "orphaned" states.  those states that are :
          //  - are siblings of the entering states
          //  - previously inactive
          //  - are not being reactivated (entered)
          //  - are not sticky
          // unioned with:
          //  - children of the toState
          //  - previously inactive
          //
          // Given:
          //   - states A (sticky: true), B, A.foo, A.bar
          //   - A.foo is currently inactive
          //   - B is currently active
          // Orphan case 1)
          //   - Transition to A.bar orphans the inactive state A.foo; it should be exited
          // Orphan case 2)
          //   - Transition directly to A orphans the inactive state A.foo; it should be exited
          //
          // Given:
          //   - states A (sticky: true), B, A.foo (sticky), A.bar
          //   - A.foo is currently inactive
          //   - B is currently active
          // Orphan case 3)
          //   - Transition directly to A orphans the inactive sticky state A.foo; it should be exited
          // Note: transition from B to A.bar does not orphan A.foo
          // Note 2: each orphaned state might be the parent of a larger inactive subtree.
          var orphanedRoots = treeChanges.entering
              // For each entering state in the path, find all sibling states which are currently inactive
              .map(function (entering) { return currentInactives.filter(isChildOf(entering.parent)); })
              // Flatten nested arrays. Now we have an array of inactive states that are children of the ones being entered.
              .reduce(flattenReduce, [])
              // Consider "orphaned": only those children that are themselves not currently being entered
              .filter(notEntering)
              // Consider "orphaned": only those children that are not themselves sticky states.
              .filter(notSticky)
              // Finally, union that set with any inactive children of the "to state"
              .concat(currentInactives.filter(isChildOf(transition.toState)));

          var currentInactivesByParent = mapInactivesByImmediateParent();
          var allOrphans = orphanedRoots
              .map(function(root) { return currentInactivesByParent[root.name] })
              .filter(angular.isDefined)
              .reduce(flattenReduce, [])
              .concat(orphanedRoots)
              // Sort by depth to exit orphans in proper order
              .sort(sortByStateDepth);

          // Add them to the list of states being exited.
          var exitOrOrphaned = exitingTypes
              .filter(typeIs("exit"))
              .map(prop("state"))
              .concat(allOrphans);

          // Now calculate the states that will be inactive if this transition succeeds.
          // We have already pushed the transitionType == "inactivate" states to 'inactives'.
          // Second, add all the existing inactive states
          futureInactives = currentInactives
              .filter(notIn(exitOrOrphaned))
              .filter(notIn(treeChanges.entering))
              .concat(exitingTypes.filter(typeIs("inactivate")).map(prop("state")))
              .sort(sortByStateDepth);

          return {
            keep: keep,
            enter: new Array(keep).concat(enteringTypes.map(prop("type"))),
            exit: new Array(keep).concat(exitingTypes.map(prop("type"))),
            inactives: futureInactives,
            reactivatingStates: enteringTypes.filter(typeIs("reactivate")).map(prop("state")),
            orphans: allOrphans
          };
        },

        // Adds a state to the inactivated sticky state registry.
        stateInactivated: function (state) {
          // Keep locals around.
          inactiveStates[state.self.name] = state;
          // Notify states they are being Inactivated (i.e., a different
          // sticky state tree is now active).
          state.self.status = 'inactive';
          if (state.self.onInactivate)
            $injector.invoke(state.self.onInactivate, state.self, state.locals.globals);
        },

        // Removes a previously inactivated state from the inactive sticky state registry
        stateReactivated: function (state) {
          if (inactiveStates[state.self.name]) {
            delete inactiveStates[state.self.name];
          }
          state.self.status = 'entered';
//        if (state.locals == null || state.locals.globals == null) debugger;
          if (state.self.onReactivate)
            $injector.invoke(state.self.onReactivate, state.self, state.locals.globals);
        },

        // Exits all inactivated descendant substates when the ancestor state is exited.
        // When transitionTo is exiting a state, this function is called with the state being exited.  It checks the
        // registry of inactivated states for descendants of the exited state and also exits those descendants.  It then
        // removes the locals and de-registers the state from the inactivated registry.
        stateExiting: function (exiting, exitQueue, onExit) {
          var exitingNames = {};
          angular.forEach(exitQueue, function (state) {
            exitingNames[state.self.name] = true;
          });

          angular.forEach(inactiveStates, function (inactiveExiting, name) {
            // TODO: Might need to run the inactivations in the proper depth-first order?
            if (!exitingNames[name] && inactiveExiting.includes[exiting.name]) {
              if (DEBUG) $log.debug("Exiting " + name + " because it's a substate of " + exiting.name + " and wasn't found in ", exitingNames);
              if (inactiveExiting.self.onExit)
                $injector.invoke(inactiveExiting.self.onExit, inactiveExiting.self, inactiveExiting.locals.globals);
              angular.forEach(inactiveExiting.locals, function(localval, key) {
                delete inactivePseudoState.locals[key];
              });
              inactiveExiting.locals = null;
              inactiveExiting.self.status = 'exited';
              delete inactiveStates[name];
            }
          });

          if (onExit)
            $injector.invoke(onExit, exiting.self, exiting.locals.globals);
          exiting.locals = null;
          exiting.self.status = 'exited';
          delete inactiveStates[exiting.self.name];
        },

        // Removes a previously inactivated state from the inactive sticky state registry
        stateEntering: function (entering, params, onEnter, updateParams) {
          var inactivatedState = getInactivatedState(entering);
          if (inactivatedState && (updateParams || !getInactivatedState(entering, params))) {
            var savedLocals = entering.locals;
            this.stateExiting(inactivatedState);
            entering.locals = savedLocals;
          }
          entering.self.status = 'entered';

          if (onEnter)
            $injector.invoke(onEnter, entering.self, entering.locals.globals);
        },
        reset: function reset(inactiveState, params) {
          function resetOne(state) { stickySupport.reset(state); }
          if (inactiveState === "*") {
            angular.forEach(stickySupport.getInactiveStates(), resetOne);
            return true;
          }
          var state = $state.get(inactiveState);
          if (!state) return false;
          var exiting = getInactivatedState(state, params);
          if (!exiting) return false;
          stickySupport.stateExiting(exiting);
          $rootScope.$broadcast("$viewContentLoading");
          return true;
        }
      };

      return stickySupport;
    }];
}

mod_sticky.provider("$stickyState", $StickyStateProvider);

/**
 * Sticky States makes entire state trees "sticky". Sticky state trees are retained until their parent state is
 * exited. This can be useful to allow multiple modules, peers to each other, each module having its own independent
 * state tree.  The peer modules can be activated and inactivated without any loss of their internal context, including
 * DOM content such as unvalidated/partially filled in forms, and even scroll position.
 *
 * DOM content is retained by declaring a named ui-view in the parent state, and filling it in with a named view from the
 * sticky state.
 *
 * Technical overview:
 *
 * ---PATHS---
 * UI-Router uses state paths to manage entering and exiting of individual states.  Each state "A.B.C.X" has its own path, starting
 * from the root state ("") and ending at the state "X".  The path is composed the final state "X"'s ancestors, e.g.,
 * [ "", "A", "B", "C", "X" ].
 *
 * When a transition is processed, the previous path (fromState.path) is compared with the requested destination path
 * (toState.path).  All states that the from and to paths have in common are "kept" during the transition.  The last
 * "kept" element in the path is the "pivot".
 *
 * ---VIEWS---
 * A View in UI-Router consists of a controller and a template.  Each view belongs to one state, and a state can have many
 * views.  Each view plugs into a ui-view element in the DOM of one of the parent state's view(s).
 *
 * View context is managed in UI-Router using a 'state locals' concept. When a state's views are fully loaded, those views
 * are placed on the states 'locals' object.  Each locals object prototypally inherits from its parent state's locals object.
 * This means that state "A.B.C.X"'s locals object also has all of state "A.B.C"'s locals as well as those from "A.B" and "A".
 * The root state ("") defines no views, but it is included in the protypal inheritance chain.
 *
 * The locals object is used by the ui-view directive to load the template, render the content, create the child scope,
 * initialize the controller, etc.  The ui-view directives caches the locals in a closure variable.  If the locals are
 * identical (===), then the ui-view directive exits early, and does no rendering.
 *
 * In stock UI-Router, when a state is exited, that state's locals object is deleted and those views are cleaned up by
 * the ui-view directive shortly.
 *
 * ---Sticky States---
 * UI-Router Extras keeps views for inactive states live, even when UI-Router thinks it has exited them.  It does this
 * by creating a pseudo state called "__inactives" that is the parent of the root state.  It also then defines a locals
 * object on the "__inactives" state, which the root state protoypally inherits from.  By doing this, views for inactive
 * states are accessible through locals object's protoypal inheritance chain from any state in the system.
 *
 * ---Transitions---
 * UI-Router Extras decorates the $state.transitionTo function.  While a transition is in progress, the toState and
 * fromState internal state representations are modified in order to coerce stock UI-Router's transitionTo() into performing
 * the appropriate operations.  When the transition promise is completed, the original toState and fromState values are
 * restored.
 *
 * Stock UI-Router's $state.transitionTo function uses toState.path and fromState.path to manage entering and exiting
 * states.  UI-Router Extras takes advantage of those internal implementation details and prepares a toState.path and
 * fromState.path which coerces UI-Router into entering and exiting the correct states, or more importantly, not entering
 * and not exiting inactive or sticky states.  It also replaces state.self.onEnter and state.self.onExit for elements in
 * the paths when they are being inactivated or reactivated.
 */



// ------------------------ Sticky State module-level variables -----------------------------------------------
var _StickyState; // internal reference to $stickyStateProvider
var internalStates = {}; // Map { statename -> InternalStateObj } holds internal representation of all states
var root, // Root state, internal representation
  pendingTransitions = [], // One transition may supersede another.  This holds references to all pending transitions
  pendingRestore, // The restore function from the superseded transition
  inactivePseudoState, // This pseudo state holds all the inactive states' locals (resolved state data, such as views etc)
  reactivatingLocals = { }, // This is a prent locals to the inactivePseudoState locals, used to hold locals for states being reactivated
  versionHeuristics = { // Heuristics used to guess the current UI-Router Version
    hasParamSet: false
  };

// Creates a blank surrogate state
function SurrogateState(type) {
  return {
    resolve: { },
    locals: {
      globals: root && root.locals && root.locals.globals
    },
    views: { },
    self: { },
    params: { },
    ownParams: ( versionHeuristics.hasParamSet ? { $$equals: function() { return true; } } : []),
    surrogateType: type
  };
}

// ------------------------ Sticky State registration and initialization code ----------------------------------
// Grab a copy of the $stickyState service for use by the transition management code
angular.module("ct.ui.router.extras.sticky").run(["$stickyState", function ($stickyState) {
  _StickyState = $stickyState;
}]);

angular.module("ct.ui.router.extras.sticky").config(
  [ "$provide", "$stateProvider", '$stickyStateProvider', '$urlMatcherFactoryProvider', 'uirextras_coreProvider',
    function ($provide, $stateProvider, $stickyStateProvider, $urlMatcherFactoryProvider, uirextras_coreProvider) {
      var core = uirextras_coreProvider;
      var internalStates = core.internalStates;
      var inherit = core.inherit;
      var inheritParams = core.inheritParams;
      var forEach = core.forEach;
      var map = core.map;
      var filterObj = core.filterObj;

      versionHeuristics.hasParamSet = !!$urlMatcherFactoryProvider.ParamSet;
      // inactivePseudoState (__inactives) holds all the inactive locals which includes resolved states data, i.e., views, scope, etc
      inactivePseudoState = angular.extend(new SurrogateState("__inactives"), { self: {  name: '__inactives'  } });
      // Reset other module scoped variables.  This is to primarily to flush any previous state during karma runs.
      root = pendingRestore = undefined;
      pendingTransitions = [];

      uirextras_coreProvider.onStateRegistered(function(state) {
        // Register the ones marked as "sticky"
        if (state.self.sticky === true) {
          $stickyStateProvider.registerStickyState(state.self);
        }
      });

      var $state_transitionTo; // internal reference to the real $state.transitionTo function
      // Decorate the $state service, so we can decorate the $state.transitionTo() function with sticky state stuff.
      $provide.decorator("$state", ['$delegate', '$log', '$q', function ($state, $log, $q) {
        // Note: this code gets run only on the first state that is decorated
        root = $state.$current;
        internalStates[""] = root;
        root.parent = inactivePseudoState; // Make inactivePsuedoState the parent of root.  "wat"
        inactivePseudoState.parent = undefined; // Make inactivePsuedoState the real root.
        // Add another locals bucket, as a parent to inactivatePseudoState locals.
        // This is for temporary storage of locals of states being reactivated while a transition is pending
        // This is necessary in some cases where $viewContentLoading is triggered before the $state.$current is updated to the toState.
        inactivePseudoState.locals = inherit(reactivatingLocals, inactivePseudoState.locals);
        root.locals = inherit(inactivePseudoState.locals, root.locals); // make root locals extend the __inactives locals.
        delete inactivePseudoState.locals.globals;

        // Hold on to the real $state.transitionTo in a module-scope variable.
        $state_transitionTo = $state.transitionTo;

        // ------------------------ Decorated transitionTo implementation begins here ---------------------------
        $state.transitionTo = function (to, toParams, options) {
          var DEBUG = $stickyStateProvider.debugMode();
          // TODO: Move this to module.run?
          // TODO: I'd rather have root.locals prototypally inherit from inactivePseudoState.locals
          // Link root.locals and inactives.locals.  Do this at runtime, after root.locals has been set.
          if (!inactivePseudoState.locals)
            inactivePseudoState.locals = root.locals;
          var idx = pendingTransitions.length;
          if (pendingRestore) {
            pendingRestore();
            if (DEBUG) {
              $log.debug("Restored paths from pending transition");
            }
          }

          var fromState = $state.$current, fromParams = $state.params;
          var rel = options && options.relative || $state.$current; // Not sure if/when $state.$current is appropriate here.
          var toStateSelf = $state.get(to, rel); // exposes findState relative path functionality, returns state.self
          var savedToStatePath, savedFromStatePath, stickyTransitions;
          var reactivated = [], exited = [], terminalReactivatedState;
          toParams = toParams || {};
          arguments[1] = toParams;

          var noop = function () {
          };
          // Sticky states works by modifying the internal state objects of toState and fromState, especially their .path(s).
          // The restore() function is a closure scoped function that restores those states' definitions to their original values.
          var restore = function () {
            if (savedToStatePath) {
              toState.path = savedToStatePath;
              savedToStatePath = null;
            }

            if (savedFromStatePath) {
              fromState.path = savedFromStatePath;
              savedFromStatePath = null;
            }

            angular.forEach(restore.restoreFunctions, function (restoreFunction) {
              restoreFunction();
            });
            // Restore is done, now set the restore function to noop in case it gets called again.
            restore = noop;
            // pendingRestore keeps track of a transition that is in progress.  It allows the decorated transitionTo
            // method to be re-entrant (for example, when superceding a transition, i.e., redirect).  The decorated
            // transitionTo checks right away if there is a pending transition in progress and restores the paths
            // if so using pendingRestore.
            pendingRestore = null;
            pendingTransitions.splice(idx, 1); // Remove this transition from the list
          };

          // All decorated transitions have their toState.path and fromState.path replaced.  Surrogate states also make
          // additional changes to the states definition before handing the transition off to UI-Router. In particular,
          // certain types of surrogate states modify the state.self object's onEnter or onExit callbacks.
          // Those surrogate states must then register additional restore steps using restore.addRestoreFunction(fn)
          restore.restoreFunctions = [];
          restore.addRestoreFunction = function addRestoreFunction(fn) {
            this.restoreFunctions.push(fn);
          };


          // --------------------- Surrogate State Functions ------------------------
          // During a transition, the .path arrays in toState and fromState are replaced.  Individual path elements
          // (states) which aren't being "kept" are replaced with surrogate elements (states).  This section of the code
          // has factory functions for all the different types of surrogate states.


          function stateReactivatedSurrogatePhase1(state) {
            var surrogate = angular.extend(new SurrogateState("reactivate_phase1"), { locals: state.locals });
            surrogate.self = angular.extend({}, state.self);
            return surrogate;
          }

          function stateReactivatedSurrogatePhase2(state) {
            var surrogate = angular.extend(new SurrogateState("reactivate_phase2"), state);
            var oldOnEnter = surrogate.self.onEnter;
            surrogate.resolve = {}; // Don't re-resolve when reactivating states (fixes issue #22)
            // TODO: Not 100% sure if this is necessary.  I think resolveState will load the views if I don't do this.
            surrogate.views = {}; // Don't re-activate controllers when reactivating states (fixes issue #22)
            surrogate.self.onEnter = function () {
              // ui-router sets locals on the surrogate to a blank locals (because we gave it nothing to resolve)
              // Re-set it back to the already loaded state.locals here.
              surrogate.locals = state.locals;
              _StickyState.stateReactivated(state);
            };
            restore.addRestoreFunction(function () {
              state.self.onEnter = oldOnEnter;
            });
            return surrogate;
          }

          function stateInactivatedSurrogate(state) {
            var surrogate = new SurrogateState("inactivate");
            surrogate.self = state.self;
            var oldOnExit = state.self.onExit;
            surrogate.self.onExit = function () {
              _StickyState.stateInactivated(state);
            };
            restore.addRestoreFunction(function () {
              state.self.onExit = oldOnExit;
            });
            return surrogate;
          }

          function stateEnteredSurrogate(state, toParams) {
            var oldOnEnter = state.self.onEnter;
            state.self.onEnter = function () {
              _StickyState.stateEntering(state, toParams, oldOnEnter);
            };
            restore.addRestoreFunction(function () {
              state.self.onEnter = oldOnEnter;
            });

            return state;
          }

          // TODO: This may be completely unnecessary now that we're using $$uirouterextrasreload temp param
          function stateUpdateParamsSurrogate(state, toParams) {
            var oldOnEnter = state.self.onEnter;
            state.self.onEnter = function () {
              _StickyState.stateEntering(state, toParams, oldOnEnter, true);
            };
            restore.addRestoreFunction(function () {
              state.self.onEnter = oldOnEnter;
            });

            return state;
          }

          function stateExitedSurrogate(state) {
            var oldOnExit = state.self.onExit;
            state.self.onExit = function () {
              _StickyState.stateExiting(state, exited, oldOnExit);
            };
            restore.addRestoreFunction(function () {
              state.self.onExit = oldOnExit;
            });

            return state;
          }


          // --------------------- decorated .transitionTo() logic starts here ------------------------
          if (toStateSelf) {
            var toState = internalStates[toStateSelf.name]; // have the state, now grab the internal state representation
            if (toState) {
              // Save the toState and fromState paths to be restored using restore()
              savedToStatePath = toState.path;
              savedFromStatePath = fromState.path;

              // Try to resolve options.reload to a state.  If so, we'll reload only up to the given state.
              var reload = options && options.reload || false;
              var reloadStateTree = reload && (reload === true ? savedToStatePath[0].self : $state.get(reload, rel));
              // If options.reload is a string or a state, we want to handle reload ourselves and not
              // let ui-router reload the entire toPath.
              if (options && reload && reload !== true)
                delete options.reload;

              var currentTransition = {
                toState: toState,
                toParams: toParams || {},
                fromState: fromState,
                fromParams: fromParams || {},
                options: options,
                reloadStateTree: reloadStateTree
              };

              pendingTransitions.push(currentTransition); // TODO: See if a list of pending transitions is necessary.
              pendingRestore = restore;

              // If we're reloading from a state and below, temporarily add a param to the top of the state tree
              // being reloaded, and add a param value to the transition.  This will cause the "has params changed
              // for state" check to return true, and the states will be reloaded.
              if (reloadStateTree) {
                currentTransition.toParams.$$uirouterextrasreload = Math.random();
                var params = reloadStateTree.$$state().params;
                var ownParams = reloadStateTree.$$state().ownParams;

                if (versionHeuristics.hasParamSet) {
                  var tempParam = new $urlMatcherFactoryProvider.Param('$$uirouterextrasreload');
                  params.$$uirouterextrasreload = ownParams.$$uirouterextrasreload = tempParam;
                  restore.restoreFunctions.push(function() {
                    delete params.$$uirouterextrasreload;
                    delete ownParams.$$uirouterextrasreload;
                  });
                } else {
                  params.push('$$uirouterextrasreload');
                  ownParams.push('$$uirouterextrasreload');
                  restore.restoreFunctions.push(function() {
                    params.length = params.length -1;
                    ownParams.length = ownParams.length -1;
                  });
                }
              }

              // $StickyStateProvider.processTransition analyzes the states involved in the pending transition.  It
              // returns an object that tells us:
              // 1) if we're involved in a sticky-type transition
              // 2) what types of exit transitions will occur for each "exited" path element
              // 3) what types of enter transitions will occur for each "entered" path element
              // 4) which states will be inactive if the transition succeeds.
              stickyTransitions = _StickyState.processTransition(currentTransition);

              if (DEBUG) debugTransition($log, currentTransition, stickyTransitions);

              // Begin processing of surrogate to and from paths.
              var surrogateToPath = toState.path.slice(0, stickyTransitions.keep);
              var surrogateFromPath = fromState.path.slice(0, stickyTransitions.keep);

              // Clear out and reload inactivePseudoState.locals each time transitionTo is called
              angular.forEach(inactivePseudoState.locals, function (local, name) {
                if (name.indexOf("@") != -1) delete inactivePseudoState.locals[name];
              });

              var saveViewsToLocals = function (targetObj) {
                return function(view, name) {
                  if (name.indexOf("@") !== -1) { // Only grab this state's "view" locals
                    targetObj[name] = view; // Add all inactive views not already included.
                  }
                }
              };

              // For each state that will be inactive when the transition is complete, place its view-locals on the
              // __inactives pseudostate's .locals.  This allows the ui-view directive to access them and
              // render the inactive views.
              forEach(stickyTransitions.inactives, function(state) {
                forEach(state.locals, saveViewsToLocals(inactivePseudoState.locals))
              });

              // For each state that will be reactivated during the transition, place its view-locals on a separate
              // locals object (prototypal parent of __inactives.locals, and remove them when the transition is complete.
              // This is necessary when we a transition will reactivate one state, but enter a second.
              // Gory details:
              //   - the entering of a new state causes $view.load() to fire $viewContentLoading while the transition is
              //     still in process
              //   - all ui-view(s) check if they should re-render themselves in response to this event.
              //   - ui-view checks if previousLocals is equal to currentLocals
              //     - it uses $state.$current.locals[myViewName] for previousLocals
              //   - Because the transition is not completed, $state.$current is set to the from state, and
              //     the ui-view for a reactivated state cannot find its previous locals.
              forEach(stickyTransitions.reactivatingStates, function(state) {
                forEach(state.locals, saveViewsToLocals(reactivatingLocals));
              });

              // When the transition is complete, remove the copies of the view locals from reactivatingLocals.
              restore.addRestoreFunction(function clearReactivatingLocals() {
                forEach(reactivatingLocals, function (val, viewname) {
                  delete reactivatingLocals[viewname];
                })
              });

              // Find all the states the transition will be entering.  For each entered state, check entered-state-transition-type
              // Depending on the entered-state transition type, place the proper surrogate state on the surrogate toPath.
              angular.forEach(stickyTransitions.enter, function (value, idx) {
                var surrogate;
                var enteringState = toState.path[idx];
                if (value === "reactivate") {
                  // Reactivated states require TWO surrogates.  The "phase 1 reactivated surrogates" are added to both
                  // to.path and from.path, and as such, are considered to be "kept" by UI-Router.
                  // This is required to get UI-Router to add the surrogate locals to the protoypal locals object
                  surrogate = stateReactivatedSurrogatePhase1(enteringState);
                  surrogateToPath.push(surrogate);
                  surrogateFromPath.push(surrogate);  // so toPath[i] === fromPath[i]

                  // The "phase 2 reactivated surrogate" is added to the END of the .path, after all the phase 1
                  // surrogates have been added.
                  reactivated.push(stateReactivatedSurrogatePhase2(enteringState));
                  terminalReactivatedState = enteringState;
                } else if (value === "reload") {
                  // If the state params have been changed, we need to exit any inactive states and re-enter them.
                  surrogateToPath.push(stateUpdateParamsSurrogate(enteringState));
                  terminalReactivatedState = enteringState;
                } else if (value === "enter") {
                  // Standard enter transition.  We still wrap it in a surrogate.
                  surrogateToPath.push(stateEnteredSurrogate(enteringState));
                }
              });

              // Find all the states the transition will be exiting.  For each exited state, check the exited-state-transition-type.
              // Depending on the exited-state transition type, place a surrogate state on the surrogate fromPath.
              angular.forEach(stickyTransitions.exit, function (value, idx) {
                var exiting = fromState.path[idx];
                if (value === "inactivate") {
                  surrogateFromPath.push(stateInactivatedSurrogate(exiting));
                  exited.push(exiting);
                } else if (value === "exit") {
                  surrogateFromPath.push(stateExitedSurrogate(exiting));
                  exited.push(exiting);
                }
              });

              // Add surrogate states for reactivated to ToPath again (phase 2), this time without a matching FromPath entry
              // This is to get ui-router to call the surrogate's onEnter callback.
              if (reactivated.length) {
                angular.forEach(reactivated, function (surrogate) {
                  surrogateToPath.push(surrogate);
                });
              }

              // We may transition directly to an inactivated state, reactivating it.  In this case, we should
              // exit all of that state's inactivated children.
              var orphans = stickyTransitions.orphans;
              // Add surrogate exited states for all orphaned descendants of the Deepest Reactivated State
              surrogateFromPath = surrogateFromPath.concat(map(orphans, function (exiting) {
                return stateExitedSurrogate(exiting);
              }));
              exited = exited.concat(orphans);

              // Replace the .path variables.  toState.path and fromState.path are now ready for a sticky transition.
              fromState.path = surrogateFromPath;
              toState.path = surrogateToPath;

              var pathMessage = function (state) {
                return (state.surrogateType ? state.surrogateType + ":" : "") + state.self.name;
              };
              if (DEBUG) $log.debug("SurrogateFromPath: ", map(surrogateFromPath, pathMessage));
              if (DEBUG) $log.debug("SurrogateToPath:   ", map(surrogateToPath, pathMessage));
            }
          }

          // toState and fromState are all set up; now run stock UI-Router's $state.transitionTo().
          var transitionPromise = $state_transitionTo.apply($state, arguments);

          // Add post-transition promise handlers, then return the promise to the original caller.
          return transitionPromise.then(function transitionSuccess(state) {
            // First, restore toState and fromState to their original values.
            restore();
            if (DEBUG)  debugViewsAfterSuccess($log, internalStates[state.name], $state);

            state.status = 'active';  // TODO: This status is used in statevis.js, and almost certainly belongs elsewhere.

            return state;
          }, function transitionFailed(err) {
            restore();
            if (DEBUG &&
              err.message !== "transition prevented" &&
              err.message !== "transition aborted" &&
              err.message !== "transition superseded") {
              $log.debug("transition failed", err);
              $log.debug(err.stack);
            }
            return $q.reject(err);
          });
        };
        return $state;
      }]);



      function debugTransition($log, currentTransition, stickyTransition) {
        function message(path, index, state) {
          return (path[index] ? path[index].toUpperCase() + ": " + state.self.name : "(" + state.self.name + ")");
        }

        var inactiveLogVar = map(stickyTransition.inactives, function (state) {
          return state.self.name;
        });
        var enterLogVar = map(currentTransition.toState.path, function (state, index) {
          return message(stickyTransition.enter, index, state);
        });
        var exitLogVar = map(currentTransition.fromState.path, function (state, index) {
          return message(stickyTransition.exit, index, state);
        });

        var transitionMessage = currentTransition.fromState.self.name + ": " +
          angular.toJson(currentTransition.fromParams) + ": " +
          " -> " +
          currentTransition.toState.self.name + ": " +
          angular.toJson(currentTransition.toParams);

        $log.debug("------------------------------------------------------");
        $log.debug("   Current transition: ", transitionMessage);
        $log.debug("Before transition, inactives are:   : ", map(_StickyState.getInactiveStates(), function (s) {
          return s.self.name;
        }));
        $log.debug("After transition,  inactives will be: ", inactiveLogVar);
        $log.debug("Transition will exit:  ", exitLogVar);
        $log.debug("Transition will enter: ", enterLogVar);
      }

      function debugViewsAfterSuccess($log, currentState, $state) {
        $log.debug("Current state: " + currentState.self.name + ", inactive states: ", map(_StickyState.getInactiveStates(), function (s) {
          return s.self.name;
        }));

        var statesOnly = function (local, name) {
          return name != 'globals' && name != 'resolve';
        };

        var viewsForState = function (state) {
          var viewLocals = filterObj(state.locals, statesOnly);

          if (!Object.keys(viewLocals).length) {
            viewLocals[''] = { $$state: { name: null } };
          }

          return map(viewLocals, function(local, name) {
            return {
              localsFor: state.self.name ? state.self.name : "(root)",
              uiViewName: name || null,
              filledByState: local.$$state.name
            };
          });
        };

        var viewsByState = viewsForState(currentState);
        var parent = currentState.parent;
        while (parent && parent !== currentState) {
          viewsByState = viewsByState.concat(viewsForState(parent));
          currentState = parent;
          parent = currentState.parent;
        }

        $log.debug("Views active on each state:");
        console.table(viewsByState.reverse());
      }
    }
  ]
);

(function(angular, undefined) {
  var app = angular.module('ct.ui.router.extras.future', [ 'ct.ui.router.extras.core' ]);

  _futureStateProvider.$inject = [ '$stateProvider', '$urlRouterProvider', '$urlMatcherFactoryProvider', 'uirextras_coreProvider' ];
  function _futureStateProvider($stateProvider, $urlRouterProvider, $urlMatcherFactory, uirextras_coreProvider) {
    var core = uirextras_coreProvider;
    var internalStates = core.internalStates;
    var stateFactories = {}, futureStates = {};
    var lazyloadInProgress = false, resolveFunctions = [], initPromise, initDone = false;
    var provider = this;

    // This function registers a promiseFn, to be resolved before the url/state matching code
    // will reject a route.  The promiseFn is injected/executed using the runtime $injector.
    // The function should return a promise.
    // When all registered promises are resolved, then the route is re-sync'ed.

    // Example: function($http) {
    //  return $http.get('//server.com/api/DynamicFutureStates').then(function(data) {
    //    angular.forEach(data.futureStates, function(fstate) { $futureStateProvider.futureState(fstate); });
    //  };
    // }
    this.addResolve = function (promiseFn) {
      resolveFunctions.push(promiseFn);
    };

    // Register a state factory function for a particular future-state type.  This factory, given a future-state object,
    // should create a ui-router state.
    // The factory function is injected/executed using the runtime $injector.  The future-state is injected as 'futureState'.

    // Example:
    //    $futureStateProvider.stateFactory('test', function(futureState) {
    //      return {
    //        name: futureState.stateName,
    //        url: futureState.urlFragment,
    //        template: '<h3>Future State Template</h3>',
    //        controller: function() {
    //          console.log("Entered state " + futureState.stateName);
    //        }
    //      }
    //    });
    this.stateFactory = function (futureStateType, factory) {
      stateFactories[futureStateType] = factory;
    };

    this.futureState = function (futureState) {
      if (futureState.stateName)  // backwards compat for now
        futureState.name = futureState.stateName;
      if (futureState.urlPrefix)  // backwards compat for now
        futureState.url = "^" + futureState.urlPrefix;

      futureStates[futureState.name] = futureState;
      var parentMatcher,  parentName = futureState.name.split(/\./).slice(0, -1).join("."),
        realParent = findState(futureState.parent || parentName);
      if (realParent) {
        parentMatcher = realParent.url || realParent.navigable && realParent.navigable.url;
      } else if (parentName === "") {
        parentMatcher = $urlMatcherFactory.compile("");
      } else {
        var futureParent = findState((futureState.parent || parentName), true);
        if (!futureParent) throw new Error("Couldn't determine parent state of future state. FutureState:" + angular.toJson(futureState));
        var pattern;
        if (futureParent.urlMatcher) {
          pattern = futureParent.urlMatcher.source.replace(/\*rest$/, "");
        }
        else {
          // if the futureParent doesn't have a urlMatcher, then we are still
          // starting from the beginning of the path
          pattern = "";
        }
        parentMatcher = $urlMatcherFactory.compile(pattern);
        futureState.parentFutureState = futureParent;
      }
      if (futureState.url) {
        futureState.urlMatcher = futureState.url.charAt(0) === "^" ?
          $urlMatcherFactory.compile(futureState.url.substring(1) + "*rest") :
          parentMatcher.concat(futureState.url + "*rest");
      }
    };

    this.get = function () {
      return angular.extend({}, futureStates);
    };

    function findState(stateOrName, findFutureState) {
      var statename = angular.isObject(stateOrName) ? stateOrName.name : stateOrName;
      return !findFutureState ? internalStates[statename] : futureStates[statename];
    }

    /* options is an object with at least a name or url attribute */
    function findFutureState($state, options) {
      if (options.name) {
        var nameComponents = options.name.split(/\./);
        if (options.name.charAt(0) === '.')
          nameComponents[0] = $state.current.name;
        while (nameComponents.length) {
          var stateName = nameComponents.join(".");
          if ($state.get(stateName, { relative: $state.current }))
            return null; // State is already defined; nothing to do
          if (futureStates[stateName])
            return futureStates[stateName];
          nameComponents.pop();
        }
      }

      if (options.url) {
        var matches = [];
        for(var future in futureStates) {
          var matcher = futureStates[future].urlMatcher;
          if (matcher && matcher.exec(options.url)) {
            matches.push(futureStates[future]);
          }
        }
        // Find most specific by ignoring matching parents from matches
        var copy = matches.slice(0);
        for (var i = matches.length - 1; i >= 0; i--) {
          for (var j = 0; j < copy.length; j++) {
            if (matches[i] === copy[j].parentFutureState) matches.splice(i, 1);
          }
        }
        return matches[0];
      }
    }

    function lazyLoadState($injector, futureState) {
      lazyloadInProgress = true;
      var $q = $injector.get("$q");
      if (!futureState) {
        var deferred = $q.defer();
        deferred.reject("No lazyState passed in " + futureState);
        return deferred.promise;
      }

      var parentPromises = $q.when([]), parentFuture = futureState.parentFutureState;
      if (parentFuture && futureStates[parentFuture.name]) {
        parentPromises = lazyLoadState($injector, futureStates[parentFuture.name]);
      }

      var type = futureState.type;
      var factory = stateFactories[type];
      if (!factory) throw Error("No state factory for futureState.type: " + (futureState && futureState.type));

      var failedLoadPolicy = factory.$options && factory.$options.failedLazyLoadPolicy || "remove";
      function deregisterFutureState() { delete(futureStates[futureState.name]); }
      function errorHandler(err) {
        if (failedLoadPolicy === "remove") deregisterFutureState();
        return $q.reject(err);
      }

      return parentPromises.then(function(array) {
        var factoryPromise = $injector.invoke(factory, factory, { futureState: futureState });

        return factoryPromise.then(function(fullState) {
          deregisterFutureState(); // Success; remove future state
          if (fullState) { array.push(fullState); } // Pass a chain of realized states back
          return array;
        });
      }).catch(errorHandler)
    }

    var otherwiseFunc = [ '$log', '$location',
      function otherwiseFunc($log, $location) {
        //$log.debug("Unable to map " + $location.path());
      }];

    function futureState_otherwise($injector, $location) {
      var resyncing = false;

      var lazyLoadMissingState =
        ['$rootScope', '$urlRouter', '$state',
          function lazyLoadMissingState($rootScope, $urlRouter, $state) {
            function resync() {
              resyncing = true; $urlRouter.sync(); resyncing = false;
            }
            if (!initDone) {
              // Asynchronously load state definitions, then resync URL
              initPromise().then(resync);
              initDone = true;
              return;
            }

            var futureState = findFutureState($state, { url: $location.path() });
            if (!futureState) {
              return $injector.invoke(otherwiseFunc);
            }

            // Config loaded.  Asynchronously lazy-load state definition from URL fragment, if mapped.
            lazyLoadState($injector, futureState).then(function lazyLoadedStateCallback(states) {
              states.forEach(function (state) {
                if (state && (!$state.get(state) || (state.name && !$state.get(state.name))))
                  $stateProvider.state(state);
              });
              lazyloadInProgress = false;
              resync();
            }, function lazyLoadStateAborted() {
              lazyloadInProgress = false;
              resync();
            });
          }];
      if (lazyloadInProgress) return;

      var nextFn = resyncing ? otherwiseFunc : lazyLoadMissingState;
      return $injector.invoke(nextFn);
    }

    $urlRouterProvider.otherwise(futureState_otherwise);

    $urlRouterProvider.otherwise = function(rule) {
      if (angular.isString(rule)) {
        var redirect = rule;
        rule = function () { return redirect; };
      }
      else if (!angular.isFunction(rule)) throw new Error("'rule' must be a function");
      otherwiseFunc = ['$injector', '$location', rule];
      return $urlRouterProvider;
    };

    var serviceObject = {
      getResolvePromise: function () {
        return initPromise();
      }
    };

    // Used in .run() block to init
    this.$get = [ '$injector', '$state', '$q', '$rootScope', '$urlRouter', '$timeout', '$log',
      function futureStateProvider_get($injector, $state, $q, $rootScope, $urlRouter, $timeout, $log) {
        function init() {
          $rootScope.$on("$stateNotFound", function futureState_notFound(event, unfoundState, fromState, fromParams) {
            if (lazyloadInProgress) return;
            //$log.debug("event, unfoundState, fromState, fromParams", event, unfoundState, fromState, fromParams);

            var futureState = findFutureState($state, { name: unfoundState.to });
            if (!futureState) return;

            event.preventDefault();
            var promise = lazyLoadState($injector, futureState);
            promise.then(function (states) {
              states.forEach(function (state) {
                if (state && (!$state.get(state) || (state.name && !$state.get(state.name))))
                  $stateProvider.state(state);
              });
              $state.go(unfoundState.to, unfoundState.toParams, unfoundState.options);
              lazyloadInProgress = false;
            }, function (error) {
              console.log("failed to lazy load state ", error);
              if (fromState.name) $state.go(fromState, fromParams);
              lazyloadInProgress = false;
            });
          });

          // Do this better.  Want to load remote config once, before everything else
          if (!initPromise) {
            var promises = [];
            angular.forEach(resolveFunctions, function (promiseFn) {
              promises.push($injector.invoke(promiseFn));
            });
            initPromise = function () {
              return $q.all(promises);
            };
          }

          // TODO: analyze this. I'm calling $urlRouter.sync() in two places for retry-initial-transition.
          // TODO: I should only need to do this once.  Pick the better place and remove the extra resync.
          initPromise().then(function retryInitialState() {
            $timeout(function () {
              if ($state.transition) {
                $state.transition.then(retryInitialState, retryInitialState);
              } else {
                $urlRouter.sync();
              }
            });
          });
        }

        init();

        serviceObject.state = $stateProvider.state;
        serviceObject.futureState = provider.futureState;
        serviceObject.get = provider.get;

        return serviceObject;
      }
    ];
  }

  app.provider('$futureState', _futureStateProvider);

  var statesAddedQueue = {
    state: function(state) {
      if (statesAddedQueue.$rootScope)
        statesAddedQueue.$rootScope.$broadcast("$stateAdded", state);
    },
    itsNowRuntimeOhWhatAHappyDay: function($rootScope) {
      statesAddedQueue.$rootScope = $rootScope;
    },
    $rootScope: undefined
  };

  app.config([ '$stateProvider', function($stateProvider) {
    // decorate $stateProvider.state so we can broadcast when a real state was added
    var realStateFn = $stateProvider.state;
    $stateProvider.state = function state_announce() {
      var val = realStateFn.apply($stateProvider, arguments);

      var state = angular.isObject(arguments[0]) ? arguments[0] : arguments[1];
      statesAddedQueue.state(state);
      return val;
    };
  }]);

  // inject $futureState so the service gets initialized via $get();
  app.run(['$futureState', function ($futureState, $rootScope) {
    statesAddedQueue.itsNowRuntimeOhWhatAHappyDay($rootScope);
  } ]);

})(angular);

angular.module('ct.ui.router.extras.previous', [ 'ct.ui.router.extras.core', 'ct.ui.router.extras.transition' ]).service("$previousState",
  [ '$rootScope', '$state', '$q',
    function ($rootScope, $state, $q) {
      var previous = null, lastPrevious = null, memos = {};

      $rootScope.$on("$transitionStart", function(evt, $transition$) {
        var from = $transition$.from;
        // Check if the fromState is navigable before tracking it.
        // Root state doesn't get decorated with $$state().  Doh.
        var fromState = from.state && from.state.$$state && from.state.$$state();
        function commit() { lastPrevious = null; }
        function revert() { previous = lastPrevious; }
        if (fromState) {
          lastPrevious = previous;
          previous = $transition$.from;

          $transition$.promise.then(commit)['catch'](revert);
        }
      });

      var $previousState = {
        get: function (memoName) {
          return memoName ? memos[memoName] : previous;
        },
        set: function (memoName, previousState, previousParams) {
          memos[memoName] = { state: $state.get(previousState), params: previousParams };
        },
        go: function (memoName, options) {
          var to = $previousState.get(memoName);
          if (!to) {
            return $q.reject(new Error('no previous state ' + (memoName ? 'for memo: ' + memoName : '')));
          }
          return $state.go(to.state, to.params, options);
        },
        memo: function (memoName, defaultStateName, defaultStateParams) {
          memos[memoName] = previous || { state: $state.get(defaultStateName), params: defaultStateParams };
        },
        forget: function (memoName) {
          if (memoName) {
            delete memos[memoName];
          } else {
            previous = undefined;
          }
        }
      };

      return $previousState;
    }
  ]
);

angular.module('ct.ui.router.extras.previous').run(['$previousState', function ($previousState) {
  // Inject $previousState so it can register $rootScope events
}]);


angular.module("ct.ui.router.extras.transition", [ 'ct.ui.router.extras.core' ]).config( [ "$provide",  function ($provide) {
      // Decorate the $state service, so we can replace $state.transitionTo()
      $provide.decorator("$state", ['$delegate', '$rootScope', '$q', '$injector',
        function ($state, $rootScope, $q, $injector) {
          // Keep an internal reference to the real $state.transitionTo function
          var $state_transitionTo = $state.transitionTo;
          // $state.transitionTo can be re-entered.  Keep track of re-entrant stack
          var transitionDepth = -1;
          var tDataStack = [];
          var restoreFnStack = [];

          // This function decorates the $injector, adding { $transition$: tData } to invoke() and instantiate() locals.
          // It returns a function that restores $injector to its previous state.
          function decorateInjector(tData) {
            var oldinvoke = $injector.invoke;
            var oldinstantiate = $injector.instantiate;
            $injector.invoke = function (fn, self, locals) {
              return oldinvoke(fn, self, angular.extend({$transition$: tData}, locals));
            };
            $injector.instantiate = function (fn, locals) {
              return oldinstantiate(fn, angular.extend({$transition$: tData}, locals));
            };

            return function restoreItems() {
              $injector.invoke = oldinvoke;
              $injector.instantiate = oldinstantiate;
            };
          }

          function popStack() {
            restoreFnStack.pop()();
            tDataStack.pop();
            transitionDepth--;
          }

          // This promise callback (for when the real transitionTo is successful) runs the restore function for the
          // current stack level, then broadcasts the $transitionSuccess event.
          function transitionSuccess(deferred, tSuccess) {
            return function successFn(data) {
              popStack();
              $rootScope.$broadcast("$transitionSuccess", tSuccess);
              deferred.resolve(data); // $transition$ deferred
              return data;
            };
          }

          // This promise callback (for when the real transitionTo fails) runs the restore function for the
          // current stack level, then broadcasts the $transitionError event.
          function transitionFailure(deferred, tFail) {
            return function failureFn(error) {
              popStack();
              $rootScope.$broadcast("$transitionError", tFail, error);
              deferred.reject(error);  // $transition$ deferred
              return $q.reject(error);
            };
          }

          // Decorate $state.transitionTo.
          $state.transitionTo = function (to, toParams, options) {
            // Create a deferred/promise which can be used earlier than UI-Router's transition promise.
            var deferred = $q.defer();
            // Place the promise in a transition data, and place it on the stack to be used in $stateChangeStart
            var tData = tDataStack[++transitionDepth] = {
              promise: deferred.promise
            };
            // placeholder restoreFn in case transitionTo doesn't reach $stateChangeStart (state not found, etc)
            restoreFnStack[transitionDepth] = function() { };
            // Invoke the real $state.transitionTo
            var tPromise = $state_transitionTo.apply($state, arguments);

            // insert our promise callbacks into the chain.
            return tPromise.then(transitionSuccess(deferred, tData), transitionFailure(deferred, tData));
          };

          // This event is handled synchronously in transitionTo call stack
          $rootScope.$on("$stateChangeStart", function (evt, toState, toParams, fromState, fromParams) {
              if (transitionDepth >= tDataStack.length) return;
              var depth = transitionDepth;
              // To/From is now normalized by ui-router.  Add this information to the transition data object.
              var tData = angular.extend(tDataStack[depth], {
                to: { state: toState, params: toParams },
                from: { state: fromState, params: fromParams }
              });

              var restoreFn = decorateInjector(tData);
              restoreFnStack[depth] = restoreFn;
              $rootScope.$broadcast("$transitionStart", tData);
            }
          );

          return $state;
        }]);
    }
  ]
);

// statevis requires d3.
(function () {
  "use strict";
  var app = angular.module("ct.ui.router.extras.statevis", [ 'ct.ui.router.extras.core', 'ct.ui.router.extras.sticky'  ]);

  app.directive('stateVis', [ '$state', '$timeout', '$interval', stateVisDirective ]);

  /**
   * This directive gets all the current states using $state.get() and displays them in a tree using D3 lib.
   * It then listens for state events and updates the tree.
   *
   * Usage:
   * <state-vis height="1000px" width="1000px"></state-vis>
   */
  function stateVisDirective($state, $timeout, $interval) {
    return {
      scope: {
        width: '@',
        height: '@'
      },
      restrict: 'AE',
      template: '<svg></svg>',
      link: function (_scope, _elem, _attrs) {
        var stateMap = {};
        var width = _scope.width || 400,
          height = _scope.height || 400;

        var tree = d3.layout.tree()
            .size([width - 20, height - 20])
            .separation(function (a, b) {
              return a.parent == b.parent ? 10 : 25;
            });

        var root = $state.get().filter(function (state) { return state.name === ""; })[0];
        var nodes = tree(root);

        root.parent = root;
        root.px = root.x = width / 2;
        root.py = root.y = height / 2;

        var activeNode = { };
        activeNode.px = activeNode.x = root.px;
        activeNode.py = activeNode.y = root.py;

        var diagonal = d3.svg.diagonal();

        var svg = d3.select(_elem.find("svg")[0])
          .attr("width", width)
          .attr("height", height)
          .append("g")
          .attr("transform", "translate(10, 10)");

        var node = svg.selectAll(".node"),
          link = svg.selectAll(".link"),
          active = svg.selectAll(".active")
          ;

        var updateInterval = 200,
          transLength = 200,
          timer = setInterval(update, updateInterval);

        function addStates(data) {
          // *********** Convert flat data into a nice tree ***************
          data = data.map(function (node) {
            return node.name === "" ? root : angular.copy(node);
          });
          angular.extend(stateMap, data.reduce(function (map, node) {
            map[node.name] = node;
            return map;
          }, {}));

          data.forEach(function (node) {
            // add to parent
            var parentName = node.name.split(/\./).slice(0, -1).join(".");
            var parent = node.name != parentName && stateMap[parentName];
            if (parent) {
              (parent.children || (parent.children = [])).push(node); // create child array if it doesn't exist
              node.px = parent.px;
              node.py = parent.py;
              nodes.push(node);
            }
          });
        }

        $interval(function () {
          _scope.states = $state.get();
          angular.forEach(nodes, function (n) {
            var s = $state.get(n.name);
            if (s) {
              n.status = s.status || 'exited';
            }
          });
//          _scope.futureStates = $futureState.get();
        }, 250);

        _scope.$watchCollection("states", function (newval, oldval) {
          var oldstates = (oldval || []).map(function (s) { return s.name; });
          addStates((newval || []).filter(function(state) { return oldstates.indexOf(state.name) == -1; } ));
//          addStates(_.reject(newval, function (state) { return _.contains(oldstates, state.name); }));
        });

//        addStates($state.get());
        update(updateInterval);

        function update() {
          // Recompute the layout and data join.
          node = node.data(tree.nodes(root), function (d) { return d.name; });
          link = link.data(tree.links(nodes), function (d) { return d.target.name; });
          active = active.data(activeNode);

          nodes.forEach(function (d) { d.y = d.depth * 70; });

          // Add entering nodes in the parent’s old position.
          var nodeEnter = node.enter();

          function stateName(node) {
            var name = node.name.split(".").pop();
            if (node.sticky) { name += " (STICKY)"; }
            if (node.deepStateRedirect) { name += " (DSR)"; }
            return name;
          }

          active.enter()
            .append("circle")
            .attr("class", "active")
            .attr("r", 13)
            .attr("cx", function (d) { return d.parent.px || 100; })
            .attr("cy", function (d) { return d.parent.py || 100; })
          ;

          nodeEnter.append("circle")
            .attr("class", "node")
            .attr("r", 9)
            .attr("cx", function (d) { return d.parent.px; })
            .attr("cy", function (d) { return d.parent.py; });

          nodeEnter.append("text")
            .attr("class", "label")
            .attr("x", function (d) { return d.parent.px; })
            .attr("y", function (d) { return d.parent.py; })
            .attr("text-anchor", function (d) { return "middle"; })
            .text(stateName)
            .style("fill-opacity", 1);


          // Add entering links in the parent’s old position.
          link.enter().insert("path", ".node")
            .attr("class", "link")
            .attr("d", function (d) {
              var o = {x: d.source.px, y: d.source.py};
              return diagonal({source: o, target: o});
            });

          // Transition nodes and links to their new positions.
          var t = svg.transition()
            .duration(transLength);

          t.selectAll(".link")
            .attr("d", diagonal);

          /* jshint -W093 */
          var circleColors = { entered: '#AF0', exited: '#777', active: '#0f0', inactive: '#55F', future: '#009' };
          t.selectAll(".node")
            .attr("cx", function (d) { return d.px = d.x; })
            .attr("cy", function (d) { return d.py = d.y; })
            .attr("r", function (d) { return d.status === 'active' ? 15 : 10; })
            .style("fill", function (d) { return circleColors[d.status] || "#FFF"; });

          t.selectAll(".label")
            .attr("x", function (d) { return d.px = d.x; })
            .attr("y", function (d) { return d.py = d.y - 15; })
            .attr("transform", function (d) { return "rotate(-25 " + d.x + " " + d.y + ")"; })
          ;

          t.selectAll(".active")
            .attr("x", function (d) { return d.px = d.x; })
            .attr("y", function (d) { return d.py = d.y - 15; });
        }
      }
    };
  }
})();


angular.module("ct.ui.router.extras",
  [
    'ct.ui.router.extras.core',
    'ct.ui.router.extras.dsr',
    'ct.ui.router.extras.future',
    'ct.ui.router.extras.previous',
    'ct.ui.router.extras.statevis',
    'ct.ui.router.extras.sticky',
    'ct.ui.router.extras.transition'
  ]);


}));

/*** EXPORTS FROM exports-loader ***/
module.exports = 'ct.ui.router.extras';


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ng-scrollbar
 * @version v0.0.7 - 2015-06-19
 * @link https://github.com/asafdav/ng-scrollbar
 * @author Asaf David <asafdav@gmail.com>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
angular.module("ngScrollbar",[]).directive("ngScrollbar",["$parse","$window",function(a,b){return{restrict:"A",replace:!0,transclude:!0,scope:{showYScrollbar:"=?isBarShown"},link:function(a,c,d){var e,g,h,i,j,k,l,m,n,o,p,q={bottom:d.hasOwnProperty("bottom")},r=angular.element(b),s=!!r[0].addEventListener,t=!!r[0].removeEventListener,u={top:0},v={top:0},w=function(){l={position:"relative",overflow:"hidden","max-width":"100%",height:"100%"},v.height&&(l.height=v.height+"px"),m={position:"absolute",height:u.height+"px",top:u.top+"px"},n={position:"relative","line-height":u.height+"px"},o={position:"relative",top:v.top+"px",overflow:"hidden"}},x=function(){i.css("top",u.top+"px");var a=u.top/v.height;v.top=-Math.round(v.scrollHeight*a),g.css("top",v.top+"px")},y=function(a){var b=a.hasOwnProperty("offsetY")?a.offsetY:a.layerY,c=Math.max(0,Math.min(parseInt(u.trackHeight,10)-parseInt(u.height,10),b));u.top=c,x(),a.stopPropagation()},z=function(a){var b=40,c=a,d=c.detail,e=c.wheelDelta,g=225,h=g-1;return d=d?e&&(f=e/d)?d/f:-d/1.35:e/120,d=1>d?-1>d?(-Math.pow(d,2)-h)/g:d:(Math.pow(d,2)+h)/g,a.delta=Math.min(Math.max(d/2,-1),1),a.delta=a.delta*b,u.top=Math.max(0,Math.min(parseInt(v.height,10)-parseInt(u.height,10),parseInt(u.top,10)-a.delta)),x(),a.preventDefault?void a.preventDefault():!1},A=0,B=function(a,b,c){u.top=Math.max(0,Math.min(parseInt(u.trackHeight,10)-parseInt(u.height,10),c)),a.stopPropagation()},C=function(a){var b=0,c=a.pageY-i[0].scrollTop-A;B(a,b,c),x()},D=function(a){r.off("mousemove",C),r.off("mouseup",D),a.stopPropagation()},E=function(a){var b=0,c=a.originalEvent.changedTouches[0].pageY-i[0].scrollTop-A;B(a,b,c),x()},F=function(a){r.off("touchmove",E),r.off("touchend",F),a.stopPropagation()},G=function(a){var b=void 0!==r[0].onmousewheel?"mousewheel":"DOMMouseScroll";s?a.addEventListener(b,z,!1):a.attachEvent("onmousewheel",z)},H=function(a){var b=void 0!==r[0].onmousewheel?"mousewheel":"DOMMouseScroll";t?a.removeEventListener(b,z,!1):a.detachEvent("onmousewheel",z)},I=function(b){b=q.bottom||b,e=angular.element(c.children()[0]),g=angular.element(e.children()[0]),h=angular.element(e.children()[1]),i=angular.element(angular.element(h.children()[0]).children()[0]),j=angular.element(i.children()[0]),k=angular.element(angular.element(h.children()[0]).children()[1]),v.height=c[0].offsetHeight,v.scrollHeight=g[0].scrollHeight,v.height<v.scrollHeight?(a.showYScrollbar=!0,a.$emit("scrollbar.show"),u.height=Math.round(v.height/v.scrollHeight*v.height),u.trackHeight=v.height,w(),c.css({overflow:"hidden"}),e.css(l),g.css(o),i.css(m),j.css(n),k.bind("click",y),G(g[0]),i.on("mousedown",function(a){A=a.pageY-i[0].offsetTop,r.on("mouseup",D),r.on("mousemove",C),a.preventDefault()}),i.on("touchstart",function(a){A=a.originalEvent.changedTouches[0].pageY-i[0].offsetTop,r.on("touchend",F),r.on("touchmove",E),a.preventDefault()}),b?(q.bottom=!1,u.top=parseInt(v.height,10)-parseInt(u.height,10)):u.top=Math.max(0,Math.min(parseInt(v.height,10)-parseInt(u.height,10),parseInt(u.top,10))),x()):(a.showYScrollbar=!1,a.$emit("scrollbar.hide"),i.off("mousedown"),H(g[0]),g.attr("style","position:relative;top:0"),e.css({height:"100%"}))},J=function(b,c){null!=p&&clearTimeout(p);var d=!!c&&!!c.rollToBottom;p=setTimeout(function(){v.height=null,I(d),a.$$phase||a.$digest(),a.$parent.$$phase||a.$parent.$digest()},72)};I(),d.rebuildOn&&d.rebuildOn.split(" ").forEach(function(b){a.$on(b,J)}),d.hasOwnProperty("rebuildOnResize")&&r.on("resize",J)},template:'<div><div class="ngsb-wrap"><div class="ngsb-container" ng-transclude></div><div class="ngsb-scrollbar" style="position: absolute; display: block;" ng-show="showYScrollbar"><div class="ngsb-thumb-container"><div class="ngsb-thumb-pos" oncontextmenu="return false;"><div class="ngsb-thumb" ></div></div><div class="ngsb-track"></div></div></div></div></div>'}}]);

/*** EXPORTS FROM exports-loader ***/
module.exports = 'ngScrollbar';

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(81);

__webpack_require__(82);

__webpack_require__(83);

__webpack_require__(84);

__webpack_require__(85);

__webpack_require__(86);

/***/ }),
/* 81 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "ALERTS": {
    "VERIFY_PHONE_ID": {
      "HEADER": "Verify your ID",
      "CONTENT": "Please verify your ID to be able to accept bookings and receive payments.",
      "BUTTON": "Verify"
    },
    "PAYOUT_SUCCESS": {
      "HEADER": "Payout completed",
      "CONTENT": "Payout to your bank account is completed. The amount should appear in your bank account within a few working days.",
      "BUTTON": "Ok"
    },
    "CANCEL_BOOKING": {
      "HEADER": "Cancel Booking",
      "CONTENT": "Are you sure you want to cancel this booking request?",
      "BUTTON_ACCEPT": "Yes",
      "BUTTON_DECLINE": "No"
    },
    "CANCEL_TRIP": {
      "HEADER": "Cancel Trip",
      "CONTENT": "Are you sure you want to cancel this trip offer?",
      "BUTTON_ACCEPT": "Yes",
      "BUTTON_DECLINE": "No"
    },
    "DELETE_PHOTO": {
      "CONTENT": "Delete photo?",
      "BUTTON_ACCEPT": "Yes",
      "BUTTON_DECLINE": "No"
    },
    "DELETE_LAST_PHOTO": {
      "HEADER": "Error",
      "CONTENT": "Cannot delete your last photo: It is being used as your profile photo. To delete or change it, you have to add more photos to your profile.",
      "BUTTON": "Ok"
    },
    "SCRIPT_ERROR": {
      "HEADER": "Oops! Something went wrong...",
      "BUTTON_ACCEPT": "Try again"
    }
  }
}
);  }]);

/***/ }),
/* 82 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "BOOKING_ACTION": {
    "BOOK_SENDER": "You have requested to book {NAME}",
    "BOOK": "Booking request from {NAME}",
    "MODIFY_SENDER": "You have requested to book {NAME}",
    "MODIFY": "Booking request from {NAME}",
    "ACCEPT_SENDER": "You have requested to book {NAME}",
    "ACCEPT": "Booking request from {NAME}",
    "DECLINE_SENDER": "You have declined a booking from {NAME}",
    "DECLINE": "We’re really sorry, but {NAME} is not available for this booking",
    "OFFER_DECLINE_SENDER": "You skipped this offer.",
    "OFFER_DECLINE": "Offer was not accepted",
    "CANCEL_SENDER": "You have cancelled this booking request",
    "CANCEL": "{NAME} has cancelled this booking request",
    "PAY_SENDER": "Upfront payment complete",
    "PAY": "Upfront payment complete",
    "EXPIRE": "Booking request expired",
    "EXPIRE_SENDER": "Booking request expired",
    "REVIEW": "You can now leave a review about your booking",
    "REVIEW_SENDER": "You can now leave a review about your booking",
    "AUTODECLINE": "Sorry, I'm not available for this booking",
    "AUTODECLINE_SENDER": "Booking request was cancelled",

  },
  "BOOKING_STATUS": {
    "PENDING": "Booking Request",
    "PENDING_SENDER": "Booking Request",
    "ACCEPT": "Booking Request",
    "ACCEPT_SENDER": "Booking Request",
    "PAY": "Booking Paid",
    "PAY_SENDER": "Booking Paid",
    "CANCEL": "Cancelled",
    "CANCEL_SENDER": "Cancelled",
    "DECLINE": "Not Available",
    "DECLINE_SENDER": "Not Available",
    "REVIEW": "Leave a Review",
    "REVIEW_SENDER": "Leave a Review",
    "EXPIRE": "Expired",
    "EXPIRE_SENDER": "Expired",
    "AUTODECLINE": "Not Available",
    "AUTODECLINE_SENDER": "Cancelled",
    "CONFIRM": "Confirm",
    "CONFIRM_SENDER": "Confirm",
    "OFFER": "Offer",
    "OFFER_SENDER": "Offer",
    "OFFER_ACCEPT": "Offer",
    "OFFER_ACCEPT_SENDER": "Offer",
    "OFFER_DECLINE": "Cancelled",
    "OFFER_DECLINE_SENDER": "Cancelled",
  },
  "BOOKING_STATUS_LONG": {
    "ACCEPT_SENDER": "Awaiting payment from {NAME}",
    "ACCEPT": "Awaiting your payment"
  },
  "BOOKING_DURATION": "for {HOURS, plural, one{# hour} other{# hours}}"
}
);  }]);

/***/ }),
/* 83 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "FORM_ERRORS": {
    "COMMON": {
      "REQUIRED": "This field is required"
    },
    "NAME": {
      "MIN_LENGTH": "Your name must contain at least 2 characters",
      "MAX_LENGTH": "Your name must not exceed 20 characters"
    },
    "EMAIL": {
      "PATTERN": "Invalid email address",
      "UNIQUE": "Email already exists"
    },
    "PASSWORD": {
      "MIN_LENGTH": "Your password must contain at least 6 characters",
      "MAX_LENGTH": "Your password must not exceed 40 characters",
      "MATCH": "Passwords do not match"
    },
    "CAPTCHA": {
      "VALID": "Captcha verification has failed"
    }
  }
}
);  }]);

/***/ }),
/* 84 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "MEMBERSHIP_CANCEL": {
    "MEMBERSHIP_HEADER": "Confirm Cancellation",
    "MEMBERSHIP_BODY": "If you cancel your subscription, it will still be valid until the date you have paid up to on your last payment.<br><strong>Are you sure you would like to cancel?</strong>",
    "MEMBERSHIP_YES": "Yes",
    "MEMBERSHIP_NO": "No",
  }
}
);  }]);

/***/ }),
/* 85 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "FORM_PHOTO": {
    "ERROR": {
      "DEFAULT": "Upload failed. Check your internet connection.",
      "DIMENSIONS": "Minimum photo size is 320x320 pixels.",
      "FORMAT": "Invalid image format. Upload .jpg or .png image."
    }
  }
}
);  }]);

/***/ }),
/* 86 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "BOOKING_MESSAGE": {
    "HEADING": {
      "BOOK": "Booking request from {name}",
      "BOOK_SENDER": "You have requested to book {name} in {location}",
      "ACCEPT": "You have requested to book {name} in {location}",
      "ACCEPT_SENDER": "Booking request from {name}",
      "CANCEL": "{name} has cancelled this booking request",
      "CANCEL_SENDER": "You have cancelled this booking request",
      "DECLINE": "Sorry, {name} is not available for this booking",
      "DECLINE_SENDER": "You are not available",
      "AUTODECLINE": "Not available",
      "AUTODECLINE_SENDER": "Booking request was cancelled",
      "PAY": "Upfront payment complete",
      "PAY_SENDER": "Upfront payment complete",
      "EXPIRE": "Booking request expired",
      "EXPIRE_SENDER": "Booking request expired",
      "REVIEW": "Please leave a review",
      "REVIEW_SENDER": "Please leave a review",
      "REVIEW_LEFT": "Reviewed",
      "REVIEW_LEFT_SENDER": "Reviewed",
      "OFFER": "{name} wants to show you around in {location}",
      "OFFER_SENDER": "Your Showaround offer in {location}",
      "OFFER_ACCEPT": "Your Showaround offer in {location}",
      "OFFER_ACCEPT_SENDER": "{name} wants to show you around in {location}",
      "OFFER_DECLINE": "Offer was not accepted",
      "OFFER_DECLINE_SENDER": "Offer was not accepted",
    },
    "FOOTER": {
      "BOOK": "Respond to this booking request",
      "BOOK_SENDER": "Awaiting response from {name}",
      "ACCEPT": "Discuss and make an upfront payment.",
      "ACCEPT_SENDER": "You have accepted this booking request",
      "CANCEL": "Booking request cancelled",
      "CANCEL_SENDER": "Booking request cancelled",
      "DECLINE": "Not available",
      "DECLINE_SENDER": "Not available",
      "PAY": "Upfront payment complete",
      "PAY_SENDER": "Upfront payment complete",
      "EXPIRE": "Booking request expired",
      "EXPIRE_SENDER": "Booking request expired"
    },
    "DECLINE": {
      "FINAL": "Sorry, I’m not available for this booking.",
      "MODIFY": "Some booking details don’t fit my schedule.<br>I’d be happy to offer alternative dates, times or durations."
    },
    "LABEL": {
      "MEETING_TIME": "Preferred meeting time",
      "NUMBER_OF_PEOPLE": "Number of people"
    },
    "BUTTON": {
      "ACCEPT": "Let's discuss",
      "DECLINE": "<span class=\"u-hidden-m-inline\">Sorry, I'm</span> not available",
      "PAY": "Pay",
      "CANCEL": "Cancel",
      "REVIEW": "Leave a review",
      "MODIFY": "Modify your booking"
    },
    "DURATION": "for {hours} {hours, plural, one{hour} other{hours}}",
    "RESPONSE_FROM": "Response from {name}",
    "CONTACTS": {
      "GUIDE": "Local host contact info",
      "GUEST": "Guest contact info"
    }
  }
}
);  }]);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saCarousel;

var _hammerjs = __webpack_require__(13);

var _hammerjs2 = _interopRequireDefault(_hammerjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animateCls = 'is-animated';
var ngAnimateClass = 'is-ngAnimationEnabled';
var containerStyles = {
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden'
};
var stackContainerStyles = {
  position: 'relative',
  width: '100%',
  height: '100%'
};
var itemStyles = {
  display: 'inline-block',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0
};
var stackItemStyles = {
  display: 'inline-block',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};

var saCarouselCtrl = function saCarouselCtrl($q, $animate, $window, $scope, $attrs, $element, preventClick) {
  'ngInject';

  var _this3 = this;

  var options = $scope.$eval($attrs.saCarouselOptions) || {};
  var containerElement;
  var isInitialized;
  var eventManager;

  function getSlideTransform(index, offset) {
    var translateX = index * 100 + offset;
    var opacity = 1 - Math.abs(translateX) / 200;
    var styles = { opacity: opacity };

    styles['-webkit-transform'] = 'translate3d(' + (translateX + '%') + ', 0, 0) scale3d(1, 1, 1)';
    styles['transform'] = 'translate3d(' + (translateX + '%') + ', 0, 0) scale3d(1, 1, 1)';

    return styles;
  }

  function setOffset(items, offset, animate) {
    containerElement.removeClass(animateCls);

    if (animate) {
      containerElement.addClass(animateCls);
    }

    items.forEach(function (item, index) {
      item.css(getSlideTransform(index, offset));
    });
  }

  this.panHandler = function (event) {
    var currentItemIndex = this.currentItemIndex;
    var deltaX = event.deltaX;
    var speedConstant = 1;
    var pageWidth = containerElement[0].offsetWidth;
    var offset;

    if (event.type === 'panend') {
      preventClick(event.srcEvent);

      if (Math.abs(deltaX) < pageWidth / 8) {
        this.showItem(currentItemIndex);
      } else {

        if (event.deltaX < 0) {
          this.nextItem();
        } else {
          this.prevItem();
        }
      }
    } else {

      // Slow down on first and last items
      if (currentItemIndex === 0 && deltaX < 0 || currentItemIndex === this.items.length - 1 && deltaX > 0) {
        speedConstant = 0.3;
      }

      offset = -100 * currentItemIndex + event.deltaX / pageWidth * 100 * speedConstant;

      setOffset(this.items, offset);
    }
  };

  // initialization

  this.currentItemIndex = 0;
  this.items = [];
  this.isEnabled = !$attrs['saCarousel'];

  this.init = function () {
    var _this = this;

    if (isInitialized || !containerElement || this.isEnabled === false) {
      return;
    }

    if (!options.stack) {
      eventManager = new _hammerjs2.default($element[0], {
        recognizers: [[_hammerjs2.default.Swipe, { direction: _hammerjs2.default.DIRECTION_HORIZONTAL }], [_hammerjs2.default.Pan, { direction: _hammerjs2.default.DIRECTION_HORIZONTAL, threshold: 30 }]]
      });

      eventManager.on('panleft panright panend', function (event) {
        $scope.$apply(function () {
          _this.panHandler(event);
        });
      });
    }

    if (containerElement) {
      containerElement.css(options.stack ? stackContainerStyles : containerStyles);
    }

    this.items.forEach(function (item, index) {
      item.css(itemStyles);
      if (options.stack) {
        item.css({
          'opacity': 0,
          'z-index': index
        });
      }
    });
    this.showItem(0);

    isInitialized = true;
  };

  this.destroy = function () {
    if (isInitialized === false) {
      return;
    }

    if (eventManager) {
      eventManager.destroy();
      eventManager = null;
    }

    if (containerElement) {
      containerElement.removeAttr('style');
    }

    this.items.forEach(function (item) {
      item.removeAttr('style');
      item.removeClass(animateCls);
    });

    isInitialized = false;
  };

  // API

  this.setContainer = function (container) {
    containerElement = container;

    if (!this.isEnabled) {
      return;
    }

    containerElement.css(options.stack ? stackContainerStyles : containerStyles);

    this.init();
  };

  this.addItem = function (item) {
    this.items.push(item);

    if (!this.isEnabled) {
      return;
    }

    item.css(options.stack ? stackItemStyles : itemStyles);
    if (options.stack) {
      item.css({
        'opacity': 0,
        'z-index': this.items.indexOf(item)
      });
    } else {
      item.css(getSlideTransform(this.items.length - 1, -100 * this.currentItemIndex));
    }
  };

  this.removeItem = function (item) {
    this.items.splice(this.items.indexOf(item), 1);
  };

  this.showItem = function (itemIndex, animate) {
    var _this2 = this;

    if (options.stack) {
      var numberOfItems = this.items.length;
      var prevIdx = this.currentItemIndex;
      var currentIdx = (itemIndex % numberOfItems + numberOfItems) % numberOfItems;

      if (animate) {
        containerElement.addClass(animateCls);
        this.items[prevIdx].addClass(ngAnimateClass);
        this.items[currentIdx].addClass(ngAnimateClass);
      }

      var promises = [$animate.animate(this.items[prevIdx], {}, { opacity: 0 }), $animate.animate(this.items[currentIdx], {}, { opacity: 1 })];

      $q.all(promises).finally(function () {
        containerElement.removeClass(animateCls);
        _this2.items[prevIdx].removeClass(ngAnimateClass);
        _this2.items[currentIdx].removeClass(ngAnimateClass);
      });

      this.currentItemIndex = currentIdx;
    } else {
      this.currentItemIndex = Math.max(0, Math.min(itemIndex, this.items.length - 1));
      setOffset(this.items, -100 * this.currentItemIndex, animate);
    }
  };

  this.prevItem = function () {
    this.showItem(this.currentItemIndex - 1, true);
  };

  this.nextItem = function () {
    this.showItem(this.currentItemIndex + 1, true);
  };

  $attrs.$observe('saCarousel', function (isEnabled) {
    _this3.isEnabled = isEnabled !== String(false);

    if (_this3.isEnabled) {
      _this3.init();
    } else {
      _this3.destroy();
    }
  });
};

saCarouselCtrl.$inject = ['$q', '$animate', '$window', '$scope', '$attrs', '$element', 'preventClick'];
function saCarousel() {
  return {
    restrict: 'A',
    bindToController: true,
    controller: saCarouselCtrl
  };
}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saCarouselContainer;
function saCarouselContainer() {
  return {
    restrict: 'A',
    require: '^saCarousel',
    link: function link($scope, $element, $attrs, saCarousel) {
      saCarousel.setContainer($element);
    }
  };
}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saCarouselControl;
function saCarouselControl() {
  return {
    restrict: 'A',
    require: ['saCarouselControl', '^saCarousel'],
    scope: true,
    controllerAs: 'ctrl',
    controller: [function () {
      this.init = function (saCarousel) {
        this.saCarousel = saCarousel;
        this.items = saCarousel.items;
      };
    }],
    link: function link($scope, $element, $attrs, ctrls) {
      ctrls[0].init(ctrls[1]);
    }
  };
}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saCarouselItem;
saCarouselItem.$inject = ['$timeout'];
function saCarouselItem($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    require: '^saCarousel',
    link: function link($scope, $element, $attrs, saCarousel) {
      $element.addClass('Carousel-item');
      saCarousel.addItem($element);

      $timeout(function () {
        return $element.find('img').attr('draggable', 'false');
      });

      $element.on('$destroy', function () {
        saCarousel.removeItem($element);
      });
    }
  };
}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _contact_form = __webpack_require__(92);

var _contact_form2 = _interopRequireDefault(_contact_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.contactForm', []).directive('saContactForm', _contact_form2.default).name;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _contact_form = __webpack_require__(93);

var _contact_form2 = _interopRequireDefault(_contact_form);

var _contact_form3 = __webpack_require__(94);

var _contact_form4 = _interopRequireDefault(_contact_form3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function f() {
  'ngInject';

  return {
    template: _contact_form2.default,
    replace: true,
    scope: {
      done: '&'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: _contact_form4.default
  };
}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<div class=\"Contact\">\n  <div class=\"Contact-form\" ng-if=\"!ctrl.isMessageSent\">\n    <h2>Contact us</h2>\n    <form name=\"contactForm\" class=\"Form\" ng-submit=\"contactForm.$valid && ctrl.submit()\">\n      <input class=\"Form-field\" name=\"email\" type=\"email\" placeholder=\"Your email\"\n             ng-model=\"ctrl.data.email\" required ng-pattern=\"ctrl.emailPattern\">\n      <div  class=\"Form-validationErrors\" ng-messages=\"contactForm.email.$error\">\n        <p class=\"Form-validationError\" ng-message=\"required\">This field is required</p>\n        <p class=\"Form-validationError\" ng-message=\"pattern\">Invalid email</p>\n      </div>\n\n    <textarea class=\"Form-field\" name=\"content\" placeholder=\"Write you message here...\"\n              ng-model=\"ctrl.data.content\" required></textarea>\n      <div  class=\"Form-validationErrors\" ng-messages=\"contactForm.content.$error\">\n        <p class=\"Form-validationError\" ng-message=\"required\">This field is required</p>\n      </div>\n\n      <div class=\"Contact-button\">\n        <button class=\"Button Button--fullWidth\" type=\"submit\" ng-disabled=\"ctrl.isSaving\" sa-button-loader=\"ctrl.isSaving\">Send</button>\n      </div>\n\n      <div class=\"Contact-contacts\">\n        <p>Alternatively, you can contact us directly:</p>\n        <div class=\"Contact-link\">\n          <sa-support-email class=\"Link--blue Link--semiBold\" email=\"true\"></sa-support-email>\n        </div>\n        <div class=\"Contact-link\"><sa-support-phone-number class=\"Link--semiBold\"></sa-support-phone-number></div>\n      </div>\n    </form>\n  </div>\n\n  <div class=\"Contact-successMessage\" ng-if=\"ctrl.isMessageSent\">\n    <p>Hello!</p>\n    <p>Thank you for contacting us. We will respond to your enquiry within 2 working days.</p>\n    <p>Please be aware that this message is generated from an unmanned mailbox. We cannot respond to any mail to this address.</p>\n    <p>While waiting, you may find that the Showaround website can answer some of your questions.</p>\n\n    <p>We’ll be in touch soon.</p>\n    <p>Cheers,<br>The Showaround Team</p>\n    <br>\n\n    <div class=\"Contact-button\">\n      <button class=\"Button Button--fullWidth\" ng-click=\"ctrl.done()\">Close</button>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var c = function () {
  c.$inject = ['patterns', 'contact'];

  function c(patterns, contact) {
    'ngInject';

    _classCallCheck(this, c);

    this.emailPattern = new RegExp(patterns.email);
    this.contactModel = contact;
  }

  _createClass(c, [{
    key: 'submit',
    value: function submit() {
      var _this = this;

      this.isSaving = true;
      this.contactModel.sendMessage(this.data).then(function () {
        return _this.isMessageSent = true;
      }).finally(function () {
        return delete _this.isSaving;
      });
    }
  }]);

  return c;
}();

exports.default = c;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _fetch_error_message = __webpack_require__(96);

var _fetch_error_message2 = _interopRequireDefault(_fetch_error_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.fetchErrorMessage', []).directive('saFetchErrorMessage', _fetch_error_message2.default).name;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchErrorMessage;

var _fetch_error_message = __webpack_require__(97);

var _fetch_error_message2 = _interopRequireDefault(_fetch_error_message);

var _fetch_error_message3 = __webpack_require__(98);

var _fetch_error_message4 = _interopRequireDefault(_fetch_error_message3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchErrorMessage() {
  return {
    template: _fetch_error_message2.default,
    replace: true,
    scope: {},
    bindToController: true,
    controllerAs: 'ctrl',
    controller: _fetch_error_message4.default
  };
}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<div class=\"NetworkError\">\n  <h1>Oops...Something went wrong.</h1>\n  <p>Check your internet connection and try again.</p>\n\n  <div class=\"NetworkError-button\">\n    <a class=\"Button Button--large\" ng-click=\"ctrl.reloadPage()\">Refresh page</a>\n  </div>\n</div>\n";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FetchErrorMessageCtrl = function () {
  FetchErrorMessageCtrl.$inject = ['$window'];

  function FetchErrorMessageCtrl($window) {
    'ngInject';

    _classCallCheck(this, FetchErrorMessageCtrl);

    this.$window = $window;
  }

  _createClass(FetchErrorMessageCtrl, [{
    key: 'reloadPage',
    value: function reloadPage() {
      this.$window.location.reload();
    }
  }]);

  return FetchErrorMessageCtrl;
}();

exports.default = FetchErrorMessageCtrl;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _how_it_works = __webpack_require__(100);

var _how_it_works2 = _interopRequireDefault(_how_it_works);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = ['$rootScope', '$scope', 'breakpoint', 'slideshow', 'videos', function ($rootScope, $scope, breakpoint, slideshow) {

  this.playVideo = function () {
    this.slideshow.show([{
      vimeoId: 170788909,
      type: 'video'
    }], 0, { isCounterVisible: false });
  };

  this.slideshow = slideshow;

  this.options = this.options || {};
  this.carouselOptions = {
    stack: this.options.stack
  };

  if (!this.options.breakpoints) {
    return;
  }

  var unbind;

  this.checkIfCarouselEnabled = function () {
    this.isCarouselEnabled = this.options.breakpoints.indexOf(breakpoint()) > -1;
  };

  this.checkIfCarouselEnabled();

  unbind = $rootScope.$on('breakpointChanged', this.checkIfCarouselEnabled.bind(this));
  $scope.$on('$destroy', function () {
    unbind();
  });
}];

function f() {
  return {
    template: _how_it_works2.default,
    replace: true,
    scope: {
      options: '<'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<section class=\"HowItWorks\">\n  <h2 ng-click=\"ctrl.playVideo()\"><i class=\"Icon Icon-youtubePlay Icon-howItWorks\"></i><span>How it works</span></h2>\n\n  <div class=\"HowItWorks-steps\" sa-carousel=\"{{ctrl.isCarouselEnabled}}\" sa-carousel-options=\"ctrl.carouselOptions\">\n    <ul sa-carousel-container>\n      <li sa-carousel-item>\n        <div class=\"HowItWorks-step\">\n          <div class=\"HowItWorks-imageWrapper\">\n            <img class=\"HowItWorks-image\"\n                 src=\"" + __webpack_require__(35) + "\"\n                 srcset=\"" + __webpack_require__(35) + " 1x," + __webpack_require__(101) + " 1.5x\" alt=\"\">\n          </div>\n          <div class=\"HowItWorks-stepDetails\">\n            <h3>Find</h3>\n            <p>Browse locals. Find the one you like.</p>\n          </div>\n        </div>\n      </li>\n\n      <li sa-carousel-item>\n        <div class=\"HowItWorks-step\">\n          <div class=\"HowItWorks-imageWrapper\">\n            <img class=\"HowItWorks-image\"\n                 src=\"" + __webpack_require__(36) + "\"\n                 srcset=\"" + __webpack_require__(36) + " 1x," + __webpack_require__(102) + " 1.5x\" alt=\"\">\n          </div>\n          <div class=\"HowItWorks-stepDetails\">\n            <h3>Arrange</h3>\n            <p>Plan & discuss activities before you meet.</p>\n          </div>\n        </div>\n      </li>\n\n      <li sa-carousel-item>\n        <div class=\"HowItWorks-step\">\n          <div class=\"HowItWorks-imageWrapper\">\n            <img class=\"HowItWorks-image\"\n                 src=\"" + __webpack_require__(37) + "\"\n                 srcset=\"" + __webpack_require__(37) + " 1x," + __webpack_require__(103) + " 1.5x\" alt=\"\">\n          </div>\n          <div class=\"HowItWorks-stepDetails\">\n            <h3>Experience</h3>\n            <p>Witness the city through the eyes of a local.</p>\n          </div>\n        </div>\n      </li>\n\n      <div class=\"HowItWorks-bubbles\" sa-carousel-control>\n        <a class=\"HowItWorks-bubble\"\n           ng-repeat=\"item in ctrl.items\"\n           ng-class=\"{ 'is-active': $index === ctrl.saCarousel.currentItemIndex}\"\n           ng-click=\"ctrl.saCarousel.showItem($index, true)\"></a>\n      </div>\n\n      <a class=\"HowItWorks-previous\" sa-carousel-control ng-click=\"ctrl.saCarousel.prevItem()\"><i class=\"Icon Icon-angleLeft\"></i></a>\n      <a class=\"HowItWorks-next\" sa-carousel-control ng-click=\"ctrl.saCarousel.nextItem()\"><i class=\"Icon Icon-angleRight\"></i></a>\n    </ul>\n  </div>\n</section>\n";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/dafd3a83b7185cf19721bad0cf0a5509.png";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/50b058a2cad921bcd09980e71bdee222.png";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/cd64ee33531a53749c192e6eba34ed95.png";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = __webpack_require__(9);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _slideshow = __webpack_require__(14);

var _slideshow2 = _interopRequireDefault(_slideshow);

var _constants = __webpack_require__(5);

var _constants2 = _interopRequireDefault(_constants);

var _services = __webpack_require__(4);

var _services2 = _interopRequireDefault(_services);

var _intro_video = __webpack_require__(298);

var _intro_video2 = _interopRequireDefault(_intro_video);

var _intro_videos = __webpack_require__(301);

var _intro_videos2 = _interopRequireDefault(_intro_videos);

__webpack_require__(304);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_angularUiRouter2.default, _slideshow2.default, _constants2.default, _services2.default];

exports.default = _angular2.default.module('common.introVideos', dependencies).directive('saIntroVideo', _intro_video2.default).directive('saIntroVideos', _intro_videos2.default).name;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _slideshow = __webpack_require__(106);

var _slideshow2 = _interopRequireDefault(_slideshow);

var _slideshow3 = __webpack_require__(107);

var _slideshow4 = _interopRequireDefault(_slideshow3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function f() {
  return {
    template: _slideshow2.default,
    replace: true,
    scope: {
      photos: '=',
      initialPhotoIndex: '=',
      edit: '=',
      isCounterVisible: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: _slideshow4.default
  };
}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<section class=\"Slideshow\">\n  <div class=\"Slideshow-frame\" ng-class=\"{ 'is-rejected': ctrl.currentPhoto.rejected }\">\n\n    <ul class=\"Slideshow-items\">\n      <li class=\"Slideshow-item\" ng-repeat=\"photo in ctrl.photos\" ng-class=\"{ 'is-current': $index === ctrl.currentPhotoIndex }\">\n        <sa-photo ng-if=\"!ctrl.crop && !photo.$isUploading && photo.type !== 'video'\" photo=\"photo\" size=\"slideshow\" dynamic></sa-photo>\n\n        <sa-slideshow-video ng-if=\"photo.type === 'video'\" video=\"photo\" is-active=\"$index === ctrl.currentPhotoIndex\"></sa-slideshow-video>\n\n        <div class=\"Loader Loader--white\" ng-if=\"photo.$isUploading\"></div>\n        <div class=\"Slideshow-rejected\"><i></i><span>Photo rejected</span></div>\n      </li>\n    </ul>\n\n  </div>\n\n  <div ng-if=\"ctrl.crop\">\n    <sa-crop photo=\"ctrl.photos[ctrl.currentPhotoIndex]\" done=\"ctrl.crop = null\"></sa-crop>\n  </div>\n\n  <div class=\"Slideshow-controls\" ng-class=\"{ 'is-disabled': ctrl.areButtonsDisabled }\">\n    <div class=\"Slideshow-counter\" ng-if=\"ctrl.isCounterVisible\">\n      <i class=\"Icon Icon-camera\"></i>\n      {{ctrl.currentPhotoIndex + 1}}/{{ctrl.photos.length}}\n    </div>\n    <a class=\"Slideshow-close\" ng-click=\"ctrl.close()\"></a>\n    <a class=\"Slideshow-close Slideshow-closeAbove\" ng-click=\"ctrl.close()\"><div></div></a>\n    <a class=\"Slideshow-previous\" ng-if=\"ctrl.photos.length > 1\" ng-click=\"ctrl.prevPhoto()\"><i class=\"Icon Icon-angleLeft\"></i></a>\n    <a class=\"Slideshow-next\" ng-if=\"ctrl.photos.length > 1\" ng-click=\"ctrl.nextPhoto()\"><i class=\"Icon Icon-angleRight\"></i></a>\n    <div class=\"Slideshow-toolbar\" ng-if=\"!ctrl.currentPhoto.$isUploading && ctrl.edit\">\n      <a class=\"Slideshow-button Slideshow-button--delete\"\n         ng-click=\"ctrl.delete(ctrl.currentPhoto)\">\n        <i class=\"Icon Icon-trash\"></i>\n      </a>\n\n      <a class=\"Slideshow-button\"\n         ng-click=\"ctrl.crop = true\">\n        <i class=\"Icon Icon-crop\"></i>\n      </a>\n\n      <a class=\"Slideshow-button\"\n         ng-click=\"ctrl.rotate(ctrl.currentPhoto, 90)\">\n        <i class=\"Icon Icon-rotateRight\"></i>\n      </a>\n\n      <a class=\"Slideshow-button\"\n         ng-click=\"ctrl.rotate(ctrl.currentPhoto, -90)\">\n        <i class=\"Icon Icon-rotateLeft\"></i>\n      </a>\n\n      <a class=\"Slideshow-button\"\n         ng-click=\"ctrl.makeMain(ctrl.currentPhoto)\"\n         ng-if=\"!ctrl.currentPhoto.main\">\n        <div class=\"Button Button--white\">Make First</div>\n      </a>\n    </div>\n  </div>\n</section>\n";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$scope', '$window', '$element', '$timeout', 'keyCodes', 'slideshow', 'alert', 'photoModel', 'guideStatus'];
function f($scope, $window, $element, $timeout, keyCodes, slideshow, alert, photoModel, guideStatus) {
  'ngInject';

  var documentEl = angular.element($window.document);

  this.currentPhotoIndex = this.initialPhotoIndex || 0;
  this.currentPhoto = this.photos[this.currentPhotoIndex];
  this.isGuide = guideStatus.isGuide();

  function keyupHandler(event) {
    $scope.$apply(function () {
      switch (event.which) {
        case keyCodes.LEFT:
          $scope.ctrl.prevPhoto();
          break;

        case keyCodes.RIGHT:
          $scope.ctrl.nextPhoto();
          break;

        case keyCodes.ESC:
          !$scope.ctrl.isAlertVisible && $scope.ctrl.close();
          break;
      }
    });
  }

  this.close = function () {
    if (!angular.isNumber(this.crop)) {
      slideshow.hide();
    }
  };

  this.nextPhoto = function () {
    if (this.areButtonsDisabled) {
      return;
    }

    this.currentPhotoIndex = this.currentPhotoIndex + 1 < this.photos.length ? this.currentPhotoIndex + 1 : 0;
    this.currentPhoto = this.photos[this.currentPhotoIndex];
  };

  this.prevPhoto = function () {
    if (this.areButtonsDisabled) {
      return;
    }

    this.currentPhotoIndex = this.currentPhotoIndex - 1 >= 0 ? this.currentPhotoIndex - 1 : this.photos.length - 1;
    this.currentPhoto = this.photos[this.currentPhotoIndex];
  };

  this.makeMain = function (photo) {
    var _this = this;

    if (this.areButtonsDisabled) {
      return;
    }

    this.areButtonsDisabled = true;

    photoModel.makeMain(photo).then(function () {
      _this.photos = photoModel.getValidPhotos();
      _this.currentPhotoIndex = 0;
    }).finally(function () {
      return delete _this.areButtonsDisabled;
    });
  };

  this.rotate = function (photo, angle) {
    var _this2 = this;

    if (this.areButtonsDisabled) {
      return;
    }

    this.areButtonsDisabled = true;
    var newAngle = (photo.angle + angle + 360) % 360;

    photoModel.rotatePhoto(photo, newAngle).finally(function () {
      delete _this2.areButtonsDisabled;
    });
  };

  this.delete = function (photo) {
    var _this3 = this;

    var alertConfig = {
      header: 'ALERTS.DELETE_PHOTO.CONTENT',
      buttons: [{
        label: 'ALERTS.DELETE_PHOTO.BUTTON_ACCEPT',
        action: 'accept',
        cssClass: 'Button--red'
      }, {
        label: 'ALERTS.DELETE_PHOTO.BUTTON_DECLINE',
        action: 'decline',
        cssClass: 'Button--inverted'
      }]
    };

    if (!(this.photos.length > 1 || !this.isGuide)) {
      alert.show({
        header: 'ALERTS.DELETE_LAST_PHOTO.HEADER',
        body: 'ALERTS.DELETE_LAST_PHOTO.CONTENT',
        buttons: [{
          label: 'ALERTS.DELETE_LAST_PHOTO.BUTTON',
          action: 'accept'
        }]
      });
      return;
    }

    if (this.areButtonsDisabled) {
      return;
    }

    this.isAlertVisible = true;
    alert.show(alertConfig, { cssClass: 'Modal--blackBackdrop' }).then(function () {
      _this3.areButtonsDisabled = true;

      return photoModel.deletePhoto(photo);
    }).finally(function () {
      $timeout(function () {
        delete _this3.isAlertVisible;
      });
    }).then(function () {
      delete _this3.areButtonsDisabled;
      _this3.photos.splice(_this3.photos.indexOf(photo), 1);
      if (_this3.photos.length) {
        _this3.prevPhoto();
      } else {
        _this3.close();
      }
    }).catch(function () {
      delete _this3.areButtonsDisabled;
    });
  };

  documentEl.on('keyup', keyupHandler);

  $element.on('$destroy', function () {
    documentEl.off('keyup', keyupHandler);
  });
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saSlideshowVideo;

var _slideshow_video = __webpack_require__(109);

var _slideshow_video2 = _interopRequireDefault(_slideshow_video);

var _slideshow_video3 = __webpack_require__(110);

var _slideshow_video4 = _interopRequireDefault(_slideshow_video3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function saSlideshowVideo() {
  return {
    template: _slideshow_video2.default,
    replace: true,
    scope: {
      video: '=',
      isActive: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: _slideshow_video4.default
  };
}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "<div class=\"Video\" style=\"position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto;\">\n  <iframe ng-src=\"{{::ctrl.getSrc()}}\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n</div>\n";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var videoCategory = 'Video';
var playAction = 'Play';
var oneMinuteProgressAction = 'Video60Sec';

var SlideshowVideoCtrl = function () {
  function SlideshowVideoCtrl($window, $scope, $element, analytics) {
    var _this = this;

    _classCallCheck(this, SlideshowVideoCtrl);

    var iframe = $element.find('iframe').eq(0);
    var handleMessage = this.handleMessage.bind(this);

    this.$scope = $scope;
    this.analytics = analytics;

    this.iframe = iframe;
    this.playerOrigin = '*';

    $window.addEventListener('message', handleMessage, false);
    $element.on('$destroy', function () {
      window.removeEventListener('message', handleMessage, false);
      _this.unbindWatcher && _this.unbindWatcher();
    });
  }

  /**
   * Handles Vimeo player events.
   * More info: https://developer.vimeo.com/player/js-api#methods
   *
   * @param event
   */


  _createClass(SlideshowVideoCtrl, [{
    key: 'handleMessage',
    value: function handleMessage(event) {
      var parsedEvent;

      if (!/^https?:\/\/player.vimeo.com/.test(event.origin)) {
        return;
      }

      if (this.playerOrigin === '*') {
        this.playerOrigin = event.origin;
      }

      if (_typeof(event.data) === 'object') {
        parsedEvent = event.data;
      } else {
        parsedEvent = JSON.parse(event.data);
      }

      switch (parsedEvent.event) {
        case 'ready':
          this.handleReady();
          break;

        case 'play':
          this.handlePlay();
          break;

        case 'playProgress':
          this.handlePlayProgress(parsedEvent.data);
          break;

        default:
          break;
      }
    }

    /**
     * Handles Vimeo player ready event.
     */

  }, {
    key: 'handleReady',
    value: function handleReady() {
      var _this2 = this;

      this.postMessage('addEventListener', 'play');
      this.postMessage('addEventListener', 'playProgress');

      if (this.isActive) {
        this.postMessage('play');
      }

      this.unbindWatcher = this.$scope.$watch('ctrl.isActive', function (isActive) {
        if (!isActive) {
          _this2.postMessage('pause');
        }
      });
    }
  }, {
    key: 'handlePlay',
    value: function handlePlay() {
      if (this._hasSentPlayEvent) {
        return;
      }

      this.sendAnalyticsEvent(playAction);
      this._hasSentPlayEvent = true;
    }
  }, {
    key: 'handlePlayProgress',
    value: function handlePlayProgress(progressData) {
      if (this._hasSentProgressEvent) {
        return;
      }

      if (progressData.seconds < 60) {
        return;
      }

      this.sendAnalyticsEvent(oneMinuteProgressAction);
      this._hasSentProgressEvent = true;
    }
  }, {
    key: 'sendAnalyticsEvent',
    value: function sendAnalyticsEvent(action) {
      this.analytics.track(action, {
        category: videoCategory,
        label: this.video.name + ' ' + this.video.guideId
      });
    }

    /**
     * Calls Vimeo player JS API method.
     * @param methodName {String}
     * @param [value] {String}
     */

  }, {
    key: 'postMessage',
    value: function postMessage(methodName, value) {
      var data = {
        method: methodName
      };

      if (value) {
        data.value = value;
      }

      this.iframe[0].contentWindow.postMessage(data, this.playerOrigin);
    }
  }, {
    key: 'getSrc',
    value: function getSrc() {
      return '//player.vimeo.com/video/' + this.video.vimeoId + '?autoplay=1';
    }
  }]);

  return SlideshowVideoCtrl;
}();

SlideshowVideoCtrl.$inject = ['$window', '$scope', '$element', 'analytics'];

exports.default = SlideshowVideoCtrl;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$window', '$rootScope', '$compile', 'scrollbarWidth', 'bodyScroll'];
function f($window, $rootScope, $compile, scrollbarWidth, bodyScroll) {
  'ngInject';

  var bodyEl = angular.element($window.document.body);
  var wrapperEl = angular.element($window.document.querySelector('.Wrapper'));
  var slideshowEl;
  var slideshow;

  slideshow = {
    show: function show(photos) {
      var _this = this;

      var initialPhotoIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var scrollWidth = scrollbarWidth();
      var scope = $rootScope.$new();

      if (slideshowEl) {
        return;
      }

      scope.photos = photos;
      scope.initialPhotoIndex = initialPhotoIndex;
      scope.edit = options.edit;
      scope.isCounterVisible = options.isCounterVisible !== false;
      slideshowEl = $compile('<slideshow photos="photos" initial-photo-index="initialPhotoIndex" edit="edit" is-counter-visible="isCounterVisible"></slideshow>')(scope);
      wrapperEl.css('padding_right', scrollWidth + 'px');
      bodyEl.css('padding_right', scrollWidth + 'px');
      bodyScroll.disable();
      bodyEl.append(slideshowEl);
      this.isVisible = true;

      this.unbindListener = $rootScope.$on('$stateChangeSuccess', function () {
        _this.hide();
      });
    },

    hide: function hide() {
      if (!slideshowEl) {
        return;
      }

      slideshowEl.remove();
      wrapperEl.css('padding_right', 0);
      bodyEl.css('padding_right', 0);
      bodyScroll.enable();

      slideshowEl = null;
      delete this.isVisible;
      this.unbindListener();
    }
  };

  return slideshow;
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(113);

var activities = ['translation', 'driving', 'shopping', 'nightlife', 'food', 'museums', 'recreation', 'culture', 'sightseeing'].sort();
var selectOptions = activities.map(function (activity) {
  return {
    value: activity,
    translationKey: 'ACTIVITIES.' + activity.toUpperCase()
  };
});
exports.default = {
  options: selectOptions,
  all: selectOptions.reduce(function (activities, activity) {
    activities[activity.value] = activity;

    return activities;
  }, {})
};

/***/ }),
/* 113 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "ACTIVITIES": {
    "TRANSLATION": "Translation & Interpretation",
    "DRIVING": "Pick up & Driving Tours",
    "SHOPPING": "Shopping",
    "NIGHTLIFE": "Nightlife & Bars",
    "FOOD": "Food & Restaurants",
    "MUSEUMS": "Art & Museums",
    "RECREATION": "Sports & Recreation",
    "CULTURE": "History & Culture",
    "SIGHTSEEING": "Exploration & Sightseeing"
  }
}
);  }]);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  translation: 'Icon-translation',
  driving: 'Icon-pickupDriving',
  shopping: 'Icon-shoppingGuide',
  nightlife: 'Icon-nightlifeBars',
  food: 'Icon-foodRestaurants',
  museums: 'Icon-artMuseums',
  recreation: 'Icon-sportsRecreation',
  culture: 'Icon-historyCulture',
  sightseeing: 'Icon-citySightseeing'
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'AD': {
    'name': 'Andorra',
    'placeId': 'ChIJlfCemC71pRIRkn_qeNc-yQc',
    'currency': 'EUR'
  },
  'AE': {
    'name': 'United Arab Emirates',
    'placeId': 'ChIJvRKrsd9IXj4RpwoIwFYv0zM',
    'currency': 'AED'
  },
  'AF': {
    'name': 'Afghanistan',
    'placeId': 'ChIJbQL_-LZu0TgReNqWvg1GtfM',
    'currency': 'USD'
  },
  'AG': {
    'name': 'Antigua and Barbuda',
    'placeId': 'ChIJwdG4bbluDYwRlHmL4Yg3aic',
    'currency': 'USD'
  },
  'AI': {
    'name': 'Anguilla',
    'placeId': 'ChIJ5QHvjnRjDowRgdTghNNqnTs',
    'currency': 'USD'
  },
  'AL': {
    'name': 'Albania',
    'placeId': 'ChIJLUwnvfM7RRMR7juY1onlfAc',
    'currency': 'EUR'
  },
  'AM': {
    'name': 'Armenia',
    'placeId': 'ChIJx7pz54RWFUARIy2C63p1tNA',
    'currency': 'EUR'
  },
  'AO': {
    'name': 'Angola',
    'placeId': 'ChIJJ4utyk7yURoRPU5KDZ0oClk',
    'currency': 'USD'
  },
  'AQ': {
    'name': 'Antarctica',
    'placeId': 'ChIJS3WQM3uWuaQRdSAPdB--Um4',
    'currency': 'USD'
  },
  'AR': {
    'name': 'Argentina',
    'placeId': 'ChIJZ8b99fXKvJURqA_wKpl3Lz0',
    'currency': 'USD'
  },
  'AS': {
    'name': 'American Samoa',
    'placeId': 'ChIJyf1IkreEpnER3UuuLZ5z7vM',
    'currency': 'USD'
  },
  'AT': {
    'name': 'Austria',
    'placeId': 'ChIJfyqdJZsHbUcRr8Hk3XvUEhA',
    'currency': 'EUR'
  },
  'AU': {
    'name': 'Australia',
    'placeId': 'ChIJ38WHZwf9KysRUhNblaFnglM',
    'currency': 'AUD'
  },
  'AW': {
    'name': 'Aruba',
    'placeId': 'ChIJ23da4s84hY4RL4yBiT6KavE',
    'currency': 'USD'
  },
  'AX': {
    'name': 'Aland Islands',
    'placeId': 'ChIJGevhxGjkikYR7Y5Cc4P2Q80',
    'currency': 'EUR'
  },
  'AZ': {
    'name': 'Azerbaijan',
    'placeId': 'ChIJ3x2iGtl8MEARCM2DPmtSyeY',
    'currency': 'EUR'
  },
  'BA': {
    'name': 'Bosnia and Herzegovina',
    'placeId': 'ChIJ16k3xxWiSxMRDOm3QwPi920',
    'currency': 'EUR'
  },
  'BB': {
    'name': 'Barbados',
    'placeId': 'ChIJoxoyrvvxQ4wRKzb0jLNR7A4',
    'currency': 'USD'
  },
  'BD': {
    'name': 'Bangladesh',
    'placeId': 'ChIJp4vhgO2qrTARa_zhxOAoLQ8',
    'currency': 'USD'
  },
  'BE': {
    'name': 'Belgium',
    'placeId': 'ChIJl5fz7WR9wUcR8g_mObTy60c',
    'currency': 'EUR'
  },
  'BF': {
    'name': 'Burkina Faso',
    'placeId': 'ChIJm3Cm1SbKLQ4Rq22DRu0Kkyc',
    'currency': 'USD'
  },
  'BG': {
    'name': 'Bulgaria',
    'placeId': 'ChIJifBbyMH-qEAREEy_aRKgAAA',
    'currency': 'EUR'
  },
  'BH': {
    'name': 'Bahrain',
    'placeId': 'ChIJEaJHak5SSD4RRhDa2-JQlC4',
    'currency': 'USD'
  },
  'BI': {
    'name': 'Burundi',
    'placeId': 'ChIJW_FUNtNEwRkRjewxVg5NI7E',
    'currency': 'USD'
  },
  'BJ': {
    'name': 'Benin',
    'placeId': 'ChIJlVZ6BCtUIxAR9S5iy_h3suw',
    'currency': 'USD'
  },
  'BL': {
    'name': 'St Barthélemy',
    'placeId': 'ChIJnej-KlR1DowR5nUq6msRdAE',
    'currency': 'USD'
  },
  'BM': {
    'name': 'Bermuda',
    'placeId': 'ChIJpbBohp4TLYoRvLiZLMf93zw',
    'currency': 'USD'
  },
  'BN': {
    'name': 'Brunei',
    'placeId': 'ChIJ0bm4BEuZGDIR1toJ3YA1_l0',
    'currency': 'USD'
  },
  'BQ': {
    'name': 'Caribbean Netherlands',
    'placeId': 'ChIJt7kdj4sYIowRz7WDIdc1beE',
    'currency': 'USD'
  },
  'BR': {
    'name': 'Brazil',
    'placeId': 'ChIJzyjM68dZnAARYz4p8gYVWik',
    'currency': 'USD'
  },
  'BS': {
    'name': 'The Bahamas',
    'placeId': 'ChIJPQ9Isjua1ogR5XnHaoO0PhM',
    'currency': 'USD'
  },
  'BT': {
    'name': 'Bhutan',
    'placeId': 'ChIJz5XFc6WSWzcR2rw2KGWsDLs',
    'currency': 'USD'
  },
  'BV': {
    'name': 'Bouvet Island',
    'placeId': 'ChIJP747leE0g7cRS7j-ENe4oLY',
    'currency': 'USD'
  },
  'BW': {
    'name': 'Botswana',
    'placeId': 'ChIJESJF0SFDpB4Re68Vhyp8ZPE',
    'currency': 'USD'
  },
  'BY': {
    'name': 'Belarus',
    'placeId': 'ChIJgUit4oQl2kYREIzsgdGhAAA',
    'currency': 'EUR'
  },
  'BZ': {
    'name': 'Belize',
    'placeId': 'ChIJ-foSwT5bXI8RTuMeP02KSvY',
    'currency': 'USD'
  },
  'CA': {
    'name': 'Canada',
    'placeId': 'ChIJ2WrMN9MDDUsRpY9Doiq3aJk',
    'currency': 'CAD'
  },
  'CF': {
    'name': 'Central African Republic',
    'placeId': 'ChIJt6KGjVPpuBARJIBcWgLGm7g',
    'currency': 'USD'
  },
  'CG': {
    'name': 'Congo',
    'placeId': 'ChIJCROj3WOlYBoRj2z8FM96AVU',
    'currency': 'USD'
  },
  'CH': {
    'name': 'Switzerland',
    'placeId': 'ChIJYW1Zb-9kjEcRFXvLDxG1Vlw',
    'currency': 'CHF'
  },
  'CI': {
    'name': 'Côte d\'Ivoire',
    'placeId': 'ChIJZ6BJsIcTlg8RQO65fGIe-QE',
    'currency': 'USD'
  },
  'CK': {
    'name': 'Cook Islands',
    'placeId': 'ChIJ3d57ue-KVHER2LQIiA6lTAI',
    'currency': 'USD'
  },
  'CL': {
    'name': 'Chile',
    'placeId': 'ChIJL68lBEHFYpYRHbkCERPhBQU',
    'currency': 'USD'
  },
  'CM': {
    'name': 'Cameroon',
    'placeId': 'ChIJIQ8-cFM3YRARU5uCmUXEAys',
    'currency': 'USD'
  },
  'CN': {
    'name': 'China',
    'placeId': 'ChIJwULG5WSOUDERbzafNHyqHZU',
    'currency': 'CNY'
  },
  'CO': {
    'name': 'Colombia',
    'placeId': 'ChIJo5QVrjqkFY4RQKPy7wSaDZo',
    'currency': 'USD'
  },
  'CR': {
    'name': 'Costa Rica',
    'placeId': 'ChIJJcmsIWLlko8RK5qBNSX3VGI',
    'currency': 'USD'
  },
  'CU': {
    'name': 'Cuba',
    'placeId': 'ChIJtUx6DwdJzYgRGqQQkVL3jHk',
    'currency': 'USD'
  },
  'CV': {
    'name': 'Cape Verde',
    'placeId': 'ChIJMVERWSGPNQkRH-oY-TbyGms',
    'currency': 'USD'
  },
  'CW': {
    'name': 'Curaçao',
    'placeId': 'ChIJx_3HYr6dhI4RI0fG2yiSf_w',
    'currency': 'USD'
  },
  'CY': {
    'name': 'Cyprus',
    'placeId': 'ChIJVU1JymcX3hQRbhTEf4A8TDI',
    'currency': 'EUR'
  },
  'CZ': {
    'name': 'Czech Republic',
    'placeId': 'ChIJQ4Ld14-UC0cRb1jb03UcZvg',
    'currency': 'EUR'
  },
  'DE': {
    'name': 'Germany',
    'placeId': 'ChIJa76xwh5ymkcRW-WRjmtd6HU',
    'currency': 'EUR'
  },
  'DJ': {
    'name': 'Djibouti',
    'placeId': 'ChIJAfb5NGfUIhYRiFsP76e7chQ',
    'currency': 'USD'
  },
  'DK': {
    'name': 'Denmark',
    'placeId': 'ChIJ-1-U7rYnS0YRzZLgw9BDh1I',
    'currency': 'DKK'
  },
  'DO': {
    'name': 'Dominican Republic',
    'placeId': 'ChIJ9bbx3jiIr44R4PcNBiQPAqY',
    'currency': 'USD'
  },
  'DZ': {
    'name': 'Algeria',
    'placeId': 'ChIJ0XsDKGqKfg0RovjXq-O-QHE',
    'currency': 'USD'
  },
  'EC': {
    'name': 'Ecuador',
    'placeId': 'ChIJ1UuaqN2HI5ARAjecEQSvdp0',
    'currency': 'USD'
  },
  'EE': {
    'name': 'Estonia',
    'placeId': 'ChIJ_UuggpyUkkYRwyW0T7qf6kA',
    'currency': 'EUR'
  },
  'EG': {
    'name': 'Egypt',
    'placeId': 'ChIJ6TZcw3aJNhQRRMTEJQmgRSw',
    'currency': 'EUR'
  },
  'ER': {
    'name': 'Eritrea',
    'placeId': 'ChIJZYW6nT9abRYR-g4SL_AIwhc',
    'currency': 'USD'
  },
  'ES': {
    'name': 'Spain',
    'placeId': 'ChIJi7xhMnjjQgwR7KNoB5Qs7KY',
    'currency': 'EUR'
  },
  'ET': {
    'name': 'Ethiopia',
    'placeId': 'ChIJK_1s3c7QNRYRWsVIU3-m9ns',
    'currency': 'USD'
  },
  'FI': {
    'name': 'Finland',
    'placeId': 'ChIJ3fYyS9_KgUYREKh1PNZGAQA',
    'currency': 'EUR'
  },
  'FJ': {
    'name': 'Fiji',
    'placeId': 'ChIJXdw8cP2QGW4Rk1vvRpkxnJ4',
    'currency': 'USD'
  },
  'FO': {
    'name': 'Faroe Islands',
    'placeId': 'ChIJ6_ktdpMVvEgRJBv3ZEgxsD8',
    'currency': 'USD'
  },
  'FR': {
    'name': 'France',
    'placeId': 'ChIJMVd4MymgVA0R99lHx5Y__Ws',
    'currency': 'EUR'
  },
  'GA': {
    'name': 'Gabon',
    'placeId': 'ChIJ7fM4VIo7fxARFWt4Ng7DDHs',
    'currency': 'USD'
  },
  'GB': {
    'name': 'United Kingdom',
    'placeId': 'ChIJqZHHQhE7WgIReiWIMkOg-MQ',
    'currency': 'GBP'
  },
  'GD': {
    'name': 'Grenada',
    'placeId': 'ChIJ0XuH9IkXOIwRjk8fWgHH2DY',
    'currency': 'USD'
  },
  'GE': {
    'name': 'Georgia',
    'placeId': 'ChIJa2JP5tcMREARwkotEmR5kE8',
    'currency': 'USD'
  },
  'GF': {
    'name': 'French Guiana',
    'placeId': 'ChIJU9f3hVcVEo0RRvQKD-n3J94',
    'currency': 'USD'
  },
  'GG': {
    'name': 'Guernsey',
    'placeId': 'ChIJ7bO_9OQgDUgRmZgNXYrVCpk',
    'currency': 'USD'
  },
  'GH': {
    'name': 'Ghana',
    'placeId': 'ChIJx9baqM1a1w8RNtKT0DDy11Q',
    'currency': 'USD'
  },
  'GI': {
    'name': 'Gibraltar',
    'placeId': 'ChIJNb4UJ3a_DA0RD4cANiYlTjg',
    'currency': 'EUR'
  },
  'GL': {
    'name': 'Greenland',
    'placeId': 'ChIJFXfA47sNok4RGOIUAYOdzzQ',
    'currency': 'USD'
  },
  'GM': {
    'name': 'The Gambia',
    'placeId': 'ChIJBzivZSmcwg4RKp0Ta0BMSp4',
    'currency': 'USD'
  },
  'GN': {
    'name': 'Guinea',
    'placeId': 'ChIJP5XOvCGzAQ8R9i1a18t7c-g',
    'currency': 'USD'
  },
  'GP': {
    'name': 'Guadeloupe',
    'placeId': 'ChIJUX0od1p1DowRqwdKtzc-vuw',
    'currency': 'USD'
  },
  'GQ': {
    'name': 'Equatorial Guinea',
    'placeId': 'ChIJp4euX2A6ZBARet4QLKKicMg',
    'currency': 'USD'
  },
  'GR': {
    'name': 'Greece',
    'placeId': 'ChIJY2xxEcdKWxMRHS2a3HUXOjY',
    'currency': 'EUR'
  },
  'GS': {
    'name': 'South Georgia and the South Sandwich Islands',
    'placeId': 'ChIJJXmoUuK2PbkRvbBNiNp8434',
    'currency': 'USD'
  },
  'GT': {
    'name': 'Guatemala',
    'placeId': 'ChIJa1DnNlATiIURu9WEWzcrmDU',
    'currency': 'USD'
  },
  'GU': {
    'name': 'Guam',
    'placeId': 'ChIJ7yQPk_92H2cRpuWzxZGucVU',
    'currency': 'USD'
  },
  'GW': {
    'name': 'Guinea-Bissau',
    'placeId': 'ChIJ8amCr3Q85A4RTggeVz-O6Ls',
    'currency': 'USD'
  },
  'GY': {
    'name': 'Guyana',
    'placeId': 'ChIJs8LYYK_vr40RQETltmeI40g',
    'currency': 'USD'
  },
  'HK': {
    'name': 'Hong Kong',
    'placeId': 'ChIJD5gyo-3iAzQRfMnq27qzivA',
    'currency': 'HKD'
  },
  'HN': {
    'name': 'Honduras',
    'placeId': 'ChIJzzG3cxp1ao8RZIL7toLe0X4',
    'currency': 'USD'
  },
  'HR': {
    'name': 'Croatia',
    'placeId': 'ChIJ7ZXdCghBNBMRfxtm4STA86A',
    'currency': 'EUR'
  },
  'HT': {
    'name': 'Haiti',
    'placeId': 'ChIJEbvLf_PGto4R0_ZUTLI4FLU',
    'currency': 'USD'
  },
  'HU': {
    'name': 'Hungary',
    'placeId': 'ChIJw-Q333uDQUcREBAeDCnEAAA',
    'currency': 'EUR'
  },
  'ID': {
    'name': 'Indonesia',
    'placeId': 'ChIJtwRkSdcHTCwRhfStG-dNe-M',
    'currency': 'IDR'
  },
  'IE': {
    'name': 'Ireland',
    'placeId': 'ChIJ-ydAXOS6WUgRCPTbzjQSfM8',
    'currency': 'EUR'
  },
  'IL': {
    'name': 'Israel',
    'placeId': 'ChIJi8mnMiRJABURuiw1EyBCa2o',
    'currency': 'ILS'
  },
  'IM': {
    'name': 'Isle of Man',
    'placeId': 'ChIJ1YEuRDCFY0gRDeDw8bxbAuo',
    'currency': 'USD'
  },
  'IN': {
    'name': 'India',
    'placeId': 'ChIJkbeSa_BfYzARphNChaFPjNc',
    'currency': 'INR'
  },
  'IO': {
    'name': 'British Indian Ocean Territory',
    'placeId': 'ChIJh6OdhOBzkiQR4WsfEHBkT6k',
    'currency': 'USD'
  },
  'IQ': {
    'name': 'Iraq',
    'placeId': 'ChIJEUr1VD2CVxURAhYGorthpW0',
    'currency': 'USD'
  },
  'IS': {
    'name': 'Iceland',
    'placeId': 'ChIJQ2Dro1Ir0kgRmkXB5TQEim8',
    'currency': 'EUR'
  },
  'IT': {
    'name': 'Italy',
    'placeId': 'ChIJA9KNRIL-1BIRb15jJFz1LOI',
    'currency': 'EUR'
  },
  'JE': {
    'name': 'Jersey',
    'placeId': 'ChIJM3WSjKRSDEgRw2waCqMjnFE',
    'currency': 'USD'
  },
  'JM': {
    'name': 'Jamaica',
    'placeId': 'ChIJnXHPxhsq2o4R-g4StcDRoFk',
    'currency': 'USD'
  },
  'JO': {
    'name': 'Jordan',
    'placeId': 'ChIJmd5kZkdvABURmU4mUQdbKI0',
    'currency': 'USD'
  },
  'JP': {
    'name': 'Japan',
    'placeId': 'ChIJLxl_1w9OZzQRRFJmfNR1QvU',
    'currency': 'JPY'
  },
  'KE': {
    'name': 'Kenya',
    'placeId': 'ChIJD5BQg9CAJxgR2W2XobAOO0A',
    'currency': 'USD'
  },
  'KG': {
    'name': 'Kyrgyzstan',
    'placeId': 'ChIJ8yfp_B04lzgRM8SITrdYECg',
    'currency': 'USD'
  },
  'KH': {
    'name': 'Cambodia',
    'placeId': 'ChIJQzfc1L-HBzERUxL0ieC_t-Q',
    'currency': 'USD'
  },
  'KI': {
    'name': 'Kiribati',
    'placeId': 'ChIJA4cCwpF8ZGURB8NSAQR9MoQ',
    'currency': 'USD'
  },
  'KM': {
    'name': 'Comoros',
    'placeId': 'ChIJjaQIZAPjmBgR29Tf5L5_Cvc',
    'currency': 'USD'
  },
  'KN': {
    'name': 'St Kitts and Nevis',
    'placeId': 'ChIJDXKKxm4ZEowR6IYdmsaa6d4',
    'currency': 'USD'
  },
  'KW': {
    'name': 'Kuwait',
    'placeId': 'ChIJoVHqvj82xT8R0u3Yks1rcnQ',
    'currency': 'USD'
  },
  'KY': {
    'name': 'Cayman Islands',
    'placeId': 'ChIJKaq4Lz6GJY8RXnFwh9PERXA',
    'currency': 'USD'
  },
  'KZ': {
    'name': 'Kazakhstan',
    'placeId': 'ChIJR6n87AcQqTgRGw6z5C-Ee18',
    'currency': 'USD'
  },
  'LA': {
    'name': 'Laos',
    'placeId': 'ChIJiUWCsFeQFDERgc2ZH0iSxQ4',
    'currency': 'USD'
  },
  'LB': {
    'name': 'Lebanon',
    'placeId': 'ChIJraoihAIXHxURcPkAbAk0fcw',
    'currency': 'USD'
  },
  'LC': {
    'name': 'St Lucia',
    'placeId': 'ChIJHaMt8WVgQIwR9Z056MSGdG4',
    'currency': 'USD'
  },
  'LI': {
    'name': 'Liechtenstein',
    'placeId': 'ChIJ_S9HHUQxm0cRibFa3Ta16mA',
    'currency': 'CHF'
  },
  'LK': {
    'name': 'Sri Lanka',
    'placeId': 'ChIJnR5a9jxZ4joRjNPiALSkPeE',
    'currency': 'USD'
  },
  'LR': {
    'name': 'Liberia',
    'placeId': 'ChIJwfyp1AP4CQ8Rc2PRMmso038',
    'currency': 'USD'
  },
  'LS': {
    'name': 'Lesotho',
    'placeId': 'ChIJ64xf1idIjB4Rsx7ReLhXLSM',
    'currency': 'USD'
  },
  'LT': {
    'name': 'Lithuania',
    'placeId': 'ChIJE74zDxSU3UYRubpdpdNUCvM',
    'currency': 'EUR'
  },
  'LU': {
    'name': 'Luxembourg',
    'placeId': 'ChIJRyEhyrlFlUcR75LTAvZg22Q',
    'currency': 'EUR'
  },
  'LV': {
    'name': 'Latvia',
    'placeId': 'ChIJ_ZqKe2cw6UYREPzyaM3PAAA',
    'currency': 'EUR'
  },
  'LY': {
    'name': 'Libya',
    'placeId': 'ChIJDQHOjtmSqBMRKsL5x0FgB_o',
    'currency': 'USD'
  },
  'MA': {
    'name': 'Morocco',
    'placeId': 'ChIJjcVRlmGICw0Rw_8sxIGT09k',
    'currency': 'USD'
  },
  'MC': {
    'name': 'Monaco',
    'placeId': 'ChIJMYU_e2_CzRIR_JzEOkx493Q',
    'currency': 'EUR'
  },
  'ME': {
    'name': 'Montenegro',
    'placeId': 'ChIJyx8sJBcyTBMRRtP_boadTDg',
    'currency': 'EUR'
  },
  'MG': {
    'name': 'Madagascar',
    'placeId': 'ChIJRYUj6uOk0SERiBN7l8HjRFI',
    'currency': 'USD'
  },
  'MH': {
    'name': 'Marshall Islands',
    'placeId': 'ChIJK8opIbIZAWURdrcJqugDPos',
    'currency': 'USD'
  },
  'ML': {
    'name': 'Mali',
    'placeId': 'ChIJz3MQG4g-FA4RgM-9oOJbOrs',
    'currency': 'USD'
  },
  'MM': {
    'name': 'Republic of the Union of Myanmar',
    'placeId': 'ChIJBylOcadSVjAREStiHOQOe7o',
    'currency': 'USD'
  },
  'MN': {
    'name': 'Mongolia',
    'placeId': 'ChIJS22qaQYFJzYRluDmNzkh3eA',
    'currency': 'USD'
  },
  'MO': {
    'name': 'Macau',
    'placeId': 'ChIJ88g14uB6ATQR9qyFtCzje8Y',
    'currency': 'USD'
  },
  'MP': {
    'name': 'Northern Mariana Islands',
    'placeId': 'ChIJUVyZkDSx2GYRMg46fKvrt50',
    'currency': 'USD'
  },
  'MQ': {
    'name': 'Martinique',
    'placeId': 'ChIJDQdmAPmgaowRsOevFxIbAOE',
    'currency': 'USD'
  },
  'MR': {
    'name': 'Mauritania',
    'placeId': 'ChIJTzmzFMO4gA4RTlO-1usLIoM',
    'currency': 'USD'
  },
  'MS': {
    'name': 'Montserrat',
    'placeId': 'ChIJnTbH4VOrE4wRorEFiIPqDx4',
    'currency': 'USD'
  },
  'MT': {
    'name': 'Malta',
    'placeId': 'ChIJxUeGHShFDhMROUK-NmHYgvU',
    'currency': 'EUR'
  },
  'MU': {
    'name': 'Mauritius',
    'placeId': 'ChIJyXRE-U1QfCERMdBrEcLZA0I',
    'currency': 'USD'
  },
  'MV': {
    'name': 'Maldives',
    'placeId': 'ChIJvXv7qr-ZtSQRiWKVgeEJRUE',
    'currency': 'USD'
  },
  'MW': {
    'name': 'Malawi',
    'placeId': 'ChIJ18ATk91b2BgRQ4VmKRcuo0Q',
    'currency': 'USD'
  },
  'MX': {
    'name': 'Mexico',
    'placeId': 'ChIJU1NoiDs6BIQREZgJa760ZO0',
    'currency': 'MXN'
  },
  'MY': {
    'name': 'Malaysia',
    'placeId': 'ChIJrzBnX5fTNDAR2BwhKJOWRQc',
    'currency': 'USD'
  },
  'MZ': {
    'name': 'Mozambique',
    'placeId': 'ChIJxUr95uqs1BgRFaEWrrm_uxI',
    'currency': 'USD'
  },
  'NA': {
    'name': 'Namibia',
    'placeId': 'ChIJIXXTbn489RsRYbLsqKXludM',
    'currency': 'USD'
  },
  'NC': {
    'name': 'New Caledonia',
    'placeId': 'ChIJyzIaP2niJ2wR7HqT1Y_20PY',
    'currency': 'USD'
  },
  'NG': {
    'name': 'Nigeria',
    'placeId': 'ChIJDY2kfa8LThARyAvFaEH-qJk',
    'currency': 'USD'
  },
  'NF': {
    'name': 'Norfolk Island',
    'placeId': 'ChIJOcm6rR_RS2wRUhVdMyOYerk',
    'currency': 'USD'
  },
  'NI': {
    'name': 'Nicaragua',
    'placeId': 'ChIJzSL_zgDCEI8RtRWsP-Wn-sg',
    'currency': 'USD'
  },
  'NL': {
    'name': 'Netherlands',
    'placeId': 'ChIJu-SH28MJxkcRnwq9_851obM',
    'currency': 'USD'
  },
  'NO': {
    'name': 'Norway',
    'placeId': 'ChIJv-VNj0VoEkYRK9BkuJ07sKE',
    'currency': 'NOK'
  },
  'NP': {
    'name': 'Nepal',
    'placeId': 'ChIJz2gufcfolTkR3obM0LyaojQ',
    'currency': 'USD'
  },
  'NR': {
    'name': 'Nauru',
    'placeId': 'ChIJTVvkHR8cfW8RgQrUxfSd2Vk',
    'currency': 'USD'
  },
  'NU': {
    'name': 'Niue',
    'placeId': 'ChIJO7duNyolnXERGIvcezR4QpE',
    'currency': 'USD'
  },
  'NZ': {
    'name': 'New Zealand',
    'placeId': 'ChIJh5Z3Fw4gLG0RM0dqdeIY1rE',
    'currency': 'NZD'
  },
  'OM': {
    'name': 'Oman',
    'placeId': 'ChIJv5vVqWaf1j0RF6ixZXZMBjo',
    'currency': 'USD'
  },
  'PA': {
    'name': 'Panama',
    'placeId': 'ChIJ4yu-yIMVpo8Rz5ulH03g7nk',
    'currency': 'USD'
  },
  'PE': {
    'name': 'Peru',
    'placeId': 'ChIJ9RRZwFDIBZERSAYheRIBnvI',
    'currency': 'USD'
  },
  'PF': {
    'name': 'French Polynesia',
    'placeId': 'ChIJTddtfNB1GHQREVfDCXp6wJs',
    'currency': 'USD'
  },
  'PG': {
    'name': 'Papua New Guinea',
    'placeId': 'ChIJr54Ov6_oWWgRehKcjg3l8No',
    'currency': 'USD'
  },
  'PH': {
    'name': 'Philippines',
    'placeId': 'ChIJY96HXyFTQDIRV9opeu-QR3g',
    'currency': 'USD'
  },
  'PK': {
    'name': 'Pakistan',
    'placeId': 'ChIJH3X9-NJS2zgRXJIU5veht0Y',
    'currency': 'USD'
  },
  'PL': {
    'name': 'Poland',
    'placeId': 'ChIJuwtkpGSZAEcR6lXMScpzdQk',
    'currency': 'EUR'
  },
  'PM': {
    'name': 'St Pierre and Miquelon',
    'placeId': 'ChIJ0VcO-0tLbEsREVxs6jdncZw',
    'currency': 'USD'
  },
  'PN': {
    'name': 'Pitcairn Islands',
    'placeId': 'ChIJiweo3H8POJ4RyJoVGceMnEY',
    'currency': 'USD'
  },
  'PR': {
    'name': 'Puerto Rico',
    'placeId': 'ChIJ-aeSGyaWAowRGpsEGCjsNvM',
    'currency': 'USD'
  },
  'PT': {
    'name': 'Portugal',
    'placeId': 'ChIJ1SZCvy0kMgsRQfBOHAlLuCo',
    'currency': 'EUR'
  },
  'PW': {
    'name': 'Palau',
    'placeId': 'ChIJmQOvorRFhDIRu-uhOd0e7RI',
    'currency': 'USD'
  },
  'PY': {
    'name': 'Paraguay',
    'placeId': 'ChIJYz3xkDQIXJQR8y5YHWH_-rM',
    'currency': 'USD'
  },
  'QA': {
    'name': 'Qatar',
    'placeId': 'ChIJf-jc_zTFRT4RMkArgc-I-hw',
    'currency': 'USD'
  },
  'RE': {
    'name': 'Reunion',
    'placeId': 'ChIJO-S4EIF3eCER-erb7ImOf0o',
    'currency': 'USD'
  },
  'RO': {
    'name': 'Romania',
    'placeId': 'ChIJw3aJlSb_sUARlLEEqJJP74Q',
    'currency': 'EUR'
  },
  'RS': {
    'name': 'Serbia',
    'placeId': 'ChIJlYCJ8t8dV0cRXYYjN-pQXgU',
    'currency': 'EUR'
  },
  'RU': {
    'name': 'Russia',
    'placeId': 'ChIJ-yRniZpWPEURE_YRZvj9CRQ',
    'currency': 'RUB'
  },
  'RW': {
    'name': 'Rwanda',
    'placeId': 'ChIJ40A451SWwhkRA6HMyyawkHQ',
    'currency': 'USD'
  },
  'SA': {
    'name': 'Saudi Arabia',
    'placeId': 'ChIJQSqV5z-z5xURm7YawktQYFk',
    'currency': 'SAR'
  },
  'SB': {
    'name': 'Solomon Islands',
    'placeId': 'ChIJ0QlQVeBR02gRgClEF6DATLQ',
    'currency': 'USD'
  },
  'SC': {
    'name': 'Seychelles',
    'placeId': 'ChIJO62-cP0hXCIR99pJ06DQ0zI',
    'currency': 'USD'
  },
  'SD': {
    'name': 'Sudan',
    'placeId': 'ChIJlbFyEMQc2RURNythKkZwv9I',
    'currency': 'USD'
  },
  'SE': {
    'name': 'Sweden',
    'placeId': 'ChIJ8fA1bTmyXEYRYm-tjaLruCI',
    'currency': 'SEK'
  },
  'SG': {
    'name': 'Singapore',
    'placeId': 'ChIJdZOLiiMR2jERxPWrUs9peIg',
    'currency': 'USD'
  },
  'SI': {
    'name': 'Slovenia',
    'placeId': 'ChIJYYOWXuckZUcRZdTiJR5FQOc',
    'currency': 'EUR'
  },
  'SJ': {
    'name': 'Svalbard and Jan Mayen',
    'placeId': 'ChIJgQmY0JVjd0URQdKkzJ42A4U',
    'currency': 'USD'
  },
  'SK': {
    'name': 'Slovakia',
    'placeId': 'ChIJf8Z8rrlgFEcRfTpysWdha80',
    'currency': 'EUR'
  },
  'SL': {
    'name': 'Sierra Leone',
    'placeId': 'ChIJQ_OrOhgGAQ8RGfcsx83paVM',
    'currency': 'USD'
  },
  'SM': {
    'name': 'San Marino',
    'placeId': 'ChIJeT_m9V_rLBMRECA0gpnzAAA',
    'currency': 'EUR'
  },
  'SN': {
    'name': 'Senegal',
    'placeId': 'ChIJcbvFs_VywQ4RQFlhmVClRlo',
    'currency': 'USD'
  },
  'SO': {
    'name': 'Somalia',
    'placeId': 'ChIJg1vR7KcuHRgRvuXpXM46OZ4',
    'currency': 'USD'
  },
  'SR': {
    'name': 'Suriname',
    'placeId': 'ChIJUdXT2dU2CI0RsjYpccDhNxA',
    'currency': 'USD'
  },
  'SS': {
    'name': 'South Sudan',
    'placeId': 'ChIJGTE-PbUwGRcRl7y2fmND8Ns',
    'currency': 'USD'
  },
  'ST': {
    'name': 'São Tomé and Príncipe',
    'placeId': 'ChIJidiaC_nscBAR6jB2VQwjUWI',
    'currency': 'USD'
  },
  'SV': {
    'name': 'El Salvador',
    'placeId': 'ChIJVwZkWaYnY48RMkiFmOsWmm8',
    'currency': 'USD'
  },
  'SY': {
    'name': 'Syria',
    'placeId': 'ChIJp8Y8QdzmGBURIPYqiPRGdYc',
    'currency': 'USD'
  },
  'SZ': {
    'name': 'Swaziland',
    'placeId': 'ChIJBw8yR-HO6B4RaXANGC_GPcE',
    'currency': 'USD'
  },
  'TC': {
    'name': 'Turks and Caicos Islands',
    'placeId': 'ChIJdWu7vlVfS4kR3sGNAoDHEX4',
    'currency': 'USD'
  },
  'TD': {
    'name': 'Chad',
    'placeId': 'ChIJYXNnvXg55xARnIDAzluDYDs',
    'currency': 'USD'
  },
  'TF': {
    'name': 'French Southern and Antarctic Lands',
    'placeId': 'ChIJN8QJBD7EFLMRKdDmkEwhirg',
    'currency': 'USD'
  },
  'TG': {
    'name': 'Togo',
    'placeId': 'ChIJGVQYE8HhIxARYJPRGjBbrvo',
    'currency': 'USD'
  },
  'TH': {
    'name': 'Thailand',
    'placeId': 'ChIJsU1CR_eNTTARAuhXB4gs154',
    'currency': 'USD'
  },
  'TJ': {
    'name': 'Tajikistan',
    'placeId': 'ChIJzbO8enN2sTgRtYgZT4QxwyU',
    'currency': 'USD'
  },
  'TK': {
    'name': 'Tokelau',
    'placeId': 'ChIJ9x14s6omUnARN5vbbUZicI8',
    'currency': 'USD'
  },
  'TL': {
    'name': 'Timor-Leste',
    'placeId': 'ChIJKaHkhgnl_SwRPFvoh4PG5QM',
    'currency': 'USD'
  },
  'TM': {
    'name': 'Turkmenistan',
    'placeId': 'ChIJy2y8dFXLZT8RkaRpQWuC3X4',
    'currency': 'USD'
  },
  'TN': {
    'name': 'Tunisia',
    'placeId': 'ChIJ4aQWg0SVVRIR75sBqjozhDo',
    'currency': 'USD'
  },
  'TO': {
    'name': 'Tonga',
    'placeId': 'ChIJHdCfu0S2k3ERqeJexcrMbfM',
    'currency': 'USD'
  },
  'TR': {
    'name': 'Turkey',
    'placeId': 'ChIJcSZPllwVsBQRKl9iKtTb2UA',
    'currency': 'TRY'
  },
  'TT': {
    'name': 'Trinidad and Tobago',
    'placeId': 'ChIJxbZQY5cHNowRJ_E5xlUoCP8',
    'currency': 'USD'
  },
  'TV': {
    'name': 'Tuvalu',
    'placeId': 'ChIJTaCxWbmcwW8RLhIHB2hUZ48',
    'currency': 'USD'
  },
  'UA': {
    'name': 'Ukraine',
    'placeId': 'ChIJjw5wVMHZ0UAREED2iIQGAQA',
    'currency': 'EUR'
  },
  'UG': {
    'name': 'Uganda',
    'placeId': 'ChIJRfmZZJ-mcRcRSUUBQ85VQYc',
    'currency': 'USD'
  },
  'UM': {
    'name': 'United States Minor Outlying Islands',
    'placeId': 'ChIJBQ-2twOlemQREDZxw68t4QQ',
    'currency': 'USD'
  },
  'US': {
    'name': 'United States',
    'placeId': 'ChIJCzYy5IS16lQRQrfeQ5K5Oxw',
    'currency': 'USD'
  },
  'UY': {
    'name': 'Uruguay',
    'placeId': 'ChIJCd5f-zoHdZURSlIWYGGWVUo',
    'currency': 'USD'
  },
  'UZ': {
    'name': 'Uzbekistan',
    'placeId': 'ChIJsXbWpSCLrjgRIB6Efq1tCso',
    'currency': 'USD'
  },
  'VA': {
    'name': 'Vatican City',
    'placeId': 'ChIJPS3UVwqJJRMRsH46sppPCQA',
    'currency': 'EUR'
  },
  'VC': {
    'name': 'St Vincent and the Grenadines',
    'placeId': 'ChIJuzU5nuKsQIwRsaHSjejT_TE',
    'currency': 'USD'
  },
  'VN': {
    'name': 'Vietnam',
    'placeId': 'ChIJXx5qc016FTERvmL-4smwO7A',
    'currency': 'USD'
  },
  'VU': {
    'name': 'Vanuatu',
    'placeId': 'ChIJE2CSyF5giW4RaibQvs85gzQ',
    'currency': 'USD'
  },
  'WF': {
    'name': 'Wallis and Futuna',
    'placeId': 'ChIJPUsabgaxyHERGwrSj-wYyRY',
    'currency': 'USD'
  },
  'WS': {
    'name': 'Samoa',
    'placeId': 'ChIJAxDsZKMTpXERcnhhdJYMh6Y',
    'currency': 'USD'
  },
  'YE': {
    'name': 'Yemen',
    'placeId': 'ChIJX7w0fKzbAxYRrneufjcp8ZI',
    'currency': 'USD'
  },
  'YT': {
    'name': 'Mayotte',
    'placeId': 'ChIJu43y3DMOCiIRSyr-lWcXMv8',
    'currency': 'USD'
  },
  'ZA': {
    'name': 'South Africa',
    'placeId': 'ChIJURLu2YmmNBwRoOikHwxjXeg',
    'currency': 'ZAR'
  },
  'ZM': {
    'name': 'Zambia',
    'placeId': 'ChIJcQv8_KX0QBkRRT5Yfqz5n_E',
    'currency': 'USD'
  },
  'ZW': {
    'name': 'Zimbabwe',
    'placeId': 'ChIJYXGxBuekMRkR7r_LxV84wKE',
    'currency': 'USD'
  },
  'CD': {
    'name': 'Democratic Republic of the Congo',
    'placeId': 'ChIJvUZ1ms_6eRkRQfGTrF4-xgQ',
    'currency': 'USD'
  },
  'DM': {
    'name': 'Dominica',
    'placeId': 'ChIJFVoV8vrSFIwRPP06BQmRs0k',
    'currency': 'USD'
  },
  'NE': {
    'name': 'Niger',
    'placeId': 'ChIJXa-hxnrsmRER1CSOFQqSM8k',
    'currency': 'USD'
  },
  'VI': {
    'name': 'US Virgin Islands',
    'placeId': 'ChIJuaza8mUQBYwRBRzFGx2JHfk',
    'currency': 'USD'
  },
  'BO': {
    'name': 'Bolivia',
    'placeId': 'ChIJlaK7d4nfXpERv-0VAbvCnhw',
    'currency': 'USD'
  },
  'FK': {
    'name': 'Falkland Islands (Islas Malvinas)',
    'placeId': 'ChIJo-ORRLmJKrwROsXZjf-qKjI',
    'currency': 'USD'
  },
  'FM': {
    'name': 'Micronesia',
    'placeId': 'ChIJE8hYrMW12WURJWWk-s2NelQ',
    'currency': 'USD'
  },
  'IR': {
    'name': 'Iran',
    'placeId': 'ChIJ8R1rwS7s9z4RzvpRntOVsEA',
    'currency': 'USD'
  },
  'KP': {
    'name': 'North Korea',
    'placeId': 'ChIJN0NP5toCfjURHIYdPhyHCzo',
    'currency': 'USD'
  },
  'MF': {
    'name': 'St Martin',
    'placeId': 'ChIJ_U5xCKxvDowRp4huTgqDGbk',
    'currency': 'USD'
  },
  'MK': {
    'name': 'Macedonia (FYROM)',
    'placeId': 'ChIJCUi8cJ8VVBMRscUfyNZa8uA',
    'currency': 'EUR'
  },
  'SX': {
    'name': 'Sint Maarten',
    'placeId': 'ChIJw5D41mJuDowRQo8zJsIsi3I',
    'currency': 'USD'
  },
  'TW': {
    'name': 'Taiwan',
    'placeId': 'ChIJL1cHXAbzbjQRaVScvwTwEec',
    'currency': 'USD'
  },
  'TZ': {
    'name': 'Tanzania',
    'placeId': 'ChIJEaFpSDFRSxgRMMTBSzEXWog',
    'currency': 'USD'
  },
  'VE': {
    'name': 'Venezuela',
    'placeId': 'ChIJAdjLNstTKIwR003VfFjyoNw',
    'currency': 'USD'
  },
  'VG': {
    'name': 'British Virgin Islands',
    'placeId': 'ChIJzVNkK5xzBYwRPTvsse5woG0',
    'currency': 'USD'
  },
  'KR': {
    'name': 'South Korea',
    'placeId': 'ChIJm7oRy-tVZDURS9uIugCbJJE',
    'currency': 'USD'
  },
  'MD': {
    'name': 'Moldova',
    'placeId': 'ChIJoWm3KDZ8yUARy6xT36wZgSU',
    'currency': 'EUR'
  },
  'PS': {
    'name': 'Palestine',
    'placeId': 'ChIJ2b1miNLyHBURhvZm0QGgF-4',
    'currency': 'ILS'
  },
  'XK': {
    'name': 'Kosovo',
    'placeId': 'ChIJ8X2_VPN6UxMRkRfDq9_u_78',
    'currency': 'EUR'
  }
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(118);

var searchLanguages = ['english', 'spanish', 'german', 'french', 'italian', 'chinese'];

var popularLanguages = ['arabic', 'chinese', 'english', 'french', 'german', 'italian', 'japanese', 'portuguese', 'russian', 'spanish'];
var languages = ['arabic', 'danish', 'german', 'belorussian', 'dutch', 'greek', 'japanese', 'portuguese', 'italian', 'polish', 'spanish', 'swedish', 'bulgarian', 'english', 'hebrew', 'korean', 'romanian', 'thai', 'catalan', 'estonian', 'hindi', 'latvian', 'russian', 'turkish', 'chinese', 'filipino', 'hungarian', 'lithuanian', 'serbian', 'ukrainian', 'croatian', 'finnish', 'icelandic', 'norwegian', 'slovak', 'urdu', 'czech', 'french', 'indonesian', 'persian', 'slovenian', 'vietnamese', 'nepali', 'armenian', 'kurdish', 'bengali', 'georgian', 'afrikaans', 'luxembourgish', 'punjabi', 'sign', 'azerbaijani', 'basque', 'bosnian'].sort();
var languageObject = languages.reduce(function (languages, language) {
  languages[language] = {
    value: language,
    translationKey: 'LANGUAGES.' + language.toUpperCase(),
    popular: popularLanguages.indexOf(language) !== -1
  };
  return languages;
}, {});

var searchLanguageObject = languages.reduce(function (searchLanguages, language) {
  searchLanguages[language] = {
    value: language,
    translationKey: 'LANGUAGES.' + language.toUpperCase()
  };
  return searchLanguages;
}, {});

exports.default = {
  options: languages.map(function (language) {
    return languageObject[language];
  }),
  all: languageObject,
  search: searchLanguages.map(function (language) {
    return searchLanguageObject[language];
  })
};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
 "LANGUAGES": {
  "ARABIC": "Arabic",
  "AZERBAIJANI": "Azerbaijani",
  "DANISH": "Danish",
  "GERMAN": "German",
  "BELORUSSIAN": "Belorussian",
  "DUTCH": "Dutch",
  "GREEK": "Greek",
  "JAPANESE": "Japanese",
  "PORTUGUESE": "Portuguese",
  "ITALIAN": "Italian",
  "POLISH": "Polish",
  "SPANISH": "Spanish",
  "SWEDISH": "Swedish",
  "BULGARIAN": "Bulgarian",
  "ENGLISH": "English",
  "HEBREW": "Hebrew",
  "KOREAN": "Korean",
  "ROMANIAN": "Romanian",
  "THAI": "Thai",
  "CATALAN": "Catalan",
  "ESTONIAN": "Estonian",
  "HINDI": "Hindi",
  "LATVIAN": "Latvian",
  "RUSSIAN": "Russian",
  "TURKISH": "Turkish",
  "CHINESE": "Chinese",
  "FILIPINO": "Filipino",
  "HUNGARIAN": "Hungarian",
  "LITHUANIAN": "Lithuanian",
  "SERBIAN": "Serbian",
  "UKRAINIAN": "Ukrainian",
  "CROATIAN": "Croatian",
  "FINNISH": "Finnish",
  "ICELANDIC": "Icelandic",
  "NORWEGIAN": "Norwegian",
  "SLOVAK": "Slovak",
  "URDU": "Urdu",
  "CZECH": "Czech",
  "FRENCH": "French",
  "INDONESIAN": "Indonesian",
  "PERSIAN": "Persian",
  "SLOVENIAN": "Slovenian",
  "VIETNAMESE": "Vietnamese",
  "NEPALI": "Nepali",
  "ARMENIAN": "Armenian",
  "KURDISH": "Kurdish",
  "BENGALI": "Bengali",
  "GEORGIAN": "Georgian",
  "LUXEMBOURGISH": "Luxembourgish",
  "AFRIKAANS": "Afrikaans",
  "PUNJABI": "Punjabi",
  "SIGN": "Sign",
  "BASQUE": "Basque",
  "BOSNIAN": "Bosnian"
 }
}
);  }]);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(120);

var translationKey = 'MEETING_TIME';
var meetingTimeValues = ['flexible', 'earlier', 'morning', 'noon', 'afternoon', 'evening', 'night'];

var selectOptions = meetingTimeValues.map(function (value) {
  return {
    value: value,
    translationKey: translationKey + '.' + value.toUpperCase()
  };
});

exports.default = {
  selectOptions: selectOptions,
  all: selectOptions.reduce(function (preferredTimeOptions, preferredTimeOption) {
    preferredTimeOptions[preferredTimeOption.value] = preferredTimeOption;

    return preferredTimeOptions;
  }, {})
};

/***/ }),
/* 120 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "MEETING_TIME": {
    "FLEXIBLE": "Flexible",
    "EARLIER": "Earlier (from 6am)",
    "MORNING": "Morning (from 9am)",
    "NOON": "Noon (from 12pm)",
    "AFTERNOON": "Afternoon (from 3pm)",
    "EVENING": "Evening (from 6pm)",
    "NIGHT": "Night (from 9pm)"
  }
}
);  }]);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // initial modal, no messenger connection
  connect: 'connect',
  // messenger connection got invalidated, reconnect
  reconnect: 'reconnect'
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(123);

var translationKeyPrefix = 'NUMBER_OF_PEOPLE.';

exports.default = [{
  value: 1,
  translationKey: translationKeyPrefix + '1'
}, {
  value: 2,
  translationKey: translationKeyPrefix + '2'
}, {
  value: 3,
  translationKey: translationKeyPrefix + '3'
}, {
  value: 4,
  translationKey: translationKeyPrefix + '4'
}];

/***/ }),
/* 123 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "NUMBER_OF_PEOPLE": {
    "1": "Just me",
    "2": "Two people",
    "3": "Three people",
    "4": "More than three"
  }
}
);  }]);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  email: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}$',
  phone: '^\\+[0-9]{9,}$'
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  booking: 'BOOKING',
  subscription: 'SUBSCRIPTION'
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  micro: [60, 60],
  mini: [100, 100],
  thumb: [200, 200],
  trip: [280, 220],
  large: [320, 320],
  slideshow: [1000, 1000]
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  fb: 'Facebook',
  vk: 'VKontakte'
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  guideId: 9504195,
  vimeoId: 145137910,
  heading: 'Adventures with Julia in&nbsp;Kiev',
  cover: __webpack_require__(129),
  coverMobile: __webpack_require__(130),
  coverSquare: __webpack_require__(131),
  thumb: __webpack_require__(132),
  type: 'video',
  name: 'Julia',
  locationName: 'Kiev, Ukraine',
  placeId: 'ChIJBUVa4U7P1EAR_kYBF9IxSXY'
}, {
  guideId: 9506277,
  vimeoId: 144345301,
  heading: 'So you say you know&nbsp;Berlin?',
  cover: __webpack_require__(133),
  coverMobile: __webpack_require__(134),
  coverSquare: __webpack_require__(135),
  thumb: __webpack_require__(136),
  type: 'video',
  name: 'Matts',
  locationName: 'Berlin, Germany',
  placeId: 'ChIJAVkDPzdOqEcRcDteW0YgIQQ'
}, {
  guideId: 9506244,
  vimeoId: 145844830,
  heading: 'In Berlin, sleep is&nbsp;commercial',
  cover: __webpack_require__(137),
  coverMobile: __webpack_require__(138),
  coverSquare: __webpack_require__(139),
  thumb: __webpack_require__(140),
  type: 'video',
  name: 'Sara',
  locationName: 'Berlin, Germany',
  placeId: 'ChIJAVkDPzdOqEcRcDteW0YgIQQ'
}, {
  guideId: 9504672,
  vimeoId: 146671085,
  heading: 'No other city like Amsterdam',
  cover: __webpack_require__(141),
  coverMobile: __webpack_require__(142),
  coverSquare: __webpack_require__(143),
  thumb: __webpack_require__(144),
  type: 'video',
  name: 'Jasmijn',
  locationName: 'Amsterdam, Netherlands',
  placeId: 'ChIJVXealLU_xkcRja_At0z9AGY'
}, {
  guideId: 9506733,
  vimeoId: 147345898,
  heading: 'Secret walks of the old Kiev',
  cover: __webpack_require__(145),
  coverMobile: __webpack_require__(146),
  coverSquare: __webpack_require__(147),
  thumb: __webpack_require__(148),
  type: 'video',
  name: 'Ksenia',
  locationName: 'Kiev, Ukraine',
  placeId: 'ChIJBUVa4U7P1EAR_kYBF9IxSXY'
}, {
  guideId: 9506308,
  vimeoId: 149543853,
  heading: 'A brief party-goer’s guide',
  cover: __webpack_require__(149),
  coverMobile: __webpack_require__(150),
  coverSquare: __webpack_require__(151),
  thumb: __webpack_require__(152),
  type: 'video',
  name: 'Elizabeth',
  locationName: 'Kiev, Ukraine',
  placeId: 'ChIJBUVa4U7P1EAR_kYBF9IxSXY'
}, {
  guideId: 9502890,
  vimeoId: 148611653,
  heading: 'The sinful spots of Hamburg',
  cover: __webpack_require__(153),
  coverMobile: __webpack_require__(154),
  coverSquare: __webpack_require__(155),
  thumb: __webpack_require__(156),
  type: 'video',
  name: 'Marina',
  locationName: 'Hamburg, Germany',
  placeId: 'ChIJuRMYfoNhsUcRoDrWe_I9JgQ'
}, {
  guideId: 9506297,
  vimeoId: 186268101,
  heading: 'City Tour with Dan in Berlin',
  cover: __webpack_require__(157),
  coverMobile: __webpack_require__(158),
  coverSquare: __webpack_require__(159),
  thumb: __webpack_require__(160),
  type: 'video',
  name: 'Dan',
  locationName: 'Berlin, Germany',
  placeId: 'ChIJAVkDPzdOqEcRcDteW0YgIQQ'
}, {
  guideId: 9503659,
  vimeoId: 160114000,
  heading: 'Istanbul: A mix of East and West',
  cover: __webpack_require__(161),
  coverMobile: __webpack_require__(162),
  coverSquare: __webpack_require__(163),
  thumb: __webpack_require__(164),
  type: 'video',
  name: 'Ayse',
  locationName: 'Istanbul, Turkey',
  placeId: 'ChIJawhoAASnyhQR0LABvJj-zOE'
}, {
  guideId: 9608663,
  vimeoId: 200683666,
  heading: 'Nothing stops Detroit',
  cover: __webpack_require__(165),
  coverMobile: __webpack_require__(166),
  coverSquare: __webpack_require__(167),
  thumb: __webpack_require__(168),
  type: 'video',
  name: 'Lisa and Bill',
  locationName: 'Detroit, United States',
  placeId: 'ChIJdR3LEAHKJIgR0sS5NU6Gdlc'
}, {
  guideId: 9608779,
  vimeoId: 189922833,
  heading: 'The famed Cuban neighbourhood',
  cover: __webpack_require__(169),
  coverMobile: __webpack_require__(170),
  coverSquare: __webpack_require__(171),
  thumb: __webpack_require__(172),
  type: 'video',
  name: 'Susan',
  locationName: 'Miami, United States',
  placeId: 'ChIJEcHIDqKw2YgRZU-t3XHylv8'
}];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/dabaed5728b9ea2eb88b2678c6338722.jpg";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/fdd5016ee95f01016317c811e70a0260.jpg";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/beb86ebd05adb921d83e6239b0f6164d.jpg";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/7ebdf548104e0930caa9d31aed6d2355.jpg";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/18222c3195bdb6ca38f423b233d0b6bd.jpg";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/a1c239aeccf43b34192e3b3414ebb9e4.jpg";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/a76e6a2446dfe6e7eb374d2be3c68bf0.jpg";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/94cd57f57042997d59523d8a30036cf2.jpg";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/b31526edc86fa2745f040b560bc19ef4.jpg";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/152616392032d54374a199474ea31425.jpg";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/4e44b1f61bedf03fa56c98ef1276082b.jpg";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/3b39b023962915e3a1b80064412789d2.jpg";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/1ce74a4371cc5d036c887925f9835b5d.jpg";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/b0cc8f2b8072f0d1da9dfe4283441ff9.jpg";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/2f67d71e55bc7fd3de3b0e6f25d4f925.jpg";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/8cc3fc0609d1b13fd13123c0f5639443.jpg";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/07261b11f0e76225441d118bec100a77.jpg";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/d83ef80ad9e7c2a1b83156606fe314aa.jpg";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/8a480fa4dcb888b1e9689b856c48e190.jpg";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/6c3c6063d706f80f8bfd4c4e0c93ed54.jpg";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/af169816ef80b909b899d67dd6347946.jpg";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/3e207053725f4ba1221990ab94974e87.jpg";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/5a73e6316f298dc7d41854a0bf498514.jpg";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/5fd690edf40c42dded54bfdbd67d6f0f.jpg";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/0ed87d9e2d7be74d0c57f54835b8894b.jpg";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/bb691701e6cf982fceac681a76aa6ac3.jpg";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/93214a77da3c53f83cc0668f7bb7d190.jpg";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/cb0de4e97aaf1507ff39f921eeb88e24.jpg";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/b0c985a760971616f576e5dfb693099a.jpg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/5bd415dcb2de069a49cf433701d15fcc.jpg";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/24a440f92e5d570409b01c47e9fad612.jpg";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/2d468bf9e94042e22c4d95c7b74913c1.jpg";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/045546483711bc7ef0fb15aee7301c29.jpg";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/7d3050e7894dbb6c20b3db79f3e9780d.jpg";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/92f5ffe5cdd6151281304d6f00478500.jpg";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/392ab9dbff73606591517b53be1a4fe2.jpg";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/68a063daaed512384c3f968286998085.jpg";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/2a544cd43ef251b1aa2c42aec85446eb.jpg";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/8b77d91ddfe16ca16dc476eeeb9c8ecf.jpg";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/458469769d7c8e5815a5688a9dcb3651.jpg";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/284328457a66b523c06badd86eaf508d.jpg";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/4c5e3240560502efc8e8fa8e47eaf153.jpg";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/fd17c09d1e4fa4d400808390071d8f5d.jpg";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/c97c587f17d12a191a6882dc1e9dedd9.jpg";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  'code': 'AED',
  'symbol': 'د.إ',
  'maxValue': 300,
  'maxSearchValue': 360,
  'maxLength': 3
}, {
  'code': 'AUD',
  'symbol': '$',
  'maxValue': 100,
  'maxSearchValue': 120,
  'maxLength': 3
}, {
  'code': 'CAD',
  'symbol': '$',
  'maxValue': 100,
  'maxSearchValue': 120,
  'maxLength': 3
}, {
  'code': 'CHF',
  'symbol': 'CHF',
  'maxValue': 80,
  'maxSearchValue': 100,
  'maxLength': 2
}, {
  'code': 'CNY',
  'symbol': '¥',
  'maxValue': 500,
  'maxSearchValue': 600,
  'maxLength': 3
}, {
  'code': 'DKK',
  'symbol': 'kr',
  'maxValue': 500,
  'maxSearchValue': 600,
  'maxLength': 3
}, {
  'code': 'EUR',
  'symbol': '€',
  'maxValue': 90,
  'maxSearchValue': 110,
  'maxLength': 2
}, {
  'code': 'GBP',
  'symbol': '£',
  'maxValue': 60,
  'maxSearchValue': 80,
  'maxLength': 2
}, {
  'code': 'HKD',
  'symbol': '$',
  'maxValue': 600,
  'maxSearchValue': 750,
  'maxLength': 3
}, {
  'code': 'IDR',
  'symbol': 'Rp',
  'maxValue': 1000000,
  'maxSearchValue': 1200000,
  'maxLength': 7
}, {
  'code': 'ILS',
  'symbol': '₪',
  'maxValue': 300,
  'maxSearchValue': 360,
  'maxLength': 3
}, {
  'code': 'INR',
  'symbol': '₹',
  'maxValue': 5000,
  'maxSearchValue': 6000,
  'maxLength': 4
}, {
  'code': 'JPY',
  'symbol': '¥',
  'maxValue': 9000,
  'maxSearchValue': 11000,
  'maxLength': 4
}, {
  'code': 'MXN',
  'symbol': '$',
  'maxValue': 1400,
  'maxSearchValue': 1700,
  'maxLength': 4
}, {
  'code': 'NOK',
  'symbol': 'kr',
  'maxValue': 700,
  'maxSearchValue': 850,
  'maxLength': 3
}, {
  'code': 'NZD',
  'symbol': '$',
  'maxValue': 120,
  'maxSearchValue': 150,
  'maxLength': 3
}, {
  'code': 'RUB',
  'symbol': '₽',
  'maxValue': 5300,
  'maxSearchValue': 6500,
  'maxLength': 4
}, {
  'code': 'SAR',
  'symbol': '﷼',
  'maxValue': 300,
  'maxSearchValue': 360,
  'maxLength': 3
}, {
  'code': 'SEK',
  'symbol': 'kr',
  'maxValue': 650,
  'maxSearchValue': 800,
  'maxLength': 3
}, {
  'code': 'SGD',
  'symbol': '$',
  'maxValue': 100,
  'maxSearchValue': 120,
  'maxLength': 3
}, {
  'code': 'TRY',
  'symbol': '₺',
  'maxValue': 200,
  'maxSearchValue': 250,
  'maxLength': 3
}, {
  'code': 'TWD',
  'symbol': 'NT$',
  'maxValue': 2500,
  'maxSearchValue': 3000,
  'maxLength': 4
}, {
  'code': 'USD',
  'symbol': '$',
  'maxValue': 80,
  'maxSearchValue': 100,
  'maxLength': 2
}, {
  'code': 'THB',
  'symbol': '฿',
  'maxValue': 3400,
  'maxSearchValue': 4150,
  'maxLength': 3
}, {
  'code': 'ZAR',
  'symbol': 'R',
  'maxValue': 1200,
  'maxSearchValue': 1500,
  'maxLength': 3
}];

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'history-and-culture': 'culture',
  'pick-up-and-driving': 'driving',
  'food-and-restaurant': 'food',
  'art-and-museums': 'museums',
  'nightlife-and-bars': 'nightlife',
  'sports-and-recreation': 'recreation',
  'exploration-and-sightseeing': 'sightseeing',
  'translation-and-interpretation': 'translation',
  'shopping': 'shopping'
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BookingSuggestion = function () {
  function BookingSuggestion($q, $http, userModel, utils) {
    _classCallCheck(this, BookingSuggestion);

    this.$q = $q;
    this.$http = $http;
    this.userModel = userModel;
    this.utils = utils;
  }

  _createClass(BookingSuggestion, [{
    key: 'findAll',
    value: function findAll(placeId, bookingId) {
      var _this = this;

      return new this.$q(function (resolve, reject) {
        var config = {
          params: {
            placeId: placeId,
            bookingId: bookingId
          }
        };

        _this.$http.get(_this.utils.getApiUrl('guides/suggestions/' + String(_this.userModel.item.id)), config).then(function (response) {
          resolve(response.data.guides);
        }).catch(reject);
      });
    }
  }]);

  return BookingSuggestion;
}();

BookingSuggestion.$inject = ['$q', '$http', 'userModel', 'utils'];

exports.default = BookingSuggestion;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Conversation;
Conversation.$inject = ['resource'];
function Conversation(resource) {
  'ngInject';

  return resource({
    url: function url() {
      return '/conversations/' + this._constructorOptions.getUserId();
    },
    comparator: function comparator(conversationA, conversationB) {
      var result = 0;

      try {
        result = conversationB.sortWeight - conversationA.sortWeight;
      } catch (e) {
        return;
      }

      return result;
    }
  });
}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$filter', 'resource'];
function f($filter, resource) {
  'ngInject';

  return resource({
    url: function url() {
      return '/trips/' + this._constructorOptions.getUserId();
    },
    comparator: function comparator(tripA, tripB) {
      var result = 0;

      try {
        result = $filter('toDate')(tripB.createdAt) - $filter('toDate')(tripA.createdAt);
      } catch (e) {
        return;
      }

      return result;
    }
  });
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Guide = function Guide(resource) {
  return resource({
    url: function url() {
      return '/guides';
    }
  });
};

Guide.$inject = ['resource'];

exports.default = Guide;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Message.$inject = ['resource', 'utils'];
function Message(resource, utils) {
  'ngInject';

  return resource({
    url: function url() {
      return utils.getApiUrlV2('/messages/' + this._constructorOptions.getUserId() + '/' + this._constructorOptions.getConversationId());
    },
    comparator: '-sentAt'
  });
}

exports.default = Message;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserResource = function () {
  UserResource.$inject = ['$q', '$http', 'utils'];

  function UserResource($q, $http, utils) {
    'ngInject';

    _classCallCheck(this, UserResource);

    this.$q = $q;
    this.$http = $http;
    this.utils = utils;
  }

  _createClass(UserResource, [{
    key: 'findById',
    value: function findById(id) {
      var _this = this;

      return new this.$q(function (resolve, reject) {
        _this.$http.get(_this.utils.getApiUrlV2('users/' + id)).then(function (response) {
          resolve(response.data);
        }).catch(reject);
      });
    }
  }, {
    key: 'getLoginHisotry',
    value: function getLoginHisotry(id) {
      var _this2 = this;

      return new this.$q(function (resolve, reject) {
        _this2.$http.get(_this2.utils.getApiUrlV2('users/' + id + '/login_history')).then(function (response) {
          resolve(response.data);
        }).catch(reject);
      });
    }
  }, {
    key: 'copyData',
    value: function copyData(id, data) {
      var _this3 = this;

      return new this.$q(function (resolve, reject) {
        _this3.$http.get(_this3.utils.getApiUrlV2('users/' + id + '/copy_data')).then(function (response) {
          resolve(response.data);
        }).catch(reject);
      });
    }
  }, {
    key: 'getBraintreeToken',
    value: function getBraintreeToken(id) {
      var _this4 = this;

      return new this.$q(function (resolve, reject) {
        _this4.$http.get(_this4.utils.getApiUrlV2('braintree/' + id + '/config')).then(function (response) {
          resolve(response.data);
        }).catch(reject);
      });
    }
  }, {
    key: 'processBraintreePayment',
    value: function processBraintreePayment(id, postData) {
      var _this5 = this;

      return new this.$q(function (resolve, reject) {
        _this5.$http.post(_this5.utils.getApiUrlV2('braintree/' + id + '/check'), postData).then(function (response) {
          resolve(response.data);
        }).catch(reject);
      });
    }
  }]);

  return UserResource;
}();

exports.default = UserResource;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var photoSize = {
  w: 120,
  h: 120
};

/**
 * Model that represents current logged in user
 */

var UserModel = function () {
  UserModel.$inject = ['$q', '$rootScope', '$window', 'userResource', 'analytics', 'imgixHelpers'];

  function UserModel($q, $rootScope, $window, userResource, analytics, imgixHelpers) {
    'ngInject';

    _classCallCheck(this, UserModel);

    this.$q = $q;
    this.$rootScope = $rootScope;
    this.$window = $window;
    // this.raven = $raven;
    this.resource = userResource;
    this.analytics = analytics;
    this.imgixHelpers = imgixHelpers;

    this.item = {};
    this.itemPromise = this.$q.resolve();
  }

  _createClass(UserModel, [{
    key: 'initItem',
    value: function initItem(id, no_event) {
      var _this = this;

      this.itemPromise = new this.$q(function (resolve, reject) {
        if (id) {
          _this.item = {
            id: id
          };
          _this.resource.findById(id).then(function (user) {
            _this.item = user;
            var traits = {
              name: user.name
            };
            var profilePhoto = user.profilePhoto;

            if (profilePhoto) {
              var crop = _this.imgixHelpers.getCropCoords(profilePhoto.crop);
              var photoUrl = _this.imgixHelpers.getUrl(profilePhoto, photoSize, crop);
              traits.avatar = 'https:' + photoUrl;
            }

            _this.analytics.identify(user.id, traits);

            // this.raven.setUserContext({id: user.id});

            if (!no_event) {
              _this.$rootScope.$emit('userModel:initialized');
            }
            resolve(_this.item);
          }).catch(reject);
        } else {
          resolve(_this.item);
        }
      });

      return this.itemPromise;
    }
  }, {
    key: 'hasMembership',
    value: function hasMembership() {
      var membership = this.item.membership || {};

      return membership.expires && new Date(membership.expires * 1000) > new Date();
    }
  }, {
    key: 'getCurrency',
    value: function getCurrency() {
      var preferences = this.item.preferences || {};

      return preferences.currency;
    }
  }, {
    key: 'hasMessenger',
    value: function hasMessenger() {
      return this.item.preferences && this.item.preferences.fbMessengerId;
    }
  }, {
    key: 'getLoginHistory',
    value: function getLoginHistory() {
      var _this2 = this;

      this.loginHistory = new this.$q(function (resolve, reject) {
        _this2.resource.getLoginHisotry(_this2.item.id).then(function (history) {
          resolve(history);
        }).catch(reject);
      });
      return this.loginHistory;
    }
  }, {
    key: 'copyData',
    value: function copyData() {
      var _this3 = this;

      this.copy = new this.$q(function (resolve, reject) {
        _this3.resource.copyData(_this3.item.id).then(function (data) {
          resolve(data);
        }).catch(reject);
      });
      return this.copy;
    }
  }, {
    key: 'getBraintreeToken',
    value: function getBraintreeToken() {
      var _this4 = this;

      if ('braintreeToken' in this) {
        return this.braintreeToken;
      }

      this.braintreeToken = new this.$q(function (resolve, reject) {
        _this4.resource.getBraintreeToken(_this4.item.id).then(function (data) {
          resolve(data);
        }).catch(reject);
      });

      return this.braintreeToken;
    }
  }, {
    key: 'processBraintreePayment',
    value: function processBraintreePayment(data) {
      var _this5 = this;

      var res = new this.$q(function (resolve, reject) {
        _this5.resource.processBraintreePayment(_this5.item.id, data).then(function (data) {
          resolve(data);
        }).catch(reject);
      });

      return res;
    }
  }]);

  return UserModel;
}();

exports.default = UserModel;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var accountActivationModal = ['modal', function (modal) {
  return {
    open: function open() {
      return modal.open({
        template: '<sa-account-activation done="close()"></sa-account-activation>',
        closeOff: true
      }).result;
    }
  };
}];

exports.default = accountActivationModal;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var autocompleteService = ['$q', '$http', function ($q, $http) {
  var locations_url = 'https://d14w0rz7s8v3pz.cloudfront.net/predictions';
  var details_url = 'https://d14w0rz7s8v3pz.cloudfront.net/details';

  delete $http.defaults.headers.common['X-Requested-With'];
  return {
    getPlacePredictions: function getPlacePredictions(string) {
      return $http.get(locations_url + '?s=' + string, { responseType: 'json' });
    },
    getPlaceDetails: function getPlaceDetails(place_id) {
      return $http.get(details_url + '?placeId=' + place_id, { responseType: 'json' });
    }
  };
}];

exports.default = autocompleteService;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var activateGuideAccount = ['$q', '$http', 'userModel', 'utils', function ($q, $http, userModel, utils) {
  return function () {
    return new $q(function (resolve, reject) {
      $http.get(utils.getApiUrlV2('/users/' + String(userModel.item.id + '/activate_guide_account'))).then(function () {
        resolve();
      }).catch(reject);
    });
  };
}];

exports.default = activateGuideAccount;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var COOKIE_NAME = 'adsw';
var admin = ['cookieStorage', function (cookieStorage) {
  return {

    /**
     * Checks if current user is admin logged in as another user
     * @returns {boolean}
     */
    isAdmin: function isAdmin() {
      return Boolean(cookieStorage.get(COOKIE_NAME));
    },

    /**
     * Deletes admin cookie
     */
    deleteCookie: function deleteCookie() {
      cookieStorage.remove(COOKIE_NAME);
    }
  };
}];

exports.default = admin;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var alert = ['$rootScope', '$timeout', 'modal', function ($rootScope, $timeout, modal) {
  return {
    show: function show(options) {
      var modalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var scope = $rootScope.$new();

      scope.options = options;

      if (options.autoClose) {
        $timeout(function () {
          modal.close();
        }, 2000);

        modalOptions.cssClass = 'Alert-autoClose Modal--sharpCorners';
        modalOptions.closeOnBackgroundClick = true;
        modalOptions.closeOff = true;
      }

      return modal.open(angular.extend({
        template: '<sa-alert accept="close()" decline="dismiss()" options="options"></sa-alert>',
        scope: scope
      }, modalOptions)).result;
    }
  };
}];

exports.default = alert;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$window'];
function f($window) {
  'ngInject';

  return {
    track: function track(event, data) {
      if (typeof gtag !== 'undefined') {
        var category = data && data['category'] ? data['category'] : null;
        var label = data && data['label'] ? data['label'] : null;
        var value = data && data['value'] ? data['value'] : null;
        var gtagData = {
          event_category: category,
          event_label: label,
          value: value
        };
        gtag('event', event, gtagData);
      }
    },
    pageview: function pageview(url) {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'page_view');
      }
    },
    identify: function identify(userId) {
      if (typeof gtag !== 'undefined') {
        gtag('set', { 'user_id': userId });
      }
    },
    reset: function reset() {
      if (typeof gtag !== 'undefined') {
        gtag('set', { 'user_id': null });
      }
    }
  };
}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

f.$inject = ['$http', 'utils', 'userModel'];
function f($http, utils, userModel) {
  'ngInject';

  return {

    /*
      analyticsSa.track({
         action: '',
         data: {}
      });
    */
    track: function track(data) {
      data.data = _angular2.default.extend(data.data, { pricePoint: userModel.item.membership.price });
      $http.post(utils.getApiUrlV2('analytics/'), data);
    }
  };
}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = auth;
auth.$inject = ['$q', '$http', '$state', '$window', 'session', 'utils', 'userModel', 'temporaryUser', 'analytics', 'join', 'localStorage'];
var analyticsSignUpCategory = 'SignUp';
var analyticsSignUpAction = 'SignedUp';

function auth($q, $http, $state, $window, session, utils, userModel, temporaryUser, analytics, join, localStorage) {
  'ngInject';

  var getCurrency = function getCurrency() {
    return localStorage.get('currency');
  };

  function setSessionData(data) {
    session.set(data);
    userModel.initItem(data.userId);
  }

  function handleResponse(response, resolve) {
    var responseData = response.data;
    var sessionData = {
      accessToken: responseData.token,
      userId: responseData.userId
    };
    var isNewUser = responseData.status === 'registered';

    setSessionData(sessionData);

    if (isNewUser) {
      analytics.track(analyticsSignUpAction, {
        category: analyticsSignUpCategory,
        value: '0.00',
        currency: 'USD'
      });

      if (typeof fbq !== 'undefined') {
        fbq('track', 'CompleteRegistration');
      }

      // Linkedin pixel for registration
      var linkedinEl = document.createElement("div");
      linkedinEl.innerHTML = '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3819929&conversionId=5396625&fmt=gif" />';
      document.body.appendChild(linkedinEl);
    }

    temporaryUser.remove();
    $q.resolve(userModel.itemPromise).then(function () {

      // Send user id to SegmentIO
      analytics.identify(String(sessionData.userId));

      // Send user id to Sentry
      // $raven.setUserContext({id: sessionData.userId});
    }).then(function () {
      resolve({ isNewUser: isNewUser });
    });
  }

  function login(path, data) {
    return new $q(function (resolve, reject) {
      var httpPromise = $http.post(utils.getApiUrl('/authentication' + (path || '')), data);

      httpPromise.then(function (response) {
        if (response.data.status === 'error') {
          alert(response.data.message);
          handleResponse(response, resolve);
        } else {
          handleResponse(response, resolve);
        }
      }).catch(reject);
    });
  }

  return {
    socialLogin: function socialLogin(networkName, accessToken, socialId) {
      var data = {
        accessToken: accessToken,
        socialId: socialId,
        currency: getCurrency()
      };

      return login('/' + networkName, data);
    },

    login: login,

    signUpWithEmail: function signUpWithEmail(data) {
      if (join.becomeGuide) {
        data.guideStatus = 'notVerified';
      }
      data.currency = getCurrency();

      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrl('authentication/profile_registration'), data).then(function (response) {
          var tempUserData = response.data;

          temporaryUser.setData(tempUserData);
          resolve(tempUserData);
        }).catch(reject);
      });
    },

    signInWithEmail: function signInWithEmail(data) {
      return login('/profile_login', data);
    },

    activateAccount: function activateAccount(data) {
      var isGuide;

      return new $q(function (resolve, reject) {
        var requestConfig = {
          params: data
        };

        $http.get(utils.getApiUrl('authentication/profile_activation'), requestConfig).then(function (response) {
          isGuide = Boolean(response.data.guideStatus);

          handleResponse(response, resolve);
        }).then(function () {
          if (isGuide) {
            $state.go('settings');
          }
        }).catch(reject);
      });
    },

    resendActivationEmail: function resendActivationEmail(data) {
      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrl('authentication/profile_registration_resend'), data).then(function (response) {
          var tempUserData = temporaryUser.getData();

          angular.extend(tempUserData, response.data);
          temporaryUser.setData(tempUserData);
          resolve();
        }).catch(reject);
      });
    },

    sendPasswordResetLink: function sendPasswordResetLink(email) {
      var data = {
        email: email
      };

      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrl('reset_password/remind'), data).then(resolve).catch(reject);
      });
    },

    manualLogin: function manualLogin(data) {
      return $q(function (resolve) {
        handleResponse(data, resolve);
      });
    },


    setSessionData: setSessionData
  };
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROTECTED_REGEXP = /^\/api_v1\/.+/;
var authInterceptor = ['$q', 'session', 'logout', function ($q, session, logout) {
  return {
    responseError: function responseError(response) {
      if (response.status === 401 && isProtected(response.config.url)) {
        logout();
      }

      return $q.reject(response);
    }
  };
}];

function isProtected(url) {
  return PROTECTED_REGEXP.test(url);
}

exports.default = authInterceptor;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = becomeGuide;
becomeGuide.$inject = ['$q', '$state', 'userModel', 'analytics', 'join'];
function becomeGuide($q, $state, userModel, analytics, join) {
  'ngInject';

  return function () {
    var joinPromise = void 0;

    if (!userModel.item.id) {
      joinPromise = join.showModal('guide').result;
    }

    return $q.resolve(joinPromise).then(function () {
      if (!userModel.item.id) {
        return;
      } else {
        // Redirect user to settings page only if he is logging in
        // Otherwise the user just registered and need to confirm email...
        // https://app.getsentry.com/showaround/fe-production/issues/113600912/
        $state.go('settings');
      }
    });
  };
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bodyElement;
bodyElement.$inject = ['$rootScope', '$state', '$document'];
function bodyElement($rootScope, $state, $document) {
  'ngInject';

  var bodyEl = angular.element($document[0].body);
  var addedClass = void 0;

  $rootScope.$on('$stateChangeSuccess', function (event, newState) {
    if (addedClass) {
      bodyEl.removeClass(addedClass);
    }

    addedClass = newState.data && newState.data.bodyClass;
    if (addedClass) {
      bodyEl.addClass(addedClass);
    }
  });

  return {
    getElement: function getElement() {
      return bodyEl;
    }
  };
}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var breakpoint = ['$rootScope', '$window', function ($rootScope, $window) {
  var windowEl = angular.element($window);
  var body = $window.document.body;
  var breakpoint = getBreakpoint();

  function triggerEvent() {
    $rootScope.$emit('breakpointChanged', breakpoint);
  }

  function getBreakpoint() {
    var otoBreakpoint = 'mobile';
    var oldBreakpoint = $window.getComputedStyle(body, ':after').getPropertyValue('content').replace(/['"]*/g, '');

    try {
      if (oldBreakpoint.length === 0) {
        if ($window.matchMedia('(max-width: 739px)')) {
          otoBreakpoint;
        } else if ($window.matchMedia('(min-width: 1200px)')) {
          otoBreakpoint = 'desktop';
        } else if ($window.matchMedia('(min-width: 1024px)')) {
          otoBreakpoint = 'tablet-horizontal';
        } else if ($window.matchMedia('(min-width: 740px)')) {
          otoBreakpoint = 'tablet';
        }
      } else {
        otoBreakpoint = oldBreakpoint;
      }
    } catch (e) {
      //
    }

    return otoBreakpoint;
  }

  windowEl.on('resize', function () {
    $rootScope.$apply(function () {
      var newBreakpoint = getBreakpoint();

      if (newBreakpoint !== breakpoint) {
        breakpoint = newBreakpoint;
        triggerEvent();
      }
    });
  });

  return getBreakpoint;
}];

exports.default = breakpoint;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calendar = ['$filter', function ($filter) {
  var dateFilter = $filter('date');

  function getCalendarHeader(date) {
    return dateFilter(date, 'MMMM yyyy');
  }

  function getDaysInMonth(date) {
    return new Date(2014, (date.getMonth() + 1) % 12, 0).getDate();
  }

  function getDayOfTheWeek(date) {
    return (date.getDay() + 7) % 7;
  }

  function formatDate(date) {
    return dateFilter(date, 'yyyyMMdd');
  }

  function stringToDate(dateString) {
    var year = parseInt(dateString.substr(0, 4), 10);
    var month = parseInt(dateString.substr(4, 2), 10) - 1;
    var day = parseInt(dateString.substr(6, 2), 10);

    return new Date(year, month, day);
  }

  function getMonth(monthDate, minDate, maxDate, disabledDates) {
    var daysInMonth = getDaysInMonth(monthDate);
    var dayOfWeek = getDayOfTheWeek(monthDate);
    var month = [];
    var iter;
    var total;
    var week;

    disabledDates = disabledDates || [];

    function getDay(date) {
      var day = {
        dayOfMonth: date.getDate(),
        fullDate: formatDate(date)
      };

      if (date < minDate || date > maxDate || date.getMonth() !== monthDate.getMonth() || disabledDates.indexOf(day.fullDate) > -1) {
        day.isDisabled = true;
      }

      return day;
    }

    total = 6 - getDayOfTheWeek(new Date(monthDate.getFullYear(), monthDate.getMonth(), daysInMonth)) + daysInMonth;
    for (iter = 1 - dayOfWeek; iter <= total; iter++) {
      if (!week || week.length === 7) {
        week = [];
        month.push(week);
      }

      week.push(getDay(new Date(monthDate.getFullYear(), monthDate.getMonth(), iter)));
    }

    return month;
  }

  function getCalendar(selectedDate, disabledDates, minDateParam, maxDateParam) {
    var now = new Date();
    var minDate = minDateParam || new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var maxDate = maxDateParam || new Date(minDate.getFullYear() + 1, minDate.getMonth(), minDate.getDate());
    var year = minDate.getFullYear();
    var month = minDate.getMonth();
    var calendar = {
      headers: [],
      months: [],
      today: formatDate(now)
    };
    var selectedDateObj = selectedDate && stringToDate(selectedDate) || now;
    var monthDate;

    if (selectedDateObj < new Date(now.getFullYear(), now.getMonth(), now.getDate())) {
      selectedDateObj = now;
    }

    calendar.selectedDate = formatDate(selectedDateObj);

    for (monthDate = new Date(year, month, 1); monthDate.getTime() <= maxDate.getTime(); monthDate = new Date(year, ++month, 1)) {
      calendar.headers.push(getCalendarHeader(monthDate));
      calendar.months.push(getMonth(monthDate, minDate, maxDate, disabledDates));

      if (selectedDateObj.getFullYear() === monthDate.getFullYear() && selectedDateObj.getMonth() === monthDate.getMonth()) {
        calendar.currentMonth = calendar.months.length - 1;
      }
    }

    return calendar;
  }

  return {
    getCalendar: getCalendar
  };
}];

exports.default = calendar;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(196);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _config2.default;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var localConfig;

try {
  localConfig = __webpack_require__(197);
} catch (e) {
  localConfig = {};
}

module.exports = angular.merge({
  apiBaseUrl: '/api_v1',
  apiBaseUrlV2: '/api_v2',
  imgUrl: '//showaroundoriginal.imgix.net/',
  imgQuality: 60,
  socketUrl: 'sa.local:31337',
  socials: {
    facebook: {
      appId: 1573475539547795,
      pageId: 1504165226499871,
      scope: 'public_profile,email,user_photos'
    },
    vk: {
      appId: 4579843,
      scope: 4 + 4194304
    }
  },
  supportEmail: 'support@showaround.com',
  supportPhoneNumber: '+353 1 254 4809',
  verificationPhotoDownloadUrl: 'https://s3-eu-west-1.amazonaws.com/images.original.showaround/',
  iosAppUrl: 'https://itunes.apple.com/app/showaround-find-local-to-show/id1001885430',
  androidAppUrl: 'https://play.google.com/store/apps/details?id=com.showaround',
  blogUrl: 'http://blog.showaround.com/',
  pressPageUrl: '/press',
  googleApiKey: 'AIzaSyBsKn0lVR7nBu4nKZQTLXXeSo91GE1vwlM'
}, localConfig);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  socials: {
    facebook: {
      scope: 'public_profile,email,user_photos'
    }
  },
  recaptcha: {
    siteKey: '6LfcLzknAAAAANN80eI0YHL8dzQogOHcKe9Tamc4'
  },
  adyen: {
    key: '10001|951F016DA4C41968436586CA23472C2200CDD76CAD38B5F40043F25F5FAC2DDF2D07ED067DF14E5C61C21CB6772895E8E82DE2EB54B32272D79D5DB2CD1238923105F28789771C7D4837E1089B52B19A2EB19A0F421205CBB2DC7CB9D3ED10FE257E1F98DC51B018851F87F75137C79EA03B3F59A5E6427B494E40C588B081D0B1B57075343CD333D62710D4D5E66F95AD746213ADAD433C0D5717F9044775F234EF4C42709C23F312AFB962F4BDC6B9C4CC558C1D72E49BD08BB5E9EBAE793995DDC182111612F23A69DCFECBEF09A137475342E9EAE65C8254085D732884E3E1CC863B07C9CF7068293E270CA1B06AD3A2EAEC4AF7FA347DB0C09BBB1A720D'
  },
  socketUrl: 'https://showaround.com:31337',
  segmentApiKey: 'h3dEQbbwE3Kcv5qzSr4KVKKa5wpBO0SI',
  sentryDsn: 'https://a1687fa45ddf43899ec4a90842a09602@app.getsentry.com/43324',
  gaKeys: [{
    tracker: 'UA-61874544-1',
    name: "Website",
    trackEvent: true
  }]
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var contact = ['$http', 'modal', 'utils', function ($http, modal, utils) {
  return {
    sendMessage: function sendMessage(postData) {
      return $http.post(utils.getApiUrlV2('support'), postData);
    },

    showModal: function showModal() {
      modal.open({
        template: '<sa-contact-form done="close()"></sa-contact-form>'
      });
    }
  };
}];

exports.default = contact;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cookieStorage = ['Storage', function (Storage) {
  return new Storage('cookie');
}];

exports.default = cookieStorage;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DISABLE_SCROLL_CLS = 'is-scrollDisabled';
var bodyScroll = ['$window', 'scrollTop', function ($window, scrollTop) {
  var body = $window.document.body;
  var bodyEl = angular.element(body);
  var wrapper = document.querySelector('.Wrapper');
  var wrapperEl = angular.element(wrapper);
  var callCount = 0;
  var offsetY;

  return {

    /**
     * Disables body scroll.
     */
    disable: function disable() {
      if (!callCount) {
        offsetY = scrollTop();
        bodyEl.addClass(DISABLE_SCROLL_CLS);
        wrapperEl.css('top', -offsetY + 'px');
      }

      callCount++;
    },

    /**
     * Enables body scroll.
     */
    enable: function enable() {
      if (callCount > 0) {
        callCount--;
      }

      if (!callCount) {
        bodyEl.removeClass(DISABLE_SCROLL_CLS);
        wrapperEl.css('top', 0);
        scrollTop(offsetY);
      }
    }
  };
}];

exports.default = bodyScroll;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['config', 'admin'];
function f(config, admin) {
  'ngInject';

  return {
    check: function check() {
      var developmentEnv = false;

      if (config.env === 'local') {
        developmentEnv = true;
      }

      return developmentEnv;
    },
    disablePopUps: function disablePopUps() {
      var disablePopUps = false;

      if (config.popups === 'disable') {
        disablePopUps = true;
      }

      return disablePopUps;
    },
    deleteAdminCookieInDevelopment: function deleteAdminCookieInDevelopment() {
      if (this.check()) {
        admin.deleteCookie();
      }
    }
  };
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO: Use modernizr!

Object.defineProperty(exports, "__esModule", {
  value: true
});
var deviceCapabilities = [function () {

  function detectTransformProperty() {
    var transformProperty = 'transform';
    var safariPropertyHack = 'webkitTransform';

    if (typeof document.body.style[transformProperty] !== 'undefined') {

      ['webkit', 'moz', 'o', 'ms'].every(function (prefix) {
        var e = '-' + prefix + '-transform';

        if (typeof document.body.style[e] !== 'undefined') {
          transformProperty = e;
          return false;
        }
        return true;
      });
    } else if (typeof document.body.style[safariPropertyHack] !== 'undefined') {
      transformProperty = '-webkit-transform';
    } else {
      transformProperty = undefined;
    }
    return transformProperty;
  }

  function detect3dSupport() {
    var el = document.createElement('p');
    var transforms = {
      'webkitTransform': '-webkit-transform',
      'msTransform': '-ms-transform',
      'transform': 'transform'
    };
    var has3d = void 0;

    // Add it to the body to get the computed style
    document.body.insertBefore(el, null);
    for (var t in transforms) {
      if (el.style[t] !== undefined) {
        el.style[t] = 'translate3d(1px,1px,1px)';
        has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
      }
    }
    document.body.removeChild(el);
    return has3d !== undefined && has3d.length > 0 && has3d !== 'none';
  }

  function getPixelRatio() {
    var ratio = 1;

    if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
      ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
    } else if (window.devicePixelRatio !== undefined) {
      ratio = window.devicePixelRatio;
    }
    return ratio;
  }

  function isIOSDevice() {
    return navigator.userAgent.match(/iPad|iPhone|iPod/i) != null;
  }

  return {
    transformProperty: detectTransformProperty(),
    has3d: detect3dSupport(),
    pixelRatio: getPixelRatio(),
    isIOSDevice: isIOSDevice()
  };
}];

exports.default = deviceCapabilities;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var scriptUrl = '//connect.facebook.net/en_US/sdk.js';
var facebook = ['$q', 'jsLoader', 'auth', 'config', '$window', function ($q, jsLoader, auth, config, $window) {
  var loaderPromise;
  var FB;
  var authResponse;

  function getLoaderPromise() {
    if (!loaderPromise) {
      loaderPromise = jsLoader(scriptUrl, 'FB').then(function (fbApi) {
        var deferred = $q.defer();

        FB = fbApi;
        $window.FB.init({
          appId: config.socials.facebook.appId,
          xfbml: false,
          version: 'v15.0'
        });

        $window.FB.getLoginStatus(function (response) {
          if (response.status === 'connected') {
            authResponse = response.authResponse;
          }

          deferred.resolve();
        });

        $window.FB.XFBML.parse();

        return deferred.promise;
      });
    }

    return loaderPromise;
  }

  function loginToFacebook() {
    var deferred = $q.defer();
    if (!authResponse) {
      $window.FB.login(function (response) {
        if (response.status === 'connected') {
          authResponse = response.authResponse;
          deferred.resolve(authResponse);
        } else {
          deferred.reject(response);
        }
      }, { scope: config.socials.facebook.scope });
    } else {
      deferred.resolve(authResponse);
    }

    return deferred.promise;
  }

  function getPhotoUrl(photoId) {
    return 'https://graph.facebook.com/' + photoId + '/picture?access_token=' + authResponse.accessToken;
  }

  function _getAlbums() {
    var deferred = $q.defer();

    $window.FB.api('/me/albums?fields=count,name,id', function (response) {
      var albums;

      if (response && !response.error) {
        albums = response.data.filter(function (album) {
          return album.count;
        }).map(function (album) {
          return {
            id: album.id,
            coverPhoto: 'https://graph.facebook.com/' + album.id + '/picture?access_token=' + authResponse.accessToken,
            name: album.name
          };
        });
        deferred.resolve(albums);
      } else {
        deferred.reject(response);
      }
    });

    return deferred.promise;
  }

  function _getPhotosOfYou() {
    var deferred = $q.defer();

    $window.FB.api(authResponse.userID + '/photos?fields=images', function (response) {
      if (response && !response.error) {
        var photosOfYou = response.data;
        var photosOfYouAlbum = {};
        if (photosOfYou.length) {
          var photoOfYouCover = photosOfYou[0].images[0].source;
          photosOfYouAlbum = {
            coverPhoto: photoOfYouCover,
            id: -1,
            name: 'Photos of You'
          };
        }
        deferred.resolve(photosOfYouAlbum);
      } else {
        deferred.reject(response);
      }
    });

    return deferred.promise;
  }

  function _getPhotos(albumId) {
    var deferred = $q.defer();
    var photos;

    if (albumId === -1) {
      $window.FB.api(authResponse.userID + '/photos?fields=images', function (response) {
        if (response && !response.error) {
          var photosOfYou = response.data;
          var photos;
          if (photosOfYou.length) {
            photos = response.data.map(function (photo) {
              var url = photo.images.sort(function (a, b) {
                return a.height + a.width - (b.height + b.width);
              }).pop().source;
              return {
                id: photo.id,
                albumId: -1,
                url: url,
                src: url
              };
            });
          }
          deferred.resolve(photos);
        } else {
          deferred.reject(response);
        }
      });
    } else {
      $window.FB.api(albumId + '/photos?fields=source,id', function (response) {
        if (response && !response.error) {
          photos = response.data.map(function (photo) {
            return {
              id: photo.id,
              albumId: albumId,
              url: photo.source,
              src: photo.source
            };
          });

          deferred.resolve(photos);
        } else {
          deferred.reject(response);
        }
      });
    }

    return deferred.promise;
  }

  function _getPhotoPermissions() {
    var deferred = $q.defer();

    $window.FB.login(function (response) {
      if (response.status === 'connected') {
        authResponse = response.authResponse;
        deferred.resolve(response.authResponse);
      } else {
        deferred.reject(response);
      }
    }, {
      scope: 'user_photos',
      'auth_type': 'rerequest'
    });

    return deferred.promise;
  }

  return {
    login: function login() {
      var deferred = $q.defer();

      getLoaderPromise().then(function () {
        return loginToFacebook();
      }).then(function (authResponse) {
        return auth.socialLogin('facebook', authResponse.accessToken, authResponse.userID);
      }).then(deferred.resolve).catch(deferred.reject);

      return deferred.promise;
    },

    getPhotoPermissions: function getPhotoPermissions() {
      return _getPhotoPermissions();
    },

    getAlbums: function getAlbums() {
      var promise = getLoaderPromise().then(function () {
        return _getAlbums();
      });

      return promise;
    },

    getPhotosOfYou: function getPhotosOfYou() {
      var promise = getLoaderPromise().then(function () {
        return _getPhotosOfYou();
      });

      return promise;
    },

    getPhotos: function getPhotos(albumId) {
      var promise = getLoaderPromise().then(function () {
        return _getPhotos(albumId);
      });

      return promise;
    },

    sendToMessenger: function sendToMessenger() {
      getLoaderPromise().then(function () {
        $window.FB.XFBML.parse();
      });
    },
    share: function share(url) {
      $window.FB.ui({
        method: 'share',
        display: 'popup',
        href: url
      }, function () {});
    },
    sendRequest: function sendRequest(url) {
      $window.FB.ui({
        method: 'send',
        link: url
      });
    },


    getPhotoUrl: getPhotoUrl,

    fetchScript: function fetchScript() {
      return getLoaderPromise();
    }
  };
}];

exports.default = facebook;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
function f() {
  'ngInject';

  function setFavicon(href, id) {
    try {
      var head = document.getElementsByTagName('head')[0];
      var faviconId = id;
      var link = document.createElement('link');
      var oldLink = document.getElementById(faviconId);
      link.id = faviconId;
      link.rel = 'shortcut icon';
      link.href = href;
      if (oldLink) {
        head.removeChild(oldLink);
      }
      head.appendChild(link);

      return this;
    } catch (e) {
      //
    }
  }

  return {
    notifyFav: function notifyFav() {
      setFavicon('/favicon_notification-32x32.png', 'favicon-32');
      setFavicon('/favicon_notification-16x16.png', 'favicon-16');
      setFavicon('/favicon_notification.ico', 'favicon');
    },
    readFav: function readFav() {
      setFavicon('/favicon-32x32.png', 'favicon-32');
      setFavicon('/favicon-16x16.png', 'favicon-16');
      setFavicon('/favicon.ico', 'favicon');
    }
  };
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['Storage'];
var STORAGE_KEY = 'featuredGuideIds';

function f(Storage) {
  'ngInject';

  var storage = new Storage('memory');

  function getIdsFromStorage() {
    return JSON.parse(storage.get(STORAGE_KEY) || '{}') || {};
  }

  return {
    setFeaturedGuideIds: function setFeaturedGuideIds(ids) {
      var identifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var featuredGuideIds = getIdsFromStorage();

      featuredGuideIds[identifier] = ids;
      storage.set(STORAGE_KEY, JSON.stringify(featuredGuideIds));
    },

    getFeaturedGuideIds: function getFeaturedGuideIds() {
      var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var featuredGuideIds = getIdsFromStorage();

      return featuredGuideIds[identifier];
    }
  };
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROFILE_URL = 'locals';

exports.default = ['$http', '$q', 'userModel', 'utils', 'currencyModel', function ($http, $q, userModel, utils, currencyModel) {
  'ngInject';

  return function (userId) {
    var tripId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var url = PROFILE_URL + '/' + (userId || userModel.item.id);
    if (tripId) {
      url = url + '?tripId=' + tripId;
    }
    var deferred = $q.defer();
    var currency = currencyModel.getValue();
    var requestConfig = {
      params: {
        currency: currency || 'EUR'
      }
    };

    $http.get(utils.getApiUrlV2(url), requestConfig).then(function (response) {
      var data = response.data;

      if (data.photos) {
        data.photos.sort(function (a, b) {
          return (b.main || 0) - (a.main || 0);
        });
      }
      data.$hasProfileInfo = true;
      deferred.resolve(response.data);
    }).catch(deferred.reject);

    return deferred.promise;
  };
}];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$q', '$http', 'utils', function ($q, $http, utils) {
  'ngInject';

  return {
    get: function get() {
      var url = utils.getApiUrlV2('/time');
      return new $q(function (resolve, reject) {
        $http.get(url).then(function (response) {
          return resolve(response);
        }).catch(reject);
      });
    }
  };
}];

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getScriptUrl = function getScriptUrl(apiKey) {
  return '//maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places';
};
var googleMapsLoader = ['$q', '$window', 'jsLoader', 'config', function ($q, $window, jsLoader, config) {
  var googleMaps;
  var googleMapsPromise;

  function errorHandler(reject) {
    googleMapsPromise = null;
    reject();
  }

  function fetchGoogleMaps() {

    // if googleMapsPromise is falsy, start loading
    if (!googleMapsPromise) {
      var url = getScriptUrl(config.googleApiKey);
      googleMapsPromise = new $q(function (resolve, reject) {
        jsLoader(url, 'google').then(function (google) {
          googleMaps = google.maps;

          // check if Google Maps script loaded successfully
          if (googleMaps) {
            resolve(googleMaps);
          } else {
            errorHandler(reject);
          }
        }).catch(function () {
          errorHandler(reject);
        });
      });
    }

    return googleMapsPromise;
  }

  return function () {
    return googleMaps ? $q.resolve(googleMaps) : fetchGoogleMaps();
  };
}];

exports.default = googleMapsLoader;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

f.$inject = ['$rootScope', '$http', '$stateParams', '$state', '$q', 'utils', 'userModel', 'currencyModel', 'currencySymbol', 'currencies', 'objectToArray', 'featuredGuides', 'placesService', 'languages', 'seoActivities', 'deslug'];
function f($rootScope, $http, $stateParams, $state, $q, utils, userModel, currencyModel, currencySymbol, currencies, objectToArray, featuredGuides, placesService, languages, seoActivities, deslug) {
  'ngInject';

  var currencyCode = currencyModel.getValue();
  var currencySym = currencySymbol(currencyCode);
  var maximumValue = currencies.filter(function (currency) {
    return currency.code === currencyCode;
  })[0].maxSearchValue;
  var isFilterBoxVisible = false;
  var oldFilters = {};
  // TODO: document how it works
  var featuredGuidesFlag = false;
  var filters = {};
  filters.priceFrom = $stateParams.priceFrom || 0;
  filters.priceTo = $stateParams.priceTo || maximumValue;
  filters.currency = $stateParams.currency || currencyCode;
  filters.location = {};
  filters.gender = {};
  filters.languages = {};
  filters.activities = {};

  var sliderOptions = {
    options: {
      floor: 0,
      ceil: maximumValue,
      translate: function translate(value) {
        if (value === 0) {
          return 'Free';
        } else {
          return currencySym + value + '/h';
        }
      }
    }
  };

  $rootScope.$on('$stateChangeStart', function (_, toState, toParams, fromState) {
    if (['guides.guide'].indexOf(fromState.name) === -1 && ['guides.city', 'guides.cityFilter'].indexOf(toState.name) !== -1) {
      _clearFilters();
    }
  });

  function _updateFromUserParams() {
    // #TODO#1356
    // the user model loading is not guaranteed to be sooner than this code
    // execution which poses the question - if the user saved his filters,
    // how do we update them?

    // Init filters from saved state (URL params take precendence)
    // TODO: implement URL precedence
    if (userModel.item.preferences) {
      if (notEmpty(userModel.item.preferences.filter)) {
        var userFilters = userModel.item.preferences.filter;
        filters.priceFrom = userFilters.priceFrom || 0;
        filters.priceTo = userFilters.priceTo || maximumValue;
        filters.currency = currencyCode;
        if (userFilters.location) {
          filters.location.name = userFilters.location.name;
          filters.location.placeId = userFilters.location.placeId;
          filters.location.lat = userFilters.location.lat;
          filters.location.lon = userFilters.location.lon;
          filters.location.countryCode = userFilters.location.countryCode;
          filters.location.px1 = userFilters.location.px1;
          filters.location.py1 = userFilters.location.py1;
          filters.location.px2 = userFilters.location.px2;
          filters.location.py2 = userFilters.location.py2;
        }
        filters.languages = arrayToObjectBoolean(userFilters.languages);
        filters.activities = arrayToObjectBoolean(userFilters.activities);
        filters.gender = arrayToObjectBoolean(userFilters.gender);
        filters.saveFilterOptions = true;
      }
    } else {
      var localStorage = false;
      if (localStorage) {
        localStorage = true;
        // TODO: implement
      }
    }
  }

  function _clearFilters() {
    //TODO: copy initial state from constructor ar reset to it
    filters.priceFrom = 0;
    filters.priceTo = maximumValue;
    filters.currency = currencyCode;
    filters.location = {};
    filters.languages = {};
    filters.activities = {};
    filters.gender = {};
    filters.filter = undefined;
    $stateParams.filter = undefined;
    $stateParams.activities = undefined;
    $stateParams.countryCode = undefined;
    $stateParams.gender = undefined;
    $stateParams.idlist = undefined;
    $stateParams.languages = undefined;
    $stateParams.lat = undefined;
    $stateParams.loc = undefined;
    $stateParams.lon = undefined;
    $stateParams.name = undefined;
    $stateParams.placeId = undefined;
    $stateParams.priceFrom = undefined;
    $stateParams.priceTo = undefined;
    $stateParams.px1 = undefined;
    $stateParams.px2 = undefined;
    $stateParams.py1 = undefined;
    $stateParams.py2 = undefined;
  }

  _updateFromUserParams();

  function notEmpty(filters) {
    return filters !== null && (filters.priceFrom !== null || filters.priceTo !== null || filters.currency !== null || filters.languages.length > 0 || filters.activities.length > 0 || filters.gender.length > 0);
  }

  // Convert for usage in POST to the backend
  function convertFilters(rawFilters) {
    if (rawFilters === null) {
      return null;
    }
    var filterCopy = _angular2.default.copy(rawFilters);
    filterCopy.languages = objectToArray.transform(filterCopy.languages);
    filterCopy.activities = objectToArray.transform(filterCopy.activities);
    filterCopy.gender = objectToArray.transform(filterCopy.gender);
    delete filterCopy.saveFilterOptions;
    return filterCopy;
  }

  // Convert backend saved filter data for usage on the form
  function arrayToObjectBoolean(array) {
    var object = {};
    array.forEach(function (item) {
      object[item] = true;
    });

    return object;
  }

  function updateAdditionalLocationParams(from, to) {
    // Reset these params because some location don't have them
    // and previous location parameters are used in such cases
    to.px1 = null;
    to.px2 = null;
    to.py1 = null;
    to.py2 = null;

    if (from.lat) {
      to.lat = from.lat;
    }
    if (from.lon) {
      to.lon = from.lon;
    }
    if (from.countryCode) {
      to.countryCode = from.countryCode;
    }
    if (from.px1) {
      to.px1 = from.px1;
    }
    if (from.py1) {
      to.py1 = from.py1;
    }
    if (from.px2) {
      to.px2 = from.px2;
    }
    if (from.py2) {
      to.py2 = from.py2;
    }
  }

  function _updateFromParams() {
    var city = '';
    var country = '';
    var location = {};

    // Workadround for SEO url's to ignore female filter.
    // AK Request on 2019-08-27.
    //if ($stateParams.filter === 'male' || $stateParams.filter === 'female' || $stateParams.filter === 'couple') {
    //  $stateParams.filter = null;
    //}

    if ($stateParams.priceFrom) {
      filters.priceFrom = $stateParams.priceFrom;
    }
    if ($stateParams.priceTo) {
      filters.priceTo = $stateParams.priceTo;
    }
    if ($stateParams.currency) {
      filters.currency = $stateParams.currency;
    }
    if ($stateParams.placeId) {
      location.name = $stateParams.name;
      location.placeId = $stateParams.placeId;
      filters.location = location;
      updateAdditionalLocationParams($stateParams, filters.location);
    } else if ($stateParams.country && $stateParams.city) {
      city = deslug.it($stateParams.city);
      country = deslug.it($stateParams.country);
      location.name = city + ', ' + country;
      filters.location = location;
    } else {
      filters.location = {};
    }
    if ($stateParams.loc) {
      filters.location.loc = $stateParams.loc;
    }
    if ($stateParams.idlist) {
      filters.location.idlist = $stateParams.idlist;
    }

    if ($stateParams.languages) {
      filters.languages = arrayToObjectBoolean($stateParams.languages.split(','));
    }
    if ($stateParams.activities) {
      filters.activities = arrayToObjectBoolean($stateParams.activities.split(','));
    }
    if ($stateParams.gender) {
      filters.gender = arrayToObjectBoolean($stateParams.gender.split(','));
    }
    if ($stateParams.filter) {
      filters.filter = $stateParams.filter;

      if (['male', 'female', 'couple'].indexOf(filters.filter) !== -1) {
        filters.gender[filters.filter] = true;
      } else if (Object.keys(languages.all).indexOf(filters.filter) !== -1) {
        filters.languages[filters.filter] = true;
      } else {
        if (Object.keys(seoActivities).indexOf(filters.filter) !== -1) {
          filters.filter = seoActivities[filters.filter];
        }
        filters.activities[filters.filter] = true;
      }
    }
  }

  function getDetails(loc, params, resolve) {
    placesService.getDetails(loc, function (detailedLocation) {
      updateAdditionalLocationParams(detailedLocation, params);
      updateAdditionalLocationParams(detailedLocation, loc);
      resolve(params);
      // TODO: does this cause history problems?
      // $state.go('.', params, {notify: false, location: 'replace'});
    });
  }

  function _getParametrizedFilters() {
    return new $q(function (resolve) {
      if (featuredGuidesFlag) {
        featuredGuidesFlag = false;
        return {};
      }
      var params = _angular2.default.copy(filters);
      params.location = null;

      params.activities = objectToArray.transform(params.activities).join(',');
      params.languages = objectToArray.transform(params.languages).join(',');
      params.gender = objectToArray.transform(params.gender).join(',');

      delete params.saveFilterOptions;
      params.currency = currencyModel.getValue();
      if (params.priceTo == maximumValue) {
        params.priceTo = null;
      }
      if (params.priceFrom == 0) {
        params.priceFrom = null;
      }

      if (filters.location) {
        if (filters.location.name) {
          params.name = filters.location.name;
        }
        if (filters.location.placeId) {
          params.placeId = filters.location.placeId;
        }
        if (filters.location.lat) {
          params.lat = filters.location.lat;
        }
        if (filters.location.lon) {
          params.lon = filters.location.lon;
        }
        if (filters.location.countryCode) {
          params.countryCode = filters.location.countryCode;
        }

        if (filters.location.px1) {
          params.px1 = filters.location.px1;
        }
        if (filters.location.py1) {
          params.py1 = filters.location.py1;
        }
        if (filters.location.px2) {
          params.px2 = filters.location.px2;
        }
        if (filters.location.py2) {
          params.py2 = filters.location.py2;
        }
      } else {
        // TODO: ehhh, something better?
        params.name = null;
        params.placeId = '';
        params.lat = '';
        params.lon = '';
        params.countryCode = '';
        params.px1 = '';
        params.px2 = '';
        params.py1 = '';
        params.py2 = '';
      }

      // load additional location data
      if (filters.location && filters.location.name && (!$stateParams.lat || $stateParams.name !== filters.location.name)) {
        if (!filters.location.placeId) {
          var city = $stateParams.city;
          //if (city === 'kiev') {
          //  city = 'kyiv';
          //}
          placesService.getPlaceId(city).then(function (response) {
            filters.location.placeId = params.placeId = response.data.placeId;
            getDetails(filters.location, params, resolve);
          });
        } else {
          getDetails(filters.location, params, resolve);
        }
      } else {
        resolve(params);
        // TODO: does this cause history problems?
        // $state.go('.', params, {notify: false, location: 'replace'});
      }
    });
  }

  return {
    filters: filters,
    userFilterUpdated: false,
    filtersActive: false,

    updateFromParams: function updateFromParams() {
      _updateFromParams();
    },
    setFeaturedGuides: function setFeaturedGuides(cond) {
      featuredGuidesFlag = cond;
    },
    updateFromUserParams: function updateFromUserParams() {
      _updateFromUserParams();
    },
    notEmpty: function notEmpty(userFilters) {
      if (!userFilters) {
        userFilters = filters;
      }
      var notEmpty = userFilters.priceFrom != 0 || userFilters.priceTo != maximumValue || objectToArray.transform(userFilters.languages).length > 0 || objectToArray.transform(userFilters.activities).length > 0 || objectToArray.transform(userFilters.gender).length > 0;

      this.filtersActive = notEmpty;

      return notEmpty;
    },
    getParametrizedFilters: function getParametrizedFilters() {
      return _getParametrizedFilters();
    },
    filterBoxVisibility: function filterBoxVisibility() {
      return isFilterBoxVisible;
    },
    setFilterBoxVisibility: function setFilterBoxVisibility(isVisible) {
      isFilterBoxVisible = isVisible;
    },
    getSliderOptions: function getSliderOptions() {
      return sliderOptions;
    },
    setSliderOptions: function setSliderOptions(options) {
      _angular2.default.extend(sliderOptions, options);
    },
    getLocation: function getLocation() {
      return filters.location;
    },
    persistFilterOptions: function persistFilterOptions(userFilters) {
      if (!_angular2.default.equals(oldFilters, userFilters)) {
        if (userModel.item.id) {
          var convertedFilters = null;
          if (notEmpty(userFilters)) {
            convertedFilters = convertFilters(userFilters);
          }
          oldFilters = _angular2.default.copy(userFilters);
          $http.post(utils.getApiUrlV2('users/' + userModel.item.id + '/filters'), convertedFilters, { params: null });
        } else {
          // guest localstorage
        }
      }
    },
    clearFilters: function clearFilters() {
      return _clearFilters();
    }
  };
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  notVerified - wants to be a local, needs to complete the profile
  and be reviewed by the admin.
  active - complete profile, reviewed by the admin, shown in the listing.
  notActive - complete profile, reviewed by the admin, not shown in the listing.
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GUIDE_STATUS = {
  notVerified: 'notVerified',
  active: 'active',
  notActive: 'notActive'
};

var guideStatus = ['$http', '$q', 'userModel', 'utils', function ($http, $q, userModel, utils) {

  return {

    /**
     * Changes guide status.
     * @param newGuideStatus
     */
    setStatus: function setStatus(newGuideStatus) {
      var deferred = $q.defer();
      var data = {
        guideStatus: newGuideStatus
      };

      $http.post(utils.getApiUrl('/settings/' + userModel.item.id), data).then(function (response) {
        if (response.data.guideStatus) {
          userModel.item.guideStatus = response.data.guideStatus.value;
        }

        deferred.resolve();
      }).catch(deferred.reject);

      return deferred.promise;
    },
    status: GUIDE_STATUS,

    /**
     * Change user's guide status to `notVerified` or `active` depending on his current guide status.
     */
    becomeGuide: function becomeGuide() {
      var newGuideStatus = userModel.item.guideStatus ? this.status.active : this.status.notVerified;

      return this.setStatus(newGuideStatus);
    },

    /**
     * Deactivates guide. If guide was not verified, he returns to initial state (guideStatus = false).
     */
    deactivate: function deactivate() {
      var newGuideStatus = this.isUnverifiedGuide() ? false : this.status.notActive;

      return this.setStatus(newGuideStatus);
    },

    /**
     * Returns true if current user has active or not verified guide status.
     * @returns {boolean}
     */
    isGuide: function isGuide() {
      return [this.status.notVerified, this.status.active].indexOf(userModel.item.guideStatus) > -1;
    },

    // because the new business rules make everyone who signs up "notVerified"
    newIsGuide: function newIsGuide() {
      return this.status.active === userModel.item.guideStatus;
    },

    /**
     * Returns true if current user has active guide status.
     * @returns {boolean}
     */
    isActiveGuide: function isActiveGuide() {
      return userModel.item.guideStatus === this.status.active;
    },

    /**
     * Returns true if current user has not verified guide status.
     * @returns {boolean}
     */
    isUnverifiedGuide: function isUnverifiedGuide() {
      return userModel.item.guideStatus === this.status.notVerified;
    },

    /**
     * Returns true if current user has not active guide status.
     * @returns {boolean}
     */
    isInactiveGuide: function isInactiveGuide() {
      return userModel.item.guideStatus === this.status.notActive;
    }
  };
}];

exports.default = guideStatus;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['config', 'deviceCapabilities'];
var getQueryString = function getQueryString(params) {
  var queryParts = Object.keys(params).map(function (key) {
    return key + '=' + String(params[key]);
  });

  return '?' + queryParts.join('&');
};

function f(config, deviceCapabilities) {
  'ngInject';

  var imgUrl = config.imgUrl;
  var imgQuality = config.imgQuality;
  var devicePixelRatio = deviceCapabilities.pixelRatio >= 1.5 ? 1.5 : 1;

  return {
    getUrl: function getUrl(photo, size, crop) {
      var params = {
        w: size.w,
        h: size.h,
        dpr: size.dpr || devicePixelRatio,
        q: imgQuality
      };

      if (crop) {
        params.rect = crop;
      }

      return imgUrl + photo.path + getQueryString(params);
    },
    getCropCoords: function getCropCoords(crop) {
      var x1 = crop.x1;
      var y1 = crop.y1;
      var x2 = crop.x2;
      var y2 = crop.y2;

      return String(x1 + ',' + y1 + ',' + Math.abs(x2 - x1) + ',' + Math.abs(y2 - y1));
    }
  };
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = joinFactory;
joinFactory.$inject = ['$rootScope', 'modal'];
function joinFactory($rootScope, modal) {
  'ngInject';

  var USER_TYPE = 'guide';

  return {
    showModal: function showModal() {
      var scope = $rootScope.$new();

      scope.userType = USER_TYPE;

      return modal.open({
        template: '<sa-join on-success="close(result)" user-type="{{userType}}"></sa-join>',
        scope: scope,
        destroyOnStateChange: true
      });
    }
  };
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = joinFactory;
joinFactory.$inject = ['$rootScope', 'modal'];
function joinFactory($rootScope, modal) {
  'ngInject';

  var USER_TYPE = 'guide';

  return {
    showModal: function showModal() {
      var scope = $rootScope.$new();
      scope.userType = USER_TYPE;
      scope.newDesign = 'fbIntro';

      return modal.open({
        template: '<sa-join on-success="close(result)" user-type="{{userType}}" new-design="{{newDesign}}"></sa-join>',
        cssClass: 'FbLanding--Modal',
        scope: scope,
        destroyOnStateChange: true,
        closeOff: true
      });
    }
  };
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _asyncJs = __webpack_require__(39);

var _asyncJs2 = _interopRequireDefault(_asyncJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

f.$inject = ['$q', '$window', 'alert'];
function f($q, $window, alert) {
  'ngInject';

  var alertConfig = {
    header: 'ALERTS.SCRIPT_ERROR.HEADER',
    buttons: [{

      label: 'ALERTS.SCRIPT_ERROR.BUTTON_ACCEPT',
      action: 'accept'
    }]
  };

  function showAlert() {
    alert.show(alertConfig).then(function () {
      $window.location.reload();
    });
  }

  return function (dependencyUrl, name) {
    var showErrorAlert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return new $q(function (resolve, reject) {
      var q = (0, _asyncJs2.default)(dependencyUrl);
      q.whenDone(function (_, __, errors) {
        if (!name && !showErrorAlert) {
          resolve();
          return;
        }
        if (errors.length || !$window[name]) {
          var error = new Error('Failed to load ' + name + ' script from ' + dependencyUrl + ' ' + errors.toString());
          showErrorAlert && showAlert();
          reject(error);
        } else {
          resolve($window[name]);
        }
      });
    });
  };
}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

f.$inject = ['localStorage'];


var localStorageKey = 'lastBookingInfo';
var propertiesToRemove = ['currency', 'price'];

function f(localStorage) {
  'ngInject';

  return {
    saveBookingInfo: function saveBookingInfo(bookingInfo, location, extension) {
      var info = _angular2.default.copy(bookingInfo);

      propertiesToRemove.forEach(function (propertyName) {
        return delete info[propertyName];
      });
      localStorage.set(localStorageKey + extension, JSON.stringify({
        booking: info,
        location: location
      }));
    },
    getBookingInfo: function getBookingInfo(location, extension) {
      var bookingInfo = null;

      try {
        bookingInfo = JSON.parse(localStorage.get(localStorageKey + extension));
        if (bookingInfo.location.fullName !== location.fullName) {
          bookingInfo = null;
        }
      } catch (error) {
        bookingInfo = null;
      }

      return bookingInfo && bookingInfo.booking;
    }
  };
}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazysizes = __webpack_require__(40);

var _lazysizes2 = _interopRequireDefault(_lazysizes);

__webpack_require__(217);

__webpack_require__(218);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service that wraps lazysizes
 */

// rewrite this
function lazysizesFactory() {
  return {
    init: function init() {
      _lazysizes2.default.init();
    }
  };
}

exports.default = lazysizesFactory;

/***/ }),
/* 217 */
/***/ (function(module, exports) {

(function(){
	'use strict';
	if(!window.addEventListener){return;}

	var regWhite = /\s+/g;
	var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
	var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/;
	var regBgUrlEscape = /\(|\)|'/;
	var allowedBackgroundSize = {contain: 1, cover: 1};
	var proxyWidth = function(elem){
		var width = lazySizes.gW(elem, elem.parentNode);

		if(!elem._lazysizesWidth || width > elem._lazysizesWidth){
			elem._lazysizesWidth = width;
		}
		return elem._lazysizesWidth;
	};
	var getBgSize = function(elem){
		var bgSize;

		bgSize = (getComputedStyle(elem) || {getPropertyValue: function(){}}).getPropertyValue('background-size');

		if(!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]){
			bgSize = elem.style.backgroundSize;
		}

		return bgSize;
	};
	var createPicture = function(sets, elem, img){
		var picture = document.createElement('picture');
		var sizes = elem.getAttribute(lazySizesConfig.sizesAttr);
		var ratio = elem.getAttribute('data-ratio');
		var optimumx = elem.getAttribute('data-optimumx');

		if(elem._lazybgset && elem._lazybgset.parentNode == elem){
			elem.removeChild(elem._lazybgset);
		}

		Object.defineProperty(img, '_lazybgset', {
			value: elem,
			writable: true
		});
		Object.defineProperty(elem, '_lazybgset', {
			value: picture,
			writable: true
		});

		sets = sets.replace(regWhite, ' ').split(regSplitSet);

		picture.style.display = 'none';
		img.className = lazySizesConfig.lazyClass;

		if(sets.length == 1 && !sizes){
			sizes = 'auto';
		}

		sets.forEach(function(set){
			var source = document.createElement('source');

			if(sizes && sizes != 'auto'){
				source.setAttribute('sizes', sizes);
			}

			if(set.match(regSource)){
				source.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1);
				if(RegExp.$2){
					source.setAttribute('media', lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2);
				}
			}
			picture.appendChild(source);
		});

		if(sizes){
			img.setAttribute(lazySizesConfig.sizesAttr, sizes);
			elem.removeAttribute(lazySizesConfig.sizesAttr);
			elem.removeAttribute('sizes');
		}
		if(optimumx){
			img.setAttribute('data-optimumx', optimumx);
		}
		if(ratio) {
			img.setAttribute('data-ratio', ratio);
		}

		picture.appendChild(img);

		elem.appendChild(picture);
	};

	var proxyLoad = function(e){
		if(!e.target._lazybgset){return;}

		var image = e.target;
		var elem = image._lazybgset;
		var bg = image.currentSrc || image.src;

		if(bg){
			elem.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg ) + ')';
		}

		if(image._lazybgsetLoading){
			lazySizes.fire(elem, '_lazyloaded', {}, false, true);
			delete image._lazybgsetLoading;
		}
	};

	addEventListener('lazybeforeunveil', function(e){
		var set, image, elem;

		if(e.defaultPrevented || !(set = e.target.getAttribute('data-bgset'))){return;}

		elem = e.target;
		image = document.createElement('img');

		image.alt = '';

		image._lazybgsetLoading = true;
		e.detail.firesLoad = true;

		createPicture(set, elem, image);

		setTimeout(function(){
			lazySizes.loader.unveil(image);

			lazySizes.rAF(function(){
				lazySizes.fire(image, '_lazyloaded', {}, true, true);
				if(image.complete) {
					proxyLoad({target: image});
				}
			});
		});

	});

	document.addEventListener('load', proxyLoad, true);

	window.addEventListener('lazybeforesizes', function(e){
		if(e.target._lazybgset && e.detail.dataAttr){
			var elem = e.target._lazybgset;
			var bgSize = getBgSize(elem);

			if(allowedBackgroundSize[bgSize]){
				e.target._lazysizesParentFit = bgSize;

				lazySizes.rAF(function(){
					e.target.setAttribute('data-parent-fit', bgSize);
					if(e.target._lazysizesParentFit){
						delete e.target._lazysizesParentFit;
					}
				});
			}
		}
	}, true);

	document.documentElement.addEventListener('lazybeforesizes', function(e){
		if(e.defaultPrevented || !e.target._lazybgset){return;}
		e.detail.width = proxyWidth(e.target._lazybgset);
	});
})();


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

(function(window, document, undefined){
	/*jshint eqnull:true */
	'use strict';
	var polyfill;
	var config = (window.lazySizes && lazySizes.cfg) || window.lazySizesConfig;
	var img = document.createElement('img');
	var supportSrcset = ('sizes' in img) && ('srcset' in img);
	var regHDesc = /\s+\d+h/g;
	var fixEdgeHDescriptor = (function(){
		var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
		var forEach = Array.prototype.forEach;

		return function(edgeMatch){
			var img = document.createElement('img');
			var removeHDescriptors = function(source){
				var ratio;
				var srcset = source.getAttribute(lazySizesConfig.srcsetAttr);
				if(srcset){
					if(srcset.match(regDescriptors)){
						if(RegExp.$2 == 'w'){
							ratio = RegExp.$1 / RegExp.$3;
						} else {
							ratio = RegExp.$3 / RegExp.$1;
						}

						if(ratio){
							source.setAttribute('data-aspectratio', ratio);
						}
					}
					source.setAttribute(lazySizesConfig.srcsetAttr, srcset.replace(regHDesc, ''));
				}
			};
			var handler = function(e){
				var picture = e.target.parentNode;

				if(picture && picture.nodeName == 'PICTURE'){
					forEach.call(picture.getElementsByTagName('source'), removeHDescriptors);
				}
				removeHDescriptors(e.target);
			};

			var test = function(){
				if(!!img.currentSrc){
					document.removeEventListener('lazybeforeunveil', handler);
				}
			};

			if(edgeMatch[1]){
				document.addEventListener('lazybeforeunveil', handler);

				if(true){
					img.onload = test;
					img.onerror = test;

					img.srcset = 'data:,a 1w 1h';

					if(img.complete){
						test();
					}
				}
			}
		};
	})();


	if(!config){
		config = {};
		window.lazySizesConfig = config;
	}

	if(!config.supportsType){
		config.supportsType = function(type/*, elem*/){
			return !type;
		};
	}

	if(window.picturefill || config.pf){return;}

	if(window.HTMLPictureElement && supportSrcset){

		if(document.msElementsFromPoint){
			fixEdgeHDescriptor(navigator.userAgent.match(/Edge\/(\d+)/));
		}

		config.pf = function(){};
		return;
	}

	config.pf = function(options){
		var i, len;
		if(window.picturefill){return;}
		for(i = 0, len = options.elements.length; i < len; i++){
			polyfill(options.elements[i]);
		}
	};

	// partial polyfill
	polyfill = (function(){
		var ascendingSort = function( a, b ) {
			return a.w - b.w;
		};
		var regPxLength = /^\s*\d+px\s*$/;
		var reduceCandidate = function (srces) {
			var lowerCandidate, bonusFactor;
			var len = srces.length;
			var candidate = srces[len -1];
			var i = 0;

			for(i; i < len;i++){
				candidate = srces[i];
				candidate.d = candidate.w / srces.w;

				if(candidate.d >= srces.d){
					if(!candidate.cached && (lowerCandidate = srces[i - 1]) &&
						lowerCandidate.d > srces.d - (0.13 * Math.pow(srces.d, 2.2))){

						bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

						if(lowerCandidate.cached) {
							lowerCandidate.d += 0.15 * bonusFactor;
						}

						if(lowerCandidate.d + ((candidate.d - srces.d) * bonusFactor) > srces.d){
							candidate = lowerCandidate;
						}
					}
					break;
				}
			}
			return candidate;
		};

		var parseWsrcset = (function(){
			var candidates;
			var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
			var regMultiple = /\s/;
			var addCandidate = function(match, candidate, url, wDescriptor){
				candidates.push({
					c: candidate,
					u: url,
					w: wDescriptor * 1
				});
			};

			return function(input){
				candidates = [];
				input = input.trim();
				input
					.replace(regHDesc, '')
					.replace(regWCandidates, addCandidate)
				;

				if(!candidates.length && input && !regMultiple.test(input)){
					candidates.push({
						c: input,
						u: input,
						w: 99
					});
				}

				return candidates;
			};
		})();

		var runMatchMedia = function(){
			if(runMatchMedia.init){return;}

			runMatchMedia.init = true;
			addEventListener('resize', (function(){
				var timer;
				var matchMediaElems = document.getElementsByClassName('lazymatchmedia');
				var run = function(){
					var i, len;
					for(i = 0, len = matchMediaElems.length; i < len; i++){
						polyfill(matchMediaElems[i]);
					}
				};

				return function(){
					clearTimeout(timer);
					timer = setTimeout(run, 66);
				};
			})());
		};

		var createSrcset = function(elem, isImage){
			var parsedSet;
			var srcSet = elem.getAttribute('srcset') || elem.getAttribute(config.srcsetAttr);

			if(!srcSet && isImage){
				srcSet = !elem._lazypolyfill ?
					(elem.getAttribute(config.srcAttr) || elem.getAttribute('src')) :
					elem._lazypolyfill._set
				;
			}

			if(!elem._lazypolyfill || elem._lazypolyfill._set != srcSet){

				parsedSet = parseWsrcset( srcSet || '' );
				if(isImage && elem.parentNode){
					parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';

					if(parsedSet.isPicture){
						if(window.matchMedia){
							lazySizes.aC(elem, 'lazymatchmedia');
							runMatchMedia();
						}
					}
				}

				parsedSet._set = srcSet;
				Object.defineProperty(elem, '_lazypolyfill', {
					value: parsedSet,
					writable: true
				});
			}
		};

		var getX = function(elem){
			var dpr = window.devicePixelRatio || 1;
			var optimum = lazySizes.getX && lazySizes.getX(elem);
			return Math.min(optimum || dpr, 2.5, dpr);
		};

		var matchesMedia = function(media){
			if(window.matchMedia){
				matchesMedia = function(media){
					return !media || (matchMedia(media) || {}).matches;
				};
			} else {
				return !media;
			}

			return matchesMedia(media);
		};

		var getCandidate = function(elem){
			var sources, i, len, media, source, srces, src, width;

			source = elem;
			createSrcset(source, true);
			srces = source._lazypolyfill;

			if(srces.isPicture){
				for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++){
					if( config.supportsType(sources[i].getAttribute('type'), elem) && matchesMedia( sources[i].getAttribute('media')) ){
						source = sources[i];
						createSrcset(source);
						srces = source._lazypolyfill;
						break;
					}
				}
			}

			if(srces.length > 1){
				width = source.getAttribute('sizes') || '';
				width = regPxLength.test(width) && parseInt(width, 10) || lazySizes.gW(elem, elem.parentNode);
				srces.d = getX(elem);
				if(!srces.src || !srces.w || srces.w < width){
					srces.w = width;
					src = reduceCandidate(srces.sort(ascendingSort));
					srces.src = src;
				} else {
					src = srces.src;
				}
			} else {
				src = srces[0];
			}

			return src;
		};

		var p = function(elem){
			if(supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != 'PICTURE'){return;}
			var candidate = getCandidate(elem);

			if(candidate && candidate.u && elem._lazypolyfill.cur != candidate.u){
				elem._lazypolyfill.cur = candidate.u;
				candidate.cached = true;
				elem.setAttribute(config.srcAttr, candidate.u);
				elem.setAttribute('src', candidate.u);
			}
		};

		p.parse = parseWsrcset;

		return p;
	})();

	if(config.loadedClass && config.loadingClass){
		(function(){
			var sels = [];
			['img[sizes$="px"][srcset].', 'picture > img:not([srcset]).'].forEach(function(sel){
				sels.push(sel + config.loadedClass);
				sels.push(sel + config.loadingClass);
			});
			config.pf({
				elements: document.querySelectorAll(sels.join(', '))
			});
		})();

	}
})(window, document);

/**
 * Some versions of iOS (8.1-) do load the first candidate of a srcset candidate list, if width descriptors with the sizes attribute is used.
 * This tiny extension prevents this wasted download by creating a picture structure around the image.
 * Note: This extension is already included in the ls.respimg.js file.
 *
 * Usage:
 *
 * <img
 * 	class="lazyload"
 * 	data-sizes="auto"
 * 	data-srcset="small.jpg 640px,
 * 		medium.jpg 980w,
 * 		large.jpg 1280w"
 * 	/>
 */

(function(document){
	'use strict';
	var regPicture;
	var img = document.createElement('img');

	if(('srcset' in img) && !('sizes' in img) && !window.HTMLPictureElement){
		regPicture = /^picture$/i;
		document.addEventListener('lazybeforeunveil', function(e){
			var elem, parent, srcset, sizes, isPicture;
			var picture, source;
			if(e.defaultPrevented ||
				lazySizesConfig.noIOSFix ||
				!(elem = e.target) ||
				!(srcset = elem.getAttribute(lazySizesConfig.srcsetAttr)) ||
				!(parent = elem.parentNode) ||
				(
					!(isPicture = regPicture.test(parent.nodeName || '')) &&
					!(sizes = elem.getAttribute('sizes') || elem.getAttribute(lazySizesConfig.sizesAttr))
				)
			){return;}

			picture = isPicture ? parent : document.createElement('picture');

			if(!elem._lazyImgSrc){
				Object.defineProperty(elem, '_lazyImgSrc', {
					value: document.createElement('source'),
					writable: true
				});
			}
			source = elem._lazyImgSrc;

			if(sizes){
				source.setAttribute('sizes', sizes);
			}

			source.setAttribute(lazySizesConfig.srcsetAttr, srcset);
			elem.setAttribute('data-pfsrcset', srcset);
			elem.removeAttribute(lazySizesConfig.srcsetAttr);

			if(!isPicture){
				parent.insertBefore(picture, elem);
				picture.appendChild(elem);
			}
			picture.insertBefore(source, elem);
		});
	}
})(document);


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var localStorage = ['Storage', function (Storage) {
  return new Storage(Storage.hasLocalStorage ? 'local' : 'memory');
}];

exports.default = localStorage;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var logout = ['$window', 'session', 'admin', 'analytics', function ($window, session, admin, analytics) {
  return function logout() {
    session.destroy();
    admin.deleteCookie();
    analytics.reset();

    $window.location.href = '/';
  };
}];

exports.default = logout;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = marketingId;
marketingId.$inject = ['$location', 'analytics'];
var marketingIdAction = 'MarketingID';

function marketingId($location, analytics) {
  'ngInject';

  return {

    /**
     * Fires `Marketing ID` analytics event if marketing id is present in search query;
     */
    init: function init() {
      var marketingId = $location.search().mid;

      if (marketingId) {
        analytics.track(marketingIdAction, {
          value: marketingId
        });
      }
    }
  };
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$http', '$q', 'utils', 'userModel'];
function f($http, $q, utils, userModel) {
  'ngInject';

  return {
    cancelSubscription: function cancelSubscription(reasons, content) {
      var url = utils.getApiUrl('/membership/' + userModel.item.id + '/disable_recurring');
      return new $q(function (resolve, reject) {
        $http.post(url, {
          reasons: reasons,
          content: content
        }).then(function (response) {
          userModel.item.membership = response.data;
          resolve();
        }).catch(reject);
      });
    }
  };
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = messenger;
messenger.$inject = ['$rootScope', '$timeout', '$http', 'modal', 'Storage', 'userModel', 'utils', 'development', 'messengerModalTypes'];
function messenger($rootScope, $timeout, $http, modal, Storage, userModel, utils, development, messengerModalTypes) {
  'ngInject';

  var STORAGE_KEY = 'sa_stm';
  var COUNT_STORAGE_KEY = 'sa_stm_c';
  var DAY = 24 * 60 * 60 * 1000;
  var DISTANT_FUTURE = 10 * 365 * DAY;
  var HIDE_INTERVALS = [DAY, 7 * DAY, DISTANT_FUTURE];

  var storage = new Storage('cookie');

  function isExpired() {
    return !storage.get(STORAGE_KEY);
  }

  function hideTemporarily() {
    var hideCount = Number(storage.get(COUNT_STORAGE_KEY));
    var hideCountNext = Math.min(hideCount + 1, HIDE_INTERVALS.length);

    storage.set(COUNT_STORAGE_KEY, hideCountNext);
    storage.set(STORAGE_KEY, 1, { expires: new Date(Date.now() + HIDE_INTERVALS[hideCountNext - 1]) });
  }

  return {
    showModal: function showModal() {
      if (development.disablePopUps()) {
        // Don't execute if development env (local_config setting)
        return;
      }

      var user = userModel.item;
      var prefs = user.preferences;

      if (isExpired() && user.id && prefs && (!prefs.fbMessengerId || prefs.isFbMessengerInvalid)) {
        hideTemporarily();

        var type = prefs.isFbMessengerInvalid ? messengerModalTypes.reconnect : messengerModalTypes.connect;

        return modal.open({
          template: '<sa-send-to-messenger-modal on-success="close()" type="' + type + '"></sa-send-to-messenger-modal>'
        });
      }
    },
    hide: function hide() {
      storage.set(STORAGE_KEY, 1, { expires: new Date(Date.now() + DISTANT_FUTURE) });
      storage.remove(COUNT_STORAGE_KEY);
    },
    disconnect: function disconnect(userId) {
      return $http.post(utils.getApiUrl('/settings/' + userId), { fbMessengerId: null });
    }
  };
}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var modal = ['$rootScope', '$state', '$window', '$q', '$http', '$templateCache', '$compile', '$controller', '$timeout', 'resolveTemplate', 'keyCodes', 'scrollbarWidth', 'slideshow', 'bodyScroll', function ($rootScope, $state, $window, $q, $http, $templateCache, $compile, $controller, $timeout, resolveTemplate, keyCodes, scrollbarWidth, slideshow, bodyScroll) {
  var documentEl = angular.element($window.document);
  var bodyEl = angular.element($window.document.body);
  var wrapperEl = angular.element($window.document.querySelector('.Wrapper'));
  var footerEl;
  var notificationEl;
  var navEl;
  $timeout(function () {
    footerEl = angular.element($window.document.querySelector('.Footer-content'));
    navEl = angular.element($window.document.querySelector('.Navigation'));
  });

  var modals = [];
  var isListeningToKeyboardEvents = false;
  var service;

  /**
   * Compiles and shows modal window
   *
   * @param {String} content
   * @param {Object} options
   * @returns {angular.element}
   */
  function showModalWindow(content, options) {
    var modalWindowEl = angular.element('<sa-modal></sa-modal>');
    var modalScope = options.scope || $rootScope.$new();
    var controllerLocals;
    var scrollWidth;

    if (options.cssClass) {
      modalWindowEl.addClass(options.cssClass);
    }

    if (!options.preventCloseWithESC) {
      // Start listening to keyboard events
      if (!isListeningToKeyboardEvents) {
        documentEl.on('keyup', keyupHandler);
        isListeningToKeyboardEvents = true;
      }
    }

    if (options.controller) {
      controllerLocals = {
        $scope: modalScope
      };

      $controller(options.controller, controllerLocals);
    }

    modalScope.modalOptions = {
      closeOnBackgroundClick: options.closeOnBackgroundClick
    };

    if (modals.length === 1 && !slideshow.isVisible) {
      scrollWidth = scrollbarWidth();
      // TODO: refactor silly padding
      wrapperEl.css('padding_right', scrollWidth + 'px');
      bodyEl.css('padding_right', scrollWidth + 'px');
      if (!footerEl) {
        footerEl = angular.element($window.document.querySelector('.Footer-content'));
      }
      if (footerEl) {
        footerEl.css('padding_right', scrollWidth + 'px');
      }
      navEl.css('padding_right', scrollWidth + 'px');
      notificationEl = angular.element($window.document.querySelector('.Notification'));
      notificationEl.css('padding_right', scrollWidth + 'px');
    }

    modalScope.title = options.title;

    modalWindowEl.html(content);
    bodyEl.append(modalWindowEl);

    modalWindowEl = $compile(modalWindowEl)(modalScope);

    return modalWindowEl;
  }

  /**
   * Closes active modal window when ESC key is pressed.
   */
  function keyupHandler(event) {
    if (event.which === keyCodes.ESC) {
      service.dismiss();
    }
  }

  /**
   * Removes modal window from DOM, destroys modal instance.
   */
  function destroyModalWindow(modalWindow) {
    var destroyModal = function destroyModal() {
      modalWindow.addClass('is-closed');
      modalWindow.remove();
    };

    bodyScroll.enable();
    if (!modals.length && !slideshow.isVisible) {
      // TODO: refactor silly padding
      bodyEl.css('padding_right', 0);
      wrapperEl.css('padding_right', 0);
      footerEl.css('padding_right', 0);
      navEl.css('padding_right', 0);
      notificationEl = angular.element($window.document.querySelector('.Notification'));
      notificationEl.css('padding_right', 0);
    }

    if (modalWindow) {
      modalWindow.addClass('is-closing');

      ['animationend', 'webkitAnimationEnd'].forEach(function (eventName) {
        modalWindow.bind(eventName, destroyModal);
      });
    }
  }

  function createModalInstance() {
    var modalInstance = {
      resultDeferred: $q.defer(),
      resolveDeferred: $q.defer(),
      index: modals.length
    };

    modalInstance.result = modalInstance.resultDeferred.promise;
    modalInstance.resolve = modalInstance.resolveDeferred.promise;

    modals.push(modalInstance);

    return modalInstance;
  }

  service = {

    /**
     * Opens modal window.
     *
     * Options:
     * template - modal window template
     * templateUrl - modal window template url
     * windowClass - CSS class which will be added to modal window element
     * [closeOnStateChange=false] - whether modal window should close when state changes
     *
     * @param {Object} options
     * @returns {Object}
     */
    open: function open(options) {
      var modalInstance;

      options = options || {};

      if (!(angular.isString(options.template) || angular.isString(options.templateUrl))) {
        throw new Error('`template` or `templateUrl` must be provided.');
      }

      modalInstance = createModalInstance();
      options.scope = options.scope || $rootScope.$new();
      options.scope.modalInstance = modalInstance;

      modalInstance.dismiss = function (reason) {
        if (options.dismissCallback) {
          options.dismissCallback(options.dismissCallbackOptions);
        }
        service.dismiss(reason, modalInstance);
      };

      modalInstance.close = function (reason) {
        service.close(reason, modalInstance);
      };

      modalInstance.destroy = function () {
        service.close(modalInstance);
      };

      modalInstance.closeOff = options.closeOff;

      if (options.closeOnStateChange) {
        $rootScope.$on('$stateChangeSuccess', function () {
          modalInstance.close();
        });
      }

      if (options.destroyOnStateChange) {
        $rootScope.$on('$stateChangeSuccess', function () {
          modalInstance.destroy();
        });
      }

      resolveTemplate(options.template || options.templateUrl).then(function (content) {
        modalInstance.modalWindow = showModalWindow(content, options);
        modalInstance.resolveDeferred.resolve();
      }, modalInstance.resolveDeferred.reject);

      return modalInstance;
    },

    /**
     * Close modal window without doing anything to promise.
     */
    destroy: function destroy(modalInstance) {
      var index;

      modalInstance = modalInstance || modals[modals.length - 1];
      index = modals.indexOf(modalInstance);

      if (modalInstance) {
        modals.splice(index, 1);
        destroyModalWindow(modalInstance.modalWindow);
      }

      // Stop listening to keyboard events
      if (!modals.length) {
        documentEl.off('keyup', keyupHandler);
        isListeningToKeyboardEvents = false;
      }
    },

    /**
     * Close modal window and reject `result` promise with reason
     *
     * @param {*} reason
     */
    dismiss: function dismiss(reason, modalInstance) {
      var index;

      modalInstance = modalInstance || modals[modals.length - 1];
      index = modals.indexOf(modalInstance);

      if (modalInstance) {
        modals.splice(index, 1);
        modalInstance.resultDeferred.reject(reason);
        destroyModalWindow(modalInstance.modalWindow);
      }

      // Stop listening to keyboard events
      if (!modals.length) {
        documentEl.off('keyup', keyupHandler);
        isListeningToKeyboardEvents = false;
      }
    },

    /**
     * Close modal window and resolve `result` promise with reason
     *
     * @param {*} reason
     */
    close: function close(reason, modalInstance) {
      var index;

      modalInstance = modalInstance || modals[modals.length - 1];
      index = modals.indexOf(modalInstance);

      if (modalInstance) {
        modals.splice(index, 1);
        modalInstance.resultDeferred.resolve(reason);
        destroyModalWindow(modalInstance.modalWindow);
      }

      // Stop listening to keyboard events
      if (!modals.length) {
        documentEl.off('keyup', keyupHandler);
        isListeningToKeyboardEvents = false;
      }
    }
  };

  return service;
}];

exports.default = modal;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    transform: function transform(obj) {
      var array = [];
      if (obj) {
        Object.keys(obj).map(function (value) {
          if (obj[value]) {
            array.push(value);
          }
        });
      }

      return array;
    }
  };
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var navigation = ['$rootScope', '$window', 'breakpoint', 'scrollTop', function ($rootScope, $window, breakpoint, scrollTop) {
  var windowEl = angular.element($window);
  var navigationThreshold;
  var addedClass;
  var navigationEl;
  var isListening = void 0;
  breakpoint = breakpoint();

  function checkScrollPosition() {
    if (scrollTop() >= navigationThreshold[breakpoint]) {
      navigationEl.removeClass(addedClass);
    } else {
      navigationEl.addClass(addedClass);
    }

    $rootScope.$emit('navigation');
  }

  function addEventListener() {
    windowEl.on('scroll', checkScrollPosition);
  }

  function removeEventListener() {
    windowEl.off('scroll', checkScrollPosition);
  }

  function removeClass() {
    navigationEl.removeClass(addedClass);
    removeEventListener();
    isListening = false;

    addedClass = null;
    navigationThreshold = null;
  }

  function addClass(cssClass, threshold) {
    removeClass();

    addedClass = cssClass;
    navigationThreshold = threshold;

    if (addedClass && navigationThreshold) {
      isListening = true;
      addEventListener();
      checkScrollPosition();
    }
  }

  $rootScope.$on('$stateChangeSuccess', function (event, newState) {
    var newStateData = newState.data || {};

    if (navigationEl) {
      addClass(newStateData.navigationCssClass, newStateData.navigationScrollThreshold);
    }
    $rootScope.$emit('navigation');
  });

  $rootScope.$on('breakpointChanged', function (event, newBreakpoint) {
    breakpoint = newBreakpoint;

    if (navigationThreshold) {
      checkScrollPosition();
    }
  });

  return {
    setNavigationElement: function setNavigationElement(element) {
      navigationEl = element;
    },

    setScrollThresholdAndClass: addClass,

    unsetScrollThresholdAndClass: removeClass,

    isFixed: function isFixed() {
      return $window.getComputedStyle(navigationEl[0], null).getPropertyValue('position') === 'fixed';
    },

    getElement: function getElement() {
      return navigationEl;
    },

    disable: function disable() {
      navigationEl.addClass('is-disabled');
      if (isListening) {
        removeEventListener();
      }
    },

    enable: function enable() {
      navigationEl.removeClass('is-disabled');
      if (isListening) {
        checkScrollPosition();
        addEventListener();
      }
    }
  };
}];

exports.default = navigation;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$rootScope', '$window', 'favicon', 'title', 'sounds'];
function f($rootScope, $window, favicon, title, sounds) {
  'ngInject';

  function _notify() {
    sounds.playNotification();
    favicon.notifyFav();
    title.notifyTitle();
  }

  function read() {
    favicon.readFav();
    title.readTitle();
  }

  return {
    visible: true,
    supportsNotifications: false,
    unread: false,

    notify: function notify() {
      _notify();

      if (!this.checkForNotificationSupport()) {
        return;
      }

      if (Notification.permission === 'granted') {
        this.showNotification();
        return;
      }
    },
    showNotification: function showNotification() {
      var options = {
        icon: __webpack_require__(23),
        badge: __webpack_require__(23),
        tag: 'general-message-notification'
      };
      var title = 'You received a new message on Showaround.';
      try {
        new Notification(title, options);
      } catch (e) {
        //
      }
    },
    askForNotificationPermissions: function askForNotificationPermissions() {
      if (!this.isNewNotificationSupported()) {
        return;
      }

      if (Notification.permission === 'default') {
        Notification.requestPermission();
      }
    },
    checkForNotificationSupport: function checkForNotificationSupport() {
      if (this.isNewNotificationSupported()) {
        this.supportsNotifications = true;
        return true;
      }

      return false;
    },
    isNewNotificationSupported: function isNewNotificationSupported() {
      if (!window.Notification || !Notification.requestPermission) {
        return false;
      }
      if (Notification.permission == 'granted') {
        return true;
      }
      try {
        new Notification('');
      } catch (e) {
        if (e.name == 'TypeError') {
          return false;
        }
      }

      return true;
    },
    init: function init() {
      var _this = this;

      $window.onblur = function () {
        _this.visible = false;
      };

      $window.onfocus = function () {
        _this.visible = true;
        if (_this.unread) {
          read();
          _this.unread = false;
        }
      };

      $rootScope.$on('socket:unreadConversationId', function () {
        if (!_this.visible) {
          _this.notify();
          _this.unread = true;
        }
      });

      this.checkForNotificationSupport();
      this.askForNotificationPermissions();
    }
  };
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var password = ['$q', '$http', 'userModel', 'auth', 'utils', function ($q, $http, userModel, auth, utils) {
  return {
    verifyPasswordResetParams: function verifyPasswordResetParams(params) {
      return new $q(function (resolve, reject) {
        var requestOptions = {
          params: params
        };

        return $http.get(utils.getApiUrl('reset_password/reset'), requestOptions).then(resolve).catch(reject);
      });
    },
    resetPassword: function resetPassword(data, params) {
      return new $q(function (resolve, reject) {
        var requestOptions = {
          params: params
        };

        return $http.post(utils.getApiUrl('reset_password/reset'), data, requestOptions).then(resolve).catch(reject);
      });
    },

    changePassword: function changePassword(data) {
      return new $q(function (resolve, reject) {
        return $http.post(utils.getApiUrl('settings/' + userModel.item.id + '/password'), data).then(function (response) {
          var responseData = response.data;

          auth.setSessionData({
            accessToken: responseData.token,
            userId: userModel.item.id
          });
          resolve();
        }).catch(reject);
      });
    }
  };
}];

exports.default = password;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
function f() {
  'ngInject';

  return {
    getPaymentStatus: function getPaymentStatus(authStatus) {
      var status;

      switch (authStatus.toUpperCase()) {
        case 'AUTHORISED':
          status = 'successful';
          break;

        case 'PENDING':
          status = 'pending';
          break;

        default:
          status = 'failed';
          break;
      }

      return status;
    }
  };
}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$q', '$http', '$rootScope', '$location', 'analytics', 'payModal', 'utils', 'userModel', 'modal', 'payments', 'currencyModel', 'analyticsSa', 'fastPayModal', 'braintreeModal', function ($q, $http, $rootScope, $location, analytics, payModal, utils, userModel, modal, payments, currencyModel, analyticsSa, fastPayModal, braintreeModal) {
  'ngInject';

  var analyticsContentType = 'product';
  var membershipCategoryName = 'Membership';
  var membershipEventName = 'PaidForMembership';

  return {
    paymentData: null,

    showPaymentWindow: function showPaymentWindow(paymentData) {
      paymentData.meta.PAYMENT_TYPE = 'SUBSCRIPTION';

      var CLICK_TRACK = 'click-membershipSelection';
      analyticsSa.track({ action: CLICK_TRACK, data: { price: paymentData.price, duration: paymentData.duration, currency: userModel.item.preferences.currency } });
      if (typeof fbq !== 'undefined') {
        fbq('track', 'AddToCart');
      }
      return braintreeModal.open(paymentData, this);

      // fast payment available if -
      var fastPaymentAvailable = userModel.item.membership.activeContract;

      if (fastPaymentAvailable) {
        return fastPayModal.open(paymentData, this);
      } else {
        return payModal.open(paymentData, this);
      }
    },
    processPayment: function processPayment(paymentData) {
      delete paymentData.meta;

      return this.sendPaymentData(paymentData);
    },
    sendPaymentData: function sendPaymentData(paymentData) {
      this.paymentData = paymentData;
      // adyen-encrypted-data: "enccypreData",
      // currency: "EUR",
      // duration: "1month" / "3month" / "12month"
      // isForFuturePayments: 1/0
      // price: 59.99
      var url = utils.getApiUrl('/membership/' + userModel.item.id + '/recurring');
      return new $q(function (resolve, reject) {
        $http.post(url, paymentData).then(function (response) {
          return resolve(response);
        }).catch(reject);
      });
    },
    sendFastPaymentData: function sendFastPaymentData(paymentData) {
      delete paymentData.meta;
      this.paymentData = paymentData;
      // currency: "EUR",
      // duration: "1month" / "3month" / "12month"
      // price: 59.99
      var url = utils.getApiUrl('/membership/' + userModel.item.id + '/contract');
      return new $q(function (resolve, reject) {
        $http.post(url, paymentData).then(function (response) {
          return resolve(response);
        }).catch(reject);
      });
    },
    showMembershipSuccessWindow: function showMembershipSuccessWindow(authResult, membership) {
      var _this = this;

      // authResult data model:
      // authResult is just a string
      // membership data model:
      // price: $stateParams.price,
      // currency: $stateParams.currency,
      // duration: parseInt($stateParams.duration),
      var paymentStatus = payments.getPaymentStatus(authResult);
      var scope = $rootScope.$new();

      if (['successful', 'pending'].indexOf(paymentStatus) > -1) {
        analytics.track(membershipEventName, {
          category: membershipCategoryName,
          value: membership.price,
          content_type: analyticsContentType,
          content_ids: userModel.item.id,
          currency: currencyModel.getValue()
        });
        var CLICK_TRACK = 'event-membershipBuySuccess';
        analyticsSa.track({ action: CLICK_TRACK, data: { price: membership.price, duration: membership.duration, currency: userModel.item.preferences.currency } });

        if (typeof fbq !== 'undefined') {
          fbq('track', 'Purchase');
        }

        // Linkedin pixel for purchase
        var linkedinEl = document.createElement("div");
        linkedinEl.innerHTML = '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3819929&conversionId=5396641&fmt=gif" />';
        document.body.appendChild(linkedinEl);

        // Kisunas Affilates pixel
        var orderId = 'random-' + Math.random();
        var pixelUrl = '<img src="https://www.shareasale.com/sale.cfm?tracking=' + orderId + '&amount=' + membership.price + '&merchantID=115429&transtype=sale" width="1" height="1">';
        var shareSaleEl = document.createElement("div");
        shareSaleEl.innerHTML = pixelUrl;
        document.body.appendChild(shareSaleEl);
      }

      scope.membership = membership;
      scope.status = paymentStatus;
      scope.retry = function () {

        _this.showPaymentWindow();
      };

      // we probably don't have sa-membership-payment-success available (load it!)
      return modal.open({
        template: '<sa-membership-payment-success status="{{ status }}" membership="membership" done="close()" retry="retry()"></sa-membership-payment-success>',
        scope: scope,
        closeOnStateChange: true
      }).result;
    },
    getBraintreeReloadUrl: function getBraintreeReloadUrl(authCode, paymentData) {
      this.paymentData = paymentData;
      return this.getReloadURL(authCode);
    },
    getReloadURL: function getReloadURL(authCode) {
      var reloadURL = $location.path() + '?authResult=' + authCode + '&duration=' + this.paymentData.duration + '&price=' + this.paymentData.price + '&currency=' + this.paymentData.currency;

      return reloadURL;
    }
  };
}];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$rootScope', '$q', '$http', '$location', 'payModal', 'utils', 'userModel', 'paymentTypes', 'payments', 'modal', 'analytics', 'fastPayModal', 'currencyModel'];
function f($rootScope, $q, $http, $location, payModal, utils, userModel, paymentTypes, payments, modal, analytics, fastPayModal, currencyModel) {
  'ngInject';

  var analyticsCategoryName = 'Booking';
  var analyticsEventName = 'MadePayment';

  return {
    showPaymentWindow: function showPaymentWindow(paymentData) {
      paymentData.meta.PAYMENT_TYPE = paymentTypes.booking;

      var fastPaymentAvailable = userModel.item.membership.activeContract;

      if (fastPaymentAvailable) {
        return fastPayModal.open(paymentData, this);
      } else {
        return payModal.open(paymentData, this);
      }
    },
    processPayment: function processPayment(paymentData) {
      delete paymentData.meta;

      return this.sendPaymentData(paymentData);
    },
    sendPaymentData: function sendPaymentData(paymentData) {
      //  adyen-encrypted-data: "enccypreData",
      //   {
      //   bookingId: this.booking.bookingId,
      //   hours: this.bookingHours,
      //   fullPrice: this.hourlyRate * this.bookingHours,
      //   currency: this.currency,
      //   isForFuturePayments: 1/0
      // };
      var url = utils.getApiUrlV2('/bookings/' + userModel.item.id + '/recurring_payment');
      return new $q(function (resolve, reject) {
        $http.post(url, paymentData).then(function (response) {
          return resolve(response);
        }).catch(reject);
      });
    },
    sendFastPaymentData: function sendFastPaymentData(paymentData) {
      delete paymentData.meta;
      //   {
      //   bookingId: this.booking.bookingId,
      //   hours: this.bookingHours,
      //   fullPrice: this.hourlyRate * this.bookingHours,
      //   currency: this.currency
      // };
      var url = utils.getApiUrlV2('/bookings/' + userModel.item.id + '/contract_payment');
      return new $q(function (resolve, reject) {
        $http.post(url, paymentData).then(function (response) {
          return resolve(response);
        }).catch(reject);
      });
    },


    // deprecated - rewrite
    showCompletedPaymentWindow: function showCompletedPaymentWindow(authResult, booking, location) {
      var _this = this;

      var paymentStatus = payments.getPaymentStatus(authResult);
      var scope = $rootScope.$new();

      if (['successful', 'pending'].indexOf(paymentStatus) > -1) {
        analytics.track(analyticsEventName, {
          category: analyticsCategoryName,
          value: booking.fullPrice,
          currency: currencyModel.getValue()
        });
      }

      scope.booking = booking;
      scope.location = location;
      scope.status = paymentStatus;
      scope.retry = function () {
        // TODO: Fix me
        _this.showPaymentWindow(booking.bookingId, '/conversations/' + booking.guideId);
      };

      return modal.open({
        template: '<completed-payment status="{{ status }}" booking="booking" location="location" done="close()" retry="retry()"></completed-payment>',
        scope: scope,
        closeOnStateChange: true
      }).result;
    },

    getReloadURL: function getReloadURL(authCode) {
      var reloadURL = $location.path() + '?authResult=' + authCode;
      return reloadURL;
    }
  };
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getGuideSearchLocationValue(prediction, place) {
  var detailedPlace = {
    placeId: prediction.placeId,
    name: prediction.description
  };

  if (place.geometry) {
    // LAT LON
    if (place.geometry.location) {
      detailedPlace.lat = place.geometry.location.lat;
      detailedPlace.lon = place.geometry.location.lng;
    }

    // PX, PY
    if (place.geometry.viewport) {
      if (place.geometry.viewport.f && place.geometry.viewport.b) {
        // detailedPlace.px2 = place.geometry.viewport.southwest.lat;
        // detailedPlace.py2 = place.geometry.viewport.southwest.lng;
        detailedPlace.px2 = place.geometry.viewport.f.f;
        detailedPlace.py2 = place.geometry.viewport.b.b;

        // detailedPlace.px1 = place.geometry.viewport.northeast.lat;
        // detailedPlace.py1 = place.geometry.viewport.northeast.lng;
        detailedPlace.px1 = place.geometry.viewport.f.b;
        detailedPlace.py1 = place.geometry.viewport.b.f;
      }
    }
  }

  // COUNTRY CODE
  place.address_components.forEach(function (value) {
    if (value.types[0] === 'country') {
      detailedPlace.countryCode = value.short_name;
    }
  });

  return detailedPlace;
}

var PlacesService = function () {
  PlacesService.$inject = ['$http', 'utils', 'autocompleteService'];

  function PlacesService($http, utils, autocompleteService) {
    'ngInject';

    _classCallCheck(this, PlacesService);

    this.utils = utils;
    this.$http = $http;
    this.autocompleteService = autocompleteService;
  }

  _createClass(PlacesService, [{
    key: 'getDetails',
    value: function getDetails(place, callback) {
      this.autocompleteService.getPlaceDetails(place.placeId).then(function (detailedPlace) {
        callback(getGuideSearchLocationValue(place, detailedPlace.data));
      });
    }
  }, {
    key: 'getPlaceId',
    value: function getPlaceId(slug) {
      if (slug == undefined || slug == '') {
        return false;
      }
      return this.$http.get(this.utils.getApiUrl('locations/') + slug);
    }
  }]);

  return PlacesService;
}();

exports.default = PlacesService;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var preventClick = ['$window', function ($window) {
  var document = $window.document;
  var documentEl = angular.element($window.document);
  var shouldPreventClick;
  var x;
  var y;

  documentEl.on('mousedown touchstart', function () {
    shouldPreventClick = false;
  });

  document.addEventListener('click', function ($event) {
    if (shouldPreventClick && x === $event.clientX && y === $event.clientY) {
      $event.preventDefault();
      $event.stopImmediatePropagation();
    }
  }, true);

  return function (event) {
    x = event.clientX;
    y = event.clientY;
    shouldPreventClick = true;
  };
}];

exports.default = preventClick;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$rootScope', '$q', '$http', 'utils', 'userModel'];
function f($rootScope, $q, $http, utils, userModel) {
  'ngInject';

  function getApiUrl() {
    return utils.getApiUrl('/reviews/' + userModel.item.id + '/feedback');
  }

  return {
    rate: function rate(rateData) {
      return $http.post(getApiUrl(), rateData);
    }
  };
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * `realtime` service
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = realtime;
realtime.$inject = ['$rootScope', '$ocLazyLoad', '$injector', 'config', 'session', 'admin', 'development'];
function realtime($rootScope, $ocLazyLoad, $injector, config, session, admin, development) {
  'ngInject';

  var socket;
  var ioSocket;

  /**
   * Returns query string needed for handshake authorization.
   * @returns {string}
   */
  function getQuery() {
    return 'token=' + session.get().accessToken;
  }

  return {

    init: function init() {
      var _this = this;

      $rootScope.$on('userModel:initialized', function () {
        if (!admin.isAdmin() || development.check()) {
          try {
            new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(41), __webpack_require__(31)]; (function (io, angularSocket) {
              $ocLazyLoad.load({
                name: angularSocket
              }).then(function () {
                var socketFactory = $injector.get('socketFactory');
                _this.connect(io, socketFactory);
              });
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        }
      });
    },

    /**
     * Connects to socket io server or updates query and reconnects, if already connected.
     *
     */
    connect: function connect(io, socketFactory) {
      var _this2 = this;

      var options = {
        query: getQuery()
      };

      if (!socket) {
        ioSocket = io.connect(config.socketUrl, options);
        socket = socketFactory({
          ioSocket: ioSocket
        });

        EVENTS.forEach(function (eventName) {
          socket.forward(eventName);
        });

        DEFAULT_EVENTS.forEach(function (eventName) {
          _this2.startListeningTo(eventName);
        });
      }
    },

    /**
     * @param {String} eventType
     * @param {Object} [data]
     */
    startListeningTo: function startListeningTo(eventType, data) {
      if (socket) {
        socket.emit('startListening', angular.extend({ eventType: eventType }, data));
      }
    },

    /**
     * @param {String} eventType
     * @param {Object} [data]
     */
    stopListeningTo: function stopListeningTo(eventType, data) {
      if (socket) {
        socket.emit('stopListening', angular.extend({ eventType: eventType }, data));
      }
    },

    isTyping: function isTyping(userId) {
      if (socket) {
        socket.emit('typing', { converserId: userId });
      }
    }
  };
}

var EVENTS = ['unreadConversationId', 'unreadConversation', 'newMessage', 'typing', 'updates'];
var DEFAULT_EVENTS = ['unreadConversationId'];

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$window', function ($window) {
  'ngInject';

  return {
    doIt: function doIt(URL) {
      $window.location.href = URL;
    }
  };
}];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var resolveTemplate = ['$http', '$q', '$templateCache', function ($http, $q, $templateCache) {

  /**
   * Resolves a promise with template content.
   *
   * @param {String} template Template or template url.
   * @returns {promise}
   */
  return function (template) {
    if (/.*\.html/.test(template)) {
      return $http.get(template, {
        cache: $templateCache
      }).then(function (response) {
        return response.data;
      });
    } else {
      return $q.resolve(template);
    }
  };
}];

exports.default = resolveTemplate;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Class = {

  //---------- Inheritance API

  /**
   */
  extend: function extend(properties) {
    var superProto = this.prototype || Class;
    var proto = Object.create(superProto);
    // This method will be attached to many constructor functions
    // => must refer to "Class" via its global name (and not via "this")
    Class.copyOwnTo(properties, proto);

    var constr = proto.constructor;
    if (!(constr instanceof Function)) {
      throw new Error('You must define a method \'constructor\'');
    }
    // Set up the constructor
    constr.prototype = proto;
    constr.super = superProto;
    constr.extend = this.extend; // inherit class method
    return constr;
  },

  /**
   */
  copyOwnTo: function copyOwnTo(source, target) {
    Object.getOwnPropertyNames(source).forEach(function (propName) {
      Object.defineProperty(target, propName, Object.getOwnPropertyDescriptor(source, propName));
    });
    return target;
  }
};

var DEFAULT_PAGE_SIZE = 20;

/**
 * `resource` service
 */
var resource = [function () {
  var globalOptions = {};

  this.config = function (options) {
    globalOptions = options || {};
  };

  this.$get = ['$http', '$q', '$rootScope', function ($http, $q, $rootScope) {

    /**
     * Options:
     * url - {String|Function}
     * pageSize - {Number} default limit for Collection.fetch().
     * params - {Object} default request parameters
     *
     * Actions
     *
     * e.g.
     * {
       *    $fetch: { params: { fields: 'name,age' } },
       *    fetch: { params: { fields: 'name' } }
       * }
     *
     *
     * @param {Object} options
     * @param {Object} [actions]
     */
    return function (options, actions) {
      var Collection;
      var Model;

      actions = actions || {};
      options = options || {};

      normalizeOptions(options);

      function getUrl(id) {
        var url;

        if (angular.isFunction(this._options.url)) {
          url = this._options.url.call(this);
        } else {
          url = this._options.url;
        }

        return (globalOptions.baseUrl || '') + url + (id ? '/' + id : '');
      }

      function getRequestConfig(action, options) {
        var config;
        var params;

        params = angular.extend({}, this._options.defaultRequestConfig.params, this._actions[action] && this._actions[action].params || {}, options && options.params || {});

        angular.forEach(params, function (param, key) {
          if (angular.isArray(param)) {
            params[key] = param.join(',');
          }
        });

        config = angular.extend({}, this._options.defaultRequestConfig, this._actions[action] || {}, options || {});

        if (Object.keys(params).length) {
          config.params = params;
        } else {
          delete config.params;
        }

        return config;
      }

      /**
       * Model
       *
       * @param {Object} attributes
       * @constructor
       */
      Model = Class.extend({
        _options: options,
        _actions: actions,

        /**
         * Model contructor.
         *
         * @param {Object} [attributes]
         * @param {Object} [options] - will be accessable as this._constructorOptions
         * @constructor
         */
        constructor: function Model(attributes, options) {
          Object.keys(this._options.nested).forEach(function (attribute) {
            var config = this._options.nested[attribute];
            var constructorOptions = this.$setupOptions(config.options);

            this[attribute] = config.isArray ? config.resource.collection.get(null, constructorOptions) : config.resource.model.get(null, constructorOptions);
            this[attribute]._parentId = attributes && attributes.id;
          }.bind(this));

          this.$set(attributes || {});

          if (angular.isObject(options)) {
            this._constructorOptions = options;
          }
        },

        /**
         * Binds all first level functions to current model instance.
         *
         * @param {Object} options
         * @returns {Object} options with bound functions
         */
        $setupOptions: function $setupOptions(options) {
          var modifiedOptions = angular.copy(options);

          if (angular.isObject(modifiedOptions)) {
            angular.forEach(modifiedOptions, function (property, key) {
              if (angular.isFunction(property)) {
                modifiedOptions[key] = property.bind(this);
              }
            }, this);
          }

          return modifiedOptions;
        },

        /**
         * Makes GET request.
         *
         * Options:
         * params - {Object} query parameters.
         *
         * @param {Object} options
         * @returns {promise}
         */
        $fetch: function $fetch(options) {
          var deferred = $q.defer();

          if (!this.$resolved && !this.$promise) {
            this.$promise = deferred.promise;
            this.$resolved = false;
          }

          $http.get(this.$$getUrl(this.id), this.$$getRequestConfig('$fetch', options)).then(function (response) {

            this.$set(response.data);
            deferred.resolve(response);
          }.bind(this), deferred.reject).finally(function () {
            if (this.$promise === deferred.promise) {
              this.$resolved = true;
              delete this.$promise;
            }
          }.bind(this));

          return deferred.promise;
        },

        /**
         * Makes PUT request if model has id property. Otherwise POST request is made.
         *
         * Options:
         * params - {Object} query parameters.
         * data - {Object} additional request data.
         * merge - {Boolean} should response data be merged into model? Defaults to true.
         *
         * @param {Object} options
         * @param {Array} [attributes] List of model attributes that should be included in request.
         * @returns {promise}
         */
        $save: function $save(options, attributes) {
          var method = this.id ? 'put' : 'post';
          var deferred = $q.defer();
          var data;

          options = options || {};

          data = angular.extend(this.$serialize(attributes), options.data || {});

          if (!this.$resolved && !this.$promise) {
            this.$promise = deferred.promise;
            this.$resolved = false;
          }

          $http[method](this.$$getUrl(this.id), data, this.$$getRequestConfig('$save', options)).then(function (response) {

            if (options.merge !== false) {
              this.$set(response.data);
            }
            deferred.resolve(response);
          }.bind(this), deferred.reject).finally(function () {
            if (this.$promise === deferred.promise) {
              this.$resolved = true;
              delete this.$promise;
            }

            if (method === 'post' && this.id && this._collection) {
              this._collection.removeDuplicates(this.id);
            }
          }.bind(this));

          return deferred.promise;
        },

        /**
         * Makes DELETE request and removes model from collection.
         * @returns {promise}
         */
        $destroy: function $destroy(options) {
          var deferred = $q.defer();

          $http.delete(this.$$getUrl(this.id), this.$$getRequestConfig('$destroy', options)).then(function (response) {

            this._collection && this._collection.remove(this);
            deferred.resolve(response);
          }.bind(this), deferred.reject);

          return deferred.promise;
        },

        /**
         * Returns object that contains only public model's attributes.
         * If `attributes` array is provided, returned object will contain only those attributes.
         *
         * @param {Array} [attributes]
         * @returns {Object}
         */
        $serialize: function $serialize(attributes) {
          var copy = angular.extend({}, this);

          if (attributes) {
            attributes = angular.isArray(attributes) ? attributes : [attributes];
          }

          angular.forEach(copy, function (attribute, key) {
            if (key.substr(0, 1) === '_' || key.substr(0, 1) === '$' || attributes && attributes.indexOf(key) === -1) {
              delete copy[key];
            } else if (attribute && attribute.hasOwnProperty && attribute.hasOwnProperty('_parentId')) {
              copy[key] = attribute.$serialize();
            }
          });

          copy = angular.copy(copy);

          return copy;
        },

        /**
         * Merges data.
         *
         * @param {Object} attributes
         */
        $set: function $set(attributes) {
          var nestedData = {};

          attributes = angular.extend({}, attributes);

          Object.keys(this._options.nested).forEach(function (attribute) {
            if (attributes[attribute]) {
              nestedData[attribute] = attributes[attribute];
              delete attributes[attribute];
            }
          });
          angular.extend(this, attributes);

          Object.keys(nestedData).forEach(function (attribute) {
            var nested = this[attribute],
                config;

            if (nested) {
              config = this._options.nested[attribute];

              if (config.isArray) {
                if (nestedData[attribute].length > 0) {
                  nested.add(nestedData[attribute]);
                }
              } else {
                nested.$set(nestedData[attribute]);
              }
            }
          }.bind(this));
        },

        /**
         * Makes all properties undefined and resets nested properties.
         */
        $reset: function $reset() {
          angular.forEach(this, function (property, key) {
            if (this._options.nested[key]) {
              if (this._options.nested[key].isArray) {
                property.reset();
              } else {
                property.$reset();
              }
            } else if (key.charAt(0) !== '_' && key.charAt(0) !== '$') {
              delete this[key];
            }
          }, this);
        },

        $$getUrl: getUrl,

        $$getRequestConfig: getRequestConfig
      });

      /**
       * Collection
       *
       * @constructor
       */
      Collection = Class.extend({
        _options: options,
        _actions: actions,
        _Model: Model,

        /**
         * Collection constructor.
         *
         * @param {Array|Object|Model} [models]
         * @param {Object} [options] - will be accessable as this._constructorOptions
         * @constructor
         */
        constructor: function Collection(models, options) {
          this._constructorOptions = options || {};

          this.length = 0;
          this.hasMore = true;
          this.offsetModifier = 0;
          this._onBeforeAdd = [];
          this._onAdd = [];
          this._onRemove = [];
          this._onReset = [];
          this._isCollection = true;
          this._duplicateCount = 0;
          this.name = options && options.name;

          models && this.add(models);
        },

        /**
         * Destructor.
         */
        destroy: function destroy() {
          delete this.name;
        },

        /**
         * Makes GET request and adds return models to collection.
         *
         * Options:
         * all - {Boolean} fetch all models.
         * offset - {Number}
         *
         * @param {Object} options
         * @returns {promise}
         */
        fetch: function fetch(options) {
          var deferred = $q.defer();
          var forceOffset;

          options = angular.copy(options) || {};

          if (!options.all) {
            options.params = options.params || {};
            forceOffset = !angular.isUndefined(options.params.offset);

            options.params.offset = forceOffset ? options.params.offset : options.reset ? 0 : this.length + this.offsetModifier;

            /*
             * Increase offset by duplicate count.
             * Needed in matches, because of API cache.
             * Enabled by passing { ignoreDuplicates: true } to constructor options.
             */
            if (this._constructorOptions.ignoreDuplicates && this._duplicateCount && !forceOffset) {

              if (!options.reset) {
                options.params.offset += this._duplicateCount || 0;
              }
            }

            options.params.limit = options.params.limit || this._options.pageSize || DEFAULT_PAGE_SIZE;
          }

          if (!this.resolved && !this.promise) {
            this.promise = deferred.promise;
            this.resolved = false;
          }

          this.isFetching = true;

          $http.get(this.url(), this._getRequestConfig('fetch', options)).then(function (response) {
            if (options.reset) {
              this.reset();
            }

            if (options.all) {
              this.hasMore = false;
            } else {
              this.hasMore = response.data.length === options.params.limit;
            }

            deferred.resolve(this.add(response.data));
          }.bind(this), deferred.reject).finally(function () {
            delete this.isFetching;

            if (this.promise === deferred.promise) {
              this.resolved = true;
              delete this.promise;
            }
          }.bind(this));

          return deferred.promise;
        },

        /**
         * Calls `fetch` method with `all` option.
         *
         * @param options
         * @returns {promise}
         */
        fetchAll: function fetchAll(options) {
          options = options || {};
          options.all = true;

          return this.fetch(options);
        },

        /**
         * Adds one or multiple models to collection.
         * If model with the same id already exists in collection, it's properties will be merged.
         *
         * Using options.index you can specify index where to insert the new models at.
         *
         * @param {Array|Object|Model} models
         * @param {Object} options
         */
        add: function add(models, options) {
          var addedModels = [];
          var insertionOffset = 0;
          var duplicates = [];
          var shouldInsertAtIndex;
          var insertAt;

          options = options || {};

          shouldInsertAtIndex = angular.isDefined(options.index);

          models = angular.isArray(models) || models._isCollection ? models : [models];
          this._executeCallbacks('_onBeforeAdd', models);

          models.forEach(function (model) {
            var index;
            var ids;

            if (this.indexOf(model) > -1) {
              this.sort();
              return;
            }

            model = model instanceof Model ? model : this.create(model);
            model._parentId = this._parentId;
            if (model.id && !index) {
              ids = this.pluck('id');
              index = ids.indexOf(model.id);
            }

            model._collection = this;

            if (index > -1) {
              insertAt = index;

              this[insertAt].$set(model);
              duplicates.push(model);
            } else {
              insertAt = insertionOffset + (shouldInsertAtIndex ? options.index : this.length);

              if (shouldInsertAtIndex) {
                insertionOffset++;
              }

              this.splice(insertAt, 0, model);
            }

            addedModels.splice(insertAt, 0, model);
          }.bind(this));

          this.sort();

          this._executeCallbacks('_onAdd', models);

          if (this.name) {
            $rootScope.$emit(this.name + ':added', addedModels);
          }

          this._duplicateCount += duplicates.length;

          return addedModels;
        },

        /**
         * Removes one or multiple models from collection.
         *
         * @param {Array|Model} models
         * @returns {Array}
         */
        remove: function remove(models, options) {
          var removed = [];
          var isReset = angular.isObject(options) ? options.isReset : false;

          if (models === this) {
            models = this.slice();
          }

          models = angular.isArray(models) ? models : [models];

          models.forEach(function (model) {
            var index = this.indexOf(model);

            if (index > -1) {
              removed.push(this.splice(index, 1)[0]);
            }
          }.bind(this));

          this._executeCallbacks('_onRemove', removed);

          if (this.name) {
            $rootScope.$emit(this.name + ':removed', removed, isReset);
          }

          return removed;
        },

        /**
         * Returns model by id.
         *
         * @param {String|Number} id
         * @returns {Model|undefined}
         */
        'get': function get(id) {
          var index = this.map(function (model) {
            return !angular.isUndefined(model.id) && model.id + '' || undefined;
          }).indexOf(id + '');

          if (index > -1) {
            return this[index];
          }
        },

        /**
         * Sorts collection.
         */
        sort: function sort() {
          var comparator = options.comparator;
          var isDescending;

          if (!comparator) {
            return;
          }

          isDescending = angular.isString(comparator) && comparator.charAt(0) === '-';
          if (isDescending) {
            comparator = comparator.substr(1);
          }

          Array.prototype.sort.call(this, angular.isFunction(comparator) ? comparator : function (a, b) {
            var aIsUndefined = angular.isUndefined(a[comparator]),
                bIsUndefined = angular.isUndefined(b[comparator]);

            if (aIsUndefined && bIsUndefined) {
              return 0;
            } else if (aIsUndefined) {
              return 1;
            } else if (bIsUndefined) {
              return -1;
            }

            return parseFloat(a[comparator]) - parseFloat(b[comparator]);
          });

          if (isDescending) {
            Array.prototype.reverse.call(this);
          }
        },

        pluck: function pluck(attribute) {
          return this.map(function (model) {
            return model[attribute];
          });
        },

        onBeforeAdd: function onBeforeAdd(callback) {
          this._onBeforeAdd.push(callback);
        },

        onAdd: function onAdd(callback) {
          this._onAdd.push(callback);
        },

        onRemove: function onRemove(callback) {
          this._onRemove.push(callback);
        },

        onReset: function onReset(callback) {
          this._onReset.push(callback);
        },

        /**
         * Removes all models from collection.
         */
        reset: function reset() {
          this.remove(this, {
            isReset: true
          });
          this.hasMore = true;
          this.offsetModifier = 0;
          this._duplicateCount = 0;
          this._executeCallbacks('_onReset');

          if (this.name) {
            $rootScope.$emit(this.name + ':reset');
          }
        },

        /**
         * Creates and returns new instance of Model with provided attributes.
         *
         * @param {Object} attributes
         * @returns {Model}
         */
        create: function create(attributes) {
          var modelOptions = angular.isObject(this._constructorOptions) ? this._constructorOptions : null;

          return new this._Model(attributes, modelOptions);
        },

        removeDuplicates: function removeDuplicates(id) {
          var modelsWithSameIds = this.filter(function (model) {
            return model.id === id;
          }),
              duplicateModels;

          if (modelsWithSameIds.length > 1) {
            duplicateModels = modelsWithSameIds.slice(1);

            this.remove(duplicateModels);
          }
        },

        $serialize: function $serialize() {
          var collectionArray = this.map(function (model) {
            return model.$serialize();
          });

          return collectionArray;
        },

        url: getUrl,

        _getRequestConfig: getRequestConfig,

        _executeCallbacks: function _executeCallbacks(name) {
          var args = Array.prototype.slice.call(arguments, 1);

          this[name].forEach(function (callback) {
            callback.apply(this, args);
          }.bind(this));
        }
      });

      ['splice', 'indexOf', 'map', 'forEach', 'filter', 'slice'].forEach(function (methodName) {
        Collection.prototype[methodName] = Array.prototype[methodName];
      });

      return {
        model: {
          _Model: Model,

          /**
           * Returns new Model instance.
           *
           * @param {Object} [attributes]
           * @returns {Model}
           */
          'get': function get(attributes, options) {
            return new this._Model(attributes, options);
          },

          /**
           * Extends Model.prototype.
           *
           * @param {Object} obj
           */
          extend: function extend(obj) {
            angular.extend(this._Model.prototype, obj);
          }
        },
        collection: {
          _Collection: Collection,

          /**
           * Returns new Collection instance.
           *
           * @param {Array|Object|Model} [models]
           * @returns {Collection}
           */
          'get': function get(models, options) {
            return new this._Collection(models, options);
          },

          /**
           * Extends Collection.prototype.
           *
           * @param {Object} obj
           */
          extend: function extend(obj) {
            angular.extend(this._Collection.prototype, obj);
          }
        },
        extend: function extend(options, actions) {
          var clone = angular.copy(this);
          var parentOptions = clone.model._Model.prototype._options;
          var parentActions = clone.model._Model.prototype._actions;
          var extendedOptions;
          var extendedActions;

          actions = actions || {};
          options = options || {};

          extendedOptions = angular.extend({}, parentOptions, normalizeOptions(options));
          extendedActions = angular.extend({}, parentActions, actions);

          // extend nested options separatly because angular.extend is not deep.
          angular.extend(extendedOptions.nested, parentOptions.nested);

          clone.model._Model = this.model._Model.extend({
            _options: extendedOptions,
            _actions: extendedActions,

            constructor: function constructor() {
              clone.model._Model.super.constructor.apply(this, arguments);
            }
          });

          clone.collection._Collection = this.collection._Collection.extend({
            _options: extendedOptions,
            _actions: extendedActions,
            _Model: clone.model._Model,

            constructor: function constructor() {
              clone.collection._Collection.super.constructor.apply(this, arguments);
            }
          });

          return clone;
        }
      };
    };
  }];
}];

function normalizeOptions(options) {
  var defaultRequestConfig = {};

  if (options.params) {
    defaultRequestConfig.params = options.params;
    delete options.params;
  }

  options.defaultRequestConfig = defaultRequestConfig;
  options.nested = options.nested || {};

  return options;
}

exports.default = resource;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var reviews = ['$rootScope', '$q', '$http', 'utils', 'userModel', 'modal', function ($rootScope, $q, $http, utils, userModel) {
  function getApiUrl(revieweeId) {
    return utils.getApiUrl('/reviews/' + userModel.item.id + '/' + revieweeId);
  }

  return {
    fetchReviewInfo: function fetchReviewInfo(revieweeId) {
      var deferred = $q.defer();

      $http.get(getApiUrl(revieweeId)).then(function (response) {
        deferred.resolve(response.data);
      }).catch(deferred.reject);

      return deferred.promise;
    },
    create: function create(revieweeId, reviewData) {
      return $http.post(getApiUrl(revieweeId), reviewData);
    }
  };
}];

exports.default = reviews;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var scrollTop = [function () {
  return function (value) {
    if (angular.isNumber(value)) {
      document.documentElement.scrollTop = value;
      document.body.scrollTop = value;
    }

    return document.documentElement.scrollTop || document.body.scrollTop || 0;
  };
}];

exports.default = scrollTop;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var scrollbarWidth = [function () {
  var width;

  return function () {
    if (typeof width === 'undefined') {
      width = getScrollbarWidth();
    }

    return width;
  };
}];

function getScrollbarWidth() {
  var wrapper = document.createElement('div');
  var content = document.createElement('div');
  var width = void 0;

  wrapper.style.position = 'absolute';
  wrapper.style.top = '-50px';
  wrapper.style.height = '50px';
  wrapper.style.overflow = 'scroll';

  wrapper.appendChild(content);
  document.body.appendChild(wrapper);

  width = wrapper.offsetWidth - content.offsetWidth;

  document.body.removeChild(wrapper);

  return width;
}

exports.default = scrollbarWidth;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOKEN_COOKIE_NAME = 't';
var USER_COOKIE_NAME = 'u';

var session = ['$rootScope', 'Storage', function ($rootScope, Storage) {
  var storage = new Storage('cookie');
  var sessionData = null;

  function updateSessionData(newSessionData) {
    if (!angular.equals(sessionData, newSessionData)) {
      sessionData = newSessionData;
      $rootScope.$emit('session:changed', newSessionData);
    }
  }

  return {
    init: function init() {
      var accessToken = storage.get(TOKEN_COOKIE_NAME);
      var userId = storage.get(USER_COOKIE_NAME);

      if (accessToken && userId) {
        updateSessionData({
          accessToken: accessToken,
          userId: userId
        });
      }
    },
    'set': function set(newSessionData) {
      if (angular.isObject(newSessionData)) {
        storage.set(TOKEN_COOKIE_NAME, newSessionData.accessToken);
        storage.set(USER_COOKIE_NAME, newSessionData.userId);

        updateSessionData(newSessionData);
      } else {
        throw new Error('`sessionData` should be an object');
      }
    },

    'get': function get() {
      return sessionData;
    },

    destroy: function destroy() {
      storage.remove(TOKEN_COOKIE_NAME);
      storage.remove(USER_COOKIE_NAME);
      updateSessionData(null);
    }
  };
}];

exports.default = session;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

f.$inject = ['$http', '$q', 'userModel', 'utils', 'settingsLayoutConfig', 'logout'];


var urls = {
  email: '/email',
  phone: '/phone/add',
  price: '/price'
};
var currentUserProperties = ['name', 'location', 'priceInfo'];

var fieldMap = {
  price: 'priceInfo'
};

// TODO: refactor DRY (see price_form.ctrl)
var getFullPrice = function getFullPrice(hourlyRate, commissionRate) {
  var fullPrice = 0;
  if (hourlyRate) {
    fullPrice = Math.ceil(hourlyRate / (100 - commissionRate) * 100);
  }
  return fullPrice;
};

function f($http, $q, userModel, utils, settingsLayoutConfig, logout) {
  'ngInject';

  this.progress = 10;

  function getPostUrl(fieldName) {
    var url = 'settings/' + userModel.item.id;

    url += urls[fieldName] || '';

    return utils.getApiUrl(url);
  }

  function updateCurrentUser(fieldName, value) {
    var transFormedFieldName = fieldMap[fieldName];
    if (value && currentUserProperties.indexOf(fieldName) > -1) {
      userModel.item[fieldName] = value;
    }

    if (value && currentUserProperties.indexOf(transFormedFieldName) > -1) {
      userModel.item[transFormedFieldName] = value;
    }
  }

  function getFieldList() {
    var fields = [];

    settingsLayoutConfig.layout.forEach(function (section) {
      section.fields.forEach(function (field) {
        fields.push(field.name);
      });
    });

    return fields;
  }

  return {
    data: {},
    reset: function reset() {
      this.data = {};
    },
    fetch: function fetch() {
      var deferred = $q.defer();

      $http.get(utils.getApiUrl('settings/' + userModel.item.id)).then(function (response) {
        this.data = response.data;

        deferred.resolve(this.data);
      }.bind(this)).catch(deferred.reject);

      return deferred.promise;
    },
    save: function save(fieldName, newValue, postDataKey) {
      var _this = this;

      var deferred = $q.defer();
      var postData = {};

      postData[postDataKey || fieldName] = newValue;
      $http.post(getPostUrl(fieldName), postData).then(function (response) {
        var newFieldData = response.data && response.data[fieldName];

        _this.data[fieldName] = newFieldData;
        if (fieldName === 'price') {
          newFieldData.value.fullPrice = getFullPrice(newFieldData.value.price, _this.data.price.commission);
        }
        updateCurrentUser(fieldName, newFieldData.value);
        deferred.resolve(newFieldData.value);
      }).catch(deferred.reject);

      return deferred.promise;
    },

    getValidFieldCount: function getValidFieldCount() {
      var fields = getFieldList();
      var count = 0;
      //var half = false;

      _angular2.default.forEach(this.data || this.data, function (value, key) {
        if (this.isValid(key, this.data) && !this.isRejected(key) && fields.indexOf(key) > -1) {
          count++;
          // if (key === 'email' || key === 'phone') {
          //   if (half) {
          //     count++;
          //   } else {
          //     half = true;
          //   }
          // } else {
          //   count++;
          // }
        }
      }.bind(this));

      this.progress = count * 10;
      return count;
    },

    /**
     * Checks if specified field is valid.
     *
     * @param {String} fieldName
     * @returns {boolean}
     */
    isValid: function isValid(fieldName, data) {
      var fieldData = (data || this.data)[fieldName];
      var value = fieldData.value;
      var isValid = false;

      switch (fieldName) {
        case 'verificationPhoto':
          isValid = Boolean(value);
          break;

        case 'phone':
          isValid = fieldData && fieldData.verified || userModel.hasMessenger();
          break;

        case 'email':
          isValid = fieldData && fieldData.verified;
          break;

        case 'languages':
        case 'activities':
          isValid = value && value.length;
          break;

        case 'location':
          isValid = value && value.placeId;
          break;

        case 'photos':
          isValid = value && value.length && !fieldData.isLoading;
          break;

        case 'price':
          isValid = true;
          break;

        case 'fbMessengerId':
          isValid = userModel.hasMessenger();
          isValid = true;
          break;

        default:
          isValid = Boolean(value);
          break;
      }

      return isValid;
    },

    /**
     * Checks if specified field is rejected.
     *
     * @param {String} fieldName
     * @returns {boolean}
     */
    isRejected: function isRejected(fieldName) {
      var fieldData = this.data[fieldName] || {};

      return fieldData.rejected;
    },

    // Phone/email verification

    resendEmailVerification: function resendEmailVerification() {
      return $http.get(utils.getApiUrl('settings/' + userModel.item.id + '/email/resend'));
    },

    verifyEmail: function verifyEmail(code) {
      var deferred = $q.defer();
      var httpPromise = $http.post(utils.getApiUrl('settings/' + userModel.item.id + '/email'), {
        code: code
      });

      httpPromise.then(function () {
        this.data.email.verified = true;
        deferred.resolve(this.data.email);
      }.bind(this)).catch(deferred.reject);

      return deferred.promise;
    },

    verifyPhone: function verifyPhone(code) {
      var deferred = $q.defer();
      var httpPromise = $http.post(utils.getApiUrl('settings/' + userModel.item.id + '/phone/verify'), {
        code: code
      });

      httpPromise.then(function () {
        this.data.phone.verified = true;
        deferred.resolve(this.data.phone);
      }.bind(this)).catch(deferred.reject);

      return deferred.promise;
    },

    resendPhoneVerification: function resendPhoneVerification() {
      return $http.get(utils.getApiUrl('settings/' + userModel.item.id + '/phone/resend'));
    },

    cancelAccount: function cancelAccount(reason) {
      return $http.post(utils.getApiUrl('settings/' + userModel.item.id + '/remove_profile'), { message: reason }).then(logout);
    }
  };
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
var fields = {
  email: {
    label: 'Email',
    name: 'email',
    template: '<email-form></email-form>'
  },
  // phone: {
  //   label: 'Booking notifications',
  //   name: 'phone',
  //   template: '<phone-form></phone-form>'
  // },
  price: {
    label: 'Hourly rate',
    name: 'price',
    template: '<price-form></price-form>'
  },

  photos: {
    label: 'Profile photos',
    name: 'photos',
    template: '<photos-form></photos-form>',
    loadingText: 'Uploading <span class="u-hidden-m-inline">from Facebook</span>'
  },
  name: {
    label: 'Name',
    name: 'name',
    template: '<name-form></name-form>'
  },
  languages: {
    label: 'Languages',
    name: 'languages',
    template: '<languages-form></languages-form>'
  },
  shortDescription: {
    label: 'Motto',
    name: 'shortDescription',
    template: '<short-description-form></short-description-form>'
  },
  aboutMe: {
    label: 'About me',
    name: 'aboutMe',
    template: '<about-me-form></about-me-form>'
  },
  location: {
    label: 'Location',
    name: 'location',
    template: '<location-form></location-form>'
  },
  tourDescription: {
    label: 'I will show you',
    name: 'tourDescription',
    template: '<tour-description-form></tour-description-form>'
  },
  activities: {
    label: 'Activities',
    name: 'activities',
    template: '<activities-form></activities-form>'
  }
};

var guideSettingsLayout = {
  layout: [{
    header: 'SETTINGS_SECTIONS.GENERAL',
    fields: [fields.name, fields.location, fields.photos, fields.languages, fields.aboutMe]
  }, {
    header: 'SETTINGS_SECTIONS.GUIDE',
    fields: [fields.shortDescription, fields.tourDescription, fields.activities, fields.price]
  }, {
    header: 'SETTINGS_SECTIONS.CONTACT',
    fields: [fields.email]
  }],
  stepCount: 11
};

function f() {
  return guideSettingsLayout;
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shuffle;
function shuffle() {
  return function shuffle(array) {
    var copy = angular.copy(array);

    for (var i = copy.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }

    return copy;
  };
}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$location', 'social', 'userModel'];
function f($location, social, userModel) {
  'ngInject';

  var _this = this;

  this.constructUrl = function (userId) {
    return $location.protocol() + '://' + $location.host() + '/locals/' + userId;
  };

  this.facebook = function () {
    social.fetchScripts('fb').then(function () {
      social.getSocialNetwork('fb').share(_this.url);
    });
  };

  this.getText = function (userId, name) {
    var text = '';
    if (userId === userModel.item.id) {
      text = 'Check out my profile on Showaround! Discover cities with locals.';
    } else {
      text = 'Check out ' + name + '\'s profile on Showaround! Discover cities with locals.';
    }

    return text;
  };

  return {
    share: function share(userId) {
      _this.url = _this.constructUrl(userId);
      return function (network) {
        return _this[network]();
      };
    },

    getShareUrl: function getShareUrl() {
      return _this.constructUrl();
    },

    twitterURL: function twitterURL(userId, name) {
      var text = _this.getText(userId, name);
      var url = _this.constructUrl(userId);
      var hashtags = 'Showaround';
      var tweetUrl = 'https://twitter.com/intent/tweet?text=' + text + '&url=' + url + '\n&hashtags=' + hashtags;
      return tweetUrl;
    },

    linkedInURL: function linkedInURL(userId, name) {
      var title = userId === userModel.item.id ? 'I\'m on Showaround' : name + '\'s Showaround profile';
      var url = _this.constructUrl(userId);
      var summary = _this.getText(userId, name);
      var linkedInURL = 'https://www.linkedin.com/shareArticle?mini=true&url=\n' + url + '&title=' + title + '&summary=' + summary;
      return linkedInURL;
    }
  };
}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
var sound = 'data:audio/mpeg;base64,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';

function f() {
  'ngInject';

  return {
    init: function init() {
      try {
        this.notificationSound = new Audio(sound);
      } catch (e) {
        //
      }
    },
    playNotification: function playNotification() {
      try {
        this.notificationSound.play();
      } catch (e) {
        //
      }
    }
  };
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var COOKIE_NAME = 'sn';
var DEFAULT_SOCIAL_NETWORK = 'fb';
var SOCIAL_NETWORKS = ['fb', 'vk'];

var social = ['$q', 'facebook', 'vk', 'userModel', 'Storage', function ($q, facebook, vk, userModel, Storage) {
  var cookieStorage = new Storage('cookie');
  var socials = {
    fb: facebook,
    vk: vk
  };

  /**
   * Returns main social network option.
   * @returns {String}
   */
  function getMainSocialNetwork() {
    var mainSocialNetwork;

    // Get social network storred in user model or cookie storage
    if (userModel.item.id) {
      mainSocialNetwork = userModel.item.socialNetwork;
    } else {
      mainSocialNetwork = cookieStorage.get(COOKIE_NAME);
    }

    // Return default social network if value is invalid
    if (SOCIAL_NETWORKS.indexOf(mainSocialNetwork) === -1) {
      mainSocialNetwork = DEFAULT_SOCIAL_NETWORK;
    }

    return mainSocialNetwork;
  }

  return {
    login: function login(networkName) {
      return socials[networkName].login();
    },

    getPhotoPermissions: function getPhotoPermissions(networkName) {
      return socials[networkName].getPhotoPermissions();
    },

    getAlbums: function getAlbums(networkName) {
      return socials[networkName].getAlbums();
    },

    getPhotosOfYou: function getPhotosOfYou(networkName) {
      return socials[networkName].getPhotosOfYou();
    },

    getPhotos: function getPhotos(networkName, albumId) {
      return socials[networkName].getPhotos(albumId);
    },

    getPhotoUrl: function getPhotoUrl(networkName, photoId) {
      return socials[networkName].getPhotoUrl(photoId);
    },

    fetchScripts: function fetchScripts(networkName) {
      return socials[networkName] && socials[networkName].fetchScript();
    },

    getSocialNetwork: function getSocialNetwork(networkName) {
      return socials[networkName];
    },

    getUserSocialNetwork: getMainSocialNetwork
  };
}];

exports.default = social;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// A list of potentially troublesome currencies that should have resized font-size
// TODO: use in membership buy modal

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  currencyList: ['IDR']
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$rootScope', 'analytics', 'localStorage', 'userModel'];
var storageKey = 'auForget';
var analyticsEvent = 'Forget';

function f($rootScope, analytics, localStorage, userModel) {
  'ngInject';

  /**
   * Emits analytics event which stops ads for this browser.
   */

  function stopRemarketing() {
    if (!parseInt(localStorage.get(storageKey), 10)) {
      analytics.track(analyticsEvent);
      localStorage.set(storageKey, 1);
    }
  }

  return {
    init: function init() {
      $rootScope.$on('userModel:initialized', function () {
        if (userModel.item.auForget) {
          stopRemarketing();
        }
      });
    }
  };
}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultStorage = 'memory';
var defaultCookieOptions = {
  path: '/'
};

/**
 * `Storage` service
 */
var Storage = ['$window', '$cookies', function ($window, $cookies) {
  var storages = {};

  function supportsLocalStorage() {
    var test = 'test';

    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  var MemoryStorage = function () {
    function MemoryStorage() {
      _classCallCheck(this, MemoryStorage);

      this._store = {};
    }

    _createClass(MemoryStorage, [{
      key: 'getItem',
      value: function getItem(key) {
        return this._store[key] || null;
      }
    }, {
      key: 'setItem',
      value: function setItem(key, value) {
        this._store[key] = value;
      }
    }, {
      key: 'removeItem',
      value: function removeItem(key) {
        delete this._store[key];
      }
    }]);

    return MemoryStorage;
  }();

  var CookieStorage = function () {
    function CookieStorage() {
      _classCallCheck(this, CookieStorage);
    }

    _createClass(CookieStorage, [{
      key: 'getItem',
      value: function getItem(key) {
        return $cookies.get(key) || null;
      }
    }, {
      key: 'setItem',
      value: function setItem(key, value, options) {
        $cookies.put(key, value, angular.extend(getDefaultCookieOptions(), options));
      }
    }, {
      key: 'removeItem',
      value: function removeItem(key) {
        $cookies.remove(key);
      }
    }]);

    return CookieStorage;
  }();

  var Storage = function () {
    function Storage(type) {
      _classCallCheck(this, Storage);

      this._storage = storages[type] || storages[defaultStorage];
    }

    _createClass(Storage, [{
      key: 'get',
      value: function get(key) {
        return this._storage.getItem(key);
      }
    }, {
      key: 'set',
      value: function set(key, value, options) {
        this._storage.setItem(key, value, options);
      }
    }, {
      key: 'remove',
      value: function remove(key) {
        this._storage.removeItem(key);
      }
    }]);

    return Storage;
  }();

  var hasLocalStorage = supportsLocalStorage();

  Storage.hasLocalStorage = hasLocalStorage;
  if (hasLocalStorage) {
    storages['local'] = $window.localStorage;
  }

  storages['memory'] = new MemoryStorage();
  storages['cookie'] = new CookieStorage();

  return Storage;
}];

function getDefaultCookieOptions() {
  var date = new Date();

  date.setFullYear(date.getFullYear() + 1);
  defaultCookieOptions.expires = date;

  return defaultCookieOptions;
}

exports.default = Storage;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOCAL_STORAGE_KEY = 'tempUser';
var temporaryUser = ['Storage', function (Storage) {
  var localStorage = new Storage(Storage.hasLocalStorage ? 'local' : 'memory');

  return {
    setData: function setData(data) {
      if (angular.isObject(data)) {
        localStorage.set(LOCAL_STORAGE_KEY, JSON.stringify(data));
      }
    },
    getData: function getData() {
      var data = null;

      try {
        data = JSON.parse(localStorage.get(LOCAL_STORAGE_KEY));
      } catch (error) {
        return;
      }

      return data;
    },
    remove: function remove() {
      localStorage.remove(LOCAL_STORAGE_KEY);
    }
  };
}];

exports.default = temporaryUser;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['userModel'];
function f(userModel) {
  'ngInject';

  return {
    testUser: function testUser() {
      var testUsersIds = [
      // Audrius Tomas Paulius Linas Mantas Darius
      9501121, 9501129, 9525236, 9501128, 9501124, 9501120];
      if (testUsersIds.indexOf(userModel.item.id) !== -1) {
        return true;
      } else {
        return false;
      }
    }
  };
}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 throttle(function, wait, [options])

 Creates and returns a new, throttled version of the passed function,
 that, when invoked repeatedly, will only actually call the original
 function at most once per every wait milliseconds.
 Useful for rate-limiting events that occur faster than you can keep up with.

 By default, throttle will execute the function as soon as you call it for the first time,
 and, if you call it again any number of times during the wait period,
 as soon as that period is over. If you'd like to disable the leading-edge call,
 pass {leading: false}, and if you'd like to disable the execution on the trailing-edge, pass
 {trailing: false}.

 @param {function} function that you want to be throttled
 @param {integer} wait - function will be called at most once per every wait milliseconds.
 @param {object} [options] - custom settings for thorttled function execution
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var throttle = ['$timeout', function ($timeout) {

  function throttle(func, wait, options) {
    var timeoutPromise = null;
    var previous = 0;
    var context;
    var args;
    var result;

    options || (options = {});

    function later() {
      previous = options.leading === false ? 0 : new Date();
      timeoutPromise = null;
      result = func.apply(context, args);
    }

    return function () {
      var now = new Date();
      var remaining;

      if (!previous && options.leading === false) {
        previous = now;
      }
      remaining = wait - (now - previous);
      context = this;
      args = arguments;

      if (remaining <= 0) {
        $timeout.cancel(timeoutPromise);
        timeoutPromise = null;
        previous = now;
        result = func.apply(context, args);
      } else if (!timeoutPromise && options.trailing !== false) {
        timeoutPromise = $timeout(later, remaining);
      }
      return result;
    };
  }

  return throttle;
}];

exports.default = throttle;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SESSION_COOKIE_NAME = 'se';

var tracking = ['$rootScope', '$http', 'Storage', function ($rootScope, $http, Storage) {
  var cookieStorage = new Storage('cookie');

  /**
   * Checks if session cookie exists.
   * @returns {boolean}
   */
  function checkCookie() {
    return !!cookieStorage.get(SESSION_COOKIE_NAME);
  }

  function sendTrackingData(shouldSaveData) {
    $http.post('/tracking', null, {
      params: {
        save: shouldSaveData
      }
    });
  }

  function extendSessionCookieExpiration() {
    var date = new Date();

    date.setMinutes(date.getMinutes() + 30);
    cookieStorage.set(SESSION_COOKIE_NAME, cookieStorage.get(SESSION_COOKIE_NAME), {
      path: '/',
      expires: date
    });
  }

  return {
    init: function init() {
      $rootScope.$on('$stateChangeSuccess', function () {
        if (!checkCookie()) {
          sendTrackingData();
        } else {
          extendSessionCookieExpiration();
        }
      });
    },

    sendTrackingData: sendTrackingData
  };
}];

exports.default = tracking;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$timeout', 'unreadConversationIds'];
function f($timeout, unreadConversationIds) {
  'ngInject';

  return {
    title: document.title,
    notificationTitle: '',
    notifyTitle: function notifyTitle() {
      this.notificationTitle = '(' + unreadConversationIds.getIds().length + ') ' + this.title;
      clearInterval(this.interval);
      document.title = this.notificationTitle;
    },
    readTitle: function readTitle() {
      document.title = this.title;
    }
  };
}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var unreadConversationIds = ['$rootScope', 'userModel', 'sounds', function ($rootScope, userModel, sounds) {
  var ids = [];
  var service = {
    add: function add(idsToAdd) {
      idsToAdd = angular.isArray(idsToAdd) ? idsToAdd : [idsToAdd];
      idsToAdd.forEach(addId);
    },
    getIds: function getIds() {
      return ids;
    },
    isEmpty: function isEmpty() {
      return !ids.length;
    },
    remove: function remove(id) {
      var index = ids.indexOf(id);

      if (index > -1) {
        ids.splice(index, 1);
      }
    },
    reset: function reset() {
      ids.length = 0;
    }
  };

  function addId(id) {
    if (angular.isNumber(id) && ids.indexOf(id) === -1) {
      ids.push(id);
    }
  }

  $rootScope.$on('socket:unreadConversationId', function (event, data) {
    service.add(data.id);
  });

  $rootScope.$on('userModel:initialized', function () {
    service.add(userModel.item.unreadConversationsIds);
  });

  $rootScope.$on('location:update', function () {
    if (userModel.item.unreadConversationsIds && userModel.item.unreadConversationsIds.length) {
      service.add(userModel.item.unreadConversationsIds);
      sounds.playNotification();
    }
  });

  return service;
}];

exports.default = unreadConversationIds;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

f.$inject = ['$http', '$q', 'utils'];


var postConfig = {
  headers: {
    'Content-Type': undefined
  },
  transformRequest: _angular2.default.identity
};

function f($http, $q, utils) {
  'ngInject';

  function uploadFile(path, file) {
    var formData = new FormData();
    formData.append('photo', file);

    return new $q(function (resolve, reject) {
      var url = utils.getApiUrl(path);

      $http.post(url, formData, postConfig).then(function (response) {
        return resolve(response.data);
      }).catch(reject);
    });
  }

  return function uploadPhoto(url, files) {
    var promises = [];
    _angular2.default.forEach(files, function (file) {
      return promises.push(uploadFile(url, file));
    });

    return promises;
  };
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var userInteraction = ['$document', '$rootScope', 'throttle', function ($document, $rootScope, throttle) {
  var callCount = 0;
  var emit = throttle(function emit() {
    $rootScope.$emit('userInteraction');
  }, 300, { trailing: false });

  return {
    startListening: function startListening() {
      if (!callCount) {
        $document.on('mousemove', emit);
        $document.on('touchstart', emit);
        $document.on('keydown', emit);
      }

      callCount++;
    },
    stopListening: function stopListening() {
      callCount = Math.min(callCount - 1, 0);

      if (!callCount) {
        $document.off('mousemove', emit);
        $document.off('touchstart', emit);
        $document.off('keydown', emit);
      }
    }
  };
}];

exports.default = userInteraction;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var utils = ['config', function (config) {
  return {
    getApiUrl: function getApiUrl(path) {
      return ((config.apiBaseUrl || '') + '/' + (path || '')).replace(/([^:]|^)\/{2,}/g, '$1/');
    },
    getApiUrlV2: function getApiUrlV2(path) {
      return ((config.apiBaseUrlV2 || '') + '/' + (path || '')).replace(/([^:]|^)\/{2,}/g, '$1/');
    }
  };
}];

exports.default = utils;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var authUrl = 'https://oauth.vk.com/authorize';
var scriptUrl = '//vk.com/js/api/openapi.js';
var photoVersions = ['xxbig', 'xbig', 'big'];
var minPhotoSize = 320;

var vk = ['$window', '$state', '$q', 'jsLoader', 'auth', 'config', 'localStorage', function ($window, $state, $q, jsLoader, auth, config, localStorage) {
  var vkConfig = config.socials.vk;
  var loaderPromise;
  var VK;
  var vkSession;

  function getRedirectUrl() {
    var location = $window.location;

    return location.protocol + '//' + location.host + $state.href('vkLogin', { code: '' });
  }

  var getCurrency = function getCurrency() {
    return localStorage.get('currency');
  };

  function getLoaderPromise() {
    if (!loaderPromise) {
      loaderPromise = jsLoader(scriptUrl, 'VK').then(function (vkApi) {
        var deferred = $q.defer();

        VK = vkApi;
        VK.init({
          apiId: vkConfig.appId
        });

        VK.Auth.getLoginStatus(function (response) {
          if (response.session) {
            vkSession = response.session;
          }

          deferred.resolve();
        });

        return deferred.promise;
      });
    }

    return loaderPromise;
  }

  function loginToVK() {
    var deferred = $q.defer();

    if (!vkSession) {
      VK.Auth.login(function (response) {
        if (response.session) {
          deferred.resolve(response.session);
        } else {
          deferred.reject();
        }
      }, vkConfig.scope);
    } else {
      deferred.resolve(vkSession);
    }

    return deferred.promise;
  }

  function _getAlbums() {
    var deferred = $q.defer();
    var options = {
      'need_covers': 1,
      https: true
    };
    var albums;

    VK.Api.call('photos.getAlbums', options, function (response) {
      if (response.response) {
        albums = response.response.map(function (album) {
          return {
            id: album.aid,
            name: album.title,
            coverPhoto: album['thumb_src']
          };
        });
        deferred.resolve(albums);
      } else {
        deferred.reject(response);
      }
    });

    return deferred.promise;
  }

  function getPhotoUrl(photo) {
    var photoUrl = null;
    var total = photoVersions.length;
    var versionName;
    var iter;

    for (iter = 0; iter < total; iter++) {
      versionName = 'src_' + photoVersions[iter];
      if (photo[versionName]) {
        photoUrl = photo[versionName];
        break;
      }
    }

    return photoUrl;
  }

  function _getPhotos(albumId) {
    var deferred = $q.defer();
    var options = {
      'album_id': albumId,
      https: true
    };
    var photos;

    VK.Api.call('photos.get', options, function (response) {
      if (response.response) {
        photos = response.response.filter(function (photo) {
          return photo.height >= minPhotoSize && photo.width >= minPhotoSize;
        }).map(function (photo) {
          return {
            id: photo.pid,
            albumId: photo.aid,
            src: getPhotoUrl(photo),
            url: photo.src
          };
        });
        deferred.resolve(photos);
      } else {
        deferred.reject(response);
      }
    });

    return deferred.promise;
  }

  return {
    login: function login() {
      var promise = getLoaderPromise().then(function () {
        return loginToVK();
      }).then(function (vkSession) {
        return auth.socialLogin('vk', vkSession.sid, vkSession.mid);
      });

      return promise;
    },

    loginWithCode: function loginWithCode(code) {
      return auth.login('/vk_code', {
        code: code,
        redirectUrl: getRedirectUrl(),
        currency: getCurrency()
      });
    },

    getPhotoPermissions: loginToVK,

    getAlbums: function getAlbums(albumId) {
      var promise = getLoaderPromise().then(function () {
        return loginToVK();
      }).then(function () {
        return _getAlbums(albumId);
      });

      return promise;
    },

    getPhotos: function getPhotos(albumId) {
      var promise = getLoaderPromise().then(function () {
        return loginToVK();
      }).then(function () {
        return _getPhotos(albumId);
      });

      return promise;
    },

    fetchScript: function fetchScript() {
      return getLoaderPromise();
    },

    getAuthUrl: function getAuthUrl() {
      return authUrl + '?client_id=' + vkConfig.appId + '&scope=' + vkConfig.scope + '&redirect_uri=' + getRedirectUrl() + '&response_type=code' + '&v=5.37';
    }
  };
}];

exports.default = vk;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$q', '$http', 'utils'];
function f($q, $http, utils) {
  'ngInject';

  return {
    reviewLeft: function reviewLeft(userId, userToReviewId) {
      var GET_REQUEST_URL = utils.getApiUrl('/reviews/' + userId + '/' + userToReviewId + '/friend');

      var promiseArgumentFunction = function promiseArgumentFunction(resolve, reject) {
        if (userId == userToReviewId) {
          resolve({ reviewLeft: true });
          return;
        }

        $http.get(GET_REQUEST_URL).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response.data);
        });
      };

      return new $q(promiseArgumentFunction);
    }
  };
}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isFetching: null
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$http', 'utils', 'userModel'];
function f($http, utils, userModel) {
  'ngInject';

  function getApiUrl(offender_id) {
    return utils.getApiUrl('/reports/' + userModel.item.id + '/' + offender_id);
  }

  return {
    reportMessage: '',
    sendReport: function sendReport(conversation, message) {
      var data;
      if (message.$type === 'message') {
        data = {
          content: message.content,
          id: message.id,
          type: message.$type,
          report: this.reportMessage
        };
      } else if (message.$type === 'booking') {
        data = {
          bookingId: message.bookingId,
          type: message.$type,
          contentResponse: message.data.responseMessage && message.data.responseMessage.content,
          contentRequest: message.data.requestMessage && message.data.requestMessage.content,
          report: this.reportMessage
        };
      }

      return $http.post(getApiUrl(conversation.id), data);
    }
  };
}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  showPrice: true
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$window', '$ocLazyLoad', '$compile', '$rootScope', 'Storage', 'userModel'];
var STORAGE_KEY = 'appBecomeGuideBanner_dismissed';

function f($window, $ocLazyLoad, $compile, $rootScope, Storage, userModel) {
  'ngInject';

  var storage = new Storage('local');

  return {
    init: function init() {
      var _this = this;

      var unbind = $rootScope.$on('$stateChangeStart', function () {
        unbind();
        if (_this.shouldDisplay()) {
          _this.display();
        }
      });
    },
    display: function display() {
      __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 589)).then(function () {
        return $ocLazyLoad.load({ name: 'components.appBecomeGuideBanner' });
      }).then(function () {
        var element = $compile('<sa-app-become-guide-banner></sa-app-become-guide-banner>')($rootScope.$new());
        $window.document.body.appendChild(element[0]);
      });
    },
    shouldDisplay: function shouldDisplay() {
      var isClosed = storage.get(STORAGE_KEY);

      if (isClosed) {
        return false;
      }

      if (userModel.item.id) {
        return false;
      }

      return true;
    },
    dismiss: function dismiss() {
      storage.set(STORAGE_KEY, true);
    }
  };
}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$rootScope', '$state'];
function f($rootScope, $state) {
  'ngInject';

  return {
    init: function init() {
      var _this = this;

      $rootScope.$on('$stateChangeSuccess', function () {
        _this.set($state.$current.locals.globals.meta);
      });
    },
    set: function set() {
      var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      $rootScope.meta = meta;
    }
  };
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$filter'];
function f($filter) {
  'ngInject';

  return {
    it: function it(input) {
      if (!input) {
        input = '';
      }
      return $filter('titleCase')($filter('dashesWithSpaces')(input));
    },
    activities: function activities(input) {
      return $filter('dashesWithSpaces')(input).replace(' and ', ' & ');
    }
  };
}

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$filter'];
function f($filter) {
  'ngInject';

  return {
    it: function it(input) {
      return $filter('lowercase')($filter('spacesWithDashes')(input));
    }
  };
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _intro_video = __webpack_require__(299);

var _intro_video2 = _interopRequireDefault(_intro_video);

var _intro_video3 = __webpack_require__(300);

var _intro_video4 = _interopRequireDefault(_intro_video3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function saIntroVideo() {
  return {
    template: _intro_video2.default,
    replace: true,
    scope: {
      video: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: _intro_video4.default
  };
}

saIntroVideo.$inject = [];

exports.default = saIntroVideo;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = "<div class=\"IntroVideo\">\n  <div class=\"IntroVideo-gradient\"></div>\n  <div class=\"IntroVideo-cover lazypreload lazyload\" data-bgset=\"{{ ::ctrl.video.coverMobile }} 745w, {{ ::ctrl.video.cover }} 1280w\" data-sizes=\"auto\"></div>\n\n  <div class=\"IntroVideo-content\">\n    <h2 ng-bind-html=\"::ctrl.video.heading\"></h2>\n  </div>\n</div>\n";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IntroVideoCtrl = function () {
  function IntroVideoCtrl(slideshow) {
    _classCallCheck(this, IntroVideoCtrl);

    this.slideshow = slideshow;
  }

  _createClass(IntroVideoCtrl, [{
    key: 'playVideo',
    value: function playVideo() {
      this.slideshow.show([{
        type: 'video',
        id: 144345301
      }]);
    }
  }]);

  return IntroVideoCtrl;
}();

IntroVideoCtrl.$inject = ['slideshow'];

exports.default = IntroVideoCtrl;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _intro_videos = __webpack_require__(302);

var _intro_videos2 = _interopRequireDefault(_intro_videos);

var _intro_videos3 = __webpack_require__(303);

var _intro_videos4 = _interopRequireDefault(_intro_videos3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function saIntroVideos() {
  return {
    template: _intro_videos2.default,
    replace: true,
    scope: {},
    bindToController: true,
    controllerAs: 'ctrl',
    controller: _intro_videos4.default
  };
}

saIntroVideos.$inject = [];

exports.default = saIntroVideos;

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = "<section class=\"IntroVideos\">\n  <div class=\"IntroVideos-controls\">\n    <a class=\"IntroVideos-previous\" ng-click=\"ctrl.showPrevious()\"><i class=\"Icon Icon-angleLeft\"></i></a>\n    <a class=\"IntroVideos-next\" ng-click=\"ctrl.showNext()\"><i class=\"Icon Icon-angleRight\"></i></a>\n\n    <div class=\"IntroVideo-buttons\">\n      <button class=\"IntroVideo-playButton\"\n              ng-class=\"{ 'is-highlighted': ctrl.isHighlighted }\"\n              ng-click=\"ctrl.playVideo()\"\n              ng-mouseenter=\"ctrl.isHighlighted = true\"\n              ng-mouseleave=\"ctrl.isHighlighted = false\">\n        <i class=\"Icon Icon-youtubePlay\"></i>\n        <span>Watch video</span>\n      </button>\n\n      <a class=\"IntroVideos-viewProfile\"\n         ui-sref=\"guides.guide({ guideId: ctrl.videos[ctrl.currentIndex].guideId })\"\n      >{{ 'INTRO_VIDEOS.VIEW_PROFILE_BTN' | translate:{ name: (ctrl.videos[ctrl.currentIndex].name | possessive) } }}</a>\n    </div>\n\n    <ul class=\"IntroVideos-indicators\">\n      <li ng-class=\"{ 'is-active': ctrl.currentIndex === $index }\" ng-repeat=\"video in ctrl.videos\">\n        <a ng-click=\"ctrl.showPage($index)\">\n          <img class=\"lazyload\" data-src=\"{{ ::video.thumb }}\" sa-src-placeholder>\n          <p class=\"IntroVideos-videoName\" ng-bind-html=\"::video.heading\"></p>\n          <p class=\"IntroVideos-guideLocation\">{{ ::video.locationName }}</p>\n        </a>\n      </li>\n    </ul>\n  </div>\n\n  <ul>\n    <li class=\"is-ngAnimationEnabled\" ng-repeat=\"video in ctrl.videos\" ng-show=\"$index === ctrl.currentIndex\">\n      <sa-intro-video video=\"video\" ng-class=\"{ 'is-highlighted': ctrl.isHighlighted }\"></sa-intro-video>\n    </li>\n  </ul>\n</section>\n";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var maxVideoCount = 3;

var IntroVideosCtrl = function () {
  IntroVideosCtrl.$inject = ['$stateParams', 'videos', 'slideshow', 'shuffle'];

  function IntroVideosCtrl($stateParams, videos, slideshow, shuffle) {
    'ngInject';

    _classCallCheck(this, IntroVideosCtrl);

    this.slideshow = slideshow;
    this.currentIndex = 0;

    var placeId = $stateParams.placeId;
    if (placeId) {
      this.videos = videos.filter(function (video) {
        return video.placeId === placeId;
      }).concat(videos.filter(function (video) {
        return video.placeId !== placeId;
      }));
    } else {
      this.videos = shuffle(videos);
    }

    this.videos = this.videos.slice(0, maxVideoCount);
  }

  _createClass(IntroVideosCtrl, [{
    key: 'playVideo',
    value: function playVideo() {
      this.slideshow.show([this.videos[this.currentIndex]], 0, { isCounterVisible: false });
    }
  }, {
    key: 'showPage',
    value: function showPage(pageIndex) {
      var videoCount = this.videos.length;
      this.currentIndex = (pageIndex % videoCount + videoCount) % videoCount;
    }
  }, {
    key: 'showNext',
    value: function showNext() {
      this.showPage(this.currentIndex + 1);
    }
  }, {
    key: 'showPrevious',
    value: function showPrevious() {
      this.showPage(this.currentIndex - 1);
    }
  }]);

  return IntroVideosCtrl;
}();

exports.default = IntroVideosCtrl;

/***/ }),
/* 304 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "INTRO_VIDEOS": {
    "VIEW_PROFILE_BTN": "View {name} profile"
  }
}
);  }]);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _services = __webpack_require__(4);

var _services2 = _interopRequireDefault(_services);

var _constants = __webpack_require__(5);

var _constants2 = _interopRequireDefault(_constants);

var _location_search_form = __webpack_require__(306);

var _location_search_form2 = _interopRequireDefault(_location_search_form);

var _location_search_input = __webpack_require__(307);

var _location_search_input2 = _interopRequireDefault(_location_search_input);

var _location_search_prediction = __webpack_require__(308);

var _location_search_prediction2 = _interopRequireDefault(_location_search_prediction);

var _location_search_predictions = __webpack_require__(310);

var _location_search_predictions2 = _interopRequireDefault(_location_search_predictions);

var _location_prediction = __webpack_require__(312);

var _location_prediction2 = _interopRequireDefault(_location_prediction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_services2.default, _constants2.default];

exports.default = _angular2.default.module('common.locationSearch', dependencies).directive('saLocationSearchForm', _location_search_form2.default).directive('saLocationSearchInput', _location_search_input2.default).directive('saLocationSearchPrediction', _location_search_prediction2.default).directive('saLocationSearchPredictions', _location_search_predictions2.default).filter('highlightLocationPrediction', _location_prediction2.default).name;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saLocationSearchFormCtrl = ['$element', function ($element) {
  this.submitForm = function () {
    $element.triggerHandler('submit');
  };
}];
var saLocationSearchForm = [function () {
  return {
    restrict: 'A',
    priority: 2,
    controller: saLocationSearchFormCtrl
  };
}];

exports.default = saLocationSearchForm;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var containerTemplate = '<sa-location-search-predictions></sa-location-search-predictions>';
var formatValue = function formatValue(value) {
  var viewValue;

  if (angular.isString(value)) {
    viewValue = value;
  } else if (angular.isObject(value)) {
    viewValue = value.fullName || value.name;
  }

  return viewValue;
};
var saLocationSearchInput = ['$document', '$timeout', '$compile', 'keyCodes', 'autocompleteService', function ($document, $timeout, $compile, keyCodes, autocompleteService) {
  return {
    restrict: 'A',
    require: ['ngModel', '?^saLocationSearchForm'],
    scope: {
      model: '=ngModel',
      locationType: '@'
    },
    link: function link($scope, $element, $attrs, ctrls) {
      var ngModelCtrl = ctrls[0];
      var saLocationSearchFormCtrl = ctrls[1];
      var documentEl = angular.element(document);
      var bodyEl = angular.element(document.body);
      var type;
      if ($scope.locationType !== 'none') {
        type = $scope.locationType || 'regions';
      }
      var predictionContainer;
      var shouldCancelBlur;
      var query;

      $scope.element = $element;
      $scope.selectedPrediction = -1;

      // Load google maps js and initialize directive when done

      initPredictionsContainer();
      addEventListeners();

      /**
       * Creates container for predictions
       */
      function initPredictionsContainer() {
        var container = angular.element(containerTemplate);

        container.attr({
          predictions: 'predictions',
          input: 'element',
          'selected-prediction': 'selectedPrediction'
        });

        predictionContainer = $compile(container)($scope);
        bodyEl.append(predictionContainer);
      }

      /**
       * Adds event listeners to input field and document
       */
      function addEventListeners() {
        $element.on('keyup', keyupHandler);
        $element.on('keydown', keydownHandler);
        $element.on('keypress', keypressHandler);

        $timeout(function () {
          predictionContainer.on('mousedown', function () {
            shouldCancelBlur = true;
          });

          predictionContainer[0].addEventListener('click', function () {
            clearPredictions();

            saLocationSearchFormCtrl && saLocationSearchFormCtrl.submitForm();
          }, true);
        });

        $element.on('blur', function () {
          if (shouldCancelBlur) {
            $element[0].focus();
            shouldCancelBlur = false;
          } else {
            if ($scope.predictions) {
              $scope.$apply(function () {
                $scope.selectedPrediction = $scope.selectedPrediction > -1 ? $scope.selectedPrediction : 0;
                setValue();
              });
            }

            clearPredictions();
          }
        });
      }

      /**
       * Handles keydown event
       * @param event
       */
      function keydownHandler(event) {
        switch (event.which) {
          case keyCodes.DOWN:
          case keyCodes.UP:
            event.preventDefault();
            break;

          case keyCodes.ENTER:
            if (document.activeElement === $element[0] && $scope.predictions && $scope.predictions.length) {
              $scope.selectedPrediction = $scope.selectedPrediction > -1 ? $scope.selectedPrediction : 0;
              setValue();
              clearPredictions();

              if (!saLocationSearchFormCtrl) {
                event.preventDefault();

                return false;
              }
            }
            break;
        }
      }

      /**
       * Handles keydown event
       * @param event
       */
      function keypressHandler(event) {
        switch (event.which) {
          case keyCodes.ENTER:
            if (document.activeElement === $element[0] && $scope.predictions && $scope.predictions.length && !saLocationSearchFormCtrl) {
              event.preventDefault();

              return false;
            }
            break;

          default:
            break;
        }
      }

      /**
       * Handles keyup event
       * @param event
       */
      function keyupHandler(event) {
        $scope.$apply(function () {
          switch (event.which) {
            case keyCodes.DOWN:
              if ($scope.predictions) {
                $scope.selectedPrediction = Math.min($scope.selectedPrediction + 1, $scope.predictions.length - 1);
              }
              break;

            case keyCodes.UP:
              if ($scope.predictions) {
                $scope.selectedPrediction = Math.max($scope.selectedPrediction - 1, 0);
              }
              break;

            case keyCodes.ESC:
              clearPredictions();
              break;

            case keyCodes.ENTER:
              break;

            default:
              fetchPredictions($element.val());
              break;
          }
        });
      }

      /**
       * Fetch predictions
       * @param {String} newQuery
       */
      function fetchPredictions(newQuery) {
        var previousQuery = query;
        var options;

        query = newQuery;

        if (newQuery && newQuery !== previousQuery && $scope.selectedPrediction === -1) {
          options = {
            input: newQuery
          };
          if ($scope.locationType !== 'none' && $scope.locationType !== 'filtered') {
            options.types = ['(' + type + ')'];
          }

          // Callback is called immediatelly if status is OVER_QUERY_LIMIT
          autocompleteService.getPlacePredictions(newQuery).then(function (predictions) {
            clearPredictions();
            $scope.predictions = predictions.data;
          });
        } else if (!newQuery) {
          clearPredictions();
        }
      }

      // Setup ngModelCtrl
      ngModelCtrl.$formatters.push(formatValue);
      ngModelCtrl.$render = function () {
        $element.val(formatValue(ngModelCtrl.$viewValue || ''));
      };
      ngModelCtrl.$parsers.push(function (input) {
        if (angular.isString(input) && ngModelCtrl.$modelValue && ngModelCtrl.$modelValue.name === input) {
          input = ngModelCtrl.$modelValue;
        }

        return input;
      });

      /**
       * Removes document event listeners
       */
      function removeEventListeners() {
        documentEl.off('keyup', keyupHandler);
        documentEl.off('keydown', keydownHandler);
      }

      /**
       * Sets ngModel value
       */
      function setValue() {
        var prediction;

        if ($scope.predictions) {
          prediction = $scope.predictions[$scope.selectedPrediction > -1 ? $scope.selectedPrediction : 0];

          if (prediction) {
            ngModelCtrl.$setViewValue({
              placeId: prediction['place_id'],
              name: prediction.description
            });
            ngModelCtrl.$commitViewValue();
            ngModelCtrl.$render();
          }
        }
      }

      /**
       * Removes predictions and resets selected prediction index
       */
      function clearPredictions() {
        delete $scope.predictions;
        $scope.selectedPrediction = -1;
      }

      /**
       * Cleans up after element is destroyed
       */
      $element.on('$destroy', function () {
        if (predictionContainer) {
          predictionContainer.remove();
        }

        removeEventListeners();
      });

      $scope.$watch('selectedPrediction', function (selectedPrediction, previousValue) {
        if (angular.isNumber(selectedPrediction) && selectedPrediction > -1 && selectedPrediction !== previousValue) {
          setValue();
        }
      });
    }
  };
}];

exports.default = saLocationSearchInput;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location_search_prediction = __webpack_require__(309);

var _location_search_prediction2 = _interopRequireDefault(_location_search_prediction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saLocationSearchPrediction = [function () {
  return {
    template: _location_search_prediction2.default,
    replace: true,
    scope: {
      prediction: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: [function () {}]
  };
}];

exports.default = saLocationSearchPrediction;

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "<li ng-bind-html=\"ctrl.prediction | highlightLocationPrediction\"></li>\n";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location_search_predictions = __webpack_require__(311);

var _location_search_predictions2 = _interopRequireDefault(_location_search_predictions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_CONTAINER_CSS = {
  background: 'white',
  display: 'none',
  position: 'absolute',
  'z-index': '2000'
};
var saLocationSearchPredictions = ['$window', 'scrollTop', function ($window, scrollTop) {
  return {
    template: _location_search_predictions2.default,
    replace: true,
    scope: {
      predictions: '=',
      input: '=',
      selectedPrediction: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: [function () {}],
    link: function link($scope, $element) {
      var windowEl = angular.element($window);

      function positionContainer() {
        var input = $scope.ctrl.input;
        var inputElement = input[0];
        var rect = inputElement.getBoundingClientRect();

        angular.extend($scope.css, {
          top: String(rect.top + rect.height + scrollTop()) + 'px',
          left: String(rect.left) + 'px',
          width: String(rect.width) + 'px'
        });
      }

      function eventHandler() {
        $scope.$apply(function () {
          if ($scope.css.display !== 'none') {
            positionContainer();
          }
        });
      }

      function removeEventHandlers() {
        windowEl.off('resize', eventHandler);
        windowEl.off('scroll', eventHandler);
      }

      $scope.css = angular.copy(DEFAULT_CONTAINER_CSS);

      $scope.$watch('ctrl.predictions.length', function (length) {
        if (length && document.activeElement === $scope.ctrl.input[0]) {
          positionContainer();
          $scope.css.display = 'block';
          windowEl.on('resize', eventHandler);
          windowEl.on('scroll', eventHandler);
        } else {
          removeEventHandlers();
          $scope.css.display = 'none';
        }
      });

      $element.on('$destroy', function () {
        removeEventHandlers();
      });
    }
  };
}];

exports.default = saLocationSearchPredictions;

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"AutocompletePredictions\" ng-style=\"css\">\n  <sa-location-search-prediction ng-repeat=\"prediction in ctrl.predictions\" prediction=\"prediction\"\n                                 ng-class=\"{ 'is-highlighted': $index === ctrl.selectedPrediction }\"\n                                 ng-mouseenter=\"ctrl.selectedPrediction = $index\"></sa-location-search-prediction>\n</ul>\n";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var highlightLocationPrediction = function highlightLocationPrediction() {
  function getMatchingTerm(terms, matchedSubstring) {
    var length = terms.length;
    var substringOffset = matchedSubstring.offset;
    var iter;
    var matchingTerm;
    var currentTerm;
    var currentTermLength;
    var currentTermOffset;

    for (iter = 0; iter < length; iter++) {
      currentTerm = terms[iter];
      currentTermOffset = currentTerm.offset;
      currentTermLength = currentTerm.value.length;

      if (currentTermOffset <= substringOffset && currentTermLength + currentTermOffset > substringOffset) {
        matchingTerm = currentTerm;
        break;
      }
    }

    return matchingTerm;
  }

  function wrapMatchingTerm(matchedTerm, matchedSubstring) {
    var term = matchedTerm.value;
    var offset = matchedSubstring.offset - matchedTerm.offset;
    var length = Math.min(term.length, matchedSubstring.length);
    var beforeSubstring = term.substring(0, offset);
    var afterSubstring = term.substring(offset + length, term.length);
    var substringHtml = '<strong>' + term.substring(offset, offset + length) + '</strong>';

    return '<span class="AutocompletePredictions-query">' + beforeSubstring + substringHtml + afterSubstring + '</span>';
  }

  function getResultHtml(matchedTermHtml, matchingTerm, prediction) {
    var description = prediction.description;
    var offset = matchingTerm.offset;
    var length = matchingTerm.value.length;
    var beforeMatchedTerm = description.substring(0, offset);
    var afterMatchedTerm = description.substring(offset + length, description.length);

    return beforeMatchedTerm + matchedTermHtml + afterMatchedTerm;
  }

  function filter(prediction) {
    try {
      var matchedSubstring = prediction['matched_substrings'][0];
      var matchingTerm = getMatchingTerm(prediction.terms, matchedSubstring);
      var matchingSubstringHtml = wrapMatchingTerm(matchingTerm, matchedSubstring);
      return getResultHtml(matchingSubstringHtml, matchingTerm, prediction);
    } catch (e) {
      return;
    }
  }

  return filter;
};

exports.default = highlightLocationPrediction;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _currency_select = __webpack_require__(22);

var _currency_select2 = _interopRequireDefault(_currency_select);

var _currency_input = __webpack_require__(20);

var _currency_input2 = _interopRequireDefault(_currency_input);

var _mobile_navigation_menu = __webpack_require__(319);

var _mobile_navigation_menu2 = _interopRequireDefault(_mobile_navigation_menu);

var _currency_model = __webpack_require__(7);

var _currency_model2 = _interopRequireDefault(_currency_model);

var _navigation = __webpack_require__(324);

var _navigation2 = _interopRequireDefault(_navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_currency_select2.default, _currency_input2.default, _mobile_navigation_menu2.default, _currency_model2.default];

exports.default = _angular2.default.module('common.navigation', dependencies).component('saNavigation', _navigation2.default).name;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popularCurrencies = ['EUR', 'USD', 'GBP'];

var currencyOptionsFactory = function currencyOptionsFactory(currencies) {
  'ngInject';

  return {
    popular: currencies.map(function (currency) {
      return currency.code;
    }).filter(function (currency) {
      return popularCurrencies.indexOf(currency) > -1;
    }),
    all: currencies.map(function (currency) {
      return currency.code;
    }).filter(function (currency) {
      return popularCurrencies.indexOf(currency) === -1;
    })
  };
};

currencyOptionsFactory.$inject = ['currencies'];
exports.default = _angular2.default.module('service.currencyOptions', []).factory('currencyOptions', currencyOptionsFactory).name;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _services = __webpack_require__(4);

var _services2 = _interopRequireDefault(_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencyResourceFactory = function currencyResourceFactory($http, utils) {
  'ngInject';

  return {
    saveCurrency: function saveCurrency(userId, value) {
      var url = utils.getApiUrlV2('/users/' + userId + '/currency');
      var postData = {
        currency: value
      };

      return $http.post(url, postData);
    }
  };
};

currencyResourceFactory.$inject = ['$http', 'utils'];
var dependencies = [_services2.default];

exports.default = _angular2.default.module('resources.currencyResource', dependencies).factory('currencyResource', currencyResourceFactory).name;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currency_select = __webpack_require__(317);

var _currency_select2 = _interopRequireDefault(_currency_select);

var _currency_select3 = __webpack_require__(318);

var _currency_select4 = _interopRequireDefault(_currency_select3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return {
    template: _currency_select2.default,
    replace: true,
    scope: {
      ngModel: '='
    },
    controllerAs: 'ctrl',
    controller: _currency_select4.default
  };
};

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "\n\n<select style=\"margin-left:5px;color:#323337 !important;font-weight:normal\">\n  <option value=\"{{ option }}\" ng-repeat=\"option in ctrl.options.popular\">{{ option }}</option>\n  <option value=\"\" disabled>&mdash;&mdash;</option>\n  <option value=\"{{ option }}\" ng-repeat=\"option in ctrl.options.all\">{{ option }}</option>\n</select>\n";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['currencyOptions'];
function f(currencyOptions) {
  'ngInject';

  this.options = currencyOptions;
}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _mobile_navigation_menu = __webpack_require__(320);

var _mobile_navigation_menu2 = _interopRequireDefault(_mobile_navigation_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileNavigationMenu = function mobileNavigationMenu($window, $rootScope, $compile, scrollbarWidth, bodyScroll) {
  'ngInject';

  var bodyEl = _angular2.default.element($window.document.body);
  var wrapperEl = _angular2.default.element($window.document.querySelector('.Wrapper'));
  var menuEl;

  var service = {
    show: function show() {
      if (menuEl) {
        return;
      }
      var scrollWidth = scrollbarWidth();
      menuEl = $compile('<sa-mobile-navigation-menu></sa-mobile-navigation-menu>')($rootScope.$new());
      wrapperEl.css('padding_right', scrollWidth + 'px');
      bodyEl.css('padding_right', scrollWidth + 'px');
      bodyScroll.disable();
      bodyEl.append(menuEl);
    },

    hide: function hide() {
      if (!menuEl) {
        return;
      }
      menuEl.remove();
      wrapperEl.css('padding_right', 0);
      bodyEl.css('padding_right', 0);
      bodyScroll.enable();

      menuEl = null;
    }
  };

  $rootScope.$on('breakpointChanged', function (event, breakpoint) {
    if (breakpoint !== 'mobile' && menuEl) {
      service.hide();
    }
  });

  return service;
};

mobileNavigationMenu.$inject = ['$window', '$rootScope', '$compile', 'scrollbarWidth', 'bodyScroll'];
var dependencies = [_mobile_navigation_menu2.default];

exports.default = _angular2.default.module('services.mobileNavigationMenu', dependencies).factory('mobileNavigationMenu', mobileNavigationMenu).name;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _currency_select = __webpack_require__(22);

var _currency_select2 = _interopRequireDefault(_currency_select);

var _currency_input = __webpack_require__(20);

var _currency_input2 = _interopRequireDefault(_currency_input);

var _currency_model = __webpack_require__(7);

var _currency_model2 = _interopRequireDefault(_currency_model);

var _mobile_navigation_menu = __webpack_require__(321);

var _mobile_navigation_menu2 = _interopRequireDefault(_mobile_navigation_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_currency_select2.default, _currency_input2.default, _currency_model2.default];

exports.default = _angular2.default.module('common.mobileNavigationMenu', dependencies).component('saMobileNavigationMenu', _mobile_navigation_menu2.default).name;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobile_navigation_menu = __webpack_require__(322);

var _mobile_navigation_menu2 = _interopRequireDefault(_mobile_navigation_menu);

var _mobile_navigation_menu3 = __webpack_require__(323);

var _mobile_navigation_menu4 = _interopRequireDefault(_mobile_navigation_menu3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: _mobile_navigation_menu2.default,
  controllerAs: 'ctrl',
  controller: _mobile_navigation_menu4.default
};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "<section class=\"MobileNavigation\">\n  <a class=\"MobileNavigation-close\" ng-click=\"ctrl.close()\"></a>\n\n  <div class=\"MobileNavigation-header lazyload\" ng-if=\"ctrl.userModel.item.id\" data-bgset=\"{{ ctrl.userModel.item.location.photo | cityPhoto }}\">\n    <div class=\"MobileNavigation-overlay\"></div>\n    <div class=\"MobileNavigation-user\">\n      <sa-photo photo=\"ctrl.userModel.item.profilePhoto\" size=\"mini\" rect></sa-photo>\n      <p class=\"MobileNavigation-userName\">{{ctrl.userModel.item.name}}</p>\n      <p class=\"MobileNavigation-userLocation\" ng-if=\"ctrl.userModel.item.location.countryCode\">\n        <i class=\"Icon Icon-marker\"></i>&nbsp;{{ctrl.userModel.item.location | location}}\n      </p>\n    </div>\n  </div>\n\n  <ul class=\"MobileNavigation-links\">\n    <li><a ui-sref=\"guides.landing\" ui-sref-active=\"is-active\">Home</a></li>\n    <div ng-if=\"ctrl.userModel.item.id\">\n      <li>\n        <a ui-sref=\"guides.guide({ guideId: ctrl.userModel.item.id })\" ui-sref-active=\"is-active\">View profile</a>\n      </li>\n\n\n      <li>\n        <a ui-sref=\"settings\" ui-sref-active=\"is-active\">Profile settings</a>\n      </li>\n\n      <li>\n        <a ui-sref=\"myTrips\" ui-sref-active=\"is-active\">My Trips</a>\n      </li>\n\n      <li ng-if=\"ctrl.userModel.hasMembership() && !ctrl.userModel.item.membership.isFree\">\n        <a ui-sref=\"membership\" ui-sref-active=\"is-active\">Subscription</a>\n      </li>\n\n<!--      <li ng-if=\"ctrl.guideStatus.isGuide() && !ctrl.guideStatus.isUnverifiedGuide() && ctrl.userModel.item.isDashboardEnabled\">-->\n<!--        <a ui-sref=\"dashboard\" ui-sref-active=\"is-active\">My Balance (&euro;{{(ctrl.dashboard.balance.available + ctrl.dashboard.balance.pending) || 0}})</a>-->\n<!--      </li>-->\n\n      <li>\n        <a ui-sref=\"notificationSettings\" ui-sref-active=\"is-active\">Notifications</a>\n      </li>\n      <div class=\"phone-menu-bg\">\n        <li ng-click=\"ctrl.isDropdownVisible4 = !ctrl.isDropdownVisible\"\n            sa-on-click-outside=\"ctrl.isDropdownVisible4 = false\"\n            ng-mouseenter=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible4 = true)\"\n            ng-mouseleave=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible4 = false)\">\n          <a>Meet a Local</a>\n          <div style=\"position: absolute;\n    width: 100%;\n    background-color: #3c3d40;\n    z-index: 9;\n    left:0px;\n        min-height: 900px;\n    z-index: 999;\n    padding-left:0px;\n    top: 0px;\" class=\"mobile-nav-modal Navigation-city-dropdown\" ng-style=\"{ display: ctrl.isDropdownVisible4 ? 'block' : 'none' }\"\n               ng-mouseleave=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible4 = false)\"\n               ng-hide=\"hide\">\n            <div style=\"\n         cursor:pointer;position:absolute;width:80px;\nheight:50px;\nz-index:9999;\"\n                 ng-click=\"hide = true\" > <span  class=\"chevron left\"></span></div>\n            <h2>Meet A Local</h2>\n            <ul>\n             <li><a style=\"padding:0px;\" href=\"/locals/ukraine/kiev\" >Kiev</a></li>\n            <li><a style=\"padding:0px;\" href=\"/locals/romania/bucharest\" >Bucharest</a></li>\n            <li><a style=\"padding:0px;\" href=\"/locals/spain/barcelona\" >Barcelona</a></li>\n            <li> <a style=\"padding:0px;\" href=\"/locals/hungary/budapest\" >Budapest</a></li>\n            <li> <a style=\"padding:0px;\" href=\"/locals/thailand/bangkok\" >Bangkok</a></li>\n            <li><a style=\"padding:0px;\" href=\"/locals/italy/rome\" >Rome</a> </li>\n            <li><a style=\"padding:0px;\" href=\"/locals/turkey/istanbul\" >Istanbul</a></li>\n            <li><a style=\"padding:0px;\"  href=\"/locals/france/paris\">Paris</a></li>\n            <li><a style=\"padding:0px;\" href=\"/locals/italy/milan\" >Milan</a></li>\n             <li><a style=\"padding:0px;\" href=\"/locals/united-arab-emirates/dubai\" >Dubai</a></li>\n            <li> <a style=\"padding:0px;\" href=\"/locals/russia/moscow\" >Moscow</a></li>\n            <li> <a style=\"padding:0px;\"  href=\"/locals/czech/prague\" >Prague</a></li>\n             <li><a style=\"padding:0px;\" href=\"/locals/georgia/tbilisi\" >Tbilisi</a></li>\n            <li><a style=\"padding:0px;\" href=\"/locals/singapore/singapore\" >Singapore</a></li>\n            <li> <a style=\"padding:0px;\" href=\"/locals/spain/madrid\" >Madrid</a></li>\n            </ul>\n\n          </div>\n        </li>\n        <li>\n          <a target=\"_blank\" href=\"https://blog.showaround.com\">Blog</a>\n        </li>\n        <li>\n          <a ui-sref=\"team\">About us</a>\n        </li>\n      </div>\n      <li>\n        <a ng-click=\"ctrl.logout(); ctrl.close();\">Sign out</a>\n      </li>\n    </div>\n\n    <div ng-if=\"!ctrl.userModel.item.id\">\n      <div class=\"phone-menu-bg\">\n        <li ng-click=\"ctrl.isDropdownVisible4 = !ctrl.isDropdownVisible\"\n            sa-on-click-outside=\"ctrl.isDropdownVisible4 = false\"\n            ng-mouseenter=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible4 = true)\"\n            ng-mouseleave=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible4 = false)\">\n          <a>Meet a Local</a>\n          <div style=\"position: absolute;\n    width: 100%;\n    background-color: #3c3d40;\n    z-index: 9;\n    left:0px;\n        min-height: 900px;\n    z-index: 999;\n    top: 0px;\" class=\"mobile-nav-modal Navigation-city-dropdown\" ng-style=\"{ display: ctrl.isDropdownVisible4 ? 'block' : 'none' }\"\n               ng-mouseleave=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible4 = false)\"\n               ng-hide=\"hide\">\n            <div style=\"\n         cursor:pointer;position:absolute;width:80px;\nheight:50px;\nz-index:9999;\"\n                 ng-click=\"hide = true\" > <span  class=\"chevron left\"></span></div>\n            <h2>Meet A Local</h2>\n            <ul>\n              <li><a style=\"padding:0px;\" href=\"/locals/ukraine/kiev\" >Kiev</a></li>\n              <li><a style=\"padding:0px;\" href=\"/locals/romania/bucharest\" >Bucharest</a></li>\n              <li><a style=\"padding:0px;\" href=\"/locals/spain/barcelona\" >Barcelona</a></li>\n              <li> <a style=\"padding:0px;\" href=\"/locals/hungary/budapest\" >Budapest</a></li>\n              <li> <a style=\"padding:0px;\" href=\"/locals/thailand/bangkok\" >Bangkok</a></li>\n              <li><a style=\"padding:0px;\" href=\"/locals/italy/rome\" >Rome</a> </li>\n              <li><a style=\"padding:0px;\" href=\"/locals/turkey/istanbul\" >Istanbul</a></li>\n              <li><a style=\"padding:0px;\"  href=\"/locals/france/paris\">Paris</a></li>\n              <li><a style=\"padding:0px;\" href=\"/locals/italy/milan\" >Milan</a></li>\n              <li><a style=\"padding:0px;\" href=\"/locals/united-arab-emirates/dubai\" >Dubai</a></li>\n              <li> <a style=\"padding:0px;\" href=\"/locals/russia/moscow\" >Moscow</a></li>\n              <li> <a style=\"padding:0px;\"  href=\"/locals/czech/prague\" >Prague</a></li>\n              <li><a style=\"padding:0px;\" href=\"/locals/georgia/tbilisi\" >Tbilisi</a></li>\n              <li><a style=\"padding:0px;\" href=\"/locals/singapore/singapore\" >Singapore</a></li>\n              <li> <a style=\"padding:0px;\" href=\"/locals/spain/madrid\" >Madrid</a></li>\n            </ul>\n\n          </div>\n        </li>\n        <li>\n          <a target=\"_blank\" href=\"https://blog.showaround.com\">Blog</a>\n        </li>\n        <li>\n          <a ui-sref=\"team\">About us</a>\n        </li>\n      </div>\n      <li><a ng-if=\"!('becomeGuide' | includedByState)\" ui-sref=\"becomeGuide\" ui-sref-active=\"is-active\">Sign up as a local</a></li>\n      <li><a ng-if=\"('becomeGuide' | includedByState)\" ui-sref-active=\"is-active\" ng-click=\"ctrl.becomeGuide()\">Sign up as a local</a></li>\n    </div>\n  </ul>\n\n  <div class=\"MobileNavigation-joinButton\" ng-if=\"!ctrl.userModel.item.id\">\n    <button class=\"Button Button--fullWidth\" sa-join-button ng-click=\"ctrl.close()\">Connect</button>\n  </div>\n\n  <div class=\"MobileNavigation-select\">\n    <span class=\"MobileNavigation-placeholder\">Change currency</span>\n    <sa-currency-select ng-model=\"ctrl.currency\" sa-currency-input></sa-currency-select>\n  </div>\n</section>\n";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MobileNavigationCtrl;
MobileNavigationCtrl.$inject = ['$rootScope', 'mobileNavigationMenu', 'userModel', 'logout', 'guideStatus', 'dashboard', 'becomeGuide', 'currencyOptions', 'currencyModel'];
function MobileNavigationCtrl($rootScope, mobileNavigationMenu, userModel, logout, guideStatus, dashboard, becomeGuide, currencyOptions, currencyModel) {
  'ngInject';

  this.userModel = userModel;
  this.guideStatus = guideStatus;
  this.dashboard = dashboard;
  this.becomeGuide = becomeGuide;
  this.currencies = currencyOptions;
  this.currency = currencyModel.getValue();

  this.logout = function () {
    logout();
    this.close();
  };

  this.close = function () {
    mobileNavigationMenu.hide();
  };

  $rootScope.$on('$stateChangeSuccess', this.close.bind(this));
}

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navigation = __webpack_require__(325);

var _navigation2 = _interopRequireDefault(_navigation);

var _navigation3 = __webpack_require__(327);

var _navigation4 = _interopRequireDefault(_navigation3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: _navigation2.default,
  controllerAs: 'ctrl',
  controller: _navigation4.default
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "\n<div class=\"Navigation Navigation-wrapper\" ng-class=\"{ 'Navigation--guest': !ctrl.userModel.item.id }\">\n  <div style=\"position: absolute;\n    width: 100%;\n    background-color: #fff;\n    z-index: 9;\n    left:0px;\n    top: 54px;\" class=\"Navigation-city-dropdown\"\n       ng-click=\"ctrl.isDropdownVisible3 = !ctrl.isDropdownVisible3\"\n       ng-style=\"{ display: ctrl.isDropdownVisible3 ? 'block' : 'none' }\"\n       ng-mouseleave=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible3 = false)\">\n    <div class=\"nav-city-top\"></div>\n    <h2 class=\"responsive-menu-h2\">Meet A local</h2>\n    <div class=\"margin-a-linksx\">\n      <div class=\"city-row\">\n      <a class=\"nav-city-linkx\"  href=\"/locals/ukraine/kiev\" >Kiev</a>\n     <a class=\"nav-city-linkx\"  href=\"/locals/romania/bucharest\" >Bucharest</a>\n     <a class=\"nav-city-linkx\"  href=\"/locals/spain/barcelona\" >Barcelona</a>\n      </div>\n      <div class=\"city-row\">\n       <a class=\"nav-city-linkx\"  href=\"/locals/hungary/budapest\" >Budapest</a>\n       <a class=\"nav-city-linkx\"  href=\"/locals/thailand/bangkok\" >Bangkok</a>\n     <a class=\"nav-city-linkx\" href=\"/locals/italy/rome\" >Rome</a>\n      </div>\n      <div class=\"city-row\">\n     <a class=\"nav-city-linkx\"  href=\"/locals/turkey/istanbul\" >Istanbul</a>\n      <a class=\"nav-city-linkx\"   href=\"/locals/france/paris\">Paris</a>\n      <a class=\"nav-city-linkx\" href=\"/locals/italy/milan\" >Milan</a>\n      </div>\n      <div class=\"city-row\">\n      <a class=\"nav-city-linkx\"  href=\"/locals/united-arab-emirates/dubai\" >Dubai</a>\n       <a class=\"nav-city-linkx\"  href=\"/locals/russia/moscow\" >Moscow</a>\n       <a class=\"nav-city-linkx\"   href=\"/locals/czech/prague\" >Prague</a>\n      </div>\n      <div class=\"city-row\">\n     <a class=\"nav-city-linkx\"  href=\"/locals/georgia/tbilisi\" >Tbilisi</a>\n      <a class=\"nav-city-linkx\" href=\"/locals/singapore/singapore\" >Singapore</a>\n       <a class=\"nav-city-linkx\" href=\"/locals/spain/madrid\" >Madrid</a>\n      </div>\n    </div>\n    <h2 class=\"responsive-menu-h2\"><a target=\"_blank\" href=\"https://blog.showaround.com\">Blog</a></h2>\n    <h2 ui-sref=\"team\" style=\"cursor:pointer;\" class=\"responsive-menu-h2\">About us</h2>\n  </div>\n  <div class=\"Navigation-body\">\n    <div class=\"Container\">\n      <div class=\"Navigation-left\">\n        <a class=\"Navigation-item Navigation-mobileMenu\" ng-click=\"ctrl.showMobileNavigationMenu()\"></a>\n      </div>\n\n      <!--\n      <div class=\"Navigation-item Ukraine-Item\">\n        <img\n          src=\"" + __webpack_require__(326) + "\"\n          class=\"Love-Ukraine\"\n          title=\"Support Ukraine! No to war!\"\n          alt=\"Support Ukraine! No to war!\" />\n      </div>\n      -->\n\n      <a class=\"Navigation-item Navigation-logo\" ui-sref=\"guides.landing\"></a>\n\n      <form class=\"Navigation-search Navigation-item\"\n            sa-location-search-form\n            ng-class=\"{ 'is-focused': ctrl.isSearchFieldFocused }\"\n            ng-submit=\"ctrl.search()\">\n        <span class=\"Navigation-searchIcon\">\n          <i class=\"Icon Icon-search\"></i>\n        </span>\n\n        <input type=\"text\" placeholder=\"Where next?\"\n               sa-location-search-input sa-location-validator\n               location-type=\"none\"\n               ng-model=\"filters.location\"\n               ng-focus=\"ctrl.isSearchFieldFocused = true\"\n               ng-blur=\"ctrl.isSearchFieldFocused = false\">\n      </form>\n      <div class=\"Navigation-right Navigation-guestButtons\" ng-if=\"!ctrl.userModel.item.id && !ctrl.isLoading\">\n        <div style=\"min-width:0px !important;\" class=\"hide-this-nav responsive-menu Navigation-item Navigation-mobileMenu Navigation-select\" ng-click=\"ctrl.isDropdownVisible3 = !ctrl.isDropdownVisible\"\n             sa-on-click-outside=\"ctrl.isDropdownVisible3 = false\"\n             ng-mouseenter=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible3 = true)\">\n\n          <span>Test menu</span>\n\n        </div>\n        <div style=\"margin-right:10px;\" class=\" hide-this Navigation-item Navigation-dropdownButton Navigation-select\" ng-click=\"ctrl.isDropdownVisible2 = !ctrl.isDropdownVisible2\"\n             sa-on-click-outside=\"ctrl.isDropdownVisible2 = false\"\n             ng-mouseenter=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible2 = true)\"\n             ng-mouseleave=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible2 = false)\">\n          <span>Meet a local</span>\n          <div class=\"Navigation-city-dropdown\" ng-style=\"{ display: ctrl.isDropdownVisible2 ? 'block' : 'none' }\">\n            <div class=\"nav-city-top\"></div>\n            <a class=\"nav-city-link\"  href=\"/locals/ukraine/kiev\" >Kiev</a>\n            <a class=\"nav-city-link\"  href=\"/locals/romania/bucharest\" >Bucharest</a>\n            <a class=\"nav-city-link\"  href=\"/locals/spain/barcelona\" >Barcelona</a>\n            <a class=\"nav-city-link\"  href=\"/locals/hungary/budapest\" >Budapest</a>\n            <a class=\"nav-city-link\"  href=\"/locals/thailand/bangkok\" >Bangkok</a>\n            <a class=\"nav-city-link\" href=\"/locals/italy/rome\" >Rome</a>\n            <a class=\"nav-city-link\"  href=\"/locals/turkey/istanbul\" >Istanbul</a>\n            <a class=\"nav-city-link\"   href=\"/locals/france/paris\">Paris</a>\n            <a class=\"nav-city-link\" href=\"/locals/italy/milan\" >Milan</a>\n            <a class=\"nav-city-link\"  href=\"/locals/united-arab-emirates/dubai\" >Dubai</a>\n            <a class=\"nav-city-link\"  href=\"/locals/russia/moscow\" >Moscow</a>\n            <a class=\"nav-city-link\"   href=\"/locals/czech/prague\" >Prague</a>\n            <a class=\"nav-city-link\"  href=\"/locals/georgia/tbilisi\" >Tbilisi</a>\n            <a class=\"nav-city-link\" href=\"/locals/singapore/singapore\" >Singapore</a>\n            <a class=\"nav-city-link\" href=\"/locals/spain/madrid\" >Madrid</a>\n\n          </div>\n        </div>\n\n        <div class=\"Navigation-item Navigation-envelope  navigation-links\" style=\"width:auto;padding-top:0px;\">\n          <span class=\"navigation-span\"><a href=\"https://blog.showaround.com/\" target=\"_blank\">Blog</a></span>\n        </div>\n\n        <div class=\"Navigation-item Navigation-envelope navigation-links\" style=\"width:auto;padding-top:0px;\" >\n          <div class=\"navigation-span\"><a ui-sref=\"team\">About us</a></div>\n        </div>\n\n        <div class=\"Navigation-item Navigation-item--button\">\n          <a class=\"Button Button--gray Button--inverted Button--invertedAlternativeHover\" ng-click=\"ctrl.showJoinModal()\">Connect</a>\n        </div>\n\n        <div class=\"Navigation-item Navigation-item--button\" ng-if=\"!('becomeGuide' | includedByState)\">\n          <a class=\"Button Button--orange\" sa-become-guide-button>Sign up as a local</a>\n        </div>\n\n        <div class=\"Navigation-item Navigation-item--button\" ng-if=\"('becomeGuide' | includedByState)\">\n          <a class=\"Button Button--orange\" ng-click=\"ctrl.becomeGuide()\">Sign up as a local</a>\n        </div>\n      </div>\n\n      <div class=\" Navigation-right\" ng-if=\"ctrl.userModel.item.id && !ctrl.isLoading\">\n        <div class=\"Navigation-item Navigation-envelope navigation-links\" style=\"width:auto;padding-top:0px;\" >\n          <div class=\"navigation-span\" style=\"padding-right:10px;\"><a ui-sref=\"myTrips\">Create a trip</a></div>\n        </div>\n        <div style=\"min-width:0px !important;\" class=\"hide-this-nav responsive-menu Navigation-item Navigation-mobileMenu Navigation-select\" ng-click=\"ctrl.isDropdownVisible3 = !ctrl.isDropdownVisible\"\n             sa-on-click-outside=\"ctrl.isDropdownVisible3 = false\"\n             ng-mouseenter=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible3 = true)\">\n\n          <span>Test menu</span>\n\n        </div>\n\n        <div style=\"margin-right:10px;\" class=\"hide-this Navigation-item Navigation-dropdownButton Navigation-select\" ng-click=\"ctrl.isDropdownVisible2 = !ctrl.isDropdownVisible2\"\n             sa-on-click-outside=\"ctrl.isDropdownVisible2 = false\"\n             ng-mouseenter=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible2 = true)\"\n             ng-mouseleave=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible2 = false)\">\n          <span>Meet a local</span>\n          <div class=\"Navigation-city-dropdown\" ng-style=\"{ display: ctrl.isDropdownVisible2 ? 'block' : 'none' }\">\n            <div class=\"nav-city-top\"></div>\n              <a class=\"nav-city-link\"  href=\"/locals/ukraine/kiev\" >Kiev</a>\n              <a class=\"nav-city-link\"  href=\"/locals/romania/bucharest\" >Bucharest</a>\n              <a class=\"nav-city-link\"  href=\"/locals/spain/barcelona\" >Barcelona</a>\n              <a class=\"nav-city-link\"  href=\"/locals/hungary/budapest\" >Budapest</a>\n              <a class=\"nav-city-link\"  href=\"/locals/thailand/bangkok\" >Bangkok</a>\n              <a class=\"nav-city-link\" href=\"/locals/italy/rome\" >Rome</a>\n              <a class=\"nav-city-link\"  href=\"/locals/turkey/istanbul\" >Istanbul</a>\n              <a class=\"nav-city-link\"   href=\"/locals/france/paris\">Paris</a>\n              <a class=\"nav-city-link\" href=\"/locals/italy/milan\" >Milan</a>\n              <a class=\"nav-city-link\"  href=\"/locals/united-arab-emirates/dubai\" >Dubai</a>\n              <a class=\"nav-city-link\"  href=\"/locals/russia/moscow\" >Moscow</a>\n              <a class=\"nav-city-link\"   href=\"/locals/czech/prague\" >Prague</a>\n              <a class=\"nav-city-link\"  href=\"/locals/georgia/tbilisi\" >Tbilisi</a>\n              <a class=\"nav-city-link\" href=\"/locals/singapore/singapore\" >Singapore</a>\n              <a class=\"nav-city-link\" href=\"/locals/spain/madrid\" >Madrid</a>\n\n          </div>\n        </div>\n\n        <div class=\"Navigation-item Navigation-envelope  navigation-links\" style=\"width:auto;padding-top:0px;\">\n          <span class=\"navigation-span\"><a href=\"https://blog.showaround.com/\" target=\"_blank\">Blog</a></span>\n        </div>\n\n        <div class=\"Navigation-item Navigation-envelope navigation-links\" style=\"width:auto;padding-top:0px;\" >\n          <div class=\"navigation-span\"><a ui-sref=\"team\">About us</a></div>\n        </div>\n       <!-- <div class=\"Navigation-item Navigation-dropdownButton Navigation-select Navigation-currencySelect\">\n          <sa-currency-select ng-model=\"ctrl.currency\" sa-currency-input></sa-currency-select>\n        </div> -->\n        <div class=\"Navigation-item Navigation-dropdownButton\"\n\n             sa-on-click-outside=\"ctrl.isDropdownVisible = false\"\n             ng-mouseenter=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible = true)\"\n             ng-mouseleave=\"ctrl.isHoverEnabled && (ctrl.isDropdownVisible = false)\">\n          <sa-photo photo=\"ctrl.userModel.item.profilePhoto\" size=\"micro\" rect dynamic></sa-photo>\n          <span>{{ctrl.userModel.item.name}}</span>\n\n          <div class=\"Navigation-dropdown\" ng-style=\"{ display: ctrl.isDropdownVisible ? 'block' : 'none' }\">\n            <ul>\n              <li    ng-click=\"ctrl.isDropdownVisible = !ctrl.isDropdownVisible\"><a ui-sref=\"guides.guide({ guideId: ctrl.userModel.item.id })\">View profile</a></li>\n              <li    ng-click=\"ctrl.isDropdownVisible = !ctrl.isDropdownVisible\"><a ui-sref=\"settings\">Profile settings</a></li>\n              <li    ng-click=\"ctrl.isDropdownVisible = !ctrl.isDropdownVisible\">\n                <a ui-sref=\"myTrips\">\n                  My Trips\n                  <div class=\"Navigation-activeTrips\" ng-if=\"ctrl.userModel.item.preferences.hasActiveTrips\"><i class=\"Icon Icon-gps\"></i></div>\n                </a>\n              </li>\n\n\n\n              <li    ng-click=\"ctrl.isDropdownVisible = !ctrl.isDropdownVisible\" ng-if=\"ctrl.userModel.hasMembership() && !ctrl.userModel.item.membership.isFree\"><a ui-sref=\"membership\">Subscription</a></li>\n<!--              <li    ng-click=\"ctrl.isDropdownVisible = !ctrl.isDropdownVisible\" ng-if=\"(ctrl.guideStatus.isGuide() || ctrl.guideStatus.isInactiveGuide()) && !ctrl.guideStatus.isUnverifiedGuide() && ctrl.userModel.item.isDashboardEnabled\">-->\n<!--                <a class=\"dashboard\" ui-sref=\"dashboard\" ui-sref-active=\"is-active\">-->\n<!--                  <div class=\"inline\">My Balance</div>-->\n<!--                  <span class=\"Navigation-balance\">&euro;{{(ctrl.dashboard.balance.available + ctrl.dashboard.balance.pending) || 0}}</span>-->\n<!--                </a>-->\n\n<!--              <li>-->\n\n              <li    ng-click=\"ctrl.isDropdownVisible = !ctrl.isDropdownVisible\"><a ui-sref=\"notificationSettings\">Notifications</a></li>\n              <li class=\"currency-new Navigation-dropdownButton Navigation-select Navigation-currencySelect\">\n                <sa-currency-select ng-model=\"ctrl.currency\" sa-currency-input></sa-currency-select>\n              </li>\n              <li    ng-click=\"ctrl.isDropdownVisible = !ctrl.isDropdownVisible\"><a ng-click=\"ctrl.logout()\">Sign out</a></li>\n            </ul>\n          </div>\n        </div>\n\n        <a class=\"Navigation-item Navigation-envelope\" ng-click=\"ctrl.openConversations()\">\n          <i class=\"Icon Icon-envelope\"></i>\n          <span class=\"Bubble\" ng-if=\"ctrl.unreadConversationIds.length\">{{ctrl.unreadConversationIds.length}}</span>\n        </a>\n\n      </div>\n      <a  ng-if=\"ctrl.userModel.item.id && !ctrl.isLoading\" style=\"float: left;left: 25px;top: -1px;\" class=\"inbox-hide-nav Navigation-item Navigation-envelope\" ng-click=\"ctrl.openConversations()\">\n        <i class=\"Icon Icon-envelope\"></i>\n        <span class=\"Bubble\" ng-if=\"ctrl.unreadConversationIds.length\">{{ctrl.unreadConversationIds.length}}</span>\n      </a>\n    </div>\n  </div>\n  <sa-system-alerts></sa-system-alerts>\n  <sa-settings-bar ng-if=\"ctrl.settings.progress && ctrl.displaySettingsBar\" upgrade=\"1\" progress=\"ctrl.settings.progress\"></sa-settings-bar>\n</div>\n";

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/40367b20045093a4f04ee81de835204f.png";

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavigationCtrl;
NavigationCtrl.$inject = ['$window', '$rootScope', '$scope', '$element', '$state', 'logout', 'join', 'modal', 'userModel', 'mobileNavigationMenu', 'breakpoint', 'guideStatus', 'unreadConversationIds', 'guideSearchFilters', 'navigation', 'deviceCapabilities', 'dashboard', 'becomeGuide', 'currencyOptions', 'conversationsFetching', 'settings', 'currencyModel'];
function NavigationCtrl($window, $rootScope, $scope, $element, $state, logout, join, modal, userModel, mobileNavigationMenu, breakpoint, guideStatus, unreadConversationIds, guideSearchFilters, navigation, deviceCapabilities, dashboard, becomeGuide, currencyOptions,
// conversations,
conversationsFetching, settings, currencyModel) {
  'ngInject';

  var _this = this;

  navigation.setNavigationElement($element.children().eq(0));

  this.settings = settings;

  this.showJoinModal = join.showModal;
  this.logout = logout;
  this.userModel = userModel;
  this.guideStatus = guideStatus;
  this.unreadConversationIds = unreadConversationIds.getIds();
  this.guideSearchFilters = guideSearchFilters;
  this.isHoverEnabled = !deviceCapabilities.isIOSDevice;
  this.dashboard = dashboard;
  this.currencies = currencyOptions;
  this.currency = currencyModel.getValue();

  $scope.filters = this.guideSearchFilters.filters;

  if (userModel.itemPromise) {
    this.isLoading = true;
    userModel.itemPromise.finally(function () {
      delete _this.isLoading;
    });
  }

  this.showMobileNavigationMenu = function () {
    mobileNavigationMenu.show();
  };

  this.search = function () {
    if (this.guideSearchFilters.filters.location) {
      this.guideSearchFilters.filters.location.idlist = null;
      this.guideSearchFilters.getParametrizedFilters().then(function (params) {
        $state.go('guides.list', params);
      });
    }
  };

  this.becomeGuide = becomeGuide;

  this.openConversations = function () {
    if (!conversationsFetching.isFetching) {
      $state.go('conversations.list', {}, { reload: true });
    }
  };

  var LOCAL_LISTING_URL = 'guides.list';
  $rootScope.$on('userModel:initialized', function () {
    _this.currency = currencyModel.getValue();
    if (guideStatus.isGuide() && !guideStatus.isUnverifiedGuide() && userModel.item.isDashboardEnabled) {
      dashboard.fetch();
    }
    $rootScope.$on('$stateChangeSuccess', function (_, toState) {
      if (toState.name === LOCAL_LISTING_URL && guideStatus.isUnverifiedGuide()) {
        // We know this is not a good solution
        // TODO: in the future do something better
        _this.settings.fetch().then(function () {
          if (_this.settings.progress != 100) {
            _this.displaySettingsBar = true;
          }
          _this.settings.getValidFieldCount();
        });
      }
    });
  });
}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _currency_model = __webpack_require__(7);

var _currency_model2 = _interopRequireDefault(_currency_model);

var _recent_bookings = __webpack_require__(329);

var _recent_bookings2 = _interopRequireDefault(_recent_bookings);

var _recent_bookings3 = __webpack_require__(331);

var _recent_bookings4 = _interopRequireDefault(_recent_bookings3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_currency_model2.default];

exports.default = _angular2.default.module('common.recentBookings', dependencies).directive('saRecentBookings', _recent_bookings2.default).factory('recentBookings', _recent_bookings4.default).name;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recent_bookings = __webpack_require__(330);

var _recent_bookings2 = _interopRequireDefault(_recent_bookings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageSize = 6;
var controller = ['$stateParams', '$state', 'recentBookings', 'listingPrice', 'placesService', 'deslug', function ($stateParams, $state, recentBookings, listingPrice, placesService, deslug) {
  if ($stateParams.price === '0') {
    listingPrice.showPrice = false;
  }
  var self = this;
  this.showPrice = listingPrice.showPrice;
  recentBookings.reset();
  this.recentBookings = recentBookings;
  this.limit = 0;
  this.city = deslug.it($stateParams.city);

  this.showMore = function () {
    this.limit += pageSize;
    this.hasMore = recentBookings.list.length > this.limit;
  };

  self.fetchData = function () {
    var _this = this;

    this.isLoading = true;
    recentBookings.fetch().then(function () {
      _this.showMore();
    }).finally(function () {
      delete _this.isLoading;
    });
  };

  if ($stateParams.placeId === undefined) {
    var currentCity = '';
    if ($stateParams.city !== undefined) {
      currentCity = $stateParams.city;
      //} else if ($state.current.name === 'guides.kiev') {
      //  currentCity = 'kyiv';
      //}
    }
    if (currentCity != '') {
      placesService.getPlaceId(currentCity).then(function (response) {
        $stateParams.placeId = response.data.placeId;
        self.fetchData();
      });
    } else {
      self.fetchData();
    }
  } else {
    self.fetchData();
  }
}];

var saRecentBookings = [function () {
  return {
    template: _recent_bookings2.default,
    replace: true,
    scope: {
      cityPage: '<?'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saRecentBookings;

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = "<section class=\"Intro-guides\">\n  <div ng-if=\"ctrl.recentBookings.list.length > 0\">\n      <h2 ng-if=\"!ctrl.cityPage\">Recent bookings</h2>\n      <h2 ng-if=\"ctrl.cityPage\" ng-bind-html=\"::'RECENT_BOOKINGS.CITY_FILTER_BOOKINGS_TITLE' | translate:{LOCATION: ctrl.city}\"></h2>\n\n      <div class=\"Intro-grid\" ng-class=\"{'Intro-ShowPrice': ctrl.showPrice}\">\n        <div class=\"Intro-column\" ng-repeat=\"booking in ctrl.recentBookings.list\">\n          <div class=\"RecentBooking\">\n            <span class=\"RecentBooking-price\" ng-bind-html=\"::booking.guide.priceInfo | guidePrice\"></span>\n\n            <a ui-sref=\"guides.guide({ guideId: (booking.guide | guideSlug) })\"><div class=\"RecentBooking-content\">\n                <div class=\"RecentBooking-city lazyload\" data-bgset=\"{{ ::booking.guide.location.photo | cityPhoto }}\"></div>\n\n                <div class=\"RecentBooking-overlay\">\n                  <sa-photo class=\"RecentBooking-photo\" photo=\"booking.guide.profilePhoto\" sa-src-placeholder lazy rect size=\"thumb\"></sa-photo>\n                  <div class=\"RecentBooking-info\">\n                    <span class=\"u-boldText\">{{::booking.user.name | limitWords}}</span> booked a tour with <span class=\"u-boldText\">{{::booking.guide.name | limitWords}}</span>\n                    <p>in <span class=\"RecentBooking-location\">{{::booking.guide.location | location}}</span></p>\n                  </div>\n                </div>\n                <div class=\"Intro-bGradient\"></div>\n              </div></a>\n\n            <div class=\"RecentBooking-review\">\n              <a ui-sref=\"guides.guide({ guideId: (booking.user | guideSlug) })\">\n                <div class=\"RecentBooking-guest\">\n                  <sa-photo photo=\"booking.user.profilePhoto\" sa-src-placeholder lazy rect size=\"mini\"></sa-photo>\n                  <p>{{::booking.user.name}}</p>\n                </div>\n              </a>\n              <p class=\"RecentBooking-reviewContent\">{{::booking.review.content}}</p>\n              <div class=\"RecentBooking-rating\">\n                <sa-rating class=\"Rating--small\" rating=\"booking.review.rating\"></sa-rating>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <sa-content-loader ng-if=\"ctrl.recentBookings.isFetching\"></sa-content-loader>\n      <div class=\"Intro-moreButton\" ng-if=\"!ctrl.recentBookings.isFetching && ctrl.recentBookings.hasMore\">\n        <a class=\"Button Button--inverted Button--orange Button--invertedAlternativeHover\"\n           ng-click=\"ctrl.recentBookings.fetch()\">Show more</a>\n      </div>\n  </div>\n</section>\n";

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = recentBookingsFactory;

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

recentBookingsFactory.$inject = ['$q', '$http', '$stateParams', 'utils', 'currencyModel'];


var limit = 6;

function recentBookingsFactory($q, $http, $stateParams, utils, currencyModel) {
  'ngInject';

  return {
    fetch: function fetch() {
      var _this = this;

      var placeId = $stateParams.placeId;
      var requestParams = {
        limit: limit,
        offset: this.list && this.list.length || 0,
        placeId: placeId,
        currency: currencyModel.getValue()
      };

      this.isFetching = true;

      return new $q(function (resolve, reject) {
        $http.get(utils.getApiUrl('intro/recent_bookings'), { params: requestParams }).then(function (response) {
          var responseData = response.data;
          var bookings = responseData.bookings;

          _this.list = _this.list || [];

          if (!_this.list.length && bookings.length && placeId && bookings[0].guide.location.placeId !== placeId) {
            bookings = [];
          }

          if (bookings.length) {
            _this.hasMore = responseData.hasMore;
            _angular2.default.forEach(bookings, function (booking) {
              return _this.list.push(booking);
            });
          }

          resolve(bookings);
        }).catch(reject).finally(function () {
          delete _this.isFetching;
        });
      });
    },

    reset: function reset() {
      this.list = [];
      this.hasMore = false;
    }
  };
}

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _social_links = __webpack_require__(333);

var _social_links2 = _interopRequireDefault(_social_links);

var _social_links3 = __webpack_require__(336);

var _social_links4 = _interopRequireDefault(_social_links3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.socialLinks', []).directive('saSocialLinks', _social_links2.default).constant('socialLinks', _social_links4.default).name;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _social_links = __webpack_require__(334);

var _social_links2 = _interopRequireDefault(_social_links);

var _social_links3 = __webpack_require__(335);

var _social_links4 = _interopRequireDefault(_social_links3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saSocialLinks = function saSocialLinks() {
  return {
    template: _social_links4.default,
    replace: true,
    scope: {},
    bindToController: true,
    controllerAs: 'ctrl',
    controller: _social_links2.default
  };
};

exports.default = saSocialLinks;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SocialLinksController = function SocialLinksController(socialLinks) {
  _classCallCheck(this, SocialLinksController);

  this.socialLinks = socialLinks;
};

SocialLinksController.$inject = ['socialLinks'];

exports.default = SocialLinksController;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = "<div class=\"SocialLinks\">\n  <ul>\n    <li ng-repeat=\"socialLink in ctrl.socialLinks\">\n      <a target=\"_blank\" ng-href=\"{{socialLink.url}}\" class=\"SocialLinks-bubble\" ng-class=\"'SocialLinks-bubble--' + socialLink.name\">\n        <i class=\"Icon\" ng-class=\"'Icon-' + socialLink.name\"></i>\n      </a>\n    </li>\n  </ul>\n</div>\n";

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: 'fb',
  url: 'https://www.facebook.com/showaroundcom'
}, {
  name: 'instagram',
  url: 'https://instagram.com/showaroundcom'
}, {
  name: 'twitter',
  url: 'https://twitter.com/showaroundcom'
}, {
  name: 'youtube',
  url: 'https://www.youtube.com/channel/UC3KXWGyos-5HVAUo5tnuH-A'
}, {
  name: 'vimeo',
  url: 'https://vimeo.com/showaround'
}];

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _support_email = __webpack_require__(338);

var _support_email2 = _interopRequireDefault(_support_email);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.supportEmail', []).directive('saSupportEmail', _support_email2.default).name;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// pass values

'user strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  'ngInject';

  return {
    replace: true,
    scope: {
      email: '@',
      text: '@'
    },
    bindToController: true,
    controller: _support_email2.default,
    controllerAs: 'ctrl',
    template: _support_email4.default
  };
};

var _support_email = __webpack_require__(339);

var _support_email2 = _interopRequireDefault(_support_email);

var _support_email3 = __webpack_require__(340);

var _support_email4 = _interopRequireDefault(_support_email3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SupportEmailController = function SupportEmailController(config) {
  'ngInject';

  _classCallCheck(this, SupportEmailController);

  this.supportEmail = config.supportEmail;
};

SupportEmailController.$inject = ['config'];
exports.default = SupportEmailController;

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = "<a\n  class=\"Link\"\n  ng-href=\"{{::ctrl.email && 'mailto:' + ctrl.supportEmail || undefined}}\">\n  {{::ctrl.text || ctrl.supportEmail}}\n</a>\n";

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _how_it_works = __webpack_require__(34);

var _how_it_works2 = _interopRequireDefault(_how_it_works);

var _top_panel = __webpack_require__(342);

var _top_panel2 = _interopRequireDefault(_top_panel);

var _top_panel3 = __webpack_require__(344);

var _top_panel4 = _interopRequireDefault(_top_panel3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_how_it_works2.default];

exports.default = _angular2.default.module('common.topPanel', dependencies).directive('saTopPanel', _top_panel2.default).service('topPanel', _top_panel4.default).name;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saTopPanel;

var _top_panel = __webpack_require__(343);

var _top_panel2 = _interopRequireDefault(_top_panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

saTopPanel.$inject = ['topPanel'];
function saTopPanel(topPanel) {
  'ngInject';

  return {
    template: _top_panel2.default,
    replace: true,
    transclude: true,
    scope: {},
    link: function link($scope) {
      $scope.close = topPanel.close.bind(topPanel);
    }
  };
}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = "<section class=\"TopPanel\">\n  <div class=\"TopPanel-content\" ng-transclude></div>\n  <a class=\"TopPanel-close\" ng-click=\"close(true)\"></a>\n</section>\n";

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TopPanel = function () {
  TopPanel.$inject = ['$rootScope', '$timeout', '$compile', '$animate', '$window', '$document', 'scrollTop', 'navigation'];

  function TopPanel($rootScope, $timeout, $compile, $animate, $window, $document, scrollTop, navigation) {
    'ngInject';

    _classCallCheck(this, TopPanel);

    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.$compile = $compile;
    this.$animate = $animate;
    this.scrollTop = scrollTop;
    this.navigation = navigation;

    this.window = angular.element($window);

    var document = $document[0];
    this.body = angular.element(document.body);
    this.wrapperEl = angular.element(document.querySelector('.Wrapper'));
  }

  _createClass(TopPanel, [{
    key: '_getTransform',
    value: function _getTransform(offset) {
      var styles = {};

      styles['-webkit-transform'] = '';
      styles['transform'] = '';
      if (offset) {
        styles['-webkit-transform'] = 'translate(0, ' + offset + 'px)';
        styles['transform'] = 'translate(0, ' + offset + 'px)';
      }

      return styles;
    }
  }, {
    key: 'open',
    value: function open(template) {
      var _this = this;

      if (this.panel || this.isAnimating) {
        this.scrollTop(0);
        return;
      }

      // Add panel to DOM
      var panel = angular.element('<sa-top-panel>' + template + '</sa-top-panel>');
      this.body.append(panel);
      this.$compile(panel)(this.$rootScope.$new());

      var panelHeight = panel[0].offsetHeight;

      // Prepare for animation
      this.navigation.disable();
      this.isAnimating = true;
      this.wrapperEl.addClass('animate-transform is-ngAnimationEnabled');

      this.$animate.animate(this.wrapperEl, {}, this._getTransform(panelHeight)).then(function () {
        _this.scrollTop(0);

        _this._scrollHandler = _this._scrollHandler.bind(_this);
        _this.window.on('scroll', _this._scrollHandler);
        _this.panel.on('$destroy', function () {
          return _this.window.off('scroll', _this._scrollHandler);
        });

        _this.unbindEventListener = _this.$rootScope.$on('$stateChangeSuccess', _this.close.bind(_this));
      }).finally(function () {
        _this.wrapperEl.removeClass('animate-transform is-ngAnimationEnabled');
        delete _this.isAnimating;
      });

      this.panel = panel;
      this.panelHeight = panelHeight;
    }
  }, {
    key: 'close',
    value: function close(animated) {
      if (!this.panel || this.isAnimating) {
        return;
      }

      if (animated === true) {
        this.wrapperEl.addClass('animate-transform is-ngAnimationEnabled');
        this.$animate.animate(this.wrapperEl, {}, this._getTransform(0)).then(this._afterClose.bind(this));
      } else {
        this.wrapperEl.css(this._getTransform(0));
        this._afterClose();
      }
    }
  }, {
    key: '_afterClose',
    value: function _afterClose() {
      this.scrollTop(Math.max(this.scrollTop() - this.panelHeight, 0));

      this.$timeout.cancel(this._timeoutPromise);
      this.window.off('scroll', this._scrollHandler);

      this.navigation.enable();
      this.panel.remove();
      this.wrapperEl.removeClass('animate-transform is-ngAnimationEnabled');

      delete this.isAnimating;
      delete this.panelHeight;
      delete this.panel;
      this.unbindEventListener();
    }
  }, {
    key: '_scrollHandler',
    value: function _scrollHandler() {

      // Stop listening to scroll event
      this.window.off('scroll', this._scrollHandler);

      // Start waiting for scroll to end
      this._waitAndClose();
    }
  }, {
    key: '_waitAndClose',
    value: function _waitAndClose() {
      var _this2 = this;

      this._lastScrollTop = this.scrollTop();
      this._timeoutPromise = this.$timeout(function () {
        var scrollTop = _this2.scrollTop();

        // User stopped scrolling!
        if (_this2._lastScrollTop === scrollTop) {

          if (_this2.scrollTop() >= _this2.panelHeight) {
            _this2.close();
          } else {
            _this2.window.on('scroll', _this2._scrollHandler);
          }
        } else {
          _this2._waitAndClose();
        }
      }, 80);
    }
  }]);

  return TopPanel;
}();

exports.default = TopPanel;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _get_started = __webpack_require__(346);

var _get_started2 = _interopRequireDefault(_get_started);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('settings.getStarted', []).component('saGetStarted', _get_started2.default).name;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get_started = __webpack_require__(347);

var _get_started2 = _interopRequireDefault(_get_started);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: _get_started2.default,
  bindings: {},
  controllerAs: 'ctrl',
  controller: ['social', 'userModel', 'analyticsSa', function controller(social, userModel, analyticsSa) {
    'ngInject';

    var _this = this;

    var self = this;
    this.url = 'https://www.showaround.com/locals/' + userModel.item.id + '?reqRef=1';

    // TODO: put this event tracking somewhere else, lots of possible duplicates
    var TRACK_GET_STARTED_AVAILABLE = 'event-getStartedAvailable';
    analyticsSa.track({ action: TRACK_GET_STARTED_AVAILABLE, data: {} });

    this.copyUrlToClipboard = function () {
      var copyElement = document.createElement("textarea");
      copyElement.style.position = 'fixed';
      copyElement.style.opacity = '0';
      copyElement.textContent = self.url;
      var body = document.getElementsByTagName('body')[0];
      body.appendChild(copyElement);
      copyElement.select();
      document.execCommand('copy');
      body.removeChild(copyElement);
    };

    this.sendReference = function () {
      var TRACK_SEND_REFERENCE_CLICK = 'click-sendReferenceRequestFb';
      analyticsSa.track({ action: TRACK_SEND_REFERENCE_CLICK, data: {} });
      return social.fetchScripts('fb').then(function () {
        social.getSocialNetwork('fb').sendRequest(_this.url);
      });
    };

    this.browseLocals = function () {
      var TRACK_BROWSE_LOCALS_CLICK = 'click-browseLocalsGetStarted';
      analyticsSa.track({ action: TRACK_BROWSE_LOCALS_CLICK, data: {} });
    };

    this.getUserLocation = function () {
      return {
        placeId: userModel.item.location.placeId,
        name: userModel.item.location.name
      };
    };
  }]
};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"GetStarted\">\n  <div class=\"GetStarted-Wrapper\">\n    <h2>How to get started?</h2>\n\n    <div class=\"GetStarted-InfoText\">\n      <p>Now that you've registered, you're halfway there – the next step is to get some experience and show visitors around your city. Travellers are hesitant about booking a local who has no reviews, that’s why we suggest asking your friends and other locals to help you ‘break the ice’.</p>\n    </div>\n\n    <img class=\"GetStarted-Images\" src=\"" + __webpack_require__(55) + "\" srcset=\"" + __webpack_require__(55) + " 1x," + __webpack_require__(348) + " 2x\" alt=\"how do you get reviews\">\n\n    <h2>How to get your first review?</h2>\n\n    <div class=\"GetStarted-InfoText\">\n      <div class=\"GetStarted-Steps GetStarted-Steps-One\">1</div>\n      <p>Contact another local from your city, meetup, and share your favourite spots, then leave a review for each other.</p>\n      <div class=\"GetStarted-Link Link Link--orange\" ui-sref=\"guides.list($ctrl.getUserLocation())\" ng-click=\"$ctrl.browseLocals()\">\n        Browse Locals Nearby\n      </div>\n    </div>\n\n    <div class=\"GetStarted-InfoText\">\n      <div class=\"GetStarted-Steps GetStarted-Steps-Two\">2</div>\n      <p>Send a reference request and invite your friends on Facebook to join and leave a review about you.  Just make sure to ask people who know you well so that the reference is worthwhile.</p>\n      <div class=\"GetStarted-Steps-MobileShare u-visible-m\">\n        <p>Copy the link below and share it with your friends on Facebook to get started.</p>\n      </div>\n\n      <div class=\"Form\" style=\"background: transparent;display: flex;align-items: center;justify-content: center;flex-wrap: wrap;\">\n        <input type=\"text\" ng-model=\"ctrl.url\" class=\"Form-field\"/>\n        <div class=\"GetStarted-Link Link Link--orange\" ng-click=\"ctrl.copyUrlToClipboard()\">Copy to clipboard</div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/80040b53c5e317a8842ee0a99be50264.png";

/***/ }),
/* 349 */,
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bookings = __webpack_require__(351);

var _bookings2 = _interopRequireDefault(_bookings);

var _lazy_load_booking_modal = __webpack_require__(352);

var _lazy_load_booking_modal2 = _interopRequireDefault(_lazy_load_booking_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('common', []).factory('bookings', _bookings2.default).factory('lazyLoadBookingModal', _lazy_load_booking_modal2.default).name;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bookings;
bookings.$inject = ['$rootScope', '$http', '$q', 'utils', 'userModel', 'modal', 'analytics', 'lazyLoadBookingModal'];
var analyticsBookingCategory = 'Booking';
var analyticsBookAction = 'RequestedToBook';
var analyticsAcceptAction = 'AcceptedBookingRequest';
var analyticsDeclineAction = 'DeclinedBookingRequest';
var analyticsCancelAction = 'CanceledBookingRequest';
var analyticsBookingPopupAction = 'OpenedBookingPopup';

function bookings($rootScope, $http, $q, utils, userModel, modal, analytics, lazyLoadBookingModal) {
  'ngInject';

  return {

    lazyLoadBookingModal: lazyLoadBookingModal.load,

    createBooking: function createBooking(guideId, bookingData) {
      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + guideId + '/create'), bookingData).then(function (response) {
          analytics.track(analyticsBookAction, {
            category: analyticsBookingCategory,
            value: '0.00',
            currency: 'USD'
          });

          resolve(response.data);
        }).catch(reject);
      });
    },

    modify: function modify(conversationId, bookingData) {
      var postData = {
        bookingId: bookingData.bookingId,
        date: bookingData.date,
        hours: bookingData.hours
      };

      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/modify'), postData).then(function (response) {
          resolve(response.data);
        }).catch(reject);
      });
    },

    accept: function accept(conversationId) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'discuss';

      var postData = { type: type };

      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/accept'), postData).then(function (response) {
          resolve(response.data);
          analytics.track(analyticsAcceptAction, {
            category: analyticsBookingCategory
          });
        }).catch(reject);
      });
    },

    acceptOffer: function acceptOffer(conversationId, message) {

      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/offer_accept'), { message: message }).then(function (response) {
          resolve(response.data);
          analytics.track(analyticsAcceptAction, {
            category: analyticsBookingCategory
          });
        }).catch(reject);
      });
    },

    confirmTour: function confirmTour(bookingId, participantId, action) {
      var postData = { action: action, bookingId: bookingId };
      $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '\n/log_booking_confirm_action/' + participantId), postData);
    },

    decline: function decline(conversationId) {
      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/decline')).then(function (response) {
          analytics.track(analyticsDeclineAction, {
            category: analyticsBookingCategory
          });
          resolve(response.data);
        }).catch(reject);
      });
    },

    declineOffer: function declineOffer(conversationId) {
      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/offer_decline')).then(function (response) {
          analytics.track(analyticsDeclineAction, {
            category: analyticsBookingCategory
          });
          resolve(response.data);
        }).catch(reject);
      });
    },

    cancel: function cancel(conversationId) {
      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/cancel')).then(function (response) {
          analytics.track(analyticsCancelAction, {
            category: analyticsBookingCategory
          });
          resolve(response.data);
        }).catch(reject);
      });
    },

    showBookingModal: function showBookingModal(guide, booking) {
      var _this = this;

      return this.lazyLoadBookingModal().then(function () {
        return _this.openModal(guide, booking);
      });
    },

    openModal: function openModal(guide, booking) {
      var modalScope = $rootScope.$new();
      var modalInstance;

      modalScope.guide = guide;
      modalScope.booking = booking || {};

      modalInstance = modal.open({
        template: '<booking-form guide="guide" booking="booking" done="close(booking)"></booking-form>',
        scope: modalScope
      });

      analytics.track(analyticsBookingPopupAction, {
        category: analyticsBookingCategory
      });

      return new $q(function (resolve, reject) {
        modalInstance.result.then(resolve).catch(reject).finally(function () {
          modalInstance.close();
        });
      });
    }
  };
}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$q', '$translate', '$ocLazyLoad'];
function f($q, $translate, $ocLazyLoad) {
  'ngInject';

  return {
    load: function load() {
      return $q(function (resolve) {
        __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 590)).then(function () {
          $ocLazyLoad.load({
            name: 'common.bookingForm'
          });
          $translate.refresh().then(function () {
            resolve();
          });
        });
      });
    }
  };
}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencySymbolFactory = function currencySymbolFactory(currencies) {
  'ngInject';

  return function (currencyCode) {
    var currency = currencies.filter(function (currency) {
      return currency.code === currencyCode;
    })[0] || {};

    return currency.symbol || currencyCode;
  };
};

currencySymbolFactory.$inject = ['currencies'];
exports.default = _angular2.default.module('service.currencySymbol', []).factory('currencySymbol', currencySymbolFactory).name;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

remarketingFactory.$inject = ['analytics'];


var denmark = 'DK';
var country = (window.SA || {}).country;

function remarketingFactory(analytics) {
  'ngInject';

  return {
    init: function init() {

      // Track event only if user is from denmark (by ip)
      // User for adwords remarketing
      if (country && country === denmark) {
        analytics.track('RemarketingDK', {
          category: 'Remarketing'
        });
      }
    }
  };
}

exports.default = _angular2.default.module('services.remarketing', []).factory('remarketing', remarketingFactory).name;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularCookies = __webpack_require__(8);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var femaleCookieName = 'sex_female';
var femaleCookieValue = '1';
var femaleRegexp = /^W/;

var fbCampaignHandlerFactory = function fbCampaignHandlerFactory($location, $cookies) {
  'ngInject';

  return function () {
    var utmContent = $location.search()['utm_content'];

    if (femaleRegexp.test(utmContent)) {
      var expires = new Date();
      expires.setMonth(expires.getMonth() + 1);

      var cookieOptions = {
        expires: expires,
        path: '/'
      };

      $cookies.put(femaleCookieName, femaleCookieValue, cookieOptions);
    }
  };
};

fbCampaignHandlerFactory.$inject = ['$location', '$cookies'];
var dependencies = [_angularCookies2.default];

exports.default = _angular2.default.module('services.fbCampaignHandler', dependencies).factory('fbCampaignHandler', fbCampaignHandlerFactory).name;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _booking_date = __webpack_require__(357);

var _booking_date2 = _interopRequireDefault(_booking_date);

var _city_photo = __webpack_require__(358);

var _city_photo2 = _interopRequireDefault(_city_photo);

var _duration = __webpack_require__(360);

var _duration2 = _interopRequireDefault(_duration);

var _language = __webpack_require__(361);

var _language2 = _interopRequireDefault(_language);

var _location = __webpack_require__(362);

var _location2 = _interopRequireDefault(_location);

var _meeting_time = __webpack_require__(363);

var _meeting_time2 = _interopRequireDefault(_meeting_time);

var _nl2br = __webpack_require__(364);

var _nl2br2 = _interopRequireDefault(_nl2br);

var _number_of_people = __webpack_require__(365);

var _number_of_people2 = _interopRequireDefault(_number_of_people);

var _phone = __webpack_require__(366);

var _phone2 = _interopRequireDefault(_phone);

var _possessive = __webpack_require__(367);

var _possessive2 = _interopRequireDefault(_possessive);

var _response_time = __webpack_require__(368);

var _response_time2 = _interopRequireDefault(_response_time);

var _to_date = __webpack_require__(369);

var _to_date2 = _interopRequireDefault(_to_date);

var _first_name = __webpack_require__(370);

var _first_name2 = _interopRequireDefault(_first_name);

var _booking = __webpack_require__(371);

var _booking2 = _interopRequireDefault(_booking);

var _long_short_date = __webpack_require__(372);

var _long_short_date2 = _interopRequireDefault(_long_short_date);

var _guide_price = __webpack_require__(373);

var _guide_price2 = _interopRequireDefault(_guide_price);

var _limit_words = __webpack_require__(374);

var _limit_words2 = _interopRequireDefault(_limit_words);

var _country_filter = __webpack_require__(375);

var _country_filter2 = _interopRequireDefault(_country_filter);

var _guide_slug = __webpack_require__(376);

var _guide_slug2 = _interopRequireDefault(_guide_slug);

var _round = __webpack_require__(377);

var _round2 = _interopRequireDefault(_round);

var _spaces_with_dashes = __webpack_require__(378);

var _spaces_with_dashes2 = _interopRequireDefault(_spaces_with_dashes);

var _dashes_with_spaces = __webpack_require__(379);

var _dashes_with_spaces2 = _interopRequireDefault(_dashes_with_spaces);

var _title_case = __webpack_require__(380);

var _title_case2 = _interopRequireDefault(_title_case);

var _deslug = __webpack_require__(381);

var _deslug2 = _interopRequireDefault(_deslug);

var _price = __webpack_require__(62);

var _price2 = _interopRequireDefault(_price);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [_price2.default];

exports.default = _angular2.default.module('filters', dependencies).filter('bookingDate', _booking_date2.default).filter('cityPhoto', _city_photo2.default).filter('duration', _duration2.default).filter('language', _language2.default).filter('location', _location2.default).filter('meetingTime', _meeting_time2.default).filter('nl2br', _nl2br2.default).filter('numberOfPeople', _number_of_people2.default).filter('phone', _phone2.default).filter('possessive', _possessive2.default).filter('responseTime', _response_time2.default).filter('toDate', _to_date2.default).filter('firstName', _first_name2.default).filter('booking', _booking2.default).filter('longShortDate', _long_short_date2.default).filter('guidePrice', _guide_price2.default).filter('limitWords', _limit_words2.default).filter('country', _country_filter2.default).filter('guideSlug', _guide_slug2.default).filter('round', _round2.default).filter('spacesWithDashes', _spaces_with_dashes2.default).filter('dashesWithSpaces', _dashes_with_spaces2.default).filter('titleCase', _title_case2.default).filter('deslug', _deslug2.default).name;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$filter', function ($filter) {
  'ngInject';

  var toDateFilter = $filter('toDate');
  var dateFilter = $filter('date');

  return function (date, shouldShowFullMonthName) {
    var result = '';
    var monthFormat = shouldShowFullMonthName ? 'MMMM' : 'MMM';

    if (angular.isString(date) || angular.isNumber(date)) {
      result = dateFilter(toDateFilter(date), 'd ' + monthFormat + ' yyyy');
    }

    return result;
  };
}];

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cityPhoto;
cityPhoto.$inject = ['imgixHelpers'];
var photoSize = {
  default: {
    small: {
      w: 380,
      h: 240,
      cropRatio: 95 / 60,
      defaultPhoto: __webpack_require__(359)
    },
    large: {
      w: 1400,
      h: 560,
      dpr: 1,
      defaultPhoto: __webpack_require__(65)
    }
  },
  landing_default: {
    small: {
      w: 380,
      h: 240,
      cropRatio: 95 / 60,
      defaultPhoto: 'https://showaroundoriginal.imgix.net/places/ChIJD7fiBh9u5kcRYJSMaMOCCwQknitr.jpg?w=380&dpr=1.5&or=0&bri=0&con=0&q=0'
    },
    large: {
      w: 1400,
      h: 560,
      dpr: 1,
      defaultPhoto: 'https://showaroundoriginal.imgix.net/places/ChIJD7fiBh9u5kcRYJSMaMOCCwQknitr.jpg?w=1400&dpr=1&or=0&bri=0&con=0&q=0'
    }
  }
};

function cityPhoto(imgixHelpers) {
  'ngInject';

  return function (photo, size) {
    var allowDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var landing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var sizeInfo = photoSize.default[size] || photoSize.default.small;
    if (landing) {
      sizeInfo = photoSize.landing_default[size] || photoSize.landing_default.small;
    }

    var url = void 0;

    if (photo) {
      url = imgixHelpers.getUrl(photo, sizeInfo, getCropCoords(photo, sizeInfo));
    } else if (allowDefault) {
      url = sizeInfo.defaultPhoto;
    } else {
      url = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }

    return url;
  };
}

function getCropCoords(photo, sizeInfo) {
  var coords = null;
  var width;

  if (sizeInfo.cropRatio) {
    width = Math.ceil(photo.height * sizeInfo.cropRatio);
    coords = String(Math.ceil((photo.width - width) / 2)) + ',0,' + String(width) + ',' + photo.height;
  }

  return coords;
}

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/c7d715aa63811e184961b98279cb7536.jpg";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  'ngInject';

  var durationMap = {
    '1month': '1 month',
    '3month': '3 months',
    '12month': '1 year'
  };

  return function (duration) {

    return durationMap[duration];
  };
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$filter'];
function f($filter) {
  'ngInject';

  var translateFilter = $filter('translate');

  return function (language) {
    language = language || '';

    return translateFilter('LANGUAGES.' + language.toUpperCase());
  };
}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var location = function location(countries) {
  return function (value) {
    var formattedValue = value && value.name;
    var countryCode = value && value.countryCode;

    if (formattedValue && countryCode) {
      formattedValue += ', ' + countries[countryCode].name;
    }

    return formattedValue;
  };
};

location.$inject = ['countries'];

exports.default = location;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var meetingTime = function meetingTime($filter) {
  var translateFilter = $filter('translate');

  return function (input) {
    return translateFilter('MEETING_TIME.' + input.toUpperCase());
  };
};

meetingTime.$inject = ['$filter'];

exports.default = meetingTime;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var nl2br = function nl2br() {
  return function (input) {
    return angular.isString(input) ? input.replace(/\n/g, '<br>') : input;
  };
};

exports.default = nl2br;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var numberOfPeople = function numberOfPeople($filter) {
  return function (input) {
    return $filter('translate')('NUMBER_OF_PEOPLE.' + String(input));
  };
};

numberOfPeople.$inject = ['$filter'];

exports.default = numberOfPeople;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var phone = function phone() {
  return function (phone) {
    return phone && phone.code && phone.number ? '+' + phone.code + phone.number : '';
  };
};

exports.default = phone;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = possessiveFilter;
function possessiveFilter() {
  return function (properNoun) {
    if (!properNoun) {
      return properNoun;
    }

    var lastChar = properNoun.charAt(properNoun.length - 1);
    return lastChar == 's' || lastChar == 'S' ? properNoun + '\'' : properNoun + '\'s';
  };
}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var responseTimes = [{
  max: 30,
  value: 'instantly'
}, {
  max: 90,
  value: 'within an hour'
}, {
  max: 720,
  value: 'within several hours'
}, {
  value: 'within a day'
}];
var responseTime = function responseTime() {

  /**
   * Converts average response time to verbal form.
   *
   * @param {Number} minutes Average response time in minutes
   * @returns {String}
   */
  var filter = function filter(minutes) {
    var result = void 0;

    if (angular.isNumber(minutes)) {
      for (var iter = 0; iter < responseTimes.length; iter++) {
        if (!responseTimes[iter].max || minutes <= responseTimes[iter].max) {
          result = responseTimes[iter].value;
          break;
        }
      }
    }

    return result;
  };

  return filter;
};

exports.default = responseTime;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var toDate = function toDate() {
  return function toDate(input) {
    var date;

    if (angular.isNumber(input)) {
      date = new Date(input * 1000);
    } else if (angular.isString(input) && input.length === 8) {
      date = new Date(Number(input.slice(0, 4)), Number(input.slice(4, 6)) - 1, Number(input.slice(6, 8)));
    }

    return date;
  };
};

exports.default = toDate;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  'ngInject';

  return function (name) {
    var whiteSpace = name.indexOf(' ');
    if (whiteSpace !== -1) {
      return name.substr(0, whiteSpace);
    } else {
      return name;
    }
  };
};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$filter', '$sce', 'userModel', function ($filter, $sce, userModel) {
  'ngInject';

  var bookingDateFilter = $filter('bookingDate');
  var translateFilter = $filter('translate');
  var priceFilter = $filter('price');

  return function (booking) {
    var output = '';
    var price;

    if (booking) {
      output += bookingDateFilter(booking.date) + '&nbsp;';

      price = userModel.item.id === booking.guideId ? booking.guidePriceInfo : booking.guestPriceInfo;
      output += '(' + priceFilter(price.amount, price.currency, 0) + '&nbsp;';
      output += translateFilter('BOOKING_DURATION', { HOURS: booking.hours }) + ')';
    }

    return $sce.trustAsHtml(output);
  };
}];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function stringToDate(dateString) {
  var year = parseInt(dateString.substr(0, 4), 10);
  var month = parseInt(dateString.substr(4, 2), 10) - 1;
  var day = parseInt(dateString.substr(6, 2), 10);

  return new Date(year, month, day);
}

exports.default = function () {
  return function (d) {
    if (typeof d.getMonth !== 'function') {
      d = stringToDate(d);
    }

    return d.getDate() + ' ' + MONTHS[d.getMonth()].substr(0, 3) + ', ' + d.getFullYear();
  };
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$filter', 'currencySymbol', function ($filter, currencySymbol) {
  'ngInject';

  return function (priceInfo, boldText) {
    var allowFree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    priceInfo = priceInfo || {};

    var price = priceInfo.fullPrice || 0;
    var currenciesWithCode = ['AUD', 'CAD', 'HKD', 'MXN', 'NZD', 'SGD', 'SEK', 'NOK', 'DKK'];
    var curencyCode = void 0;

    if (currenciesWithCode.indexOf(priceInfo.currency) > -1) {
      curencyCode = '<sup>' + priceInfo.currency + '<sup>';
    } else {
      curencyCode = '';
    }

    if (price || !allowFree) {

      var symbol = currencySymbol(priceInfo.currency);
      return '<strong><sup>' + symbol + '</sup>' + price + curencyCode + '</strong>/h';
    } else {
      var tag = boldText ? 'strong' : 'span';
      return '<' + tag + '>Free</' + tag + '>';
    }
  };
}];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = limitWordsFilter;
function limitWordsFilter() {
  return function (value) {
    var wordLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var words = value.match(/\S+/g) || [''];
    return words.slice(0, wordLimit)[0];
  };
}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['countries'];
function f(countries) {
  'ngInject';

  return function (value) {
    var formattedValue = value && value.name;
    var countryCode = value && value.countryCode;

    if (formattedValue && countryCode) {
      formattedValue = countries[countryCode].name;
    }

    return formattedValue;
  };
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = guideSlugFilter;
guideSlugFilter.$inject = ['slug'];
function guideSlugFilter(slug) {
  'ngInject';

  var slugFilter = slug;

  return function () {
    var guide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var slug = [];

    if (guide.nameSlug) {
      slug.push(slugFilter.it(guide.nameSlug));
    } else if (guide.name) {
      slug.push(slugFilter.it(guide.name));
    }

    if (guide.location && guide.location.city && guide.location.country) {
      slug.push(slugFilter.it(guide.location.city));
      slug.push(slugFilter.it(guide.location.country));
    }

    if (guide.id) {
      slug.push(guide.id);
    } else if (guide.userId) {
      slug.push(guide.userId);
    }

    return slug.join('-');
  };
}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  'ngInject';

  return function (number) {
    number = number * 1;
    if (number < 10) {
      number = '<10';
    } else if (number > 9 && number < 100) {
      number = '10+';
    } else if (number > 99 && number < 999) {
      number = Math.floor(number / 100) * 100 + '+';
    } else if (number > 999) {
      number = Math.floor(number / 1000) + 'k+';
    }
    return number;
  };
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
function f() {
  return function (name) {
    return name.replace(/\s/g, '-');
  };
}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
function f() {
  return function (name) {
    return name.replace(/-/g, ' ');
  };
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
function f() {
  return function (input) {
    input = input || '';
    return input.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };
}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['deslug'];
function f(deslug) {
  'ngInject';

  return function (s) {
    return deslug.it(s);
  };
}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _fb_join_modal = __webpack_require__(383);

var _fb_join_modal2 = _interopRequireDefault(_fb_join_modal);

var _fb_join_modal3 = __webpack_require__(385);

var _fb_join_modal4 = _interopRequireDefault(_fb_join_modal3);

var _request_reference_modal = __webpack_require__(386);

var _request_reference_modal2 = _interopRequireDefault(_request_reference_modal);

var _no_profile_photo_modal = __webpack_require__(387);

var _no_profile_photo_modal2 = _interopRequireDefault(_no_profile_photo_modal);

var _no_profile_photo_modal3 = __webpack_require__(389);

var _no_profile_photo_modal4 = _interopRequireDefault(_no_profile_photo_modal3);

var _pay_conversation_modal = __webpack_require__(390);

var _pay_conversation_modal2 = _interopRequireDefault(_pay_conversation_modal);

var _pay_conversation_modal3 = __webpack_require__(392);

var _pay_conversation_modal4 = _interopRequireDefault(_pay_conversation_modal3);

var _location_confirmation_modal = __webpack_require__(393);

var _location_confirmation_modal2 = _interopRequireDefault(_location_confirmation_modal);

var _location_confirmation_service = __webpack_require__(396);

var _location_confirmation_service2 = _interopRequireDefault(_location_confirmation_service);

var _create_trip_banner = __webpack_require__(397);

var _create_trip_banner2 = _interopRequireDefault(_create_trip_banner);

var _conversation_trip_avatar = __webpack_require__(399);

var _conversation_trip_avatar2 = _interopRequireDefault(_conversation_trip_avatar);

var _conversation_trip = __webpack_require__(401);

var _conversation_trip2 = _interopRequireDefault(_conversation_trip);

var _system_alerts = __webpack_require__(403);

var _system_alerts2 = _interopRequireDefault(_system_alerts);

var _system_alerts3 = __webpack_require__(405);

var _system_alerts4 = _interopRequireDefault(_system_alerts3);

var _trip_offer_accept_modal = __webpack_require__(406);

var _trip_offer_accept_modal2 = _interopRequireDefault(_trip_offer_accept_modal);

var _trip_offer_accept_modal3 = __webpack_require__(408);

var _trip_offer_accept_modal4 = _interopRequireDefault(_trip_offer_accept_modal3);

var _offer_message = __webpack_require__(409);

var _offer_message2 = _interopRequireDefault(_offer_message);

var _last_offer_message = __webpack_require__(410);

var _last_offer_message2 = _interopRequireDefault(_last_offer_message);

var _send_offer_modalService = __webpack_require__(411);

var _send_offer_modalService2 = _interopRequireDefault(_send_offer_modalService);

var _send_offer_success_alert = __webpack_require__(412);

var _send_offer_success_alert2 = _interopRequireDefault(_send_offer_success_alert);

var _pay_modal = __webpack_require__(413);

var _pay_modal2 = _interopRequireDefault(_pay_modal);

var _credit_card_type = __webpack_require__(414);

var _credit_card_type2 = _interopRequireDefault(_credit_card_type);

var _fast_pay_modal = __webpack_require__(415);

var _fast_pay_modal2 = _interopRequireDefault(_fast_pay_modal);

var _fast_pay_modal3 = __webpack_require__(417);

var _fast_pay_modal4 = _interopRequireDefault(_fast_pay_modal3);

var _braintree_modal = __webpack_require__(418);

var _braintree_modal2 = _interopRequireDefault(_braintree_modal);

var _braintree_modal3 = __webpack_require__(420);

var _braintree_modal4 = _interopRequireDefault(_braintree_modal3);

__webpack_require__(421);

__webpack_require__(422);

__webpack_require__(423);

__webpack_require__(424);

__webpack_require__(425);

__webpack_require__(426);

__webpack_require__(427);

__webpack_require__(428);

__webpack_require__(429);

__webpack_require__(430);

__webpack_require__(431);

__webpack_require__(432);

__webpack_require__(433);

__webpack_require__(434);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import 'nls!./fast_pay_modal/fast_pay_modal.json';


// modules
// import saMyTripsModule from './trips/my_trips';
// import saTripsModule from './trips/trips';

// translations


//  pay modal


//  pay modal
// import saPayModal from './pay_modal/pay_modal';


// trip offer accept modal


// System alerts


// import saRequestReference from './request_reference/request_reference_page/request_reference';
exports.default = _angular2.default.module('components', []).component('saNoProfilePhotoModal', _no_profile_photo_modal2.default).factory('noProfilePhotoModal', _no_profile_photo_modal4.default).component('saFbJoinModal', _fb_join_modal2.default).factory('fbJoinModal', _fb_join_modal4.default).factory('requestReferenceModal', _request_reference_modal2.default).component('saTripOfferAcceptModal', _trip_offer_accept_modal2.default).factory('tripOfferAcceptModal', _trip_offer_accept_modal4.default)

// .component('saPayModal', saPayModal)
.factory('payModal', _pay_modal2.default).factory('creditCardType', _credit_card_type2.default).factory('offerMessage', _offer_message2.default).factory('lastOfferMessage', _last_offer_message2.default).factory('sendOfferModal', _send_offer_modalService2.default).factory('sendOfferSuccessAlert', _send_offer_success_alert2.default).component('saFastPayModal', _fast_pay_modal2.default).factory('fastPayModal', _fast_pay_modal4.default).component('saBraintreeModal', _braintree_modal2.default).factory('braintreeModal', _braintree_modal4.default)

// System alerts
.component('saSystemAlerts', _system_alerts2.default).factory('systemAlerts', _system_alerts4.default)

// .component('saRequestReference', saRequestReference)
.component('saPayConversationModal', _pay_conversation_modal2.default).component('saCreateTripBanner', _create_trip_banner2.default).component('saConversationTrip', _conversation_trip2.default).component('saConversationTripAvatar', _conversation_trip_avatar2.default).component('saLocationConfirmationModal', _location_confirmation_modal2.default).factory('locationConfirmationService', _location_confirmation_service2.default).factory('payConversationModal', _pay_conversation_modal4.default).name;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fb_join_modal = __webpack_require__(384);

var _fb_join_modal2 = _interopRequireDefault(_fb_join_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {
    done: '&',
    guide: '<'
  },
  template: _fb_join_modal2.default,
  controller: ['$state', 'social', 'userModel', 'requestReferenceModal', 'referenceCheck', function controller($state, social, userModel, requestReferenceModal, referenceCheck) {
    'ngInject';

    this.facebook = {
      cssClass: 'Button--fb',
      iconCssClass: 'Icon-fb',
      name: 'fb',
      displayName: 'Facebook',
      social: true
    };

    this.connectWithFb = function () {
      var _this = this;

      this.isLoading = true;

      social.login('fb').then(function () {
        var userId = userModel.item.id;
        var userToReviewId = _this.guide.id;

        referenceCheck.reviewLeft(userId, userToReviewId).then(function (result) {
          if (!result.reviewLeft) {
            requestReferenceModal.open(_this.guide);
          }

          _this.done({
            result: result
          });
        }).finally(function () {
          delete _this.isLoading;
        });
      });
    };

    this.infoTerms = function () {
      $state.go('info.terms');
      this.done({ reason: 1 });
    };
    this.infoPrivacy = function () {
      $state.go('info.privacy');
      this.done({ reason: 1 });
    };
  }]
};

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = "<div class=\"FbJoinModal\">\n  <div class=\"FbJoinModal-title\">Connect with Facebook </br> to leave a reference about {{$ctrl.guide.name}} </div>\n  <div class=\"FbJoinModal-button-wrapper\">\n    <sa-join-option-button ng-if=\"!$ctrl.isLoading\" options=\"$ctrl.facebook\" ng-click=\"$ctrl.connectWithFb()\"></sa-join-option-button>\n    <div class=\"FbJoinModal-loader-wrapper\" ng-if=\"$ctrl.isLoading\">\n      <div class=\"Join-loader FbJoinModal-loader-wrapper\">\n        <div class=\"Loader\"></div>\n      </div>\n    </div>\n  </div>\n  <div class=\"FbJoinModal-text\">We won’t post anything on your behalf without your permission.</div>\n  <hr class=\"FbJoinModal-separator\">\n  <div class=\"Join-terms\" class=\"FbJoinModal-text\">I confirm that I agree with Showaround’s <a class=\"Link Link--blue\" ng-click=\"$ctrl.infoTerms()\">Terms of Service</a> and <a class=\"Link Link--blue\" ng-click=\"$ctrl.infoPrivacy()\">Privacy Policy</a>.</div>\n</div>\n\n";

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['modal', '$rootScope'];
function f(modal, $rootScope) {
  'ngInject';

  return {
    open: function open(guide) {
      var scope = $rootScope.$new();
      scope.guide = guide;
      return modal.open({
        template: '<sa-fb-join-modal done="close(reason)" guide="guide"></sa-fb-join-modal>',
        scope: scope
      }).result;
    }
  };
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['modal', '$rootScope', '$ocLazyLoad', '$q'];
function f(modal, $rootScope, $ocLazyLoad, $q) {
  'ngInject';

  return {
    open: function open(guide) {
      return $q(function (resolve) {
        __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 591)).then(function () {
          $ocLazyLoad.load({
            name: 'components.requestReferenceModal'
          });

          var scope = $rootScope.$new();
          scope.guide = guide;

          resolve(modal.open({
            template: '<sa-request-reference-modal done="close()" guide="guide"></sa-request-reference-modal>',
            scope: scope
          }).result);
        });
      });
    }
  };
}

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _no_profile_photo_modal = __webpack_require__(388);

var _no_profile_photo_modal2 = _interopRequireDefault(_no_profile_photo_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {
    done: '&'
  },
  template: _no_profile_photo_modal2.default,
  controller: ['$state', function controller($state) {
    'ngInject';

    this.addPhoto = function () {
      $state.go('settings', { noPhoto: true });
      this.done();
    };
  }]
};

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports = "<div class=\"NoProfilePhotoModal\">\n  <div class=\"Join-loader\" ng-if=\"ctrl.isLoading\">\n    <div class=\"Loader\"></div>\n  </div>\n  <div ng-if=\"!ctrl.isLoading\">\n    <div class=\"NoProfilePhotoModal-image\"></div>\n    <div class=\"NoProfilePhotoModal-header\">\n      Become Visible\n    </div>\n    <div class=\"NoProfilePhotoModal-body\">\n      <p>The chances that your request will be accepted is nearly four times better if you add a profile photo.</p>\n    </div>\n  </div>\n\n  <div class=\"NoProfilePhotoModal-button\">\n    <button class=\"Button Button-smallTextMobile\" ng-click=\"$ctrl.addPhoto()\">\n      Add Photo\n    </button>\n  </div>\n</div>\n";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['modal', 'development'];
function f(modal, development) {
  'ngInject';

  return {
    open: function open() {
      if (development.disablePopUps()) {
        return;
      }

      return modal.open({
        template: '<sa-no-profile-photo-modal done="close()"></sa-no-profile-photo-modal>'
      }).result;
    }
  };
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pay_conversation_modal = __webpack_require__(391);

var _pay_conversation_modal2 = _interopRequireDefault(_pay_conversation_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {
    done: '&',
    conversation: '<'
  },
  template: _pay_conversation_modal2.default
};

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "<div class=\"PayConversationModal\">\n  <div class=\"Join-loader\" ng-if=\"ctrl.isLoading\">\n    <div class=\"Loader\"></div>\n  </div>\n  <div ng-if=\"!ctrl.isLoading\">\n    <div class=\"PayConversationModal-image\"></div>\n    <div class=\"PayConversationModal-header\">\n      Settle your payment\n    </div>\n    <div class=\"PayConversationModal-body\">\n      <p>Ready to pay for the booking? Pay up front and make {{$ctrl.conversation.name}} feel secure and comfortable about this booking.</p>\n    </div>\n\n    <div class=\"PayConversationModal-button\">\n      <sa-pay-button booking=\"$ctrl.conversation.booking\" min-hours=\"$ctrl.conversation.guideInfo.minHours\" guide-id=\"$ctrl.conversation.id\"></sa-pay-button>\n    </div>\n\n    <div class=\"PayConversationModal-link\">\n      <a href=\"\" class=\"Link Link--blue\" ng-click=\"$ctrl.done()\">Not ready yet</a>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$rootScope', 'modal', 'development', 'userModel', 'Storage'];
function f($rootScope, modal, development, userModel, Storage) {
  'ngInject';

  // sa_booking_pay_modal

  var PAY_MODAL_KEY = 'sa_bpm';
  var THREE_HOURS = 10800000;
  var COOKIE_EXPIRATION = THREE_HOURS;
  var storage = new Storage('cookie');

  var timePassed = function timePassed() {
    var key = PAY_MODAL_KEY;
    var data = storage.get(key);
    if (data) {
      return false;
    } else {
      storage.set(key, 1, { expires: new Date(new Date().getTime() + COOKIE_EXPIRATION) });
      return true;
    }
  };

  return {
    open: function open(conversation) {
      if (development.disablePopUps()) {
        return;
      }
      // Mind the order!
      var payBookingStatus = conversation.booking.status === 'accept';

      var offerShowPayConversation = false;
      if (conversation.booking.status === 'offer_accept') {
        var offerAccept = conversation.$messages.filter(function (message) {
          if (message.action === 'offer_accept') {
            return true;
          }
        })[0];

        var offerAcceptSentAt;
        if (offerAccept) {
          offerAcceptSentAt = offerAccept.sentAt;
        } else {
          return;
        }

        var sentMessageCount = conversation.$messages.filter(function (message) {
          if (message.$type === 'message' && message.sender === userModel.item.id && message.sentAt > offerAcceptSentAt) {
            return true;
          }
        }).length;

        var receivedMessageCount = conversation.$messages.filter(function (message) {
          if (message.$type === 'message' && message.sender !== userModel.item.id && message.sentAt > offerAcceptSentAt) {
            return true;
          }
        }).length;

        if (receivedMessageCount >= 1 && sentMessageCount >= 2) {
          offerShowPayConversation = true;
        }
      }

      var paidBooking;
      try {
        paidBooking = conversation.booking.guestPriceInfo.amount;
      } catch (e) {
        paidBooking = false;
      }

      var traveller = conversation.booking.guideId !== userModel.item.id;
      var wrongConditions = !((payBookingStatus || offerShowPayConversation) && paidBooking && traveller);
      if (wrongConditions) {
        return;
      } else if (!timePassed()) {
        return;
      }

      var scope = $rootScope.$new();
      scope.conversation = conversation;

      return modal.open({
        template: '<sa-pay-conversation-modal conversation="conversation" done="close()"></sa-pay-conversation-modal>',
        scope: scope
      }).result;
    }
  };
}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location_confirmation_modal = __webpack_require__(394);

var _location_confirmation_modal2 = _interopRequireDefault(_location_confirmation_modal);

var _settings = __webpack_require__(395);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {
    onSuccess: '&',
    name: '@',
    type: '@'
  },
  template: _location_confirmation_modal2.default,
  controller: ['$rootScope', '$scope', '$http', '$timeout', '$window', 'utils', 'userModel', 'settings', 'locationConfirmationService', function controller($rootScope, $scope, $http, $timeout, $window, utils, userModel, settings, locationConfirmationService) {
    'ngInject';

    var _this = this;

    var NOTIFICATION_DELAY = 15000;

    this.SETTINGS_ERRORS = _settings2.default.SETTINGS_ERRORS;

    try {
      var locationInitialId = '';
      if (locationConfirmationService.response && locationConfirmationService.response.location && locationConfirmationService.response.location.placeId) {
        locationInitialId = locationConfirmationService.response.location.placeId;
      }

      this.locationView = true;
      this.homeView = false;
      // remove this variable, inline text
      this.placeHolder = 'Enter your current location';

      // TODO: should redo this to be passed as parameters instead
      this.HOME = 'home';
      this.TRAVEL = 'trip_yes';

      this.YES = 'trip_yes';
      this.NO = 'trip_no';

      this.AUTOTRIP = 'AUTOTRIP';
      this.LOCATION_CONFIRMATION = 'LOCATION_CONFIRMATION';

      this.submitValue = [];

      if (this.type == this.LOCATION_CONFIRMATION) {
        this.submitValue[0] = this.HOME;
        this.submitValue[1] = this.TRAVEL;
      } else if (this.type == this.AUTOTRIP) {
        this.submitValue[0] = this.YES;
        this.submitValue[1] = this.NO;
      }

      if (locationConfirmationService.response.location) {
        this.locationInput = locationConfirmationService.response.location;
      }

      if (locationConfirmationService.response.suggestedHomeLocation) {
        this.homeInput = locationConfirmationService.response.suggestedHomeLocation;
      }

      this.url = utils.getApiUrlV2('trips/' + userModel.item.id + '/location_popup');
    } catch (e) {
      // $window.Raven.captureException(e);
    }

    function focusInput(which) {
      try {
        $window.document.getElementById(which).focus();
      } catch (e) {
        //
      }
    }

    $timeout(function () {
      focusInput('location');
    });

    // Submit button on autotrip/location confirmation popup
    this.submit = function (submitValue) {
      _this.isSaving = true;
      if (_this.type === _this.LOCATION_CONFIRMATION) {
        _this.confirmLocation(submitValue);
      } else if (_this.type === _this.AUTOTRIP) {
        _this.autoTrip(submitValue);
      }
    };

    this.saveHomeLocation = function (placeId) {
      settings.save('location', placeId, 'placeId').then(function () {
        _this.onSuccess();
      }).catch(function () {
        _this.isSaving = false;
      }).finally(function () {
        userModel.initItem(userModel.item.id, true).then(function () {
          $timeout(function () {
            $rootScope.$emit('location:update');
          }, NOTIFICATION_DELAY);
        });
      });
    };

    this.confirmLocation = function (locationType) {
      _this.saveLocationType(locationType).finally(function () {
        if (locationType === _this.HOME) {
          // save home location
          _this.saveHomeLocation(_this.locationInput.placeId);
        } else {
          // User on a trip
          // save home location via new input
          // switch views
          _this.locationView = false;
          _this.homeView = true;
          // change placeholder
          _this.placeHolder = '';
          // cancel saving
          _this.isSaving = false;
          // focus input
          $timeout(function () {
            focusInput('home');
          });
        }
      });
    };

    // should be in service

    this.checkForLocationChange = function () {
      return _this.locationInput.placeId !== locationInitialId;
    };

    this.saveLocationType = function (locationType) {
      var postData = {
        action: locationType
      };
      if (locationType === _this.TRAVEL) {
        postData.placeId = _this.locationInput.placeId;
      }
      if (_this.checkForLocationChange()) {
        postData.changedFromPlaceId = locationInitialId;
      }
      return $http.post(_this.url, postData);
    };

    this.saveHome = function () {
      _this.isSaving = true;
      _this.saveHomeLocation(_this.homeInput.placeId);
    };

    this.autoTrip = function (confirmation) {
      _this.saveTravelResponse(confirmation).then(function () {
        _this.onSuccess();
      }).catch(function () {
        _this.isSaving = false;
      });
    };

    // TODO: should be in service
    this.saveTravelResponse = function (confirmation) {
      var travelResponse = { action: confirmation, placeId: _this.locationInput.placeId };
      if (_this.checkForLocationChange()) {
        travelResponse.changedFromPlaceId = locationInitialId;
      }
      return $http.post(_this.url, travelResponse);
    };
  }]
};

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports = "<div class=\"LocationNotificationModal\">\n  <div class=\"Join-loader\" ng-if=\"$ctrl.isLoading\">\n    <div class=\"Loader\"></div>\n  </div>\n  <div ng-if=\"!$ctrl.isLoading\">\n    <div class=\"LocationNotificationModal-header\">\n      <div>Hey {{::$ctrl.name}}, <span ng-if=\"$ctrl.type === $ctrl.AUTOTRIP\">are you on a trip?</span></div>\n      <div ng-if=\"$ctrl.type === $ctrl.LOCATION_CONFIRMATION\">is this your home location or are you on a trip?</div>\n    </div>\n    <div class=\"LocationNotificationModal-image\"></div>\n  </div>\n\n  <!-- User on a trip, save home location view -->\n  <div class=\"LocationNotificationModal-home-onTrip\" ng-if=\"$ctrl.homeView\">\n    <span><i class=\"Icon Icon-tick\"></i></span>\n    You are on a trip to {{ ::$ctrl.locationInput | location}}\n  </div>\n\n  <div ng-class=\"$ctrl.homeView ? 'LocationNotificationModal-home-formWrapper' : ''\">\n\n\n    <div class=\"LocationNotificationModal-infoText\">\n      <span ng-if=\"$ctrl.locationView && $ctrl.type === $ctrl.LOCATION_CONFIRMATION\">\n        Enter new or edit current location\n      </span>\n      <span class=\"LocationNotificationModal-home-set\" ng-if=\"$ctrl.homeView\">\n        Set your home location\n      </span>\n    </div>\n\n\n    <form class=\"Form Location-form\" name=\"$ctrl.locationForm\" novalidate>\n      <div ng-if=\"$ctrl.locationView\">\n        <input id=\"location\" class=\"Form-field Location-input\" type=\"text\" name=\"location\" placeholder=\"{{$ctrl.placeholder}}\"\n          autocomplete=\"off\"\n          ng-model=\"$ctrl.locationInput\" required sa-location-search-input\n          location-type=\"filtered\"\n          sa-location-validator>\n        <div class=\"Form-validationErrors Location-validation\" ng-messages=\"$ctrl.locationForm.location.$error\">\n          <p class=\"Form-validationError\" ng-message=\"required\">{{$ctrl.SETTINGS_ERRORS.REQUIRED | translate}}</p>\n          <p class=\"Form-validationError\" ng-message=\"location\">{{$ctrl.SETTINGS_ERRORS.LOCATION_INVALID | translate}}</p>\n        </div>\n      </div>\n\n      <!-- Can't get form reset to work properly -->\n      <div ng-if=\"$ctrl.homeView\">\n        <input id=\"home\" class=\"Form-field Location-input\" type=\"text\" name=\"home\" placeholder=\"{{$ctrl.placeholder}}\"\n          autocomplete=\"off\"\n          location-type=\"filtered\"\n          ng-model=\"$ctrl.homeInput\" required sa-location-search-input sa-location-validator>\n        <div class=\"Form-validationErrors Location-validation\" ng-messages=\"$ctrl.locationForm.home.$error\">\n          <p class=\"Form-validationError\" ng-message=\"required\">{{$ctrl.SETTINGS_ERRORS.REQUIRED | translate}}</p>\n          <p class=\"Form-validationError\" ng-message=\"location\">{{$ctrl.SETTINGS_ERRORS.LOCATION_INVALID | translate}}</p>\n        </div>\n      </div>\n\n      <!-- AUTOTRIP TEXT -->\n      <div class=\"LocationNotificationModal-autotrip-text\" ng-if=\"$ctrl.type === $ctrl.AUTOTRIP\">\n        Would you like to save it as a trip and receive offers from locals?\n      </div>\n\n      <div class=\"row Location-buttons\">\n        <sa-content-loader ng-if=\"$ctrl.isSaving\"></sa-content-loader>\n        <div class=\"col-md-6\" ng-if=\"!$ctrl.isSaving && $ctrl.locationView\">\n          <button class=\"Button Button--blue Location-button Button-smallTextMobile\"\n           ng-click=\"$ctrl.locationForm.$valid && $ctrl.submit($ctrl.submitValue[0])\"\n           ng-disabled=\"$ctrl.isSaving\">\n           <span ng-if=\"$ctrl.type === $ctrl.LOCATION_CONFIRMATION\">Home location</span><span ng-if=\"$ctrl.type === $ctrl.AUTOTRIP\">Yes</span>\n          </button>\n        </div>\n        <div class=\"col-md-6\" ng-if=\"!$ctrl.isSaving && $ctrl.locationView\">\n          <button class=\"Button Button--blue Location-button Button-smallTextMobile Button--darkBlue\"\n            ng-click=\"$ctrl.locationForm.$valid && $ctrl.submit($ctrl.submitValue[1])\"\n            ng-disabled=\"$ctrl.isSaving\">\n            <span ng-if=\"$ctrl.type === $ctrl.LOCATION_CONFIRMATION\">I'm on a trip</span><span ng-if=\"$ctrl.type === $ctrl.AUTOTRIP\">No</span>\n          </button>\n        </div>\n        <div class=\"Button Button--blue Location-button Button-smallTextMobile\" ng-if=\"!$ctrl.isSaving && $ctrl.homeView\" ng-click=\"$ctrl.locationForm.$valid && $ctrl.saveHome()\">\n          Save\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n";

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports = {"SETTINGS":{"EMAIL":"Email","PHONE":"Phone number","ADDRESS":"Home address","PRICE":"Price per hour","NAME":"Name","PHOTOS":"Profile photos","LOCATION":"Location","ABOUT_ME":"About me","ABOUT_CITY":"I will show you","LANGUAGES":"Languages","ACTIVITIES":"Activities","SHORT_DESCRIPTION":"Motto"},"SETTINGS_STATUS":{"NOT_VERIFIED":"Not verified","VERIFIED":"Verified"},"SETTINGS_VALUES":{"PHOTOS":"{PHOTO_COUNT} of {MAX_PHOTO_COUNT} photos"},"SETTINGS_SECTIONS":{"GENERAL":"General information","CONTACT":"Contact information","GUIDE":"Local host information"},"SETTINGS_ERRORS":{"REQUIRED":"This field is required","REQUIRED_ONE":"Select at least one","NAME_MIN_LENGTH":"Your name must contain at least 2 characters","NAME_MAX_LENGTH":"Your name must not exceed 20 characters","LOCATION_INVALID":"Invalid location","ABOUT_ME_MIN_LENGTH":"Your text must contain at least 20 characters","SHORT_DESCRIPTION_MIN_LENGTH":"Your text must contain at least 10 characters","ABOUT_CITY_MIN_LENGTH":"Your text must contain at least 20 characters","PRICE_RANGE":"Please select an hourly rate between 1 and ","PRICE_INVALID":"Use numbers only","EMAIL_PATTERN":"Invalid email address","PHONE_PATTERN":"Invalid phone number","CODE_INVALID":"Invalid verification code"},"SETTINGS_REJECTIONS":{"IDENTIFICATION":"Oops! Your photo was rejected. Try uploading the photo again or check if it conforms to our guidelines.","PHOTOS":"Some of your photos have been rejected.","PHOTOS_LINK":"Learn why.","GENERIC":"Rejected."},"SETTINGS_ALERTS":{"DEACTIVATE_HEADER":"Deactivate your local host status","DEACTIVATE":"You will be instantly removed from our local hosts list, but you still need to complete bookings you’ve confirmed and accepted.","DEACTIVATE_ACCEPT":"Deactivate","DEACTIVATE_DECLINE":"Keep hosting","DEACTIVATE_TO_CLOSE":"To close your account, you have to deactivate your host status first.","CANCEL_CLOSE":"Ok, got it!"}}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$http', '$timeout', '$q', 'utils', 'modal', 'Storage', 'userModel', 'admin'];
function f($http, $timeout, $q, utils, modal, Storage, userModel, admin) {
  'ngInject';

  return {
    response: {},

    checkShow: function checkShow() {
      var _this = this;

      return new $q(function (resolve) {
        if (admin.isAdmin()) {
          resolve();
          return;
        }
        var url = utils.getApiUrlV2('trips/' + userModel.item.id + '/location_popup');
        $http.get(url).then(function (response) {
          _this.response = response.data;
          resolve();
        });
      });
    },

    showModal: function showModal() {
      if (admin.isAdmin()) {
        return;
      }

      var showModal = this.response.show;
      var MODAL_TYPE;

      if (!showModal || !userModel.item.location) {
        return;
      }

      if (userModel.item.location.placeId === null) {
        MODAL_TYPE = 'LOCATION_CONFIRMATION';
      } else {
        MODAL_TYPE = 'AUTOTRIP';
      }

      modal.open({
        template: '<sa-location-confirmation-modal type="' + MODAL_TYPE + '" name="' + userModel.item.name + '" on-success="close()">',
        cssClass: 'LocationNotificationModal-modal Modal--sharpCorners',
        preventCloseWithESC: true
      });
    }
  };
}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create_trip_banner = __webpack_require__(398);

var _create_trip_banner2 = _interopRequireDefault(_create_trip_banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {
    location: '<'
  },
  template: _create_trip_banner2.default
};

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = "<div class=\"TripBanner-container\">\n\n  <!-- HEADER -->\n  <div class=\"TripBanner-header\">\n    <span Class=\"TripBanner-header-save\">Save time:</span> Create a trip & get offers from locals\n  </div>\n\n  <!-- STEPS -->\n  <div class=\"TripBanner-steps\">\n    <div class=\"TripBanner-step\">\n      <span class=\"TripBanner-step-icon one\">1</span>Create a trip\n    </div>\n    <div class=\"TripBanner-step\">\n      <span class=\"TripBanner-step-icon two\">2</span>Get offers from locals\n    </div>\n    <div class=\"TripBanner-step\">\n      <span class=\"TripBanner-step-icon three\">3</span>Pick the one you like\n    </div>\n  </div>\n\n  <!-- CTA -->\n  <div>\n    <button class=\"Button TripBanner-button\" ui-sref=\"myTrips({location: $ctrl.location})\">\n      Create a trip\n    </button>\n  </div>\n</div>\n";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _conversation_trip_avatar = __webpack_require__(400);

var _conversation_trip_avatar2 = _interopRequireDefault(_conversation_trip_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: _conversation_trip_avatar2.default,
  bindings: {
    avatars: '<'
  },
  controller: ['imgixHelpers', function controller(imgixHelpers) {
    'ngInject';

    var STARTING_POSITION = -20;
    var INCREMENT_OVERLAP = 20;
    var Z_INDEX = 100;
    var shift = STARTING_POSITION;
    var z_index = Z_INDEX;

    this.avatars.forEach(function (avatar) {
      shift = shift + INCREMENT_OVERLAP;
      z_index = z_index - 1;
      avatar.shift = shift + 'px';
      avatar.z_index = z_index;
      var url = imgixHelpers.getUrl(avatar, { w: 32, h: 32 }, imgixHelpers.getCropCoords(avatar.crop));
      avatar.path = 'white url(\'' + url + '\')';
    });

    // One avatar takes up 32px, any additional avatars take up 20px
    var ONE_AVATAR = 32;
    var OTHER_AVATARS = 20;
    var FIRST_AVATAR = 1;
    this.avatarWidth = ONE_AVATAR + OTHER_AVATARS * (this.avatars.length - FIRST_AVATAR) + 'px';
  }]
};

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = "<div class=\"Conversation-trip-container\" ng-style=\"{'width': $ctrl.avatarWidth }\">\n  <div ng-repeat=\"avatar in $ctrl.avatars\">\n    <div class=\"ConversationTrip-avatar\"\n      ng-style=\"{'left': avatar.shift, 'z-index': avatar.z_index, 'background': avatar.path, 'background-size': 'contain'}\"\n      ng-if=\"$index < 5\">\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _conversation_trip = __webpack_require__(402);

var _conversation_trip2 = _interopRequireDefault(_conversation_trip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: _conversation_trip2.default,
  bindings: {
    conversation: '<'
  },
  controller: ['$state', 'userModel', function controller($state, userModel) {
    'ngInject';

    try {
      this.location = userModel.item.location.name;
    } catch (e) {
      this.location = '';
    }

    this.openConversation = function () {
      $state.go('guides.trips');
    };
  }]
};

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = "<a class=\"ConversationListItem ConversationListItem-trip\"\n  ng-class=\"$ctrl.conversation.unread ? 'is-unread' : ''\"\n  ng-click=\"$ctrl.openConversation()\">\n  <div class=\"ConversationListItem-padding\">\n    <div class=\"ConversationListItem-photoContainer\">\n      <div class=\"ConversationListItem-tripAvatar\">\n      </div>\n      <div class=\"ConversationListItem-info ConversationTrip-details\">\n        <!-- username -->\n        <p class=\"ConversationListItem-name ConversationListItem-name-trip\">Showaround</p>\n        <!-- user avatars -->\n        <sa-conversation-trip-avatar ng-if=\"$ctrl.conversation.photoList.length\" ng-class=\"!$ctrl.conversation.photoList.length ? 'ConversationTrip-avatar-unavailable' : ''\" avatars=\"$ctrl.conversation.photoList\"></sa-conversation-trip-avatar>\n      </div>\n\n    </div>\n\n    <div class=\"ConversationListItem-lastMessage-wrapper\">\n      <!-- people looking for locals -->\n      <p class=\"ConversationListItem-lastMessage ConversationListItem-text\">{{::'CONVERSATION_TRIP.LOOKING_FOR_LOCALS' | translate:{ COUNT: $ctrl.conversation.count } }} looking for a local in {{$ctrl.location}}. <span class=\"ConversationTrip-extraText\">{{::'CONVERSATION_TRIP.OFFERS' | translate:{ COUNT: $ctrl.conversation.count } }}</span></p>\n    </div>\n\n    <div>\n      <!-- send offers -->\n      <button class=\"Button ConversationTrip-button Button--inverted Button--invertedAlternativeHover Button--conversation-trip \">\n        {{::'CONVERSATION_TRIP.SEND_OFFERS' | translate:{ COUNT: $ctrl.conversation.count } }}\n      </button>\n    </div>\n  </div>\n</a>\n";

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _system_alerts = __webpack_require__(404);

var _system_alerts2 = _interopRequireDefault(_system_alerts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: _system_alerts2.default,
  controller: ['$scope', 'systemAlerts', function controller($scope, systemAlerts) {
    'ngInject';

    this.systemAlerts = systemAlerts;

    this.dismiss = function () {
      systemAlerts.dismiss();
    };
  }]
};

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = "<div class=\"SystemAlert-wrapper SystemAlert-hidden\" ng-class=\"{'SystemAlert-visible-animation': $ctrl.systemAlerts.show, 'SystemAlert-visible': $ctrl.systemAlerts.preshow}\" ng-click=\"$ctrl.dismiss()\">\n  <div class=\"SystemAlert SystemAlert-{{$ctrl.systemAlerts.systemAlertType}}\">\n    <span><i class=\"Icon Icon-{{$ctrl.systemAlerts.systemAlertType}}\"></i></span>\n    <span class=\"SystemAlert-text\">\n      {{ $ctrl.systemAlerts.alertText }}\n    </span>\n  </div>\n</div>\n";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$rootScope', '$timeout', 'userModel'];
function f($rootScope, $timeout, userModel) {
  'ngInject';

  var SHOW_TIMEOUT = 200;
  var HIDE_TIMEOUT = 6000;
  var TRANSITION_SHOW_HIDE = 20;
  var ANIMATION_TIMEOUT = 500;

  // TODO: popup interactions

  return {
    navigationElem: null,
    alertText: '',
    show: false,
    preshow: false,

    showAlert: function showAlert(text) {
      var _this = this;

      if (!userModel.item.id) {
        return;
      }

      this.alertText = text;

      this.timePreShow = $timeout(function () {
        _this.preshow = true;
        _this.timeShow = $timeout(function () {
          _this.show = true;
        }, TRANSITION_SHOW_HIDE);
        _this.timeHide = $timeout(function () {
          _this.dismiss();
        }, HIDE_TIMEOUT);
      }, SHOW_TIMEOUT);
    },
    cancel: function cancel() {
      this.preshow = false;
      this.show = false;

      $timeout.cancel(this.timePreShow);
      $timeout.cancel(this.timeShow);
      $timeout.cancel(this.timeHide);
      $timeout.cancel(this.timeDismiss);
    },
    warning: function warning(text) {
      this.systemAlertType = 'warning';
      this.showAlert(text);
    },
    success: function success(text) {
      this.systemAlertType = 'tick';
      this.showAlert(text);
    },
    dismiss: function dismiss() {
      var _this2 = this;

      this.show = false;
      this.timeDismiss = $timeout(function () {
        _this2.preshow = false;
      }, ANIMATION_TIMEOUT);
    }
  };
}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trip_offer_accept_modal = __webpack_require__(407);

var _trip_offer_accept_modal2 = _interopRequireDefault(_trip_offer_accept_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {
    done: '&'
  },
  template: _trip_offer_accept_modal2.default,
  controller: ['$timeout', '$scope', 'trips', 'userModel', function controller($timeout, $scope, trips, userModel) {
    'ngInject';

    this.userModel = userModel;

    this.trips = trips;
    this.conversation = this.trips.accept.conversation;
    this.message = this.trips.accept.message;
    this.message.data.responseMessage = {};
    this.message.data.responseMessage.content = '';

    this.isProcessing = false;
    this.acceptOffer = function () {
      // TODO: hmmm... should process longer
      this.isProcessing = true;
      this.isProcessing = false;
      this.done();
    };

    // TODO: refactor (see duplicate in booking form)
    $timeout(function () {
      $scope.$broadcast('elastic:adjust');
    });
  }]
};

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "<div class=\"TripOfferAcceptModal\">\n  <div class=\"TripOfferAcceptModal-header\">\n    Reply to this offer\n  </div>\n\n\n  <form class=\"Form\" name=\"offerAcceptModal\" novalidate ng-submit=\"offerAcceptModal.$valid && $ctrl.acceptOffer()\">\n    <div class=\"TripOfferAcceptModal-body\">\n      <div class=\"TripOfferAcceptModal-bookingInfo\">\n        <div class=\"TripOfferAcceptModal-detailGroup\">\n          <span class=\"TripOfferAcceptModal-detail\">\n            <span class=\"Icon Icon-calendar\"></span>\n            <strong>{{ ::$ctrl.message.data.date | bookingDate:true }}</strong>\n          </span>\n\n          <span class=\"TripOfferAcceptModal-detail\">\n            <span class=\"Icon Icon-time\"></span>\n            <strong>\n              <span>For {{ ::'TRIP.DURATION' | translate:{ hours: $ctrl.message.data.hours } }}\n              </span>\n            </strong>\n          </span>\n        </div>\n\n        <div>\n          <span class=\"TripOfferAcceptModal-detail\">{{ ::'BOOKING_MESSAGE.LABEL.MEETING_TIME' | translate }}: <strong>{{ ::$ctrl.message.data.meetingTime | meetingTime }}</strong></span>\n\n          <span class=\"TripOfferAcceptModal-detail\">{{ ::'BOOKING_MESSAGE.LABEL.NUMBER_OF_PEOPLE' | translate }}: <strong>{{ ::$ctrl.message.data.numberOfPeople | numberOfPeople }}</strong></span>\n        </div>\n      </div>\n\n      <div class=\"TripOfferAcceptModal-profileInfoWrapper\">\n        <a target=\"_blank\" ui-sref=\"guides.guide({ guideId: $ctrl.conversation.id })\">\n          <sa-photo photo=\"$ctrl.conversation.profilePhoto\" size=\"micro\" rect></sa-photo>\n        </a><div class=\"TripOfferAcceptModal-profileInfo\">\n          <div>\n            <!-- TODO: refactor into separate component from trip.html? -->\n            <a target=\"_blank\" class=\"TripOfferAcceptModal-name\" ui-sref=\"guides.guide({ guideId: $ctrl.conversation.id })\">\n              {{$ctrl.conversation.name}}\n            </a>\n            <div class=\"TripOfferAcceptModal-rating Rating--small Rating\" ng-if=\"$ctrl.conversation.guideInfo.avgRating\">\n              <sa-rating class=\"Guide-stat-value Rating--small\" rating=\"$ctrl.conversation.guideInfo.avgRating\"></sa-rating>\n            </div>\n\n            <div class=\"TripOfferAcceptModal-location\" ng-class=\"!$ctrl.conversation.location ? 'TripOfferAcceptModal-location--unavailable' : ''\">\n              From {{$ctrl.conversation.location.name}}\n            </div>\n          </div>\n\n          <div class=\"TripOfferAcceptModal-offerMessage\">\n            {{$ctrl.message.data.requestMessage.content}}\n          </div>\n        </div>\n      </div>\n\n      <div class=\"TripOfferAcceptModal-responseMessage\">\n        <div class=\"TripOfferAcceptModal-textarea\">\n          <p class=\"TripOfferAcceptModal-label\">Your message</p>\n          <textarea class=\"u-visible-m\"\n            name=\"message\"\n            placeholder=\"Your message\"\n            msd-elastic\n            sa-limit-length=\"3000\"\n            sa-cursor\n            ng-model=\"$ctrl.message.data.responseMessage.content\" required\n            ng-minlength=\"30\"></textarea>\n          <div class=\"Form-validationErrors Form-validationErrors-visible-m\" ng-messages=\"offerAcceptModal.$error\">\n            <p class=\"Form-validationError\" ng-message=\"minlength\">{{::'OFFER_ACCEPT_MODAL.MESSAGE_MIN_LENGTH' | translate}}</p>\n            <p class=\"Form-validationError\" ng-message=\"required\">{{::'OFFER_ACCEPT_MODAL.REQUIRED' | translate}}</p>\n          </div>\n          <textarea class=\"u-hidden-m-block\"\n            name=\"message\"\n            placeholder=\"Your message\"\n            sa-limit-length=\"3000\"\n            sa-cursor\n            ng-model=\"$ctrl.message.data.responseMessage.content\" required\n            ng-minlength=\"30\"></textarea>\n          <div class=\"Form-validationErrors Form-validationErrors-hidden-m\" ng-messages=\"offerAcceptModal.$error\">\n            <p class=\"Form-validationError\" ng-message=\"minlength\">{{::'OFFER_ACCEPT_MODAL.MESSAGE_MIN_LENGTH' | translate}}</p>\n            <p class=\"Form-validationError\" ng-message=\"required\">{{::'OFFER_ACCEPT_MODAL.REQUIRED' | translate}}</p>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"TripOfferAcceptModal-footer\">\n        <div class=\"TripOfferAcceptModal-button\">\n          <button class=\"Button Button-smallTextMobile\"\n            ng-disabled=\"offerAcceptModal.$invalid\"\n            sa-button-loader=\"$ctrl.isProcessing\">\n            Send\n          </button>\n        </div>\n      </div>\n    </div>\n  </form>\n\n\n</div>\n";

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['modal'];
function f(modal) {
  'ngInject';

  return {
    open: function open() {

      return modal.open({
        template: '<sa-trip-offer-accept-modal done="close()"></sa-trip-offer-accept-modal>'
      }).result;
    }
  };
}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$http', 'utils'];
function f($http, utils) {
  'ngInject';

  return {
    receivedMessage: null,

    getMessage: function getMessage(userId, visitorId) {
      return $http.get(utils.getApiUrlV2('offer_texts/' + userId + '/' + visitorId));
    }
  };
}

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['localStorage'];
var LAST_OFFER_MESSAGE_STORAGE = 'sa_last_offer_message';

function f(localStorage) {
  'ngInject';

  return {
    saveMessage: function saveMessage(message) {
      localStorage.set(LAST_OFFER_MESSAGE_STORAGE, message);
    },
    getMessage: function getMessage() {
      var message = localStorage.get(LAST_OFFER_MESSAGE_STORAGE);

      return message;
    }
  };
}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$q', '$ocLazyLoad', '$state', '$rootScope', 'modal', 'guideStatus', 'alert', 'trips', 'userModel', 'offerMessage', 'lastOfferMessage', 'membershipModal', 'analyticsSa'];
function f($q, $ocLazyLoad, $state, $rootScope, modal, guideStatus, alert, trips, userModel, offerMessage, lastOfferMessage, membershipModal, analyticsSa) {
  'ngInject';

  return {
    sendOffer: function sendOffer(isFilledSettings, offer) {
      var _this = this;

      var promise = new $q(function (resolve, reject) {
        reject();
      });

      var CLICK_TRACK = 'click-sendOffer';
      analyticsSa.track({ action: CLICK_TRACK, data: { userId: userModel.item.id } });

      if (guideStatus.isUnverifiedGuide() && !isFilledSettings) {
        alert.show({
          header: 'SEND_OFFER_MODAL.NOT_VERIFIED.HEADER',
          body: 'SEND_OFFER_MODAL.NOT_VERIFIED.BODY',
          buttons: [{
            label: 'SEND_OFFER_MODAL.NOT_VERIFIED.LABEL',
            action: 'accept'
          }]
        }).then(function () {
          $state.go('settings');
        });
        return promise;
      } else if (guideStatus.isInactiveGuide()) {
        return alert.show({
          header: 'SEND_OFFER_MODAL.NOT_ACTIVE.HEADER',
          body: 'SEND_OFFER_MODAL.NOT_ACTIVE.BODY',
          buttons: [{
            label: 'SEND_OFFER_MODAL.NOT_ACTIVE.LABEL',
            action: 'accept'
          }]
        }).then(function () {
          guideStatus.becomeGuide();
          return _this.open(offer);
        });
      } else if (userModel.item.id > 10151546 && userModel.item.isActiveGuide && userModel.item.location && userModel.item.location.name === 'Dubai' && !userModel.hasMembership()) {
        return membershipModal(offer.user.id).then(function () {
          return _this.open(offer);
        });
      } else if (userModel.item.id > 10195550 && userModel.item.isActiveGuide && userModel.item.location && userModel.item.location.countryCode === 'TR' && !userModel.hasMembership()) {
        return membershipModal(offer.user.id).then(function () {
          return _this.open(offer);
        });
      } else if (userModel.item.askToBuyMembersipOnTripOffer && !userModel.hasMembership()) {
        return membershipModal(offer.user.id).then(function () {
          return _this.open(offer);
        });
      } else {
        return this.open(offer);
      }
    },
    open: function open(offer) {
      var offerMessagePromise = $q(function (resolve) {
        var lastOfferMessageContent = lastOfferMessage.getMessage();
        if (lastOfferMessageContent) {
          resolve(lastOfferMessageContent);
        } else {
          offerMessage.getMessage(userModel.item.id, offer.user.id).then(function (response) {
            offerMessage.receivedMessage = response.data.message;
            resolve(response.data.message);
          });
        }
      });

      var modalPromise = $q(function (resolve) {
        __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 592)).then(function () {
          $ocLazyLoad.load({
            name: 'components.saSendOfferModal'
          });

          trips.offer.tripId = offer.id;
          trips.offer.visitorId = offer.user.id;
          trips.offer.trip = offer;

          resolve();
        });
      });

      var promises = [modalPromise, offerMessagePromise];

      return $q.all(promises).then(function (result) {
        trips.offer.trip.message = result[1];

        return $q(function (resolve) {
          resolve(modal.open({
            template: '<sa-send-offer-modal offer="offer" done="close()"></sa-send-offer-modal>'
          }));
        });
      });
    }
  };
}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['alert', 'Storage'];
function f(alert, Storage) {
  'ngInject';

  var SEND_OFFERS_KEY = 'sa_send_offers_alert';
  var localStorage = new Storage('local');

  // TODO: extract openedOnce to a service?
  var openedOnce = function openedOnce() {
    var data = localStorage.get(SEND_OFFERS_KEY);
    if (data) {
      return true;
    } else {
      data = 1;
      localStorage.set(SEND_OFFERS_KEY, data);
      return false;
    }
  };

  return {
    show: function show() {
      if (openedOnce()) {
        return;
      }

      alert.show({
        header: 'SEND_OFFER_MODAL.SEND_OFFERS.HEADER',
        body: 'SEND_OFFER_MODAL.SEND_OFFERS.BODY',
        buttons: [{
          label: 'SEND_OFFER_MODAL.SEND_OFFERS.LABEL',
          action: 'accept'
        }]
      });
    }
  };
}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$q', '$ocLazyLoad', '$rootScope', 'modal', function ($q, $ocLazyLoad, $rootScope, modal) {
  'ngInject';

  return {
    open: function open(paymentData, paymentProvider) {
      return $q(function (resolve) {
        __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 593)).then(function () {
          $ocLazyLoad.load({
            name: 'components.payModal'
          });

          var scope = $rootScope.$new();
          scope.paymentData = paymentData;
          scope.paymentProvider = paymentProvider;

          resolve(modal.open({
            template: '<sa-pay-modal payment-data="paymentData" payment-provider="paymentProvider" done="close()"></sa-pay-modal>',
            scope: scope
          }));
        });
      });
    }
  };
}];

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//code from credit-card-type library - A library for determining credit card type --> https://github.com/braintree/credit-card-type/blob/master/index.js

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  'ngInject';

  var types = {};
  var VISA = 'visa';
  var MASTERCARD = 'master-card';
  var AMERICAN_EXPRESS = 'american-express';

  var CVV = 'CVV';
  var CID = 'CID';
  var CVC = 'CVC';

  var testOrder = [VISA, MASTERCARD, AMERICAN_EXPRESS];

  types[VISA] = {
    niceType: 'Visa',
    type: VISA,
    prefixPattern: /^4$/,
    exactPattern: /^4\d*$/,
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: CVV,
      size: 3
    }
  };

  types[MASTERCARD] = {
    niceType: 'MasterCard',
    type: MASTERCARD,
    prefixPattern: /^(5|5[1-5]|2|22|222|222[1-9]|2[3-6]|27[0-1]|2720)$/,
    exactPattern: /^(5[1-5]|222[1-9]|2[3-6]|27[0-1]|2720)\d*$/,
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: CVC,
      size: 3
    }
  };

  types[AMERICAN_EXPRESS] = {
    niceType: 'American Express',
    type: AMERICAN_EXPRESS,
    prefixPattern: /^(3|34|37)$/,
    exactPattern: /^3[47]\d*$/,
    isAmex: true,
    gaps: [4, 10],
    lengths: [15],
    code: {
      name: CID,
      size: 4
    }
  };

  function creditCardType(cardNumber) {
    var type, value, i;
    var prefixResults = [];
    var exactResults = [];

    if (!(typeof cardNumber === 'string' || cardNumber instanceof String)) {
      return [];
    }

    for (i = 0; i < testOrder.length; i++) {
      type = testOrder[i];
      value = types[type];

      if (cardNumber.length === 0) {
        prefixResults.push(value);
        continue;
      }

      if (value.exactPattern.test(cardNumber)) {
        exactResults.push(value);
      } else if (value.prefixPattern.test(cardNumber)) {
        prefixResults.push(value);
      }
    }

    return exactResults.length ? exactResults : prefixResults;
  }

  return {
    cardType: creditCardType
  };
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fast_pay_modal = __webpack_require__(416);

var _fast_pay_modal2 = _interopRequireDefault(_fast_pay_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {
    paymentData: '<',
    done: '&',
    paymentProvider: '<',
    reloadParams: '<'
  },
  template: _fast_pay_modal2.default,
  controller: ['payModal', 'reloadPage', 'userModel', 'paymentTypes', 'currencyModel', function controller(payModal, reloadPage, userModel, paymentTypes, currencyModel) {
    'ngInject';

    var _this = this;

    this.subscriptionPayment = paymentTypes.subscription === this.paymentData.meta.PAYMENT_TYPE;
    this.bookingPayment = paymentTypes.booking === this.paymentData.meta.PAYMENT_TYPE;

    if (this.subscriptionPayment) {
      this.paymentData.currency = currencyModel.getValue();
    }

    this.savedCard = userModel.item.membership.activeContract;

    this.formatCardExpiry = function (expiry) {
      var month = expiry.month,
          year = expiry.year;

      return month + '/' + year;
    };

    this.pay = function () {
      _this.isSaving = true;
      _this.errorShake = false;
      _this.paymentProvider.sendFastPaymentData(_this.paymentData).then(function (response) {
        if (!response.data.result) {
          response.data.result = response.data;
        }
        _this.done();
        reloadPage.doIt(_this.paymentProvider.getReloadURL(response.data.result.resultCode));
      }).catch(function (response) {
        if (!response.data.result) {
          response.data.result = response.data;
        }
        _this.errorShake = true;
        if (response.data.result.refusalReason) {
          _this.error = response.data.result.refusalReason;
        }
        if (response.data.result.errorType === 'validation') {
          _this.error = response.data.result.message;
        }
        _this.isSaving = false;
      });
    };

    this.changePaymentDetails = function () {
      _this.done();
      payModal.open(_this.paymentData, _this.paymentProvider);
    };
  }]
};

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = "<div class=\"FastPayModal\">\n  <div class=\"FastPayModal-header\">\n    <div class=\"FastPayModal-headerText\">\n      <span ng-if=\"$ctrl.subscriptionPayment\">You are about to purchase a subscription</span>\n      <span ng-if=\"$ctrl.bookingPayment\">You are about to pay for the tour</span>\n    </div>\n\n    <form class=\"FastPayModal-cardDetails\">\n      <div class=\"FastPayModal-cardField FastPayModal-cardField--number\">XXXX XXXX XXXX {{::$ctrl.savedCard.cardNumber}}</div>\n      <div class=\"FastPayModal-cardField FastPayModal-cardField--expiry\">{{::$ctrl.formatCardExpiry($ctrl.savedCard.expiry)}}</div>\n      <div class=\"FastPayModal-cardField FastPayModal-cardField--name\">{{::$ctrl.savedCard.name}}</div>\n      <div class=\"FastPayModal-cardType\" ng-class=\"::'FastPayModal-cardType--' + $ctrl.savedCard.cardType\"></div>\n    </form>\n\n    <a class=\"FastPayModal-changeCard\" ng-click=\"$ctrl.changePaymentDetails()\">Change</a>\n  </div>\n  <div class=\"FastPayModal-body\">\n    <div ng-if=\"$ctrl.error\" class=\"PayModal-Error-Container\">\n      <div class=\"PayModal-Error-Header\">\n        Unable to Process Payment\n      </div>\n\n      <div class=\"PayModal-Error-Reason\">\n        {{$ctrl.error}}\n      </div>\n\n      <div class=\"PayModal-Error-Continue\">\n        Please change credit card and try again.\n      </div>\n    </div>\n\n    <div class=\"FastPayModal-subscriptionType\" ng-if=\"!$ctrl.error\">\n      <span ng-if=\"$ctrl.subscriptionPayment\">Subscription for <strong>{{::$ctrl.paymentData.duration | duration}}</strong></span>\n      <span ng-if=\"$ctrl.bookingPayment\">Booking in {{::$ctrl.paymentData.meta.bookingLocation}}, {{::$ctrl.paymentData.meta.bookingDate | bookingDate}}</span>\n    </div>\n\n    <div class=\"FastPayModal-paymentAmount\" ng-if=\"!$ctrl.error\">\n      Total amount: {{ ($ctrl.paymentData.price || $ctrl.paymentData.fullPrice) | price:$ctrl.paymentData.currency }}\n    </div>\n\n    <div class=\"FastPayModal-buttons\" ng-if=\"!$ctrl.error\">\n      <button class=\"Button\" ng-click=\"$ctrl.pay()\" ng-disabled=\"$ctrl.isSaving\" ng-class=\"{ 'PayModal-Button-Error': $ctrl.errorShake }\" sa-button-loader=\"$ctrl.isSaving\">Confirm</button>\n      <button class=\"Button Button--gray3\" ng-click=\"$ctrl.done()\">Cancel</button>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$rootScope', 'modal', function ($rootScope, modal) {
  'ngInject';

  return {
    open: function open(paymentData, paymentProvider) {
      var scope = $rootScope.$new();
      scope.paymentData = paymentData;
      scope.paymentProvider = paymentProvider;

      return modal.open({
        template: '<sa-fast-pay-modal payment-data="paymentData" payment-provider="paymentProvider" done="close()"></sa-fast-pay-modal>',
        scope: scope
      }).result;
    }
  };
}];

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _braintree_modal = __webpack_require__(419);

var _braintree_modal2 = _interopRequireDefault(_braintree_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {
    paymentData: '<',
    done: '&',
    paymentProvider: '<',
    reloadParams: '<'
  },
  template: _braintree_modal2.default,
  controller: ['$timeout', '$location', 'config', 'paymentsSubscription', 'userModel', 'reloadPage', function controller($timeout, $location, config, paymentsSubscription, userModel, reloadPage) {
    'ngInject';

    var s = this;
    userModel.getBraintreeToken().then(function (result) {
      braintree.dropin.create({
        authorization: result.clientToken,
        container: '#dropin-container',
        threeDSecure: {
          amount: s.paymentData.price
        },
        card: {
          cardholderName: {
            required: true
          }
        }
      }).then(function (instance) {
        s.pay = function () {
          instance.requestPaymentMethod().then(function (payload) {
            // Check liabilityShift for 3dsecure
            if (payload.liabilityShiftPossible === true && payload.liabilityShifted === false) {
              s.errorShake = true;
              s.isSaving = false;
              instance.clearSelectedPaymentMethod();
              return;
            }

            var data = {
              nonce: payload.nonce,
              duration: s.paymentData.duration,
              price: s.paymentData.price
            };

            userModel.processBraintreePayment(data).then(function (response) {
              if (response.success) {
                s.paymentData.currency = userModel.item.membership.pricePoints.currencyDefault;
                var urlToReload = s.paymentProvider.getBraintreeReloadUrl('AUTHORISED', s.paymentData);
                reloadPage.doIt(urlToReload);
                s.done();
              } else {
                console.log(response);
                s.errorShake = true;
                s.isSaving = false;
                instance.clearSelectedPaymentMethod();
              }
            });

            s.isSaving = true;
          }).catch(function (err) {
            console.error(err);
          });
        };
      }).catch(function (err) {
        console.error(err);
      });
    });

    this.userModel = userModel;
  }]
};

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = "<div class=\"BraintreeModal\">\n  <div style=\"padding: 30px; width: 100%; min-width:200px;\">\n    <div id=\"dropin-container\"></div>\n\n    <button class=\"Button Button--fullWidth\" ng-click=\"$ctrl.pay()\" ng-disabled=\"$ctrl.isSaving\" ng-class=\"{ 'PayModal-Button-Error': $ctrl.errorShake }\" sa-button-loader=\"$ctrl.isSaving\">Confirm</button>\n\n    <div class=\"PayModal-Price\" style=\"text-align: center; padding: 10px;\">\n      Total {{ ::$ctrl.paymentData.price | price:$ctrl.userModel.item.membership.pricePoints.currencyDefault }} for {{::$ctrl.paymentData.duration | duration}}\n    </div>\n\n    <div class=\"PayModal-Error-Header u-centerdText\" ng-class=\"{ 'u-hidden': !$ctrl.errorShake }\">Payment is refused.</div>\n  </div>\n</div>";

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$q', '$ocLazyLoad', '$rootScope', 'modal', function ($q, $ocLazyLoad, $rootScope, modal) {
  'ngInject';

  return {
    open: function open(paymentData, paymentProvider) {
      var scope = $rootScope.$new();
      scope.paymentData = paymentData;
      scope.paymentProvider = paymentProvider;

      return modal.open({
        template: '<sa-braintree-modal payment-data="paymentData" payment-provider="paymentProvider" done="close()"></sa-braintree-modal>',
        scope: scope
      }).result;
    }
  };
}];

/***/ }),
/* 421 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "TRIP": {
    "DURATION": "{hours} {hours, plural, one{hour} other{hours}}",
  }
}
);  }]);

/***/ }),
/* 422 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "TRIP_CONTAINER": {
    "PEOPLE": "{COUNT, plural, one{# person is} other{# people are}}",
  }
}
);  }]);

/***/ }),
/* 423 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "SEND_OFFER_MODAL": {
    "HOURS": "{HOURS} {HOURS, plural, one{hour} other{hours}}",
    "MESSAGE_MIN_LENGTH" : "Your message is too short. Please be more specific.",
    "REQUIRED" : "This field is required",
    "SEND_OFFERS": {
      "HEADER": "Offer has been sent",
      "BODY": "Thank you! Your offer has been sent successfully. You can expect responses from visitors who are interested. They will appear in your Showaround inbox.",
      "LABEL": "OK, got it",
    },
    "NOT_VERIFIED": {
      "HEADER": "Complete your profile",
      "BODY": "Please complete your profile in order to be able to send offers.",
      "LABEL": "Complete Profile",
    },
    "NOT_ACTIVE": {
      "HEADER": "Activate your status",
      "BODY": "You have previously deactivated your local host status. Activate to be able to send offers.",
      "LABEL": "Activate",
    },
  },
}
);  }]);

/***/ }),
/* 424 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "CREATE_TRIP": {
    "ERROR": {
      "ALREADY-EXISTS": "Cannot create multiple trips to the same location",
      "TRIP-TO-HOMELOCATION": "Cannot create a trip to your home location",
      "GENERIC_ERROR": "Cannot create this trip",
      "LOCATION_INVALID": "Invalid location",
      "REQUIRED_ONE": "Select at least one",
      "DATE": "Select a date",
    },
    "SUCCESS": {
      "HEADER": "New Trip created",
      "BODY": "Congratulations! You’ve successfully created a new trip. Available locals will send you offers for your visit. They will appear in your Showaround inbox.",
      "LABEL": "OK, got it",
    },
  }
}
);  }]);

/***/ }),
/* 425 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "MY_TRIP": {
    "DURATION": "for {hours} {hours, plural, one{hour} other{hours}}",
    "DELETE" : {
      "HEADER" : "Delete your trip",
      "CONTENT" : "Are you sure you want to delete this trip?",
      "LABEL" : "Cancel the creation of automatic trips in the future",
      "DELETE" : "Delete",
      "CANCEL" : "Cancel",
    }
  }
}
);  }]);

/***/ }),
/* 426 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "CONVERSATION_TRIP" : {
    "LOOKING_FOR_LOCALS": "{COUNT, plural, one{# person is} other{# people are}}",
    "OFFERS": "{COUNT, plural, one{Send an offer and show him around!} other{Send them offers and show them around!}}",
    "SEND_OFFERS": "{COUNT, plural, one{View} other{View all}}",
  }
}
);  }]);

/***/ }),
/* 427 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "OFFER_ACCEPT_MODAL": {
    "MESSAGE_MIN_LENGTH" : "Your message is too short. Please be more specific.",
    "REQUIRED" : "This field is required",
  },
}
);  }]);

/***/ }),
/* 428 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "PAY_MODAL": {
    "CARD_INVALID": "Card Number invalid",
    "HOLDER_NAME_INVALID": "Card Holder Name invalid",
    "EXPIRY_MONTH_INVALID": "Expiry Month invalid",
    "EXPIRY_YEAR_INVALID": "Expiry Year invalid",
    "CVC_INVALID": "Security Code invalid",
    "CVC_TOOLTIP": "The security code is the last 3 numbers on the back of your card (4 numbers on the front if Amex)",
    "FUTURE_USE": "Saving your card details means that you won’t have to re-enter this information the next time you pay for your booking or subscription.",
  }
}
);  }]);

/***/ }),
/* 429 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "GUIDES": {
    "CITY_FILTER_LANGUAGES": "Choose from <strong>{COUNT}</strong> <strong>{FILTER}</strong> speaking {COUNT, plural, one{local} other{locals}} in <strong>{LOCATION}</strong>, who can show you around",
    "CITY_FILTER_ACTIVITIES_OLD": "<strong>{COUNT, plural, one{# local} other{# locals}}</strong> in <strong>{LOCATION}</strong>, can offer you <strong>{FILTER}</strong> tours",
    "CITY_FILTER_ACTIVITIES": "<strong>{COUNT, plural, one{# local} other{# locals}}</strong> in <strong>{LOCATION}</strong>, can offer you <strong>{FILTER}</strong> tours",
    "CITY_FILTER_GENDER": "<strong>{COUNT, plural, one{# {FILTER} local} other{# {FILTER} locals}}</strong> can show you around in <strong>{LOCATION}</strong>",

    "COUNT_LONG_LOCATION_OLD": "Discover <strong>{LOCATION}</strong>, with one of <strong>{COUNT, plural, one{# local} other{# locals}}</strong> who {COUNT, plural, one{is} other{are}} ready to show you around",
    "COUNT_LONG_LOCATION": "Discover <strong>{LOCATION}</strong>, with one of <strong>{COUNT, plural, one{# local} other{# locals}}</strong> who {COUNT, plural, one{is} other{are}} ready to show you around",
    "COUNT_LONG_LOCATION_KIEV": "Take a <strong>{LOCATION}</strong> tour with one of <strong>{COUNT}</strong> city guides who are ready to show you around",
    "COUNT_LONG": "Discover a deeper insight into a new city with one of <strong>{COUNT}</strong> Showaround locals",
    "COUNT_LONG_S_LOC": "Explore <strong>{LOCATION}</strong>, with {COUNT, plural, one{} other{one of}} <strong>{COUNT}</strong> Showaround {COUNT, plural, one{local} other{locals}}",

    "INTRO_HEADING_OLD": "Showaround locals can tailor your activities and give you an insider's view on where to go and what to see",
    "INTRO_HEADING": "Find your local tour guide with Showaround",
    "INTRO_HEADING_KIEV": "Discover <strong>things to do</strong> in Kiev, Ukraine, with {COUNT, plural, one{} other{one of}} {COUNT} Showaround {COUNT, plural, one{local} other{locals}}",

    "IN": "in"
  }
}
);  }]);

/***/ }),
/* 430 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "DASHBOARD": {
    "ERRORS": {
      "REQUIRED": "This field is required",
      "IBAN": "Invalid IBAN",
      "SWIFT": "Invalid SWIFT/BIC code"
    }
  }
}
);  }]);

/***/ }),
/* 431 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "LEAVE_REVIEW": {
    "HEADER_GUIDE": "Please leave a review about your guest and your tour",
    "HEADER_GUEST": "Please leave a review about your local host and your tour",
    "INFO_TEXT": "Your reviews are critically important in making Showaround a credible and trustworthy community. Help both locals and guests by sharing a sincere review.",
    "RATING_LABEL": "Rating",
    "CONTENT_LABEL_GUIDE": "Review (on guest profile)",
    "CONTENT_LABEL_GUEST": "Review (on local host profile)",
    "CONTENT_PLACEHOLDER_GUIDE": "Share some feedback about your guest and your tour experience.",
    "CONTENT_PLACEHOLDER_GUEST": "Share some feedback about your host and your tour experience.",
    "FEEDBACK_LABEL": "Private feedback to Showaround (optional)",
    "FEEDBACK_PLACEHOLDER": "Is there anything about your tour experience that you’d like to share with Showaround privately?"
  }
}
);  }]);

/***/ }),
/* 432 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "RECENT_BOOKINGS": {
    "CITY_FILTER_BOOKINGS_TITLE": "Recent local guide bookings in {LOCATION}"
  }
}
);  }]);

/***/ }),
/* 433 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "INTRO": {
    "GUIDES": "{COUNT, plural, one{# local} other{# locals}}"
  }
}
);  }]);

/***/ }),
/* 434 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "REQUEST_REFERENCE_MODAL": {
    "REQUIRED" : "This field is required",
    "MESSAGE_MIN_LENGTH" : "Your message is too short. Please be more specific.",
    "SUCCESS": {
      "HEADER": "Thank You!",
      "BODY": "Your reference has been submitted and will appear shortly on the local’s profile.",
      "LABEL": "OK, got It",
    },
  }
}
);  }]);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _account_activation = __webpack_require__(436);

var _account_activation2 = _interopRequireDefault(_account_activation);

var _activate_guide_account = __webpack_require__(438);

var _activate_guide_account2 = _interopRequireDefault(_activate_guide_account);

var _active_state = __webpack_require__(440);

var _active_state2 = _interopRequireDefault(_active_state);

var _alert = __webpack_require__(441);

var _alert2 = _interopRequireDefault(_alert);

var _app_link = __webpack_require__(443);

var _app_link2 = _interopRequireDefault(_app_link);

var _become_guide_button = __webpack_require__(444);

var _become_guide_button2 = _interopRequireDefault(_become_guide_button);

var _become_guide_info = __webpack_require__(445);

var _become_guide_info2 = _interopRequireDefault(_become_guide_info);

var _bubble = __webpack_require__(447);

var _bubble2 = _interopRequireDefault(_bubble);

var _button_loader = __webpack_require__(448);

var _button_loader2 = _interopRequireDefault(_button_loader);

var _calendar = __webpack_require__(449);

var _calendar2 = _interopRequireDefault(_calendar);

var _contact_button = __webpack_require__(451);

var _contact_button2 = _interopRequireDefault(_contact_button);

var _content_loader = __webpack_require__(452);

var _content_loader2 = _interopRequireDefault(_content_loader);

var _copy_my_data_modal = __webpack_require__(454);

var _copy_my_data_modal2 = _interopRequireDefault(_copy_my_data_modal);

var _crop = __webpack_require__(456);

var _crop2 = _interopRequireDefault(_crop);

var _cursor = __webpack_require__(458);

var _cursor2 = _interopRequireDefault(_cursor);

var _enable_hover = __webpack_require__(459);

var _enable_hover2 = _interopRequireDefault(_enable_hover);

var _ellipsis = __webpack_require__(460);

var _email_validator = __webpack_require__(461);

var _email_validator2 = _interopRequireDefault(_email_validator);

var _fastclick = __webpack_require__(462);

var _fastclick2 = _interopRequireDefault(_fastclick);

var _footer = __webpack_require__(463);

var _footer2 = _interopRequireDefault(_footer);

var _cookies_line = __webpack_require__(465);

var _cookies_line2 = _interopRequireDefault(_cookies_line);

var _cookies_line_modal = __webpack_require__(467);

var _cookies_line_modal2 = _interopRequireDefault(_cookies_line_modal);

var _grid = __webpack_require__(469);

var _grid2 = _interopRequireDefault(_grid);

var _guide_activities = __webpack_require__(470);

var _guide_activities2 = _interopRequireDefault(_guide_activities);

var _header = __webpack_require__(472);

var _header2 = _interopRequireDefault(_header);

var _input_clear = __webpack_require__(474);

var _input_clear2 = _interopRequireDefault(_input_clear);

var _join_button = __webpack_require__(475);

var _join_button2 = _interopRequireDefault(_join_button);

var _keep_scroll_pos = __webpack_require__(476);

var _keep_scroll_pos2 = _interopRequireDefault(_keep_scroll_pos);

var _language_input = __webpack_require__(477);

var _language_input2 = _interopRequireDefault(_language_input);

var _location_validator = __webpack_require__(479);

var _location_validator2 = _interopRequireDefault(_location_validator);

var _modal = __webpack_require__(480);

var _modal2 = _interopRequireDefault(_modal);

var _multiselect = __webpack_require__(482);

var _multiselect2 = _interopRequireDefault(_multiselect);

var _not_found = __webpack_require__(484);

var _not_found2 = _interopRequireDefault(_not_found);

var _on_click_outside = __webpack_require__(486);

var _on_click_outside2 = _interopRequireDefault(_on_click_outside);

var _on_scroll = __webpack_require__(487);

var _on_scroll2 = _interopRequireDefault(_on_scroll);

var _photo = __webpack_require__(488);

var _photo2 = _interopRequireDefault(_photo);

var _photo_upload_input = __webpack_require__(490);

var _photo_upload_input2 = _interopRequireDefault(_photo_upload_input);

var _popover = __webpack_require__(60);

var _popover2 = _interopRequireDefault(_popover);

var _prevent_autoscroll = __webpack_require__(491);

var _prevent_autoscroll2 = _interopRequireDefault(_prevent_autoscroll);

var _rating = __webpack_require__(492);

var _rating2 = _interopRequireDefault(_rating);

var _review_form = __webpack_require__(494);

var _review_form2 = _interopRequireDefault(_review_form);

var _select = __webpack_require__(496);

var _select2 = _interopRequireDefault(_select);

var _src_placeholder = __webpack_require__(498);

var _src_placeholder2 = _interopRequireDefault(_src_placeholder);

var _state_class = __webpack_require__(499);

var _state_class2 = _interopRequireDefault(_state_class);

var _sticky_bar = __webpack_require__(500);

var _sticky_bar2 = _interopRequireDefault(_sticky_bar);

var _support_phone_number = __webpack_require__(501);

var _support_phone_number2 = _interopRequireDefault(_support_phone_number);

var _time_ago = __webpack_require__(502);

var _time_ago2 = _interopRequireDefault(_time_ago);

var _unique_email_validator = __webpack_require__(504);

var _unique_email_validator2 = _interopRequireDefault(_unique_email_validator);

var _parse_name_input = __webpack_require__(505);

var _parse_name_input2 = _interopRequireDefault(_parse_name_input);

var _suspended = __webpack_require__(506);

var _suspended2 = _interopRequireDefault(_suspended);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import saSendToMessengerButton from './send_to_messenger_button';
//import saSendToMessengerModal from './send_to_messenger_modal';
// import saSocialShareButtons from './social_share_buttons';

// import saTermsChange from'./terms_change';
exports.default = _angular2.default.module('directives', []).directive('saAccountActivation', _account_activation2.default).directive('saActivateGuideAccount', _activate_guide_account2.default)
// .directive('saTermsChange', saTermsChange)
.directive('saActiveState', _active_state2.default).directive('saAlert', _alert2.default).directive('saAppLink', _app_link2.default).directive('saBecomeGuideButton', _become_guide_button2.default).directive('saBecomeGuideInfo', _become_guide_info2.default)
//.directive('saBookingUpdatesModal', saBookingUpdatesModal)
.directive('saBubble', _bubble2.default).directive('saButtonLoader', _button_loader2.default).directive('saCalendar', _calendar2.default).directive('saContactButton', _contact_button2.default).directive('saContentLoader', _content_loader2.default).directive('saCopyMyDataModal', _copy_my_data_modal2.default).directive('saCrop', _crop2.default).directive('saCursor', _cursor2.default).directive('saEnableHover', _enable_hover2.default).directive('saEllipsis', _ellipsis.saEllipsis).directive('saEllipsisContainer', _ellipsis.saEllipsisContainer).directive('saEmailValidator', _email_validator2.default).directive('saFastClick', _fastclick2.default).directive('saFooter', _footer2.default).directive('saCookiesLine', _cookies_line2.default).directive('saCookiesLineModal', _cookies_line_modal2.default).directive('saGrid', _grid2.default).directive('saGuideActivities', _guide_activities2.default).directive('saHeader', _header2.default).directive('saInputClear', _input_clear2.default).directive('saJoinButton', _join_button2.default).directive('saKeepScrollPos', _keep_scroll_pos2.default).directive('saLanguageInput', _language_input2.default).directive('saLocationValidator', _location_validator2.default).directive('saModal', _modal2.default).directive('saMultiselect', _multiselect2.default).directive('saNotFound', _not_found2.default).directive('saOnClickOutside', _on_click_outside2.default).directive('saOnScroll', _on_scroll2.default).directive('saPhoto', _photo2.default).directive('saPhotoUploadInput', _photo_upload_input2.default).directive('saPopover', _popover2.default).directive('saPreventAutoScroll', _prevent_autoscroll2.default).directive('saRating', _rating2.default).directive('saReviewForm', _review_form2.default).directive('saSelect', _select2.default)
//.directive('saSendToMessengerButton', saSendToMessengerButton)
//.directive('saSendToMessengerModal', saSendToMessengerModal)
// .directive('saSocialShareButtons', saSocialShareButtons)
.directive('saSrcPlaceholder', _src_placeholder2.default).directive('saStateClass', _state_class2.default).directive('saStickyBar', _sticky_bar2.default).directive('saSupportPhoneNumber', _support_phone_number2.default).directive('saTimeAgo', _time_ago2.default).directive('saUniqueEmailValidator', _unique_email_validator2.default).directive('saParseNameInput', _parse_name_input2.default).directive('saSuspended', _suspended2.default).name;
//import saBookingUpdatesModal from './booking_updates_modal';

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _account_activation = __webpack_require__(437);

var _account_activation2 = _interopRequireDefault(_account_activation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = ['temporaryUser', 'auth', function (temporaryUser, auth) {
  this.updateTempUser = function () {
    this.tempUser = temporaryUser.getData() || {};
  };

  this.showEmailForm = function () {
    this.isEmailFormVisible = true;
    this.newEmail = this.tempUser.email;
  };

  this.resendEmail = function (email) {
    var data;

    if (this.isLoading) {
      return;
    }

    data = {
      id: this.tempUser.id
    };

    if (email && email !== this.tempUser.email) {
      data.email = email;
    }

    this.isLoading = true;
    auth.resendActivationEmail(data).then(function () {
      var hasEmailChanged = data.email;

      this.isEmailResent = true;
      this.updateTempUser();

      delete this.newEmail;
      delete this.isEmailFormVisible;

      if (hasEmailChanged) {
        delete this.isResendButtonDisabled;
      } else {
        this.isResendButtonDisabled = true;
      }
    }.bind(this)).finally(function () {
      delete this.isLoading;
    }.bind(this));
  };

  this.submitEmailForm = function () {
    if (this.newEmail && this.newEmail !== this.tempUser.email) {
      this.resendEmail(this.newEmail);
    } else {
      delete this.isEmailFormVisible;
    }
  };

  this.updateTempUser();
}];
var saAccountActivation = [function () {
  return {
    template: _account_activation2.default,
    replace: true,
    scope: {
      done: '&'
    },
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saAccountActivation;

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = "<div class=\"AccountActivation\">\n  <h1>\n    <span class=\"AccountActivation-icon\"></span>&nbsp;\n    <span>Verification email is on the way</span>\n  </h1>\n\n  <p>Check your inbox! Your verification email was sent to\n    <strong>{{ctrl.tempUser.email}}</strong>.\n    <a class=\"Link Link--blue Link--semiBold\" ng-click=\"ctrl.showEmailForm()\">Change email</a>.\n  </p>\n\n  <div class=\"AccountActivation-box\" ng-if=\"ctrl.isEmailResent && !ctrl.isEmailFormVisible\">\n    <p>Verification email resent.</p>\n  </div>\n\n  <div class=\"AccountActivation-button\" ng-if=\"!ctrl.isEmailFormVisible\">\n    <button class=\"Button Button--fullWidth\" ng-disabled=\"ctrl.isLoading || ctrl.isResendButtonDisabled\" sa-button-loader=\"ctrl.isLoading\" ng-click=\"!ctrl.isResendButtonDisabled && ctrl.resendEmail()\">Resend</button>\n  </div>\n\n  <form ng-if=\"ctrl.isEmailFormVisible\" name=\"ctrl.emailForm\" ng-submit=\"ctrl.emailForm.$valid && ctrl.submitEmailForm()\" novalidate>\n    <div class=\"AccountActivation-box\">\n      <div class=\"Form Form--transparent Form--wide\">\n        <input class=\"Form-field\" type=\"email\" name=\"email\" placeholder=\"Email address\"\n               ng-model=\"ctrl.newEmail\"\n               required\n               sa-email-validator>\n        <div class=\"Form-validationErrors\" ng-messages=\"ctrl.emailForm.email.$error\">\n          <p class=\"Form-validationError\" ng-message=\"required\">{{::'FORM_ERRORS.COMMON.REQUIRED' | translate}}</p>\n          <p class=\"Form-validationError\" ng-message=\"pattern\">{{::'FORM_ERRORS.EMAIL.PATTERN' | translate}}</p>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"AccountActivation-button\">\n      <button class=\"Button Button--fullWidth\" type=\"submit\" ng-if=\"ctrl.isEmailFormVisible\" ng-disabled=\"ctrl.isLoading\" sa-button-loader=\"ctrl.isLoading\" ng-click=\"this.resendEmail()\">Change email</button>\n    </div>\n  </form>\n</div>\n";

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _activate_guide_account = __webpack_require__(439);

var _activate_guide_account2 = _interopRequireDefault(_activate_guide_account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hiddenClass = 'with-hiddenNavigationTablet';
var controller = ['$window', '$document', '$rootScope', '$element', 'activateGuideAccount', 'navigation', 'userModel', 'throttle', function ($window, $document, $rootScope, $element, activateGuideAccount, navigation, userModel, throttle) {
  var _this = this;

  var windowEl = angular.element($window);
  var bodyEl = angular.element($document[0].body);
  var navigationEl = navigation.getElement();
  var resizeHandler = throttle(function () {
    bodyEl.css('padding-top', String($element[0].offsetHeight) + 'px');

    if (isFixed) {
      navigationEl.css('top', String($element[0].offsetHeight) + 'px');
    } else {
      navigationEl.css('top', null);
    }
  }, 100);
  var positionElements = function positionElements() {
    if (isNavigationHidden() && !navigation.isFixed() || !isNavigationHidden() && !navigation.isFixed()) {
      $element.css({
        position: 'absolute',
        top: '-' + String($element[0].offsetHeight) + 'px',
        left: 0,
        width: '100%',
        'z-index': 1000
      });

      isFixed = false;
    } else {
      $element.css({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        'z-index': 1000
      });

      isFixed = true;
    }

    resizeHandler();
  };
  var isFixed = false;
  var unbindRootScopeEvent;
  positionElements();

  this.activateAccount = function () {
    _this.isLoading = true;
    activateGuideAccount().then(function () {
      userModel.item.isActiveGuide = true;
    }).finally(function () {
      delete _this.isLoading;
      positionElements();
      _this.done();
    });
  };

  function isNavigationHidden() {
    return bodyEl.hasClass(hiddenClass);
  }

  unbindRootScopeEvent = $rootScope.$on('navigation', positionElements);

  windowEl.on('resize', resizeHandler);
  $element.on('$destroy', function () {
    unbindRootScopeEvent();
    windowEl.off('resize', resizeHandler);

    bodyEl.css('padding-top', null);
    navigationEl.css('top', null);
  });
}];
var saActivateGuideAccount = [function () {
  return {
    template: _activate_guide_account2.default,
    replace: true,
    scope: {
      done: '&'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saActivateGuideAccount;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <div class=\"Notification Notification--orange\">\n    <div class=\"Container\">\n      <div class=\"Notification-wrapper Notification-activate\">\n        <div class=\"Notification-row\">\n          <div class=\"Notification-text\">\n            <p class=\"u-semiBoldText\">Your profile was hidden from the locals lists due to your low response rate.</p>\n          </div>\n\n          <div class=\"Notification-button\">\n            <button class=\"Button Button--white Button--inverted\" ng-click=\"ctrl.activateAccount()\" sa-button-loader=\"ctrl.isLoading\" ng-disabled=\"ctrl.isLoading\">Reactivate</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saActiveState = ['$rootScope', '$state', function ($rootScope, $state) {
  return {
    link: function link($scope, $element, $attr) {
      var classToAdd = $attr.addClass;
      var expectedState = $attr.saActiveState;

      function updateState() {
        if ($state.is(expectedState)) {
          $element.addClass(classToAdd);
        } else {
          $element.removeClass(classToAdd);
        }
      }

      updateState();

      $rootScope.$on('$stateChangeSuccess', updateState);
    }
  };
}];

exports.default = saActiveState;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alert = __webpack_require__(442);

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saAlert = function saAlert() {
  return {
    template: _alert2.default,
    replace: true,
    scope: {
      accept: '&',
      decline: '&',
      options: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: ['$state', '$scope', 'report', function ($state, $scope, report) {
      $scope.$watch('ctrl.reportMessage', function () {
        report.reportMessage = $scope.ctrl.reportMessage;
      });

      this.buttonClicked = function (action, redirectTo) {

        switch (action) {
          case 'accept':
            this.accept();
            break;

          case 'decline':
            this.decline();
            break;
        }

        if (redirectTo) {
          $state.go(redirectTo);
        }
      };
    }]
  };
};

exports.default = saAlert;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = "<div class=\"Alert\">\n  <h1 class=\"Alert-vertical-center\">\n    <span class='Alert-checkbox'><i ng-if=\"ctrl.options.icon\" class=\"Icon RateService-icon Alert-icon\"></i></span>\n    <span class=\"Alert-title\" ng-bind-html=\"::ctrl.options.header | translate\"></span>\n  </h1>\n  <p class=\"Alert-body\" ng-bind-html=\"::ctrl.options.body | translate\"></p>\n  <form class=\"Form\" name=\"alertForm\" novalidate>\n    <div  ng-if=\"ctrl.options.textarea\">\n      <textarea class=\"AlertTextarea\" name=\"message\"\n        placeholder=\"{{ctrl.options.textarea | translate}}\"\n        msd-elastic\n        sa-cursor\n        ng-model=\"ctrl.reportMessage\"\n        >\n      </textarea>\n    </div>\n    <div class=\"Alert-buttons\" ng-if=\"ctrl.options.buttons\">\n      <div class=\"Alert-button\" ng-repeat=\"button in ctrl.options.buttons\">\n        <a class=\"Button Button--fullWidth\"  ng-class=\"button.cssClass\" ng-click=\"ctrl.buttonClicked(button.action, button.redirectTo)\" ng-bind-html=\"::button.label | translate\"></a>\n      </div>\n    </div>\n  </form>\n</div>\n";

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saAppLink = ['config', function (config) {
  var appUrls = {
    ios: config.iosAppUrl,
    android: config.androidAppUrl
  };

  return {
    restrict: 'A',
    link: function link($scope, $element, $attrs) {
      $attrs.$set('href', appUrls[$attrs.saAppLink]);
      $attrs.$set('target', '_blank');
    }
  };
}];

exports.default = saAppLink;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saBecomeGuideButton = ['$state', 'userModel', 'guideStatus', function ($state, userModel, guideStatus) {
  return {
    restrict: 'A',
    link: {
      pre: function pre($scope, $element, $attr) {
        var state = !userModel.item.id || !guideStatus.isGuide() ? 'becomeGuide' : 'settings';

        $attr.$set('href', $state.href(state));
      }
    }
  };
}];

exports.default = saBecomeGuideButton;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _become_guide_info = __webpack_require__(446);

var _become_guide_info2 = _interopRequireDefault(_become_guide_info);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saBecomeGuideInfo = [function () {
  return {
    template: _become_guide_info2.default,
    replace: true
  };
}];

exports.default = saBecomeGuideInfo;

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "<div class=\"BecomeGuideInfo\">\n  <div class=\"BecomeGuideInfo-section\">\n    <div class=\"BecomeGuideInfo-sectionContent\">\n      <div class=\"BecomeGuideInfo-imageWrapper\">\n        <div class=\"BecomeGuideInfo-image BecomeGuideInfo-image--anyoneCanBeGuide\"></div>\n      </div>\n\n      <h2>Become a Local</h2>\n      <p>Anyone can do it and that means you! You don't have to be a pro to show people around, just be yourself and let your guests discover the city you love.</p>\n    </div>\n  </div>\n\n  <div class=\"BecomeGuideInfo-section\">\n    <div class=\"BecomeGuideInfo-sectionContent\">\n      <div class=\"BecomeGuideInfo-imageWrapper\">\n        <div class=\"BecomeGuideInfo-image BecomeGuideInfo-image--defineRate\"></div>\n      </div>\n\n      <h2>Choose your price</h2>\n      <p>You determine how much you want to make and can set your hourly rate accordingly. For every hour you’re out exploring, you’ll be earning.</p>\n    </div>\n  </div>\n\n  <div class=\"BecomeGuideInfo-section\">\n    <div class=\"BecomeGuideInfo-sectionContent\">\n      <div class=\"BecomeGuideInfo-imageWrapper\">\n        <div class=\"BecomeGuideInfo-image BecomeGuideInfo-image--acceptOffers\"></div>\n      </div>\n\n      <h2>Accept interesting offers </h2>\n      <p>You decide who you want to meet and when. You’re completely in charge of your schedule. Get to know interesting people from around the world!</p>\n    </div>\n  </div>\n\n  <div class=\"BecomeGuideInfo-section\">\n    <div class=\"BecomeGuideInfo-sectionContent\">\n      <div class=\"BecomeGuideInfo-imageWrapper\">\n        <div class=\"BecomeGuideInfo-image BecomeGuideInfo-image--getPaid\"></div>\n      </div>\n\n      <h2>Show around! Earn Money.</h2>\n      <p>Show your guests the best your city has to offer! As your reputation improves through ratings and reviews, so will your ranking in the search. The higher you’re ranked, the more offers you’ll get and the more money you’ll be able to make.</p>\n    </div>\n  </div>\n\n  <!--<div class=\"BecomeGuideInfo-section\">\n    <div class=\"BecomeGuideInfo-sectionContent\">\n      <div class=\"BecomeGuideInfo-imageWrapper\">\n        <div class=\"BecomeGuideInfo-image BecomeGuideInfo-image--convenientPayout\"></div>\n      </div>\n\n      <h2>Done with your tour? Cash out.</h2>\n      <p>Once your tour has finished, you can withdraw your cash directly to your bank account. Please note, we are currently able to transfer money into accounts within the EEA (European Economic Area) only. However, you can also get paid in cash on the day of the tour.</p>\n    </div>\n  </div>-->\n</div>\n";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saBubble = [function () {
  return {
    template: '<span class="Bubble">{{value}}</span>',
    replace: true,
    scope: {
      value: '='
    },
    link: function link($scope, $element) {
      function showElement() {
        $element.css('display', 'inline-block');
      }

      function hideElement() {
        $element.css('display', 'none');
      }

      hideElement();

      $scope.$watch('value', function (value) {
        if (angular.isNumber(value) && value > 0) {
          showElement();
        } else {
          hideElement();
        }
      });
    }
  };
}];

exports.default = saBubble;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cssClass = 'is-loading';
var defaultLoaderClass = 'Loader--white';
var template = '<div class="Button-loader"><div class="Loader Loader--small"></div></div>';
var saButtonLoader = function saButtonLoader() {
  return {
    restrict: 'A',
    scope: {
      'saButtonLoader': '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
      var loaderClass = $attrs.hasOwnProperty('loaderClass') && ($attrs.loaderClass || '') || defaultLoaderClass;
      var loader;

      function showLoader() {
        $element.addClass(cssClass);

        if (!loader) {
          loader = angular.element(template);
          loader.children().addClass(loaderClass);
          $element.append(loader);
        }
      }

      function hideLoader() {
        if (loader) {
          loader.remove();
          loader = null;
        }
        $element.removeClass(cssClass);
      }

      $scope.$watch('ctrl.saButtonLoader', function (isLoading) {
        if (isLoading) {
          showLoader();
        } else {
          hideLoader();
        }
      });
    }]
  };
};

exports.default = saButtonLoader;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calendar = __webpack_require__(450);

var _calendar2 = _interopRequireDefault(_calendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saCalendar = ['calendar', function (calendar) {
  return {
    template: _calendar2.default,
    replace: true,
    require: 'ngModel',
    scope: {
      disabledDates: '=',
      allowEmptyValues: '@',
      minDate: '=',
      maxDate: '='
    },
    link: function link($scope, $element, $attr, ngModel) {
      var shouldAllowEmptyValues = $scope.allowEmptyValues !== 'false';
      var calendarModel;

      function setDate(date) {
        var newValue = date !== $scope.selectedDate || !shouldAllowEmptyValues ? date : null;

        $scope.selectedDate = newValue;
        ngModel.$setViewValue(newValue);
      }

      $scope.previousMonth = function () {
        if (calendarModel.currentMonth > 0) {
          calendarModel.currentMonth--;
        }
      };

      $scope.nextMonth = function () {
        if (calendarModel.currentMonth < calendarModel.months.length - 1) {
          calendarModel.currentMonth++;
        }
      };

      $scope.selectDay = function (day) {
        if (!day.isDisabled) {
          setDate(day.fullDate);
        }
      };

      ngModel.$render = function () {
        var modelValue;

        calendarModel = calendar.getCalendar(ngModel.$modelValue, $scope.disabledDates, $scope.minDate, $scope.maxDate);
        $scope.calendar = calendarModel;
        modelValue = $scope.calendar.selectedDate;

        if (modelValue) {
          setDate(modelValue);
        } else if (!shouldAllowEmptyValues) {
          setDate($scope.calendar.today);
        }
      };
      $scope.$watch(function () {
        return $scope.minDate;
      }, function () {
        var modelValue;
        calendarModel = calendar.getCalendar(ngModel.$modelValue, $scope.disabledDates, $scope.minDate, $scope.maxDate);
        $scope.calendar = calendarModel;
        modelValue = $scope.calendar.selectedDate;
        if (modelValue) {
          setDate(modelValue);
        } else if (!shouldAllowEmptyValues) {
          setDate($scope.calendar.today);
        }
      });
    }
  };
}];

exports.default = saCalendar;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "<div class=\"Calendar\">\n  <div class=\"Calendar-header\">\n    <a class=\"Calendar-previous\" ng-click=\"previousMonth()\"><i class=\"Icon Icon-angleLeft\"></i></a>\n    <p class=\"Calendar-month\">{{calendar.headers[calendar.currentMonth]}}</p>\n    <a class=\"Calendar-next\" ng-click=\"nextMonth()\"><i class=\"Icon Icon-angleRight\"></i></a>\n  </div>\n\n  <div class=\"Calendar-body\">\n    <table>\n      <tr>\n        <th>S</th>\n        <th>M</th>\n        <th>T</th>\n        <th>W</th>\n        <th>T</th>\n        <th>F</th>\n        <th>S</th>\n      </tr>\n\n      <tr ng-repeat=\"week in calendar.months[calendar.currentMonth]\">\n        <td ng-repeat=\"day in week\"\n            ng-class=\"{\n              'is-disabled': day.isDisabled,\n              'is-highlighted': day.fullDate === selectedDate\n            }\">\n          <a ng-click=\"selectDay(day)\">{{::day.dayOfMonth}}</a>\n        </td>\n      </tr>\n    </table>\n  </div>\n</div>\n";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saContactButton = function saContactButton() {
  return {
    restrict: 'A',
    controller: ['$element', 'contact', function ($element, contact) {
      $element.on('click', contact.showModal);

      $element.on('$destroy', function () {
        $element.off('click', contact.showModal);
      });
    }]
  };
};

exports.default = saContactButton;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _content_loader = __webpack_require__(453);

var _content_loader2 = _interopRequireDefault(_content_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saContentLoader = function saContentLoader() {
  return {
    template: _content_loader2.default,
    replace: true
  };
};

exports.default = saContentLoader;

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ContentLoader\">\n  <div class=\"Loader\"></div>\n</div>\n";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    template: _copy_my_data_modal2.default,
    replace: true,
    scope: {
      done: '&'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
};

var _copy_my_data_modal = __webpack_require__(455);

var _copy_my_data_modal2 = _interopRequireDefault(_copy_my_data_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = function controller($rootScope, $scope, settings, userModel) {
  'ngInject';

  var self = this;
  self.isSaving = false;
  self.isLoaded = false;
  self.email = false;
  self.emailVerified = false;
  self.error = false;

  settings.fetch().then(function (data) {
    if (settings.isValid('email')) {
      self.email = data.email.value;
      self.emailVerified = data.email.verified;
    }
    self.isLoaded = true;
  });

  self.copyData = function () {
    userModel.copyData().then(function (data) {
      self.done();
    }, function (data) {
      self.error = true;
    });
  };
};

controller.$inject = ['$rootScope', '$scope', 'settings', 'userModel'];

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = "<div class=\"BookingUpdatesModal\">\n  <div class=\"BookingUpdatesModal-header\">\n    Get a copy of what you have shared on Showaround.com\n  </div>\n  <div class=\"BookingUpdatesModal-body cookies\">\n    <div ng-if=\"!ctrl.error && ctrl.email && ctrl.emailVerified\">\n      <p>We will email you a letter with clear instructions on how you can download your profile information, photos, comments and more.</p>\n\n      <p>Please note that it may take up to 14 calendar days to collect this data.</p>\n\n      <div class=\"Form-buttons\">\n        <button class=\"Button Button--blue\" ng-click=\"ctrl.copyData()\" ng-disabled=\"ctrl.isSaving\">Verify</button>\n        <a class=\"Form-cancel Link Link--blue\" ng-click=\"ctrl.done()\" ng-disabled=\"ctrl.isSaving\">Cancel</a>\n      </div>\n    </div>\n    <div ng-if=\"(!ctrl.email || !ctrl.emailVerified) && ctrl.isLoaded\">\n      <p>Please fill and verify your email in \"<strong>Contact information</strong>\" section of \"<strong>Profile settings</strong>\". If you want to get a copy of what you have shared on Showaround.com</p>\n    </div>\n    <div ng-if=\"ctrl.error\">\n      <p>You already requested copy of your data, within last 7 days.</p>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _hammerjs = __webpack_require__(13);

var _hammerjs2 = _interopRequireDefault(_hammerjs);

var _crop = __webpack_require__(58);

var _crop2 = _interopRequireDefault(_crop);

var _crop3 = __webpack_require__(457);

var _crop4 = _interopRequireDefault(_crop3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

controller.$inject = ['$scope', '$window', '$element', 'photoModel', 'keyCodes'];


var minCropSize = [300, 300];
var defaultSlaceFactor = 0.05;

function controller($scope, $window, $element, photoModel, keyCodes) {
  'ngInject';

  var _this2 = this;

  var documentEl = angular.element($window.document);
  var photo = this.photo;
  var crop = photo.crop;

  function keyupHandler(event) {
    $scope.$apply(function () {
      if (event.which === keyCodes.ESC && !$scope.ctrl.crop.isLoading) {
        $scope.ctrl.done();
        event.stopImmediatePropagation();
      }
    });
  }

  this.save = function () {
    var _this = this;

    var cropCoords;
    var cropData;

    if (this.isLoading) {
      return;
    }

    cropCoords = this.crop.getCoords();
    cropData = {
      x1: cropCoords[0][0],
      y1: cropCoords[0][1],
      x2: cropCoords[1][0],
      y2: cropCoords[1][1]
    };

    this.isLoading = true;

    photoModel.cropPhoto(photo, cropData).then(function () {
      return _this.done();
    }).finally(function () {
      return delete _this.isLoading;
    });
  };

  this.cancel = function () {
    this.done();
  };

  this.crop = new _crop2.default($element[0].querySelector('.Crop-zone'), {
    minSize: minCropSize,
    coords: [[crop.x1, crop.y1], [crop.x2, crop.y2]],
    transform: {
      realSize: [photo.width, photo.height]
    }
  });

  /**
   * Zooms photo inside crop box in.
   */
  this.zoomIn = function (scaleFactor) {
    var scaleValue = 1 + (Number(scaleFactor) || defaultSlaceFactor);

    this.crop.scaleImage(scaleValue);
  };

  /**
   * Zooms photo inside crop box out.
   */
  this.zoomOut = function (scaleFactor) {
    var scaleValue = 1 - (Number(scaleFactor) || defaultSlaceFactor);

    this.crop.scaleImage(scaleValue);
  };

  documentEl.on('keyup', keyupHandler);
  $element.on('$destroy', function () {
    _this2.crop.destroy();
    documentEl.off('keyup', keyupHandler);
  });
}

function f() {
  return {
    template: _crop4.default,
    require: 'saCrop',
    replace: true,
    scope: {
      photo: '=',
      done: '&'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller,
    link: function link($scope, $element, $attr, saCropCtrl) {
      var eventManager = new _hammerjs2.default($element[0].querySelector('.Crop-zone'), {
        recognizers: [[_hammerjs2.default.Pinch, { enable: true }]]
      });

      eventManager.on('pinchin', function () {
        $scope.$apply(function () {
          return saCropCtrl.zoomIn();
        });
      });

      eventManager.on('pinchout', function () {
        $scope.$apply(function () {
          return saCropCtrl.zoomOut();
        });
      });
    }
  };
}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "<div class=\"Crop\" ng-class=\"{ 'is-loading': ctrl.isLoading }\">\n  <div class=\"Crop-box\">\n    <div class=\"Crop-zone\" hmPinchIn=\"ctrl.zoomIn()\">\n      <sa-photo photo=\"ctrl.photo\"></sa-photo>\n      <div class=\"Crop-mask\"></div>\n    </div>\n    <div class=\"Crop-zoom\">\n      <a class=\"Crop-zoomButton\" ng-click=\"ctrl.zoomOut(0.15)\" ng-disabled=\"ctrl.isLoading\">\n        <i class=\"Icon Icon-minusCircle\"></i>\n      </a>\n\n      <a class=\"Crop-zoomButton\" ng-click=\"ctrl.zoomIn(0.15)\" ng-disabled=\"ctrl.isLoading\">\n        <i class=\"Icon Icon-plusCircle\"></i>\n      </a>\n    </div>\n    <div class=\"Loader Loader--white\"></div>\n    <div class=\"Crop-buttons\">\n      <div class=\"Crop-button\">\n        <a class=\"Button Button--white Button--inverted Button--fullWidth\" ng-click=\"ctrl.cancel()\" ng-disabled=\"ctrl.isLoading\">Cancel</a>\n      </div>\n      <div class=\"Crop-button\">\n        <a class=\"Button Button--white Button--fullWidth\" ng-click=\"ctrl.save()\" ng-disabled=\"ctrl.isLoading\">Save</a>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Directive that moves input cursor to the end of the text when it's focused for the first time.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$timeout', function ($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    link: function link($scope, $element) {
      var element = $element[0];

      $element.one('focus', function () {
        var caretPosition = element.value.length;

        $timeout(function () {
          if (element.createTextRange) {
            var range = element();
            range.move('character', caretPosition);
            range.select();
          } else if (element.setSelectionRange) {
            element.setSelectionRange(caretPosition, caretPosition);
          }
        });
      });
    }
  };
}];

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS_CLASS = 'is-hoverEnabled';

/**
 * Adds `is-hoverEnabled` CSS class to body element.
 */
var saEnableHover = ['$document', 'deviceCapabilities', function ($document, deviceCapabilities) {
  return {
    restrict: 'A',
    link: function link() {

      // Enable hover if not IOS device
      if (!deviceCapabilities.isIOSDevice) {
        angular.element($document[0].body).addClass(CSS_CLASS);
      }
    }
  };
}];

exports.default = saEnableHover;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ELLIPSIS_SYMBOL = '...';
var saEllipsisContainer = exports.saEllipsisContainer = ['$rootScope', '$timeout', function () {
  return {
    restrict: 'A',
    controller: ['$element', function ($element) {
      this.getHeight = function () {
        // TODO: this is such a performance hog
        // Kill me with fire, please
        return $element[0].offsetHeight;
      };
    }]
  };
}];
var saEllipsis = exports.saEllipsis = ['$rootScope', '$window', 'throttle', function ($rootScope, $window, throttle) {
  var windowEl = angular.element($window);

  return {
    restrict: 'A',
    scope: {
      ngBind: '='
    },
    require: '^saEllipsisContainer',
    link: function link($scope, $element, $attrs, saEllipsisContainer) {
      var resizeHandler;

      function isOverflowed(maxHeight) {
        return maxHeight < $element[0].clientHeight;
      }

      function setEllipsis() {
        var maxHeight;
        var textLength;

        if (!$scope.ngBind) {
          $element.text();
          return;
        }

        maxHeight = saEllipsisContainer.getHeight();
        textLength = $scope.ngBind.length - 1 - ELLIPSIS_SYMBOL.length;

        $element.text($scope.ngBind);
        while (isOverflowed(maxHeight) && textLength > 0) {
          textLength--;
          $element.text($scope.ngBind.slice(0, textLength) + ELLIPSIS_SYMBOL);
        }
      }

      resizeHandler = throttle(setEllipsis, 60);

      $scope.$watch('ngBind', setEllipsis);
      // Disable because iOS Safari keeps laggin scrolling in conversations
      // windowEl.on('resize', resizeHandler);

      $scope.$on('$destroy', function () {
        windowEl.off('resize', resizeHandler);
      });
    }
  };
}];

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saEmailValidator = ['patterns', function (patterns) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link($scope, $element, $attr, ngModel) {
      var emailRegexp = new RegExp(patterns.email);

      ngModel.$validators.pattern = function (value) {
        return !ngModel.$isEmpty(value) && emailRegexp.test(value);
      };
    }
  };
}];

exports.default = saEmailValidator;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fastclick = __webpack_require__(59);

var _fastclick2 = _interopRequireDefault(_fastclick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saFastclick = [function () {
  return {
    link: function link($scope, $element) {
      _fastclick2.default.attach($element[0]);
    }
  };
}];

exports.default = saFastclick;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _footer = __webpack_require__(464);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saFooter = [function () {
  return {
    template: _footer2.default,
    replace: true,
    scope: {},
    bindToController: true,
    controllerAs: 'ctrl',
    controller: ['$window', 'config', 'userModel', function ($window, config, userModel) {
      this.blogUrl = config.blogUrl;
      this.pressPageUrl = config.pressPageUrl;
      this.currentYear = new Date().getFullYear();
      this.userModel = userModel;

      $window.SA = $window.SA || {};
      this.shouldShowTeamPage = $window.SA.country !== 'LT';
    }]
  };
}];

exports.default = saFooter;

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = "<section class=\"Footer\">\n  <div class=\"Footer-photo\"></div>\n\n  <div class=\"Footer-content\">\n    <div class=\"Footer-container\">\n      <div class=\"Footer-links\">\n        <span class=\"Footer-links-column\">\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"team\" ng-if=\"ctrl.shouldShowTeamPage\">About</a>\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.about\" ng-if=\"!ctrl.shouldShowTeamPage\">About</a>\n        </span>\n        <span class=\"Footer-links-column\">\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.contact\">Support</a>\n        </span>\n        <span class=\"Footer-links-column\">\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.terms\">Terms</a>\n        </span>\n        <span class=\"Footer-links-column\">\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.privacy\">Privacy</a>\n        </span>\n      </div>\n\n      <div class=\"Footer-links Footer-links--tablet Footer-grid\">\n\n        <div class=\"Footer-column Footer-column--slogan\">\n          <div class=\"Footer-logo\"></div>\n\n          <p>Discover a city with a local.</p>\n          <sa-social-links></sa-social-links>\n        </div>\n\n        <div class=\"Footer-column Footer-column--links\">\n          <h2>Getting started</h2>\n\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"team\" ng-if=\"ctrl.shouldShowTeamPage\">About Us</a>\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.about\" ng-if=\"!ctrl.shouldShowTeamPage\">About Us</a>\n          <a class=\"Link Link--cornflowerBlue\" ng-if=\"!ctrl.userModel.item.id\"\n            ui-sref=\"becomeGuide\">Sign Up As a Local</a>\n          <a class=\"Link Link--cornflowerBlue\" ng-if=\"ctrl.userModel.item.id\"\n            ui-sref=\"info.becomeGuide\">Why be a local?</a>\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"android\">Android app</a>\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"ios\">iOS app</a>\n          <a class=\"Link Link--cornflowerBlue\" ng-href=\"{{ ::ctrl.pressPageUrl }}\" target=\"_blank\">Press</a>\n          <a class=\"Link Link--cornflowerBlue\" ng-href=\"{{ ::ctrl.blogUrl }}\" target=\"_blank\">Blog</a>\n        </div>\n\n        <div class=\"Footer-column Footer-column--links\">\n          <h2>Resources</h2>\n\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.bookingAdvice\">Booking Advice</a>\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.adviceForGuide\">Advice For a Local</a>\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.reviews\">Reviews & Ratings</a>\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.contact\">Support & Contact</a>\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"popularCities\">Popular Cities</a>\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"countries\">Countries</a>\n        </div>\n\n        <div class=\"Footer-column Footer-column--linksWide\">\n          <h2>Policies</h2>\n\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.terms\">Terms of Service</a>\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.privacy\">Privacy Policy</a>\n          <!--<a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.paymentsPricing\">Payments & Pricing</a>-->\n          <!--<a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.refunds\">Cancellation & Refunds</a>-->\n          <a class=\"Link Link--cornflowerBlue\" ui-sref=\"info.security\">Security</a>\n        </div>\n\n        <div class=\"Footer-column Footer-column--apps\">\n          <h2>Download our apps</h2>\n\n          <a class=\"App App--apple is-active\" sa-app-link=\"ios\">\n            <div class=\"App-icon\"></div>\n          </a>\n\n          <a class=\"App App--google is-active\" sa-app-link=\"android\">\n            <div class=\"App-icon\"></div>\n          </a>\n        </div>\n      </div>\n\n      <div class=\"Footer-socialLinks\">\n        <sa-social-links></sa-social-links>\n      </div>\n\n      <p class=\"Footer-copyright\">&copy; Showaround {{ctrl.currentYear}}</p>\n    </div>\n  </div>\n</section>\n";

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cookies_line = __webpack_require__(466);

var _cookies_line2 = _interopRequireDefault(_cookies_line);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saCookiesLine = [function () {
  return {
    template: _cookies_line2.default,
    replace: true,
    scope: {},
    bindToController: true,
    controllerAs: 'ctrl',
    controller: ['$window', 'config', 'userModel', 'modal', '$rootScope', '$scope', '$cookies', function ($window, config, userModel, modal, $rootScope, $scope, $cookies) {
      var self = this;
      this.userModel = userModel;
      this.isCookiesLineEnabled = $rootScope.isCookiesLineEnabled !== undefined ? $rootScope.isCookiesLineEnabled : true;

      this.modalOpen = function () {
        modal.open({
          template: '<sa-cookies-line-modal done="close()"></sa-cookies-line-modal>'
        }).result.finally(function () {
          $state.go(toState.name, toParams);
        });
      };

      this.accept = function () {
        $rootScope.isCookiesLineEnabled = false;
      };

      $scope.$watch(function () {
        return $rootScope.facebookPixel;
      }, function (value) {
        if (!value) {
          $cookies.put('disable_fb_pixel', 'disabled');
        } else {
          $cookies.remove('disable_fb_pixel');
        }
      });

      $scope.$watch(function () {
        return $rootScope.analytics;
      }, function (value) {
        if (!value) {
          $cookies.put('disable_google_analytics', 'disabled');
        } else {
          $cookies.remove('disable_google_analytics');
        }
      });

      $scope.$watch(function () {
        return $rootScope.adWords;
      }, function (value) {
        if (!value) {
          $cookies.put('disable_google_adwords', 'disabled');
        } else {
          $cookies.remove('disable_google_adwords');
        }
      });

      $scope.$watch(function () {
        return $rootScope.taboola;
      }, function (value) {
        if (!value) {
          $cookies.put('disable_taboola', 'disabled');
        } else {
          $cookies.remove('disable_taboola');
        }
      });

      $scope.$watch(function () {
        return $rootScope.isCookiesLineEnabled;
      }, function (value) {
        if (!value) {
          $cookies.put('disable_cookies_line', 'disabled');
          self.isCookiesLineEnabled = false;
        } else {
          $cookies.remove('disable_cookies_line');
          self.isCookiesLineEnabled = true;
        }
      });
    }]
  };
}];

exports.default = saCookiesLine;

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cookies_line\" ng-show=\"ctrl.isCookiesLineEnabled\">\n    <div class=\"cookies_line--container\">\n        <div class=\"cookies_line--item\">We and our partners use cookies to understand how you use our site, improve your\n            experience and serve you personalized content. Read about how we use cookies in our cookie policy and how\n            you can control them by clicking \"Manage Settings\". By continuing to use this site, you\n            accept these cookies.\n        </div>\n        <div class=\"cookies_line--item\">\n            <button class=\"Button Button--inverted\" ng-click=\"ctrl.modalOpen()\">Manage Settings</button>\n            <button class=\"Button\" ng-click=\"ctrl.accept()\">Accept</button>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    template: _cookies_line_modal2.default,
    replace: true,
    scope: {
      done: '&'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
};

var _cookies_line_modal = __webpack_require__(468);

var _cookies_line_modal2 = _interopRequireDefault(_cookies_line_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = function controller($rootScope, $scope, userModel) {
  'ngInject';

  var self = this;
  self.analytics = $rootScope.analytics !== undefined ? $rootScope.analytics : true;
  self.facebookPixel = $rootScope.facebookPixel !== undefined ? $rootScope.facebookPixel : true;
  self.adWords = $rootScope.adWords !== undefined ? $rootScope.adWords : true;
  self.taboola = $rootScope.taboola !== undefined ? $rootScope.taboola : true;

  self.confirm = function () {
    $rootScope.analytics = self.analytics;
    $rootScope.facebookPixel = self.facebookPixel;
    $rootScope.adWords = self.adWords;
    $rootScope.taboola = self.taboola;
    $rootScope.isCookiesLineEnabled = false;
    self.done();
  };
};

controller.$inject = ['$rootScope', '$scope', 'userModel'];

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "<div class=\"BookingUpdatesModal\">\n    <div class=\"BookingUpdatesModal-header\">\n        What cookies we use on Showaround.com\n    </div>\n    <div class=\"BookingUpdatesModal-body cookies\">\n        <div style=\"text-align: left;\">\n            <h2>MANAGE SETTINGS</h2>\n            <h3>Necessary cookies</h3>\n            <p class=\"Alert-body\">These browser tracking and authentication information cookies are necessary for the Website to function and cannot be disabled on our systems.</p>\n            <div class=\"Checkbox\" style=\"margin-top:5px;margin-bottom:5px;margin-left: 11px;\">\n                Required cookies from Showaround.com\n            </div>\n            <h3>Managed cookies</h3>\n            <p class=\"Alert-body\">These cookies are important for the Website to function but can be disabled.</p>\n            <div class=\"Checkbox\" style=\"margin-top:5px;margin-bottom:24px;\">\n                <input name=\"googleAnalyticsCookies\" id=\"googleAnalyticsCookies\" type=\"checkbox\" checked=\"checked\"\n                       ng-model=\"ctrl.analytics\">\n                <label for=\"googleAnalyticsCookies\">Google Analytics</label>\n            </div>\n            <div class=\"Checkbox\" style=\"margin-top:5px;margin-bottom:24px;\">\n                <input name=\"facebookPixelCookies\" id=\"facebookPixelCookies\" type=\"checkbox\" checked=\"checked\"\n                       ng-model=\"ctrl.facebookPixel\">\n                <label for=\"facebookPixelCookies\">Facebook pixel</label>\n            </div>\n            <div class=\"Checkbox\" style=\"margin-top:5px;margin-bottom:24px;\">\n                <input name=\"adWordsCookies\" id=\"adWordsCookies\" type=\"checkbox\" checked=\"checked\"\n                       ng-model=\"ctrl.adWords\">\n                <label for=\"adWordsCookies\">Google AdWords</label>\n            </div>\n            <div class=\"Checkbox\" style=\"margin-top:5px;margin-bottom:24px;\">\n                <input name=\"taboolaCookies\" id=\"taboolaCookies\" type=\"checkbox\" checked=\"checked\"\n                       ng-model=\"ctrl.taboola\">\n                <label for=\"taboolaCookies\">Taboola</label>\n            </div>\n        </div>\n\n        <div class=\"Form-buttons\">\n            <button class=\"Button Button--blue\" ng-click=\"ctrl.confirm()\">Verify</button>\n            <a class=\"Form-cancel Link Link--blue\" ng-click=\"ctrl.done()\">Cancel</a>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GUTTER_SIZE = 8;
var MIN_COLUMN_COUNT = 2;
var COLUMN_WIDTH = 224;

var saGrid = ['$window', '$timeout', function ($window, $timeout) {
  return {
    restrict: 'A',
    link: function link($scope, $element, $attr) {
      var parentEl = $element.parent()[0];
      var windowEl = angular.element($window);
      var columnWidth = Number($attr.columnWidth) || COLUMN_WIDTH;
      var minColumnCount = Number($attr.minColumnCount) || MIN_COLUMN_COUNT;
      var gutterSize = Number($attr.gutterSize) || GUTTER_SIZE;

      function setElementWidth() {
        var parentStyles = getComputedStyle(parentEl, null);
        var parentWidth = parentEl.clientWidth - parseFloat(parentStyles.getPropertyValue('padding-left')) - parseFloat(parentStyles.getPropertyValue('padding-right'));
        var columnCount = Math.floor((parentWidth + gutterSize) / (columnWidth + gutterSize));

        if (parentWidth < minColumnCount * columnWidth || columnCount < minColumnCount) {
          $element.css('width', '100%');
        } else {
          $element.css('width', String(columnCount * columnWidth + (columnCount - 1) * gutterSize) + 'px');
        }
      }

      $element.css('width', '0px');

      $timeout(setElementWidth);

      windowEl.on('resize', setElementWidth);

      $element.on('$destroy', function () {
        windowEl.off('resize', setElementWidth);
      });
    }
  };
}];

exports.default = saGrid;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _guide_activities = __webpack_require__(471);

var _guide_activities2 = _interopRequireDefault(_guide_activities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function swap(obj) {
  var ret = {};
  for (var key in obj) {
    ret[obj[key]] = key;
  }
  return ret;
}

var saGuideActivities = function saGuideActivities() {
  return {
    template: _guide_activities2.default,
    replace: true,
    scope: {
      activities: '=',
      country: '=',
      city: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: ['activityIcons', 'seoActivities', function f(activityIcons, seoActivities) {
      'ngInject';

      this.rSeoActivities = swap(seoActivities);
      this.activityIcons = activityIcons;
    }]
  };
};

exports.default = saGuideActivities;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "<div class=\"GuideActivities\">\n  <div class=\"GuideActivities-activity\" ng-repeat=\"activity in ::ctrl.activities\">\n    <i class=\"Icon\" ng-class=\"::ctrl.activityIcons[activity]\"></i>\n    <a ui-sref=\"guides.cityFilter({country: ctrl.country, city: ctrl.city, filter: ctrl.rSeoActivities[activity]})\"\n       target=\"_blank\"\n       class=\"Link\"><span ng-bind-html=\"::'ACTIVITIES.' + (activity | uppercase) | translate\"></span></a>\n  </div>\n</div>\n\n";

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(473);

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = function controller($rootScope, userModel) {
  'ngInject';

  var _this = this;

  this.showActivation = false;

  // this.showPolicyChange = false;

  $rootScope.$on('userModel:initialized', function () {
    _this.showActivation = userModel.item.id && !userModel.item.isActiveGuide;
    // this.showPolicyChange = userModel.item.id && userModel.item.isTermsUpdated;
  });

  this.done = function () {
    _this.showActivation = false;
  };

  // this.doneTerms = () => {
  //   this.showPolicyChange = false;
  // };
};

controller.$inject = ['$rootScope', 'userModel'];
var saHeader = function saHeader() {
  return {
    template: _header2.default,
    replace: true,
    controllerAs: 'ctrl',
    controller: controller
  };
};

exports.default = saHeader;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = "<header>\n  <sa-activate-guide-account ng-if=\"ctrl.showActivation\" done=\"ctrl.done()\"></sa-activate-guide-account>\n<!--  <sa-terms-change ng-if=\"ctrl.showPolicyChange\" done=\"ctrl.doneTerms()\"></sa-terms-change>-->\n  <sa-navigation></sa-navigation>\n</header>\n";

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saInputClear;
function saInputClear($document, $timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link($scope, $element, $attr, ngModel) {
      var clearButton = angular.element('<button class="ClearButton" type="button" style="display: none"></button>');
      var isHidden = true;

      function showButton() {
        if (isHidden) {
          clearButton.css({
            display: 'block'
          });
          isHidden = false;
        }
      }

      function hideButton() {
        if (!isHidden) {
          clearButton.css({
            display: 'none'
          });
          isHidden = true;
        }
      }

      function isInputEmpty() {
        return !$element.val();
      }

      clearButton.css({
        display: 'none'
      });

      $element.parent().prepend(clearButton);

      $element.on('focus keyup', function () {
        if (!isInputEmpty()) {
          showButton();
        } else {
          hideButton();
        }
      });

      $element.on('blur', function () {
        $timeout(function () {
          hideButton();
        }, 200);
      });

      clearButton.on('click', function () {
        $scope.$apply(function () {
          ngModel.$setViewValue(null);
          ngModel.$commitViewValue();
          ngModel.$render();
          $element[0].focus();
        });
      });

      $element.on('$destroy', function () {

        // Clean up
        clearButton.remove();
      });
    }
  };
}

saInputClear.$inject = ['$document', '$timeout'];

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saJoinButton = ['join', function (join) {
  return {
    restrict: 'A',
    link: function link($scope, $element) {
      $element.on('click', function () {
        join.showModal();
      });
    }
  };
}];

exports.default = saJoinButton;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$window', '$timeout', '$location', '$uiViewScroll', '$state'];
function f($window, $timeout, $location, $uiViewScroll, $state) {
  'ngInject';

  // cache scroll position of each route's templateUrl

  var scrollPosCache = {};

  // compile function
  var directive = function directive(scope) {

    scope.$on('$stateChangeStart', function (_, toState, toParams, fromState) {
      // store scroll position for the current view
      if ($state.$current) {
        scrollPosCache[fromState.name] = [$window.pageXOffset, $window.pageYOffset];
      }
    });

    scope.$on('$stateChangeSuccess', function (_, toState) {
      var prevScrollPos = scrollPosCache[toState.name] || [0, 0];
      $timeout(function () {
        $window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
      }, 0);
    });
  };

  return directive;
}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _language_input = __webpack_require__(478);

var _language_input2 = _interopRequireDefault(_language_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saLanguageInput = ['languages', function (languages) {
  return {
    template: _language_input2.default,
    replace: true,
    require: 'ngModel',
    scope: {},
    link: function link($scope, $element, $attr, ngModel) {
      var selectEl = $element.find('select');
      var $isEmpty = ngModel.$isEmpty;

      function blueHandler() {
        ngModel.$setTouched();
      }

      $scope.languages = languages;

      ngModel.$render = function () {
        $scope.selectedLanguages = ngModel.$modelValue || [];
      };

      ngModel.$isEmpty = function (value) {
        return $isEmpty(value) || angular.isArray(value) && !value.length;
      };

      $scope.$watch('selectedLanguages.length', function () {
        ngModel.$setViewValue(angular.copy($scope.selectedLanguages));
      });

      selectEl.on('blur', blueHandler);

      $scope.$on('$destroy', function () {
        selectEl.off('blur', blueHandler);
      });
    }
  };
}];

exports.default = saLanguageInput;

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <sa-multiselect ng-model=\"selectedLanguages\" data=\"languages\">\n    <option value=\"\">Select languages</option>\n    <option value=\"\" disabled></option>\n    <option value=\"{{language.value}}\" ng-repeat=\"language in languages.options | filter:{ popular: true }\" ng-disabled=\"selectedLanguages.indexOf(language.value) !== -1\">{{language.translationKey | translate}}</option>\n    <option value=\"\" disabled></option>\n    <option value=\"{{language.value}}\" ng-repeat=\"language in languages.options | filter:{ popular: false }\" ng-disabled=\"selectedLanguages.indexOf(language.value) !== -1\">{{language.translationKey | translate}}</option>\n  </sa-multiselect>\n</div>\n";

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * `itValidateLocation` directive.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var saLocationValidator = [function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      ngModel.$validators.location = function (location) {
        return ngModel.$isEmpty(location) || angular.isObject(location) && location.placeId;
      };
    }
  };
}];

exports.default = saLocationValidator;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modal = __webpack_require__(481);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// More than slideshow (for delete, rotate photo actions)
var INITIAL_Z_INDEX = 2000;
var saModal = ['$rootScope', 'modal', 'bodyScroll', function ($rootScope, modal, bodyScroll) {
  return {
    transclude: true,
    replace: true,
    template: _modal2.default,
    link: function postLink($scope, $element) {
      $element.css('z-index', INITIAL_Z_INDEX + $scope.modalInstance.index);
      bodyScroll.disable();

      $scope.dismiss = $scope.modalInstance.dismiss;
      $scope.close = $scope.modalInstance.close;
      $scope.closeOff = $scope.modalInstance.closeOff;
    }
  };
}];

exports.default = saModal;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "<div class=\"Modal\" sa-fastclick touch=\"modal\">\n  <div class=\"Modal-wrapper\">\n    <div class=\"Modal-window\">\n      <div class=\"Modal-header\">\n        <h1 class=\"Modal-title\">{{title}}</h1>\n        <a ng-if=\"!closeOff\" class=\"Modal-close\" ng-click=\"!modalOptions.closeOnBackgroundClick && dismiss()\"><i class=\"Icon Icon-close\"></i></a>\n      </div>\n      <div class=\"Modal-body\" ng-transclude sa-on-click-outside=\"modalOptions.closeOnBackgroundClick && dismiss()\"></div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiselect = __webpack_require__(483);

var _multiselect2 = _interopRequireDefault(_multiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saMultiselect = ['languages', function () {
  return {
    template: _multiselect2.default,
    replace: true,
    transclude: true,
    require: 'ngModel',
    scope: {
      data: '='
    },
    link: function link($scope, $element, $attr, ngModel) {
      function updateViewValue() {
        var newValue = $scope.selectedItems.map(function (item) {
          return item.value;
        });

        ngModel.$setViewValue(newValue);
      }

      function sortSelectedItems() {
        $scope.selectedItems.sort(function (a, b) {
          return a.value > b.value ? 1 : a.value < b.value ? -1 : 0;
        });
      }

      function addItem(item) {
        $scope.selectedItems.push(item);
      }

      $scope.removeItem = function (index) {
        $scope.selectedItems.splice(index, 1);
        updateViewValue();
      };

      ngModel.$render = function () {
        var selectedItems = (ngModel.$modelValue || []).map(function (item) {
          return $scope.data.all[item];
        });

        $scope.selectedItems = selectedItems;
      };

      $scope.$watch('data', function () {
        $scope.options = $scope.data.options;
      });

      $scope.$watch('selectedItem', function (newValue) {
        if (newValue) {
          addItem($scope.data.all[newValue]);
          sortSelectedItems();
          updateViewValue();
          delete $scope.selectedItem;
        }
      });
    }
  };
}];

exports.default = saMultiselect;

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "<div class=\"Form-multiselect\">\n  <div class=\"Form-select\">\n    <select ng-model=\"selectedItem\" ng-transclude>\n      <option value=\"\"></option>\n    </select>\n  </div>\n  <div class=\"Form-multiselectOption\" ng-repeat=\"item in selectedItems\">\n    <a ng-click=\"removeItem($index)\"><i class=\"Icon Icon-timesCircle\"></i></a>\n    <span ng-bind-html=\"::item.translationKey | translate\"></span>\n  </div>\n</div>\n";

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _not_found = __webpack_require__(485);

var _not_found2 = _interopRequireDefault(_not_found);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saNotFound = [function () {
  return {
    template: _not_found2.default,
    replace: true
  };
}];

exports.default = saNotFound;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = "<div class=\"NotFound\">\n  <h1>Oops...That page doesn’t exist.</h1>\n  <p>Looks like something got mixed up.</p>\n  <div class=\"NotFound-button\">\n    <a class=\"Button Button--large\" ui-sref=\"guides.landing\">Take me to homepage</a>\n  </div>\n</div>\n";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var instanceCount = 0;

var saOnClickOutside = ['$window', '$timeout', function ($window, $timeout) {
  return {
    scope: {
      saOnClickOutside: '&'
    },
    link: function link($scope, $element) {
      var documentEl = angular.element($window.document);
      var body = $window.document.body;
      var wasClickedInside = false;
      var index = instanceCount++;

      function documentClickHandler(event) {
        if (!wasClickedInside && index === instanceCount - 1 && event.target !== body) {
          $scope.$apply(function () {
            $scope.saOnClickOutside();
          });
        }

        wasClickedInside = false;
      }

      $element.on('click', function () {
        wasClickedInside = true;
      });

      $timeout(function () {
        documentEl.on('click', documentClickHandler);
      });

      $element.on('$destroy', function () {
        documentEl.off('click', documentClickHandler);
        --instanceCount;
      });
    }
  };
}];

exports.default = saOnClickOutside;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * itOnScroll directive
 * Evaluates expression when scroll reaches the bottom of document.
 *
 * Usage:
 * <element it-on-scroll="expression"></element>
 *
 * Optional attributes:
 * threshold="[value in pixels]" - minimum distance from the bottom. By default threshold equals 0.
 * invert - evaluate expression when scroll reaches the top of document.
 * disable="true" - disables evaluation of expression
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var saOnScroll = ['$parse', '$timeout', '$window', '$rootScope', 'throttle', 'scrollTop', function ($parse, $timeout, $window, $rootScope, throttle, scrollTop) {
  var SCROLL_THROTTLE = 100;

  return {
    restrict: 'A',
    link: function postLink($scope, $element, $attr) {
      var window = angular.element($window);
      var bodyEl = $window.document.body;
      var scrollAction = $parse($attr.saOnScroll);
      var threshold = Number($attr.threshold) || 0;
      var inverted = angular.isDefined($attr.invert);
      var scrollHandlerThrottled;

      function executeAction() {
        scrollAction($scope);
      }

      function scrollHandler() {
        if (!$scope.$eval($attr.disable) && hasReachedThreshold(inverted)) {
          if (!$scope.$$phase) {
            $scope.$apply(executeAction);
          } else {
            executeAction();
          }
        }
      }

      function hasReachedThreshold(inverted) {
        var element = $element[0];
        var elementOffsetY = element.getBoundingClientRect().top - bodyEl.getBoundingClientRect().top;
        var elementHeight = $element[0].offsetHeight + elementOffsetY;
        var scrollOffset = scrollTop();
        var hasReached = false;

        if (!elementHeight) {
          hasReached = false;
        } else if (inverted) {
          hasReached = scrollOffset <= threshold;
        } else {
          hasReached = scrollOffset + bodyEl.offsetHeight >= elementHeight - threshold;
        }

        return hasReached;
      }

      // throttle calls to scroll handler
      scrollHandlerThrottled = throttle(scrollHandler, SCROLL_THROTTLE);

      // since the local listing is just hidden when we enter a local profile
      // the scroll handler is still available and $destroy is not called
      // we have to turn it off temporarily when viewing a local
      var unbindStateChange = $rootScope.$on('$stateChangeStart', function (_, toState, toParams, fromState) {
        var toViewLocal = (fromState.name === 'guides.list' || fromState.name === 'guides.city' || fromState.name === 'guides.cityFilter' || fromState.name === 'guides.listNoName' || fromState.name === 'guides.landing') && toState.name === 'guides.guide';
        var toViewLocals = (toState.name === 'guides.list' || toState.name === 'guides.city' || toState.name === 'guides.cityFilter' || toState.name === 'guides.listNoName' || toState.name === 'guides.landing') && fromState.name === 'guides.guide';
        if (toViewLocal) {
          window.off('scroll', scrollHandlerThrottled);
        }

        if (toViewLocals) {
          window.on('scroll', scrollHandlerThrottled);
        }
      });

      window.on('scroll', scrollHandlerThrottled);

      $scope.$on('$destroy', function () {
        window.off('scroll', scrollHandlerThrottled);
        unbindStateChange();
      });

      $timeout(scrollHandler);
    }
  };
}];

exports.default = saOnScroll;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['config', 'photoSizes', 'deviceCapabilities'];
var placeholder = __webpack_require__(489);
var getRect = function getRect(crop) {
  var x1 = crop.x1;
  var y1 = crop.y1;
  var x2 = crop.x2;
  var y2 = crop.y2;

  return String(x1 + ',' + y1 + ',' + Math.abs(x2 - x1) + ',' + Math.abs(y2 - y1));
};
var getQueryString = function getQueryString(params) {
  var queryParts = Object.keys(params).map(function (key) {
    return key + '=' + String(params[key]);
  });

  return '?' + queryParts.join('&');
};

function getPhotoUrl(size, isRect, crop, fit, photo, imgUrl, imgQuality, devicePixelRatio) {
  var photoPath = photo && photo.path;
  var dpr = devicePixelRatio;
  var params;
  var photoUrl;

  if (photo && photoPath) {
    if (!size || photo.width < size[0] && photo.height < size[1]) {
      size = [photo.width, photo.height];
      dpr = 1;
    }

    params = {
      w: size[0],
      h: size[1],
      dpr: dpr,
      or: photo.angle || 0,
      q: imgQuality,
      bri: photo.brightness || 0,
      con: photo.contrast || 0
    };

    // https://docs.imgix.com/apis/url/size/rect
    // crops a region inside an image
    if (isRect && photo.crop) {
      params.rect = getRect(photo.crop);
    }

    // https://docs.imgix.com/apis/url/size/crop
    // top, bottom, left, right, faces, and entropy
    if (crop && photo.position) {
      // TODO: check imgix params again?
      params.crop = photo.position;
    } else if (!photo.position) {
      params.crop = 'faces';
    }

    if (fit) {
      params.fit = 'crop';
    }

    photoUrl = imgUrl + photoPath.replace('{type}', 'original_') + getQueryString(params);
  } else {
    photoUrl = placeholder;
  }

  return photoUrl;
}

function f(config, photoSizes, deviceCapabilities) {
  'ngInject';

  var imgUrl = config.imgUrl;
  var imgQuality = config.imgQuality;
  var devicePixelRatio = deviceCapabilities.pixelRatio >= 1.5 ? 1.5 : 1;

  return {
    scope: {
      photo: '='
    },
    template: '<img>',
    replace: true,
    link: function link($scope, $element, $attr) {
      var size = photoSizes[$attr.size];
      var isRect = $attr.hasOwnProperty('rect');
      var crop = $attr.hasOwnProperty('crop');
      var fit = $attr.hasOwnProperty('fit');
      var isDynamic = $attr.hasOwnProperty('dynamic');
      var isLazy = $attr.hasOwnProperty('lazy');
      var srcAttribute = isLazy ? 'data-src' : 'src';

      if (isLazy) {
        $element.addClass('lazyload');
      }

      function setPhotoUrl() {
        $attr.$set(srcAttribute, getPhotoUrl(size, isRect, crop, fit, $scope.photo, imgUrl, imgQuality, devicePixelRatio));
      }

      function setWatchers() {
        $scope.$watch('photo.crop', setPhotoUrl);
        $scope.$watch('photo.angle', setPhotoUrl);
      }

      $scope.$watch('::photo', function (photo) {
        setPhotoUrl();
        if (isDynamic && typeof photo !== 'undefined') {
          setWatchers();
        }
      });
    }
  };
}

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/3e1671dc9a7eec4a6360a9e2e72b4564.jpg";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

f.$inject = ['$window', '$q', 'utils', 'session', 'uploadPhoto'];


var inputCSS = {
  position: 'absolute',
  'z-index': 2,
  top: '0px',
  left: '0px',
  width: '100%',
  opacity: 0,
  'font-size': '100px'
};

function f($window, $q, utils, session, uploadPhoto) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      onUpload: '&',
      uploadUrl: '@',
      fileLimit: '='
    },
    link: function postLink($scope, $element, $attrs) {
      var counter = 0;
      var isFormDataSupported = 'FormData' in $window;
      var isMultipleUploadAllowed = $attrs.hasOwnProperty('multiple');
      var fileInput = void 0;

      function handleFormDataChange(event) {
        var files = event.target.files;

        if ($attrs.fileLimit) {
          files = Array.prototype.slice.call(files, 0, Math.min(files.length, $scope.fileLimit));
        }

        $scope.$apply(function () {
          $scope.onUpload({
            promises: uploadPhoto($scope.uploadUrl, files)
          });
          createFileInput();
        });
      }

      function getHiddenInput(name, value) {
        return '<input type="hidden" name="' + name + '" value="' + value + '">';
      }

      function handleFormDataChangeViaIFrame() {
        var url = utils.getApiUrl($scope.uploadUrl) + '?type=iframe';
        var iFrame = void 0;
        var transportForm = void 0;

        counter++;

        iFrame = _angular2.default.element('<iframe src="" style="display:none;" name="uploadFrame-' + counter + '" frameborder="0"></iframe>');
        transportForm = _angular2.default.element('<form action="' + url + '" enctype="multipart/form-data" target="uploadFrame-' + counter + '" method="post"></form>');

        $element.parent().append(iFrame);
        iFrame.after(transportForm);

        var promise = new $q(function (resolve, reject) {
          iFrame.on('load', function () {
            $scope.$apply(function () {
              var content = void 0;
              var photoData = void 0;

              try {
                content = iFrame.contents().find('body').text();
                photoData = JSON.parse(content);
                resolve(photoData);
              } catch (e) {
                reject();
              }

              iFrame.remove();
            });
          });
        });

        transportForm.append(fileInput);
        transportForm.append(getHiddenInput('accessToken', session.get().accessToken));
        transportForm[0].submit();
        transportForm.remove();

        createFileInput();

        $scope.$apply(function () {
          $scope.onUpload({
            promises: [promise]
          });
        });
      }

      function createFileInput() {
        if (fileInput) {
          fileInput.remove();
          fileInput = fileInput.clone();
        } else {
          fileInput = _angular2.default.element('<input type="file" name="photo" ' + (isMultipleUploadAllowed ? 'multiple' : '') + '>').css(inputCSS);
        }

        $element.append(fileInput);

        if (isFormDataSupported) {
          fileInput.on('change', handleFormDataChange);
        } else {
          fileInput.on('change', handleFormDataChangeViaIFrame);
        }
      }

      $scope.$on('$destroy', function () {
        if (isFormDataSupported) {
          fileInput.off('change', handleFormDataChange);
        } else {
          fileInput.off('change', handleFormDataChangeViaIFrame);
        }
      });

      if ($element.css('position') !== 'absolute') {
        $element.css('position', 'relative');
      }

      createFileInput();
    }
  };
}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saPreventAutoscroll = ['$window', 'scrollTop', function ($window, scrollTop) {
  return {
    restrict: 'A',
    link: function link() {
      $window.addEventListener('beforeunload', function () {
        scrollTop(0);
      });
    }
  };
}];

exports.default = saPreventAutoscroll;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rating = __webpack_require__(493);

var _rating2 = _interopRequireDefault(_rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STARS = [1, 2, 3, 4, 5];
var saRating = [function () {
  return {
    template: _rating2.default,
    replace: true,
    scope: {
      rating: '='
    },
    link: function link($scope) {
      $scope.stars = STARS;
    }
  };
}];

exports.default = saRating;

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = "<p class=\"Rating\">\n  <i class=\"Icon Icon-star\" ng-class=\"{ 'is-highlighted': star <= rating }\" ng-repeat=\"star in ::stars\"></i>\n</p>\n";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _review_form = __webpack_require__(495);

var _review_form2 = _interopRequireDefault(_review_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RATES = [1, 2, 3, 4, 5];
var saReviewForm = ['reviews', function (reviews) {
  return {
    template: _review_form2.default,
    scope: {
      revieweeId: '@',
      onSave: '&'
    },
    link: function link($scope) {
      $scope.rates = RATES;
      $scope.review = {
        rate: RATES[RATES.length - 1]
      };

      $scope.leaveReview = function () {
        $scope.isSendButtonEnabled = false;

        reviews.create($scope.revieweeId, $scope.review).then(function () {
          $scope.onSave();
        }).finally(function () {
          $scope.isSendButtonEnabled = true;
        });
      };
    }
  };
}];

exports.default = saReviewForm;

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "<form class=\"form\" name=\"ReviewForm\" ng-submit=\"leaveReview()\">\n  <br>\n  <h4>Leave a review</h4>\n  <br>\n  <div class=\"form-group\">\n    <select class=\"form-control\" name=\"rate\" ng-model=\"review.rate\" ng-options=\"rate for rate in rates\"></select>\n  </div>\n  <div class=\"form-group\">\n    <textarea class=\"form-control\" name=\"content\" ng-model=\"review.content\"></textarea>\n  </div>\n\n  <button class=\"form-control\">Send</button>\n</form>\n";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _select = __webpack_require__(497);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function f() {
  'ngInject';

  return {
    template: _select2.default,
    replace: true,
    transclude: true,
    require: 'ngModel',
    scope: {
      ngModel: '=',
      options: '='
    },
    link: {
      pre: function pre($scope, $element, $attrs) {
        var select = $element.find('select');

        select.attr('id', $attrs.id);
        $element.removeAttr('id');

        $scope.optionsEpression = $attrs.optionsExpression;
      },
      post: function post($scope, $element, $attrs, ngModelCtrl) {
        var select = $element.find('select');

        select.on('blur', function () {
          $scope.$apply(function () {
            ngModelCtrl.$setTouched();
          });
        });

        ngModelCtrl.$render = function () {
          $scope.selectValue = ngModelCtrl.$modelValue;
        };

        $scope.$watch('selectValue', function (newValue) {
          ngModelCtrl.$setViewValue(newValue);
        });
      }
    }
  };
}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = "<div class=\"Form-select\">\n  <select ng-model=\"selectValue\" ng-options=\"{{::optionsEpression}}\">\n    <option value=\"\" selected=\"selected\"></option>\n  </select>\n</div>\n";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Transparent image

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saSrcPlaceholder;
var placeholderImage = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

function saSrcPlaceholder() {
  return {
    restrict: 'A',
    link: function link($scope, $element) {
      $element.attr('src', placeholderImage);
    }
  };
}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saStateClass = ['$rootScope', function ($rootScope) {
  return {
    restrict: 'A',
    link: function link($scope, $element) {
      var addedClass;

      function updateClass(cssClass) {
        $element.removeClass(addedClass);
        addedClass = null;

        if (cssClass) {
          $element.addClass(cssClass);
          addedClass = cssClass;
        }
      }

      $rootScope.$on('$stateChangeSuccess', function (event, newState) {
        updateClass(newState.data && newState.data.cssClass);
      });
    }
  };
}];

exports.default = saStateClass;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saStickyBar = ['$window', 'throttle', function ($window, throttle) {
  var windowEl = angular.element($window);

  return {
    restrict: 'A',
    link: function link($scope, $element) {
      var barElement = angular.element($element.children()[0]);
      var setCSS = throttle(function () {
        var isFixed = isBarFixed();
        var height = barElement[0].offsetHeight;

        if (isFixed) {
          $element.css('height', String(height) + 'px');
        } else {
          $element.css('height', null);
        }
      }, 100);

      function isBarFixed() {
        return $window.getComputedStyle(barElement[0], null).getPropertyValue('position') === 'fixed';
      }

      windowEl.on('resize', setCSS);
      $element.on('$destroy', function () {
        windowEl.off('resize', setCSS);
      });

      setCSS();
    }
  };
}];

exports.default = saStickyBar;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saSupportPhoneNumber = ['config', function (config) {
  return {
    template: '<a class="Link Link--blue" ng-href="{{::\'tel://\' + ctrl.phoneNumberLink}}">{{::ctrl.phoneNumber}}</a>',
    replace: true,
    scope: {},
    bindToController: true,
    controllerAs: 'ctrl',
    controller: [function () {
      this.phoneNumber = config.supportPhoneNumber;
      this.phoneNumberLink = config.supportPhoneNumber.replace(/\s/g, '');
    }]
  };
}];

exports.default = saSupportPhoneNumber;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(503);

var UPDATE_INTERVAL = 60000;
var saTimeAgo = ['$translate', '$filter', function ($translate) {
  return {
    restrict: 'A',
    link: function postLink($scope, $element, $attr) {
      var addPrefix = false;
      var isProfile = angular.isDefined($attr.profile);
      var timer;

      function startTimeAgoTimer(time) {
        if (timer) {
          clearInterval(timer);
        }
        timer = setInterval(function () {
          setTimeAgo(time);
        }, UPDATE_INTERVAL);
      }

      function template(translationId, count, withPrefix) {
        var output = $translate.instant('TIMEAGO.' + translationId);

        if (addPrefix || withPrefix) {
          output = $translate.instant('MORE_THAN') + ' ' + output;
        }

        output = output.replace(/%d/i, Math.abs(Math.round(count)));
        return output;
      }

      function updateTimeAgo(time) {
        var limitTo = $attr.limitTo ? new Date($attr.limitTo) : null;
        var timeAgoPart;
        var timeAgo;
        var now;
        var seconds;
        var minutes;
        var hours;
        var days;
        var years;

        if (!time) {
          return;
        }

        time = new Date(time);
        now = new Date();

        if (limitTo && now > limitTo) {
          now = limitTo;
          addPrefix = true;
        }

        seconds = (now - time) / 1000;
        minutes = seconds / 60;
        hours = minutes / 60;
        days = hours / 24;
        years = days / 365;

        if (isProfile) {
          timeAgoPart = template('WEEKS', 2, true);
        } else {
          timeAgoPart = days > 13 && days < 30 && template('WEEKS', days / 7) || days > 30 && days < 60 && template('MONTH', 1) || days > 60 && days < 365 && template('MONTHS', days / 30) || years < 2 && template('YEAR', 1) || template('YEARS', years);
        }

        timeAgo = seconds < 59 && template('MOMENT', seconds) || seconds >= 60 && seconds < 119 && template('MINUTE', 1) || minutes < 59 && template('MINUTES', minutes) || minutes >= 60 && minutes < 119 && template('HOUR', 1) || hours >= 2 && hours < 24 && template('HOURS', hours) || hours > 23 && hours < 48 && template('YESTERDAY', 1) || days > 1 && days < 7 && template('DAYS', days) || days > 6 && days < 13 && template('WEEK', days) || timeAgoPart;

        return timeAgo;
      }

      function setTimeAgo(time) {
        $element.text(updateTimeAgo(time));
      }

      $attr.$observe('saTimeAgo', function (time) {
        var date;

        time = parseFloat(time);
        if (angular.isNumber(time)) {
          date = new Date(time * 1000);
          setTimeAgo(date);
          startTimeAgoTimer(date);
        }
      });

      $scope.$on('$destroy', function () {
        if (timer) {
          clearInterval(timer);
        }
      });
    }
  };
}];

exports.default = saTimeAgo;

/***/ }),
/* 503 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "TIMEAGO": {
    "MOMENT": "a moment ago",
    "MINUTE": "a minute ago",
    "MINUTES": "%d minutes ago",
    "HOUR": "an hour ago",
    "HOURS": "%d hours ago",
    "YESTERDAY": "yesterday",
    "DAYS": "%d days ago",
    "WEEK": "a week ago",
    "WEEKS": "%d weeks ago",
    "MONTH": "a month ago",
    "MONTHS": "%d months ago",
    "YEAR": "a year ago",
    "YEARS": "%d years ago"
  },
  "MORE_THAN": "more than"
}
);  }]);

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saUniqueEmailValidator = ['$q', '$http', 'utils', function ($q, $http, utils) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link($scope, $elementm, $attr, ngModel) {
      ngModel.$asyncValidators.unique = function (modelValue, viewValue) {
        var promise;
        var postData;

        if (!viewValue) {
          promise = $q.resolve();
        } else {
          postData = {
            email: viewValue
          };

          promise = $http.post(utils.getApiUrl('authentication/profile_registration_email_check'), postData).catch(function () {
            return true;
          }).then(function (response) {
            return response.data && response.data.exists ? $q.reject() : $q.resolve();
          });
        }

        return promise;
      };
    }
  };
}];

exports.default = saUniqueEmailValidator;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var saParseNameInput = function saParseNameInput() {
  return {
    restrict: 'A',
    require: ['saParseNameInput', 'ngModel'],
    controller: [function () {
      var ngModel;

      function parseInput(inputValue) {
        var transformedInput = inputValue;

        if (inputValue) {
          transformedInput = transformedInput.replace(/[0-9]/g, '');
          transformedInput = transformedInput.replace(/(.)\1\1/gi, '$1$1');
          transformedInput = transformedInput.replace(/[\\\[\]\^<,\-_"@\/\{\}\(\)\*\$%\?=>:\|;\.!%±~§#'`\+]/i, '');
          transformedInput = transformedInput.charAt(0).toUpperCase() + transformedInput.slice(1);
        }
        if (transformedInput !== inputValue) {
          ngModel.$setViewValue(transformedInput);
          ngModel.$render();
        }

        return inputValue;
      }

      this.init = function (ngModelCtrl) {
        ngModel = ngModelCtrl;
        ngModel.$parsers.push(parseInput);
      };
    }],
    link: function postLink(scope, element, attrs, ctrls) {
      ctrls[0].init(ctrls[1]);
    }
  };
};

exports.default = saParseNameInput;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _suspended = __webpack_require__(507);

var _suspended2 = _interopRequireDefault(_suspended);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

controller.$inject = ['$state', '$window', '$document', '$rootScope', '$element', 'activateGuideAccount', 'navigation', 'userModel', 'throttle', 'settings'];


function controller($state, $window, $document, $rootScope, $element, activateGuideAccount, navigation, userModel, throttle, settings) {
  'ngInject';

  if (!userModel.item.isSuspended) {
    window.location.replace('/');
  }

  // hide navigation and footer
  var navigationEl = navigation.getElement();
  var footerEl = document.getElementsByClassName('Footer')[0];
  var hideNavAndFooter = function hideNavAndFooter() {
    navigationEl.css('display', 'none');
    footerEl.style.display = 'none';
  };

  hideNavAndFooter();
}

var saSuspended = [function () {
  return {
    template: _suspended2.default,
    replace: true,
    scope: {
      done: '&'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saSuspended;

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = "<div style=\"text-align: center\">\n    <h1>Your account is suspended</h1>\n    <h2>If you have any questions please contact our support</h2>\n\n    <div class=\"Info-contacts\" style=\"margin-top: 50px\">\n        <sa-support-email\n                class=\"Link--blue\"\n                sa-contact-button>\n        </sa-support-email>\n    </div>\n\n</div>";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PhotoResource = function () {
  PhotoResource.$inject = ['$q', '$http', 'userModel', 'utils'];

  function PhotoResource($q, $http, userModel, utils) {
    'ngInject';

    _classCallCheck(this, PhotoResource);

    this.$q = $q;
    this.$http = $http;
    this.userModel = userModel;
    this.utils = utils;
  }

  _createClass(PhotoResource, [{
    key: 'uploadFromSocialNetwork',
    value: function uploadFromSocialNetwork(photo) {
      var _this = this;

      var userId = this.userModel.item.id;
      var url = this.utils.getApiUrl('/photos/' + userId + '/upload/file?type=social');

      return new this.$q(function (resolve, reject) {
        _this.$http.post(url, photo).then(function (response) {
          return resolve(response.data);
        }).catch(reject);
      });
    }
  }, {
    key: 'makeMain',
    value: function makeMain(photoId) {
      var _this2 = this;

      return new this.$q(function (resolve, reject) {
        var userId = _this2.userModel.item.id;
        var url = _this2.utils.getApiUrl('/photos/' + userId + '/set_main/' + photoId);

        _this2.$http.post(url).then(resolve).catch(reject);
      });
    }
  }, {
    key: 'rotatePhoto',
    value: function rotatePhoto(photoData) {
      var _this3 = this;

      return new this.$q(function (resolve, reject) {
        var userId = _this3.userModel.item.id;
        var url = _this3.utils.getApiUrl('photos/' + userId + '/rotate');

        _this3.$http.post(url, photoData).then(resolve).catch(reject);
      });
    }
  }, {
    key: 'cropPhoto',
    value: function cropPhoto(photoData) {
      var _this4 = this;

      return new this.$q(function (resolve, reject) {
        var userId = _this4.userModel.item.id;
        var url = _this4.utils.getApiUrl('photos/' + userId + '/crop');

        _this4.$http.post(url, photoData).then(function (response) {
          return resolve(response.data);
        }).catch(reject);
      });
    }
  }, {
    key: 'deletePhoto',
    value: function deletePhoto(photoId) {
      var _this5 = this;

      return new this.$q(function (resolve, reject) {
        var userId = _this5.userModel.item.id;
        var url = _this5.utils.getApiUrl('photos/' + userId + '/delete/' + photoId);

        _this5.$http.delete(url).then(resolve).catch(reject);
      });
    }
  }]);

  return PhotoResource;
}();

exports.default = _angular2.default.module('resources.photo', []).service('photoResource', PhotoResource).name;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trips = function trips($q, $http, utils, userModel, Trip) {
  'ngInject';

  var tripConstructorOptions = {
    getUserId: function getUserId() {
      return userModel.item.id;
    }
  };

  var collection = Trip.collection.get(null, tripConstructorOptions);

  return {
    collection: collection,
    offer: {},
    accept: {},

    reset: function reset() {
      this.collection.reset();
      delete this.lastTripId;
      delete this.hasFailed;
    },
    fetch: function fetch() {
      var _this = this;

      var requestOptions = {};
      requestOptions.params = {};
      if (this.lastTripId) {
        requestOptions.params.lastTripId = this.lastTripId;
      }

      this.isFetching = true;

      return new $q(function (resolve, reject) {
        $http.get(utils.getApiUrlV2('trips/' + userModel.item.id), requestOptions).then(function (response) {
          _this.lastTripId = response.data.lastTripId;
          _this.location = response.data.location;
          _this.count = response.data.count;
          _this.isFilledSettings = response.data.isFilledSettings;
          collection.add(response.data.trips);
          collection.sort();
          resolve(response.data);
        }).catch(function (response) {
          reject(response.data);
          _this.hasFailed = true;
        }).finally(function () {
          return _this.isFetching = false;
        });
      });
    },
    sendOffer: function sendOffer() {
      var _this2 = this;

      var SEND_OFFER_URL = utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + this.offer.visitorId + '/offer_create');
      return new $q(function (resolve, reject) {
        var postData = {
          tripId: _this2.offer.tripId,
          message: _this2.offer.trip.message,
          date: _this2.offer.trip.date,
          meetingTime: _this2.offer.trip.meetingTime,
          hours: _this2.offer.trip.hours
        };
        $http.post(SEND_OFFER_URL, postData).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response.data);
        });
      });
    }
  };
};

trips.$inject = ['$q', '$http', 'utils', 'userModel', 'Trip'];
exports.default = _angular2.default.module('trips.trips', []).service('trips', trips).name;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dashboard = function dashboard($q, $http, utils, userModel, modal) {
  'ngInject';

  return {
    fetch: function fetch() {
      var _this = this;

      var promise = new $q(function (resolve, reject) {
        $http.get(utils.getApiUrl('dashboard/' + userModel.item.id)).then(function (response) {
          var responseData = response.data;

          _this.balance = responseData.balance;
          _this.history = responseData.history;
          _this.account = responseData.account;
          _this.userInfo = responseData.userInfo;
          _this.metaData = responseData.metaData;
          _this.supportedCountries = responseData.supportedCountries;

          resolve();
        }).catch(reject).finally(function () {
          delete _this.isFetching;
        });
      });

      this.isFetching = promise;

      return promise;
    },

    saveBankAccountInfo: function saveBankAccountInfo(billingInfo) {
      var _this2 = this;

      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrl('dashboard/' + userModel.item.id + '/edit'), billingInfo).then(function (response) {
          _this2.userInfo = response.data;
          resolve();
        }).catch(reject);
      });
    },

    payout: function payout() {
      var _this3 = this;

      var postData = {
        bookings: this.balance.availableBookings
      };
      var config = {
        params: {
          type: 'bank'
        }
      };
      var promise = void 0;

      if (!(this.userInfo && this.userInfo.bankAccount && this.userInfo.bankAccount.accountNumber)) {
        promise = this.openBankAccountModal();
      }

      promise = $q.resolve(promise).then(function () {
        return $q(function (resolve, reject) {
          $http.post(utils.getApiUrl('dashboard/' + userModel.item.id + '/payout'), postData, config).then(function (response) {
            var payoutEvent = response.data;

            _this3.balance.available = 0;
            _this3.history.unshift(payoutEvent);

            resolve(response.data);
          }).catch(reject);
        });
      });

      return promise;
    },

    openBankAccountModal: function openBankAccountModal() {
      var modalInstance = modal.open({
        template: '<bank-account-form done="close()"></bank-account-form>',
        closeOnStateChange: true
      });

      return modalInstance.result;
    }
  };
};

dashboard.$inject = ['$q', '$http', 'utils', 'userModel', 'modal'];
exports.default = _angular2.default.module('dashboard.dashboard', []).service('dashboard', dashboard).name;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var notificationSettingsService = function notificationSettingsService($q, $http, userModel, settings, utils) {
  'ngInject';

  return {
    fetch: function fetch() {
      var promises = [];

      promises.push($http.get(utils.getApiUrl('settings/' + userModel.item.id + '/notifications')));
      promises.push(settings.fetch());

      return $q.all(promises).then(function (result) {
        var settingsValues = result[1];

        this.values = result[0].data;

        if (!settings.isValid('email')) {
          delete this.values.email;
        } else {
          this.email = settingsValues.email.value;
        }

        if (!settings.isValid('phone')) {
          delete this.values.phone;
        } else {
          this.phone = settingsValues.phone.value;
        }

        if (!settings.isValid('fbMessengerId')) {
          delete this.values.fbMessengerId;
        } else {
          this.fbMessengerId = settingsValues.fbMessengerId.value;
        }
      }.bind(this));
    },
    save: function save(data) {
      // TODO: refactor checkboxes into dynamic generator for checkbox values
      return $http.post(utils.getApiUrl('settings/' + userModel.item.id + '/notifications'), data).then(function () {
        angular.extend(this.values, data);
      }.bind(this));
    }
  };
};

notificationSettingsService.$inject = ['$q', '$http', 'userModel', 'settings', 'utils'];
exports.default = angular.module('notificationSettings.notificationSettings', []).service('notificationSettings', notificationSettingsService).name;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _activation = __webpack_require__(513);

var _activation2 = _interopRequireDefault(_activation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('activation', []).controller('ActivationController', _activation2.default).name;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$state', '$stateParams', 'auth', 'joinForm', function ($state, $stateParams, auth, joinForm) {
  'ngInject';

  auth.activateAccount($stateParams).then(function () {
    if ($stateParams.redirectUrl) {
      window.location.href = $stateParams.redirectUrl;
    } else {
      $state.go('intro');
    }
  }).catch(function (response) {
    if (response.data.error === 'invalid-request') {
      $state.go('guides.list');
      joinForm();
    }
  });
}];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _autologin = __webpack_require__(515);

var _autologin2 = _interopRequireDefault(_autologin);

var _autologin3 = __webpack_require__(518);

var _autologin4 = _interopRequireDefault(_autologin3);

var _email_autologin = __webpack_require__(519);

var _email_autologin2 = _interopRequireDefault(_email_autologin);

var _verify_email = __webpack_require__(520);

var _verify_email2 = _interopRequireDefault(_verify_email);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('autologin', []).directive('saAutologin', _autologin2.default).factory('autologin', _autologin4.default).controller('EmailAutologinController', _email_autologin2.default).controller('VerifyEmailController', _verify_email2.default).name;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;

var _autologin = __webpack_require__(516);

var _autologin2 = _interopRequireDefault(_autologin);

var _autologin3 = __webpack_require__(517);

var _autologin4 = _interopRequireDefault(_autologin3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function f() {
  return {
    template: _autologin2.default,
    replace: true,
    scope: {},
    bindToController: true,
    controllerAs: 'ctrl',
    controller: _autologin4.default
  };
}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <div class=\"ContentLoader\" ng-if=\"!ctrl.isErrorMessageVisible\">\n    <div class=\"Loader\"></div>\n  </div>\n  <sa-fetch-error-message ng-if=\"ctrl.isErrorMessageVisible\"></sa-fetch-error-message>\n</div>\n";

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var c = function c($stateParams, autologin) {
  'ngInject';

  var _this = this;

  _classCallCheck(this, c);

  autologin.loginWithSMSCode($stateParams.code).catch(function () {
    return _this.isErrorMessageVisible = true;
  });
};

c.$inject = ['$stateParams', 'autologin'];
exports.default = c;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$q', '$http', '$state', 'auth', 'utils'];
function f($q, $http, $state, auth, utils) {
  'ngInject';

  return {
    verifyEmail: function verifyEmail(params) {
      var promise;

      if (verifyParams(params)) {
        promise = $http.get(utils.getApiUrl('authentication/email_validation'), {
          params: params
        });

        promise.then(function (response) {
          auth.setSessionData({
            accessToken: response.data.token,
            userId: response.data.userId
          });
          $state.go('settings');
        });
      } else {
        promise = $q.reject();
      }

      return promise;
    },
    login: function login(params) {
      var promise;

      if (verifyParams(params)) {
        promise = $http.get(utils.getApiUrl('authentication/autologin_validation'), {
          params: params
        });

        promise.then(function (response) {
          auth.setSessionData({
            accessToken: response.data.token,
            userId: response.data.userId
          });

          this.handleAction(params);
        }.bind(this)).catch(function () {
          $state.go('intro');
        });
      } else {
        promise = $q.reject();
      }

      return promise;
    },
    handleAction: function handleAction(params) {
      var redirectTo;
      var stateParams;

      switch (params.action) {
        case 'conversation':
          redirectTo = 'conversations.list';
          break;

        case 'notificationSettings':
          redirectTo = 'notificationSettings';
          break;

        case 'declinedBooking':
          redirectTo = 'guides.list';
          break;

        case 'replyMessage':
          redirectTo = 'conversations.conversation';
          stateParams = {
            conversationId: params.conversationId
          };
          break;

        case 'profileSettings':
          redirectTo = 'settings';
          break;

        case 'new_locals':
          redirectTo = 'guides.list';
          stateParams = params;
          break;

        case 'trips':
          redirectTo = 'guides.trips';
          stateParams = params;
          break;

        case 'browseLocals':
          redirectTo = 'guides.list';
          stateParams = params;
          break;

        case 'referenceRequest':
          redirectTo = 'requestReference';
          break;

        case 'userProfile':
          redirectTo = 'guides.guide';
          stateParams = {
            guideId: params.userId
          };
          break;

        default:
          redirectTo = 'intro';
          break;
      }

      $state.go(redirectTo, stateParams);
    },
    loginWithSMSCode: function loginWithSMSCode(code) {
      var url = utils.getApiUrl('/authentication/sms_autologin/' + code);

      return new $q(function (resolve, reject) {
        $http.get(url).then(function (response) {
          auth.setSessionData({
            accessToken: response.data.token,
            userId: response.data.userId
          });
          $state.go('intro');
          resolve();
        }).catch(reject);
      });
    }
  };
}

var REQUIRED_PARAMS = ['uid', 'code', 'email'];

function verifyParams(params) {
  var isValid = true;

  REQUIRED_PARAMS.forEach(function (paramName) {
    if (!params.hasOwnProperty(paramName)) {
      isValid = false;
    }
  });

  return isValid;
}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EmailAutologinController = ['$state', '$stateParams', 'autologin', function ($state, $stateParams, autologin) {
  autologin.login($stateParams);
}];

exports.default = EmailAutologinController;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VerifyEmailController = ['$stateParams', 'autologin', function ($stateParams, autologin) {
  autologin.verifyEmail($stateParams);
}];

exports.default = VerifyEmailController;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _become_guide = __webpack_require__(522);

var _become_guide2 = _interopRequireDefault(_become_guide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('becomeGuide', []).component('saBecomeGuide', _become_guide2.default).name;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _become_guide = __webpack_require__(523);

var _become_guide2 = _interopRequireDefault(_become_guide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = function controller($window, userModel, becomeGuide, guideStatus) {
  'ngInject';

  this.userModel = userModel.item;

  this.austria = $window.SA.country === 'AT';

  if (userModel.item.id && guideStatus.isGuide()) {
    this.isGuide = true;
  }

  this.becomeGuide = function () {
    becomeGuide();
  };
};

controller.$inject = ['$window', 'userModel', 'becomeGuide', 'guideStatus'];
exports.default = {
  template: _become_guide2.default,
  replace: true,
  controllerAs: 'ctrl',
  controller: controller
};

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = "<div class=\"BecomeGuide\">\n  <div class=\"BecomeGuide-header\">\n    <div class=\"BecomeGuide-header-overlay\"></div>\n\n    <div class=\"BecomeGuide-header-content\">\n      <h1>Sign up as a local</h1>\n      <p>Show travellers around & make extra money</p>\n      <div class=\"BecomeGuide-button\">\n        <button class=\"Button Button--blue Button--large Button--fullWidth\" ng-if=\"!ctrl.isGuide\" ng-click=\"ctrl.becomeGuide()\">Sign up as a local</button>\n        <a class=\"Button Button--blue Button--large Button--fullWidth\" ng-if=\"ctrl.isGuide\" ui-sref=\"settings\">Sign up as a local</a>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"!ctrl.austria\">\n    <div class=\"BecomeGuide-info\">\n      <sa-become-guide-info></sa-become-guide-info>\n    </div>\n\n    <section class=\"BecomeGuide-footer\">\n      <h1>You don’t have to be an expert</h1>\n      <p>All you need is a vibrant personality, an intimate knowledge of your city and a passion for meeting new people.</p>\n      <div class=\"BecomeGuide-button\">\n        <button class=\"Button Button--blue Button--large Button--fullWidth\" ng-if=\"!ctrl.isGuide\" ng-click=\"ctrl.becomeGuide()\">Sign up as a local</button>\n        <a class=\"Button Button--blue Button--large Button--fullWidth\" ng-if=\"ctrl.isGuide\" ui-sref=\"settings\">Sign up as a local</a>\n      </div>\n    </section>\n  </div>\n</div>\n";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _forgot_password = __webpack_require__(525);

var _forgot_password2 = _interopRequireDefault(_forgot_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('forgotPassword', []).directive('saForgotPassword', _forgot_password2.default).name;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _forgot_password = __webpack_require__(526);

var _forgot_password2 = _interopRequireDefault(_forgot_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMAIL_ERROR = 'email-not-exists';
var controller = ['$stateParams', 'password', 'auth', function ($stateParams, password, auth) {
  this.resetPassword = function () {
    this.isLoading = true;
    delete this.isWrongEmail;
    delete this.isEmailSent;

    auth.sendPasswordResetLink(this.email).then(function () {
      this.resetPasswordForm.$setUntouched();
      this.resetPasswordForm.$setPristine();
      this.passwordResetEmail = this.email;
      delete this.email;
    }.bind(this)).catch(function (response) {
      var status = response.status;
      var error = response && response.data && response.data.error;

      if (status === 400 && error === EMAIL_ERROR) {
        this.isWrongEmail = true;
      }
    }.bind(this)).finally(function () {
      delete this.isLoading;
    }.bind(this));
  };
}];
var saForgotPassword = [function () {
  return {
    template: _forgot_password2.default,
    replace: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saForgotPassword;

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = "<div class=\"PasswordForm\">\n  <h1>Reset password</h1>\n\n  <div class=\"PasswordForm-form\">\n    <form class=\"Form Form--wide Form--transparent\" name=\"ctrl.resetPasswordForm\" novalidate ng-submit=\"ctrl.resetPasswordForm.$valid && ctrl.resetPassword()\">\n      <p class=\"Form-error Form-error--centered\" ng-if=\"ctrl.isWrongEmail\">Email does not exist</p>\n\n      <input class=\"Form-field\" id=\"emailField\" type=\"email\" name=\"email\" placeholder=\"Email\"\n             ng-model=\"ctrl.email\"\n             required\n             sa-email-validator>\n      <div class=\"Form-validationErrors\" ng-messages=\"ctrl.resetPasswordForm.email.$error\">\n        <p class=\"Form-validationError\" ng-message=\"required\">{{::'FORM_ERRORS.COMMON.REQUIRED' | translate}}</p>\n        <p class=\"Form-validationError\" ng-message=\"pattern\">{{::'FORM_ERRORS.EMAIL.PATTERN' | translate}}</p>\n      </div>\n\n      <div class=\"PasswordForm-submit\">\n        <button class=\"Button Button--fullWidth\" type=\"submit\" ng-disabled=\"ctrl.isLoading || ctrl.passwordResetEmail\" sa-button-loader=\"ctrl.isLoading\">Reset password</button>\n      </div>\n    </form>\n  </div>\n\n  <div class=\"PasswordForm-message\" ng-if=\"ctrl.passwordResetEmail\">\n    <p>An e-mail with password reset instructions has been sent to</p>\n    <p><strong>{{ctrl.passwordResetEmail}}</strong></p>\n  </div>\n</div>\n";

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _join = __webpack_require__(528);

var _join2 = _interopRequireDefault(_join);

var _join_form = __webpack_require__(531);

var _join_form2 = _interopRequireDefault(_join_form);

var _join_option_button = __webpack_require__(533);

var _join_option_button2 = _interopRequireDefault(_join_option_button);

var _join_options = __webpack_require__(535);

var _join_options2 = _interopRequireDefault(_join_options);

var _sign_in_form = __webpack_require__(537);

var _sign_in_form2 = _interopRequireDefault(_sign_in_form);

var _sign_up_form = __webpack_require__(539);

var _sign_up_form2 = _interopRequireDefault(_sign_up_form);

var _join_form3 = __webpack_require__(541);

var _join_form4 = _interopRequireDefault(_join_form3);

__webpack_require__(542);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('join', []).directive('saJoin', _join2.default).directive('saJoinForm', _join_form2.default).directive('saJoinOptionButton', _join_option_button2.default).directive('saJoinOptions', _join_options2.default).directive('saSignInForm', _sign_in_form2.default).directive('saSignUpForm', _sign_up_form2.default).factory('joinForm', _join_form4.default).name;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _join = __webpack_require__(529);

var _join2 = _interopRequireDefault(_join);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOCAL_STORAGE_KEY = 'joinOption';

var controller = ['$window', 'social', 'vk', 'localStorage', function ($window, social, vk, localStorage) {
  this.setJoinOption = function (option) {
    switch (option) {
      case 'email':
        this.isJoinFormVisible = true;
        break;

      case 'vk':
        $window.location = vk.getAuthUrl();
        break;

      default:
        this.connectWithSocial(option);
        break;
    }
  };

  this.connectWithSocial = function (socialNetworkName) {
    var _this = this;

    this.isLoading = true;

    social.login(socialNetworkName).then(function (result) {
      _this.onSuccess({
        result: result
      });
    }).catch(function () {
      delete _this.isLoading;
    });
  };

  this.isSocial = function () {
    return localStorage.get(LOCAL_STORAGE_KEY) === 'vk' || localStorage.get(LOCAL_STORAGE_KEY) === 'fb';
  };
}];
var saJoin = [function () {
  return {
    template: _join2.default,
    replace: true,
    scope: {
      onSuccess: '&',
      userType: '@',
      newDesign: '@'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saJoin;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div>\n  <div ng-switch=\"ctrl.newDesign\">\n      <div ng-switch-when=\"fbIntro\">\n        <div class=\"Join\" ng-if=\"!ctrl.isJoinFormVisible\">\n          <div class=\"Intro-Center\">\n            <img src=\"" + __webpack_require__(530) + "\" class=\"Modal--Logo\" />\n            <h1>Sign up to connect with locals</h1>\n          </div>\n\n          <div class=\"Join-options\">\n            <sa-join-options ng-if=\"!ctrl.isLoading\" done=\"ctrl.setJoinOption(option)\"></sa-join-options>\n            <div class=\"Join-loader\" ng-if=\"ctrl.isLoading\">\n              <div class=\"Loader\"></div>\n            </div>\n          </div>\n\n          <a class=\"Link-Maybe-Later\" ng-click=\"ctrl.onSuccess()\">Maybe later</a>\n        </div>\n        <sa-join-form ng-if=\"ctrl.isJoinFormVisible\" done=\"ctrl.onSuccess()\"></sa-join-form>\n\n      </div>\n      <div ng-switch-default>\n        <div class=\"Join\" ng-if=\"!ctrl.isJoinFormVisible\">\n          <!-- Everyone is a local -->\n          <!-- <div ng-switch=\"ctrl.userType\">\n            <h2 ng-switch-when=\"guide\">You’re just a few steps away from becoming a local!</h2>\n            <h2 ng-switch-when=\"guest\">You need to sign up to book a local</h2>\n          </div> -->\n          <h1>Connect with your social account or email</h1>\n\n          <div class=\"Join-options\">\n            <sa-join-options ng-if=\"!ctrl.isLoading\" done=\"ctrl.setJoinOption(option)\"></sa-join-options>\n            <div class=\"Join-loader\" ng-if=\"ctrl.isLoading\">\n              <div class=\"Loader\"></div>\n            </div>\n          </div>\n\n          <p ng-if=\"ctrl.isSocial()\">We won’t post anything on your behalf without your permission.</p>\n\n          <hr>\n\n          <p class=\"Join-terms\">I confirm that I agree with Showaround’s <a class=\"Link Link--blue\" ui-sref=\"info.terms\">Terms of Service</a> and <a class=\"Link Link--blue\" ui-sref=\"info.privacy\">Privacy Policy</a>.</p>\n        </div>\n\n        <sa-join-form ng-if=\"ctrl.isJoinFormVisible\" done=\"ctrl.onSuccess()\"></sa-join-form>\n      </div>\n  </div>\n\n\n</div>\n";

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/13624bd089e5a7b17ab5215961f534bd.png";

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _join_form = __webpack_require__(532);

var _join_form2 = _interopRequireDefault(_join_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOCAL_STORAGE_KEY = 'hasEmailLogin';
var controller = ['localStorage', function (localStorage) {
  this.isNewUser = localStorage.get(LOCAL_STORAGE_KEY) !== 'true';

  this.close = function () {
    localStorage.set(LOCAL_STORAGE_KEY, true);
    this.done();
  };
}];
var saJoinForm = [function () {
  return {
    template: _join_form2.default,
    replace: true,
    scope: {
      done: '&'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saJoinForm;

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports = "<div class=\"JoinForm\">\n  <h1>Connect with your email</h1>\n  <div class=\"JoinForm-tabs\">\n    <span class=\"JoinForm-tab\" ng-class=\"{ 'is-active': !ctrl.isNewUser}\" ng-click=\"ctrl.isNewUser = false\">\n      <span class=\"JoinForm-tabBubble\"></span>\n      <span>Existing user</span>\n    </span>\n    <span class=\"JoinForm-tab\" ng-class=\"{ 'is-active': ctrl.isNewUser}\" ng-click=\"ctrl.isNewUser = true\">\n      <span class=\"JoinForm-tabBubble\"></span>\n      <span>Create new user</span>\n    </span>\n  </div>\n\n  <div class=\"JoinForm-form\">\n    <sa-sign-in-form ng-if=\"!ctrl.isNewUser\" data=\"ctrl.userData\" done=\"ctrl.close()\"></sa-sign-in-form>\n    <sa-sign-up-form ng-if=\"ctrl.isNewUser\" data=\"ctrl.userData\" done=\"ctrl.close()\"></sa-sign-up-form>\n  </div>\n</div>\n";

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _join_option_button = __webpack_require__(534);

var _join_option_button2 = _interopRequireDefault(_join_option_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = ['$q', '$element', 'social', function ($q, $element, social) {
  this.fetchScripts = function () {
    this.isLoadingScript = true;

    social.fetchScripts(this.options.name).finally(function () {
      delete this.isLoadingScript;
    }.bind(this));
  };

  if (this.options.social) {
    this.fetchScripts();
  }
}];
var saJoinOptionButton = [function () {
  return {
    template: _join_option_button2.default,
    replace: true,
    scope: {
      options: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saJoinOptionButton;

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = "<button class=\"Button Button--fullWidth Button--icon Button--join Button--large\" ng-class=\"ctrl.options.cssClass\" ng-disabled=\"ctrl.isLoadingScript\">\n  <div class=\"Join-loader\" ng-if=\"ctrl.isLoadingScript\">\n    <div class=\"Loader\"></div>\n  </div>\n  <span><i class=\"Icon\" ng-class=\"ctrl.options.iconCssClass\"></i></span>\n  Connect with {{ctrl.options.displayName}}\n</button>\n";

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _join_options = __webpack_require__(536);

var _join_options2 = _interopRequireDefault(_join_options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOCAL_STORAGE_KEY = 'joinOption';
var BUTTON_CONFIG = {
  fb: {
    cssClass: 'Button--fb',
    iconCssClass: 'Icon-fb',
    name: 'fb',
    displayName: 'Facebook',
    social: true
  },
  vk: {
    cssClass: 'Button--vk',
    iconCssClass: 'Icon-vk',
    name: 'vk',
    displayName: 'VKontakte',
    social: true
  },
  email: {
    cssClass: 'Button--email Button--orange2',
    iconCssClass: 'Icon-envelopeInverted',
    name: 'email',
    displayName: 'your email'
  }
};
var controller = ['social', 'localStorage', function (social, localStorage) {
  var mainOption = localStorage.get(LOCAL_STORAGE_KEY);

  if (!BUTTON_CONFIG[mainOption]) {
    mainOption = social.getUserSocialNetwork();
  }

  this.mainButton = BUTTON_CONFIG[mainOption];
  this.otherButtons = Object.keys(BUTTON_CONFIG).filter(function (optionName) {
    return optionName !== mainOption;
  }).map(function (optionName) {
    return BUTTON_CONFIG[optionName];
  });

  this.selectOption = function (option) {
    this.done({
      option: option.name
    });

    // Save last selected option
    localStorage.set(LOCAL_STORAGE_KEY, option.name);
  };
}];
var saJoinOptions = [function () {
  return {
    template: _join_options2.default,
    replace: true,
    scope: {
      done: '&'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saJoinOptions;

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = "<div class=\"JoinOptions\">\n  <div class=\"JoinOptions-wrapper\">\n    <div class=\"JoinOptions-button\">\n      <sa-join-option-button options=\"ctrl.mainButton\" ng-click=\"ctrl.selectOption(ctrl.mainButton)\"></sa-join-option-button>\n    </div>\n\n    <div class=\"JoinOptions-button\">\n      <button class=\"Button Button--fullWidth Button--inverted Button--dropdown Button--siam Button--noTextTransform Button--large\" ng-click=\"ctrl.isPopoverVisible = !ctrl.isPopoverVisible\">\n        Show other options\n      </button>\n    </div>\n\n    <div class=\"Popover Popover--bottom\" ng-if=\"ctrl.isPopoverVisible\" sa-on-click-outside=\"ctrl.isPopoverVisible = false;\">\n      <div class=\"JoinOptionsPopover\">\n        <div class=\"JoinOptionsPopover-button\" ng-repeat=\"buttonOptions in ctrl.otherButtons\">\n          <sa-join-option-button options=\"buttonOptions\" ng-click=\"ctrl.selectOption(buttonOptions)\"></sa-join-option-button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sign_in_form = __webpack_require__(538);

var _sign_in_form2 = _interopRequireDefault(_sign_in_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = ['auth', function (auth) {
  this.submit = function () {
    this.isLoading = true;
    this.isAuthErrorVisible = false;

    auth.signInWithEmail(this.data).then(function () {
      this.done();
    }.bind(this)).catch(function () {
      this.isAuthErrorVisible = true;
    }.bind(this)).finally(function () {
      delete this.isLoading;
    }.bind(this));
  };
}];
var saSignInForm = [function () {
  return {
    template: _sign_in_form2.default,
    replace: true,
    scope: {
      done: '&',
      data: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saSignInForm;

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = "<form class=\"Form Form--wide Form--transparent\" name=\"ctrl.signInForm\" ng-submit=\"ctrl.signInForm.$valid && ctrl.submit()\" novalidate>\n  <p class=\"Form-error Form-error--centered\" ng-if=\"ctrl.isAuthErrorVisible\">{{::'JOIN.WRONG_EMAIL_PASSWORD' | translate}}</p>\n\n  <input class=\"Form-field\" type=\"email\" placeholder=\"Email address\" name=\"email\"\n         ng-model=\"ctrl.data.email\"\n         required\n         sa-email-validator>\n  <div class=\"Form-validationErrors\" ng-messages=\"ctrl.signInForm.email.$error\">\n    <p class=\"Form-validationError\" ng-message=\"required\">{{::'FORM_ERRORS.COMMON.REQUIRED' | translate}}</p>\n    <p class=\"Form-validationError\" ng-message=\"pattern\">{{::'FORM_ERRORS.EMAIL.PATTERN' | translate}}</p>\n  </div>\n\n  <input class=\"Form-field\" type=\"password\" placeholder=\"Password\" name=\"password\"\n         ng-model=\"ctrl.data.password\"\n         required>\n  <div class=\"Form-validationErrors\" ng-messages=\"ctrl.signInForm.password.$error\">\n    <p class=\"Form-validationError\" ng-message=\"required\">{{::'FORM_ERRORS.COMMON.REQUIRED' | translate}}</p>\n  </div>\n\n  <div class=\"JoinForm-forgotPassword\">\n    <a class=\"Link Link--blue Link--semiBold\" ui-sref=\"forgotPassword\">Forgot password?</a>\n  </div>\n\n  <div class=\"JoinForm-submit\">\n    <button class=\"Button Button--fullWidth\" type=\"submit\" sa-button-loader=\"ctrl.isLoading\" ng-disabled=\"ctrl.isLoading\">Login</button>\n  </div>\n</form>\n";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sign_up_form = __webpack_require__(540);

var _sign_up_form2 = _interopRequireDefault(_sign_up_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMAIL_EXISTS_ERROR = 'email-exists';
var controller = ['auth', 'accountActivationModal', 'config', function (auth, accountActivationModal, config) {
  var _this = this;

  this.data = {};

  grecaptcha.render('recaptcha-container', {
    'sitekey': config.recaptcha.siteKey,
    callback: function callback(token) {
      _this.data.token = token;
      _this.signUpForm.token.$setValidity('valid', true);
      _this.signUpForm.token.$setValidity('required', true);
    }
  });

  this.submit = function () {
    this.isLoading = true;

    auth.signUpWithEmail(this.data).then(function () {
      accountActivationModal.open();
      this.done();
    }.bind(this)).catch(function (response) {
      var status = response.status;
      var error = response.data && response.data.error;
      this.data.token = '';

      if (status === 400 && error === EMAIL_EXISTS_ERROR) {
        this.signUpForm.email.$setValidity('unique', false);
      } else if (status === 400 && error === CAPTCHA_ERROR) {
        this.signUpForm.token.$setValidity('valid', false);
        grecaptcha.reset();
      }
    }.bind(this)).finally(function () {
      delete this.isLoading;
    }.bind(this));
  };
}];

function saSignUpForm() {
  return {
    template: _sign_up_form2.default,
    replace: true,
    scope: {
      done: '&',
      data: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}

exports.default = saSignUpForm;

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports = "<form\n  class=\"Form Form--wide Form--transparent\"\n  name=\"ctrl.signUpForm\"\n  ng-submit=\"ctrl.signUpForm.$valid && ctrl.submit()\"\n  novalidate\n>\n  <input\n    class=\"Form-field\"\n    type=\"text\"\n    placeholder=\"Name\"\n    name=\"name\"\n    ng-model=\"ctrl.data.name\"\n    sa-parse-name-input\n    minlength=\"2\"\n    maxlength=\"20\"\n    required\n  />\n  <div class=\"Form-validationErrors\" ng-messages=\"ctrl.signUpForm.name.$error\">\n    <p class=\"Form-validationError\" ng-message=\"required\">\n      {{::'FORM_ERRORS.COMMON.REQUIRED' | translate}}\n    </p>\n    <p class=\"Form-validationError\" ng-message=\"minlength\">\n      {{::'FORM_ERRORS.NAME.MIN_LENGTH' | translate}}\n    </p>\n    <p class=\"Form-validationError\" ng-message=\"maxlength\">\n      {{::'FORM_ERRORS.NAME.MAX_LENGTH' | translate}}\n    </p>\n  </div>\n\n  <input\n    class=\"Form-field\"\n    type=\"email\"\n    placeholder=\"Email address\"\n    name=\"email\"\n    ng-model=\"ctrl.data.email\"\n    ng-model-options=\"{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }\"\n    required\n    sa-email-validator\n  />\n  <div class=\"Form-validationErrors\" ng-messages=\"ctrl.signUpForm.email.$error\">\n    <p class=\"Form-validationError\" ng-message=\"required\">\n      {{::'FORM_ERRORS.COMMON.REQUIRED' | translate}}\n    </p>\n    <p class=\"Form-validationError\" ng-message=\"pattern\">\n      {{::'FORM_ERRORS.EMAIL.PATTERN' | translate}}\n    </p>\n    <p class=\"Form-validationError\" ng-message=\"unique\">\n      {{::'FORM_ERRORS.EMAIL.UNIQUE' | translate}}\n    </p>\n  </div>\n\n  <input\n    class=\"Form-field\"\n    type=\"password\"\n    placeholder=\"Password\"\n    name=\"password\"\n    ng-model=\"ctrl.data.password\"\n    required\n    minlength=\"6\"\n    maxlength=\"40\"\n  />\n  <div\n    class=\"Form-validationErrors\"\n    ng-messages=\"ctrl.signUpForm.password.$error\"\n  >\n    <p class=\"Form-validationError\" ng-message=\"required\">\n      {{::'FORM_ERRORS.COMMON.REQUIRED' | translate}}\n    </p>\n    <p class=\"Form-validationError\" ng-message=\"minlength\">\n      {{::'FORM_ERRORS.PASSWORD.MIN_LENGTH' | translate}}\n    </p>\n    <p class=\"Form-validationError\" ng-message=\"maxlength\">\n      {{::'FORM_ERRORS.PASSWORD.MAX_LENGTH' | translate}}\n    </p>\n  </div>\n\n  <div id=\"recaptcha-container\" class=\"margin-top\"></div>\n\n  <input type=\"hidden\" name=\"token\" ng-model=\"ctrl.data.token\" required />\n  <div class=\"Form-validationErrors\" ng-messages=\"ctrl.signUpForm.token.$error\">\n    <p class=\"Form-validationError\" ng-message=\"valid\">\n      {{::'FORM_ERRORS.CAPTCHA.VALID' | translate}}\n    </p>\n    <p class=\"Form-validationError\" ng-message=\"required\">\n      {{::'FORM_ERRORS.COMMON.REQUIRED' | translate}}\n    </p>\n  </div>\n\n  <div class=\"JoinForm-submit\">\n    <button\n      class=\"Button Button--fullWidth\"\n      type=\"submit\"\n      sa-button-loader=\"ctrl.isLoading\"\n      ng-disabled=\"ctrl.isLoading\"\n    >\n      Sign Up\n    </button>\n  </div>\n</form>\n";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['modal', function (modal) {
  'ngInject';

  return function () {
    return modal.open({
      template: '<sa-join-form done="close()"></sa-join-form>'
    }).result;
  };
}];

/***/ }),
/* 542 */
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "JOIN": {
    "WRONG_EMAIL_PASSWORD": "Wrong email or password"
  }
}
);  }]);

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _mailing = __webpack_require__(544);

var _mailing2 = _interopRequireDefault(_mailing);

var _mailing3 = __webpack_require__(545);

var _mailing4 = _interopRequireDefault(_mailing3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('mailing', []).controller('MailingController', _mailing2.default).factory('mailing', _mailing4.default).name;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MailingController = ['$stateParams', 'mailing', function ($stateParams, mailing) {
  mailing.handleRedirect($stateParams);
}];

exports.default = MailingController;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var mailing = ['$state', function ($state) {
  return {
    handleRedirect: function handleRedirect(params) {
      var redirectTo;

      switch (params.page) {
        case 'support':
          redirectTo = 'info.contact';
          break;

        case 'privacy-policy':
          redirectTo = 'info.privacy';
          break;

        case 'terms-and-conditions':
          redirectTo = 'info.terms';
          break;

        case 'guide-tips':
          redirectTo = 'info.adviceForGuide';
          break;

        case 'guest-tips':
          redirectTo = 'info.bookingAdvice';
          break;

        default:
          redirectTo = 'intro';
          break;
      }

      $state.go(redirectTo);
    }
  };
}];

exports.default = mailing;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _membership = __webpack_require__(547);

var _membership2 = _interopRequireDefault(_membership);

var _cancel_membership_modal = __webpack_require__(550);

var _cancel_membership_modal2 = _interopRequireDefault(_cancel_membership_modal);

var _cancel_membership_service = __webpack_require__(554);

var _cancel_membership_service2 = _interopRequireDefault(_cancel_membership_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('membership', []).component('saMembership', _membership2.default).component('saCancelMembershipModal', _cancel_membership_modal2.default).factory('cancelMembershipService', _cancel_membership_service2.default).name;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _membership = __webpack_require__(548);

var _membership2 = _interopRequireDefault(_membership);

var _membership3 = __webpack_require__(549);

var _membership4 = _interopRequireDefault(_membership3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: _membership2.default,
  replace: true,
  controllerAs: 'ctrl',
  controller: _membership4.default
};

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports = "<div class=\"Membership\">\n  <h1>Traveller's subscription</h1>\n\n  <div ng-if=\"!ctrl.isLoading\">\n    <div class=\"Membership-expires\">\n      <div ng-if=\"ctrl.userModel.item.membership.recurring\">\n        <div class=\"Membership-type\">\n          You are currently subscribed for a <strong>{{ctrl.userModel.item.membership.recurring.type}} traveller's subscription</strong>\n        </div>\n        <p>For the next payment, your card will be automatically charged on:&nbsp;<strong>{{ ctrl.expires | bookingDate:true}}</strong></p>\n        <button class=\"Button Button--inverted Button--gray3 Membership-Cancel\"\n          ng-click=\"ctrl.cancelSubscription()\" sa-button-loader=\"ctrl.loading\" loader-class=\"Loader--blue Loader--small\">\n          Cancel Subscription\n        </button>\n      </div>\n      <div ng-if=\"!ctrl.userModel.item.membership.recurring\">\n        You've cancelled your traveller's subscription. You can continue using the service until it expires on: <strong>{{ ctrl.expires | bookingDate:true}}</strong>\n      </div>\n    </div>\n  </div>\n\n  <sa-content-loader ng-if=\"ctrl.isLoading\"></sa-content-loader>\n</div>\n";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MembershipCtrl = function MembershipCtrl(userModel, cancelMembershipService) {
  'ngInject';

  _classCallCheck(this, MembershipCtrl);

  this.userModel = userModel;
  this.expires = this.userModel.item.membership.expires;

  this.cancelSubscription = function () {
    var _this = this;

    this.loading = true;
    cancelMembershipService.open().then(function () {
      _this.userModel.item.membership.recurring = false;
    }).finally(function () {
      _this.loading = false;
    });
  };
};

MembershipCtrl.$inject = ['userModel', 'cancelMembershipService'];
exports.default = MembershipCtrl;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(551);

var _cancel_membership_modal = __webpack_require__(553);

var _cancel_membership_modal2 = _interopRequireDefault(_cancel_membership_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {
    done: '&',
    decline: '&',
    reasons: '<'
  },
  template: _cancel_membership_modal2.default,
  controller: ['$scope', 'membership', function controller($scope, membership) {
    'ngInject';

    var _this = this;

    this.$onInit = function () {
      _this.membership = membership;

      // code for some selected
      $scope.formReasons = $scope.formReasons || {};
      for (var prop in _this.reasons) {
        $scope.formReasons[prop.value] = false;
      }
      var calculateSomeSelected = function calculateSomeSelected() {
        $scope.someSelected = Object.keys($scope.formReasons).some(function (key) {
          return $scope.formReasons[key];
        });

        return $scope.someSelected;
      };
      $scope.checkboxChanged = calculateSomeSelected;
      $scope.someSelected = true;
    };

    this.unsubscribe = function () {
      _this.loading = true;
      _this.membership.cancelSubscription($scope.formReasons, _this.message).then(function () {
        _this.done();
      });
    };
  }]
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(552);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(12)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--6-1!../../../../../node_modules/sass-loader/lib/loader.js??ref--6-2!./cancel_membership_modal.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--6-1!../../../../../node_modules/sass-loader/lib/loader.js??ref--6-2!./cancel_membership_modal.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)();
exports.push([module.i, ".CancelMembershipModal{max-width:565px}.CancelMembershipModal-header{font-weight:600;padding:20px;color:#555}.CancelMembershipModal-body{background:#f0f2e9;border-top:1px solid #eaede9;border-bottom:1px solid #eaede9;padding:20px}.CancelMembershipModal-body .Checkbox{color:#666;margin-top:0;margin-bottom:10px}.CancelMembershipModal-body label{font-size:15px}.CancelMembershipModal-textarea{display:block;width:100%;max-width:500px;padding:12px;border:1px solid #aaa;border-radius:4px;font-size:14px;font-weight:600;color:#323337;resize:none;margin-top:12px}.CancelMembershipModal-footer{width:200px;margin:0 auto;padding:5px 0}@media (min-width:740px){.CancelMembershipModal-footer{width:465px;padding:20px 0}}.CancelMembershipModal-button{margin:5px 0;width:200px;height:42px}@media (min-width:740px){.CancelMembershipModal-button{margin:0 12px}}", ""]);

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = "<div class=\"CancelMembershipModal\">\n  <div class=\"CancelMembershipModal-header\">\n  Please choose or specify the reason for cancelling your subscription. Your feedback helps us to improve the website and user experience.\n  </div>\n\n  <form name=\"cancelForm\" ng-submit=\"checkboxChanged() && cancelForm.$valid && $ctrl.unsubscribe()\" novalidate>\n    <div class=\"CancelMembershipModal-body\">\n      <div ng-class=\"{ 'error' : cancelForm.formReasons.$error }\">\n        <div class=\"Checkbox\" ng-repeat=\"reason in $ctrl.reasons\"><input id=\"{{reason.value}}\" name=\"formReasons\" type=\"checkbox\" ng-model=\"formReasons[reason.value]\" ng-change=\"checkboxChanged()\" ng-required=\"!someSelected\">\n      <label for=\"{{reason.value}}\">{{reason.label}}</label></div>\n      </div>\n      <div class=\"Form-validationErrors\" ng-messages=\"cancelForm.formReasons.$error\">\n        <p class=\"Form-validationError\" ng-message=\"required\">{{::'SETTINGS_ERRORS.REQUIRED_ONE' | translate}}</p>\n      </div>\n\n      <textarea class=\"CancelMembershipModal-textarea\" name=\"message\"\n        placeholder=\"Tell us what you think...\"\n        msd-elastic\n        sa-cursor\n        ng-model=\"$ctrl.message\"></textarea>\n    </div>\n\n    <div class=\"CancelMembershipModal-footer\">\n      <button type=\"submit\" class=\"Button CancelMembershipModal-button\" sa-button-loader=\"$ctrl.loading\">\n        Yes, unsubscribe\n      </button>\n\n      <div ng-click=\"$ctrl.decline()\" class=\"Button Button--gray CancelMembershipModal-button\">\n        Not now\n      </div>\n    </div>\n  </form>\n</div>\n";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$http', '$q', '$rootScope', '$timeout', 'userModel', 'utils', 'modal'];
function f($http, $q, $rootScope, $timeout, userModel, utils, modal) {
  'ngInject';

  return {
    open: function open() {
      return new $q(function (resolve) {
        var url = utils.getApiUrl('/membership/' + userModel.item.id + '/cancellation_reasons');
        $http.get(url).then(function (response) {
          var scope = $rootScope.$new();
          scope.reasons = response.data.subscriptionCancelOptions;
          return resolve(modal.open({
            template: '<sa-cancel-membership-modal done="close()" decline="dismiss()" reasons="reasons"></sa-cancel-membership-modal>',
            scope: scope
          }).result);
        });
      });
    }
  };
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _password_form = __webpack_require__(556);

var _password_form2 = _interopRequireDefault(_password_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('passwordForm', []).directive('saPasswordForm', _password_form2.default).name;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _password_form = __webpack_require__(557);

var _password_form2 = _interopRequireDefault(_password_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = function controller($scope, $state, $stateParams, password, userModel, systemAlerts, auth) {
  'ngInject';

  var isResettingPassword = false;
  var successfullPasswordChange = 'Password successfully changed';

  function transitionToSettings() {
    $state.go('settings').then(function () {
      systemAlerts.success(successfullPasswordChange);
    });
  }

  this.verifyParams = function () {
    this.isVerifying = true;

    password.verifyPasswordResetParams($stateParams).then(function () {
      isResettingPassword = true;
    }).catch(function () {
      $state.go('forgotPassword');
    }.bind(this)).finally(function () {
      delete this.isVerifying;
    }.bind(this));
  };

  this.submit = function () {
    this.isLoading = true;

    (isResettingPassword ? password.resetPassword : password.changePassword)(angular.copy(this.data), $stateParams).then(function (r) {
      if (isResettingPassword) {
        auth.manualLogin(r).then(function () {
          transitionToSettings();
        });
      } else {
        transitionToSettings();
      }
    });
  };

  this.checkPassword = function () {
    var password = this.data && this.data.password;
    var passwordRepeated = this.passwordRepeat;

    if (password && passwordRepeated !== password) {
      this.passwordForm && this.passwordForm.passwordRepeat.$setValidity('match', false);
    } else {
      this.passwordForm && this.passwordForm.passwordRepeat.$setValidity('match', true);
    }
  };

  $scope.$watch('ctrl.data.password', this.checkPassword.bind(this));
  $scope.$watch('ctrl.passwordRepeat', this.checkPassword.bind(this));

  if ($stateParams.uid && $stateParams.code && $stateParams.email) {
    this.verifyParams($stateParams);
  } else if (!userModel.item.id) {
    $state.go('forgotPassword');
  } else {
    this.hasPassword = $stateParams.create !== 'true';
  }
};

controller.$inject = ['$scope', '$state', '$stateParams', 'password', 'userModel', 'systemAlerts', 'auth'];
var saPasswordForm = [function () {
  return {
    template: _password_form2.default,
    replace: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saPasswordForm;

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = "<div class=\"PasswordForm\">\n  <h1>Change your password</h1>\n\n  <div class=\"PasswordForm-form\">\n    <form class=\"Form Form--wide Form--transparent\" name=\"ctrl.passwordForm\" novalidate ng-submit=\"ctrl.passwordForm.$valid && ctrl.submit()\">\n      <input class=\"Form-field\" type=\"password\" name=\"currentPassword\" placeholder=\"Current password\"\n             ng-if=\"ctrl.hasPassword\"\n             ng-model=\"ctrl.data.currentPassword\"\n             required>\n      <div class=\"Form-validationErrors\" ng-messages=\"ctrl.passwordForm.password.$error\">\n        <p class=\"Form-validationError\" ng-message=\"required\">{{::'FORM_ERRORS.COMMON.REQUIRED' | translate}}</p>\n      </div>\n\n      <input class=\"Form-field\" type=\"password\" name=\"password\" placeholder=\"New password\"\n             ng-model=\"ctrl.data.password\"\n             required\n             minlength=\"6\"\n             maxlength=\"40\">\n      <div class=\"Form-validationErrors\" ng-messages=\"ctrl.passwordForm.password.$error\">\n        <p class=\"Form-validationError\" ng-message=\"required\">{{::'FORM_ERRORS.COMMON.REQUIRED' | translate}}</p>\n        <p class=\"Form-validationError\" ng-message=\"minlength\">{{::'FORM_ERRORS.PASSWORD.MIN_LENGTH' | translate}}</p>\n        <p class=\"Form-validationError\" ng-message=\"maxlength\">{{::'FORM_ERRORS.PASSWORD.MAX_LENGTH' | translate}}</p>\n      </div>\n\n      <input class=\"Form-field\" type=\"password\" name=\"passwordRepeat\" ng-model=\"ctrl.passwordRepeat\" placeholder=\"Repeat new password\">\n      <div class=\"Form-validationErrors\" ng-messages=\"ctrl.passwordForm.passwordRepeat.$error\">\n        <p class=\"Form-validationError\" ng-message=\"match\">{{::'FORM_ERRORS.PASSWORD.MATCH' | translate}}</p>\n      </div>\n\n      <div class=\"PasswordForm-submit\">\n        <button class=\"Button Button--fullWidth\" type=\"submit\" ng-disabled=\"ctrl.isLoading || ctrl.hasPasswordChanged\" sa-button-loader=\"ctrl.isLoading\">Save password</button>\n      </div>\n    </form>\n  </div>\n</div>\n";

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _login_history = __webpack_require__(559);

var _login_history2 = _interopRequireDefault(_login_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('loginHistory', []).directive('saLoginHistory', _login_history2.default).name;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _login_history = __webpack_require__(560);

var _login_history2 = _interopRequireDefault(_login_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = function controller($scope, userModel) {
  'ngInject';

  var self = this;
  this.parser = {};
  new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(61)]; (function (UAParser) {
    self.parser = new UAParser();
  }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);

  userModel.getLoginHistory().then(function (history) {
    self.history = history;
    for (var i = 0; self.history.length > i; i++) {
      self.parser.setUA(self.history[i].user_agent);
      self.history[i].browser = self.parser.getBrowser();
    }
  });
};

controller.$inject = ['$scope', 'userModel'];
var saLoginHistory = [function () {
  return {
    template: _login_history2.default,
    replace: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saLoginHistory;

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = "<div class=\"loginHistory\">\n    <h1>Login History</h1>\n\n    <div class=\"Dashboard-table\" ng-if=\"ctrl.history.length > 0\">\n        <div class=\"Dashboard-tableHeader Dashboard-tableHeader__flex\">\n            <h2>IP (country)</h2>\n            <h2>Browser</h2>\n            <h2>Date</h2>\n        </div>\n        <div class=\"Dashboard-tableBody\">\n            <div class=\"Dashboard-tableRow Dashboard-tableRow__loginHistory Dashboard-historyRow\" ng-repeat=\"historyItem in ctrl.history\">\n                <div class=\"Dashboard-tableCell Dashboard-tableCell__loginHistory\">\n                    <span class=\"Dashboard-historyDate\">{{historyItem.ip}} ({{historyItem.location.formatted_address}})</span>\n                </div>\n                <div class=\"Dashboard-tableCell Dashboard-tableCell__loginHistory\">\n                    <span class=\"Dashboard-historyDate\" ng-if=\"historyItem.browser.name\">{{historyItem.browser.name}} v{{historyItem.browser.version}}</span>\n                    <span class=\"Dashboard-historyDate\" ng-if=\"!historyItem.browser.name\">Unknown</span>\n                </div>\n                <div class=\"Dashboard-tableCell Dashboard-tableCell__loginHistory\">\n                    <span class=\"Dashboard-historyDate\">{{historyItem.created_at}}</span>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"loginHistory--table\" ng-if=\"ctrl.history.length == 0\">\n        <div class=\"loginHistory--row\">\n            No login history.\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _user_id = __webpack_require__(562);

var _user_id2 = _interopRequireDefault(_user_id);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('userId', []).component('saUserId', _user_id2.default).name;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _user_id = __webpack_require__(563);

var _user_id2 = _interopRequireDefault(_user_id);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: '<div class="UserId"><h1>Your user ID is: {{::ctrl.userId}}</h1></div>',
  controllerAs: 'ctrl',
  controller: _user_id2.default
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['userModel'];
function f(userModel) {
  'ngInject';

  this.userId = userModel.item.id;
}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _vk_login = __webpack_require__(565);

var _vk_login2 = _interopRequireDefault(_vk_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('vkLogin', []).directive('saVkLogin', _vk_login2.default).name;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vk_login = __webpack_require__(566);

var _vk_login2 = _interopRequireDefault(_vk_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controller = ['$state', '$stateParams', 'vk', function ($state, $stateParams, vk) {
  var _this = this;

  var code = $stateParams.code;

  if (code) {
    this.isLoading = true;
    vk.loginWithCode($stateParams.code).finally(function () {
      $state.go('intro');
      _this.isLoading = false;
    });
  } else {
    $state.go('intro');
  }
}];

var saVkLogin = [function () {
  return {
    template: _vk_login2.default,
    replace: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}];

exports.default = saVkLogin;

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <sa-content-loader ng-if=\"ctrl.isLoading\"></sa-content-loader>\n</div>\n";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(568);

var _info_box = __webpack_require__(570);

var _info_box2 = _interopRequireDefault(_info_box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saInfoBox = {
  template: _info_box2.default,
  bindings: {
    heading: '<?',
    description: '<?'
  }
};

exports.default = angular.module('components.infoBox', []).component('saInfoBox', saInfoBox).name;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(569);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(12)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/sass-loader/lib/loader.js??ref--6-2!./info_box.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/sass-loader/lib/loader.js??ref--6-2!./info_box.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)();
exports.push([module.i, ".InfoBox{max-width:820px;padding:0 10px;margin:50px auto 40px}.InfoBox h1,.InfoBox h2{text-align:center;margin:10px 0;font-size:32px}.InfoBox p.Overflow-expandableText{white-space:pre-wrap;font-size:16px;line-height:1.6;color:#666}.InfoBox p.Overflow-expandLink{font-size:16px}.InfoBox .Overflow-expandableText--expanded{max-height:2500px}", ""]);

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = "<div class=\"InfoBox\">\n  <div>\n    <!-- Guided tours heading is for Kisunas Kiev Seo, Discover heading is for Austria.\n         Default was h1\n    -->\n    <div ng-if=\"!$ctrl.heading.includes('Discover') && !$ctrl.heading.includes('Guided Tours in')\">\n      <h1 ng-bind-html=\"$ctrl.heading\"></h1>\n    </div>\n    <div ng-if=\"$ctrl.heading.includes('Discover') || $ctrl.heading.includes('Guided Tours in')\">\n      <h2 ng-bind-html=\"$ctrl.heading\"></h2>\n    </div>\n    <sa-overflow text=\"$ctrl.description\" reveal-text=\"Read More\" retain-whitespace=\"1\"></sa-overflow>\n  </div>\n</div>\n";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overflow = __webpack_require__(572);

var _overflow2 = _interopRequireDefault(_overflow);

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(573);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saOverflow = function saOverflow($timeout) {
  'ngInject';

  return {
    template: _overflow2.default,
    scope: {
      text: '=',
      revealText: '@',
      retainWhitespace: '@'
    },
    link: function link($scope, $element) {
      // Kisunas SEO workaround
      //if (window.location.pathname === "/guides/ukraine/kiev") {
      //  $scope.textExpanded = true;
      //}
      if ($scope.retainWhitespace != '1') {
        $scope.text = $scope.text.replace(/\n\s*\n/g, '\n');
      }
      if (!$scope.revealText) {
        $scope.revealText = 'More';
      }
      $timeout(function () {
        $element = _angular2.default.element($element[0].children[0]);
        var textElement = $element[0].children[0];
        var BUFFER = 4;
        if (textElement.scrollHeight > $element[0].scrollHeight + BUFFER) {
          $element.addClass('Overflow');
        }
      });

      $scope.expand = function () {
        $scope.textExpanded = true;
      };
    }
    // Why won't this work?
    // bindToController: true,
    // controllerAs: '$ctrl',
    // controller: function ($scope) {
    //   'ngInject';
    //   $scope.expand = () => {
    //     console.log($scope.text)
    //     console.log($scope.originalText)
    //     $scope.text = $scope.originalText;
    //     $scope.textExpanded = true;
    //   };
    // },
  };
};

saOverflow.$inject = ['$timeout'];
exports.default = _angular2.default.module('common.overflow', []).directive('saOverflow', saOverflow).name;

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = "<div>\n  <p class=\"Overflow-expandableText\" ng-class=\"{'Overflow-expandableText--expanded' : textExpanded}\" ng-bind-html=\"text\"></p>\n  <p class=\"Link Link--blue Overflow-expandLink\" ng-class=\"{'Overflow-expandableText--moreHidden' : textExpanded}\" ng-click=\"expand()\">+ {{revealText}}</p>\n  <!-- TODO: refactor -->\n</div>\n";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(574);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(12)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/sass-loader/lib/loader.js??ref--6-2!./overflow.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/sass-loader/lib/loader.js??ref--6-2!./overflow.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)();
exports.push([module.i, ".Overflow-expandableText{max-height:5em;-webkit-transition:max-height .3s ease-in,opacity .2s ease-in;-moz-transition:max-height .3s ease-in,opacity .2s ease-in;transition:max-height .3s ease-in,opacity .2s ease-in;overflow:hidden}.Overflow-expandableText--expanded{max-height:1000px}p.Overflow-expandLink.Link{-webkit-transition:max-height .1s ease-out;-moz-transition:max-height .1s ease-out;transition:max-height .1s ease-out;overflow:hidden;max-height:0;padding-bottom:0}.Overflow p.Overflow-expandLink.Link{max-height:2em;padding-bottom:8px}.Overflow p.Overflow-expandableText--moreHidden.Link{max-height:0;padding-bottom:0}", ""]);

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = appConfig;

var _state_config = __webpack_require__(576);

var _state_config2 = _interopRequireDefault(_state_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

appConfig.$inject = ['$provide', '$httpProvider', '$sceDelegateProvider', '$stateProvider', '$locationProvider', '$animateProvider', '$translateProvider', 'resourceProvider', 'config'];
function appConfig($provide, $httpProvider, $sceDelegateProvider, $stateProvider, $locationProvider, $animateProvider, $translateProvider, resourceProvider, config) {
  'ngInject';

  // Config $http service

  $httpProvider.interceptors.push('authInterceptor');
  $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  // Config states
  angular.forEach(_state_config2.default, function (config, stateName) {
    $stateProvider.state(stateName, angular.extend({
      resolve: {
        user: ['userModel', function (userModel) {
          return userModel.itemPromise;
        }]
      }
    }, config));
  });
  $locationProvider.html5Mode(true);

  $sceDelegateProvider.resourceUrlWhitelist(['self', 'https://player.vimeo.com/video/**', 'http://player.vimeo.com/video/**']);

  $animateProvider.classNameFilter(/is\-ngAnimationEnabled/);

  // Config angular-translate
  $translateProvider.useLoader('translationLoader');
  $translateProvider.useMessageFormatInterpolation();
  $translateProvider.preferredLanguage('en');
  $translateProvider.useSanitizeValueStrategy('escapeParameters');

  // Config resource
  resourceProvider.config({ baseUrl: config.apiBaseUrl });
  resourceProvider.config({ baseUrlV2: config.apiBaseUrlV2 });

  // $ravenProvider.development(!config.sentryDsn);

  // Decorate
  $provide.decorator('$uiViewScroll', ['$window', '$timeout', '$state', '$previousState', 'scrollTop', function ($window, $timeout, $state, $previousState, scrollTop) {
    function getParentStateName(state) {
      return state && state.name.split('.')[0];
    }

    return function () {
      var currentState = $state.current;
      var isSticky = Boolean(currentState.sticky);
      var parentName = getParentStateName(currentState);
      var previousState = $previousState.get();
      var previousParentStateName = getParentStateName(previousState && previousState.state);

      if (!previousState || !isSticky || parentName !== previousParentStateName) {
        $timeout(function () {
          scrollTop(0);
        }, 0, false);
      }
    };
  }]);
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var redirectGuestUser = ['$state', 'userModel', function ($state, userModel) {
  if (!userModel.item.id) {
    $state.go('guides.landing');
  }
}];

// idlist - comma separated list of local ids, specified locals are shown at the top
// loc - ?

var resolveGuides = {};
resolveGuides.foo = ['$q', '$ocLazyLoad', '$translate', function ($q, $ocLazyLoad, $translate) {
  'ngInject';

  return $q(function (resolve) {
    try {
      __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(594)]; (function () {
        $ocLazyLoad.load({
          name: 'guides'
        });
        $translate.refresh();
        resolve();
      }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
    } catch (e) {}
  });
}];

// r - referral parameter
// value - t (invitetravel)

// Tied changes #0
var searchParams = 'placeId&idlist&loc&priceFrom&priceTo&languages&activities&gender&lat&lon&countryCode&px1&px2&py1&py2&price&r';

module.exports = {
  intro: {
    url: '/locals/landing?idlist&lt&price&r',
    views: {
      '': {
        template: '<sa-intro></sa-intro>'
      }
    },
    analyticsName: 'Intro',
    resolve: {
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(595)]; (function () {
              $ocLazyLoad.load({
                name: 'intro'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  guides: {
    abstract: true,
    url: '',
    template: '\n    <div ui-view="guides" sa-keep-scroll-pos ng-show="(\'guides.listNoName\' | isState) || (\'guides.cityFilter\' | isState) || (\'guides.city\' | isState) || (\'guides.list\' | isState) || (\'guides.landing\' | isState) || (\'guides.kiev\' | isState) || (\'guides.kiev_seo\' | isState)"></div>\n    <div ui-view="guide" autoscroll ng-show="\'guides.guide\' | isState"></div>\n    <div ui-view="trips" sa-keep-scroll-pos ng-show="\'guides.trips\' | isState"></div>'
  },

  // TODO: THIS LOOKS SO HORRIBLY WRONG
  // done to save scroll location :(
  'guides.trips': {
    sticky: true,
    url: '/trips',
    views: {
      trips: {
        template: '<sa-trips></sa-trips>'
      }
    },
    onEnter: redirectGuestUser,
    onExit: ['trips', function onExit(trips) {
      'ngInject';

      trips.reset();
    }],
    resolve: {
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(596)]; (function () {
              $ocLazyLoad.load({
                name: 'components.trips'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  'guides.landing': {
    sticky: true,
    url: '/?name&placeId&idlist&lat&lon&countryCode&px1&px2&py1&py2&price&r',
    views: {
      guides: {
        template: '<sa-guides-landing></sa-guides-landing>'
      }
    },
    data: {
      bodyClass: 'with-hiddenNavigationTablet',
      navigationCssClass: 'Navigation--transparentTablet Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 408,
        'tablet-horizontal': 408,
        tablet: 360
      }
    },
    resolve: resolveGuides,
    analyticsName: 'CityLandingPage'
  },
  /*'guides.kiev_seo': {
    url: '/guides/ukraine/kiev',
    sticky: true,
    views: {
      guides: {
        template: '<sa-guides></sa-guides>',
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ($stateParams, deslug) => {
        'ngInject';
         $stateParams.city = 'kiev';
        $stateParams.country = 'ukraine';
        $stateParams.idlist = '';
        $stateParams.r = '';
         const city = 'Kiev';
         return {
          title: `${deslug.it(city)} tours with local ${deslug.it(city)} guides`,
          description: `Our ${deslug.it(city)} tour guides can provide you with a fun, entertaining, and personalized ${deslug.it(city)} tours. Click here to discover local travel guides who can show you one of the greatest cities in Europe.`
        };
      },
      foo: resolveGuides.foo
    },
    analyticsName: 'GuidesCity',
  },
  */
  'guides.listNoName': {
    url: '/s?' + searchParams,
    sticky: true,
    views: {
      guides: {
        template: '<sa-guides></sa-guides>'
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ['guideSearchFilters', function meta(guideSearchFilters) {
        'ngInject';

        var robots = void 0;
        if (guideSearchFilters.notEmpty()) {
          robots = 'noindex, nofollow';
        }

        return {
          title: 'Meet Locals',
          description: 'Browse our list of locals who are ready to show you the best of their cities. With locals, you can get an insider’s view on where to go and what to see.',
          robots: robots
        };
      }],
      foo: resolveGuides.foo
    },
    analyticsName: 'Guides'
  },
  'guides.list': {
    url: '/s/:name?' + searchParams,
    sticky: true,
    views: {
      guides: {
        template: '<sa-guides></sa-guides>'
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ['$stateParams', 'deslug', 'guideSearchFilters', function meta($stateParams, deslug, guideSearchFilters) {
        'ngInject';

        var robots = void 0;
        if (guideSearchFilters.notEmpty() || $stateParams.name) {
          robots = 'noindex, nofollow';
        }

        var locationName = deslug.it($stateParams.name);

        return {
          title: 'Meet Locals' + (locationName ? ' in ' + locationName : ''),
          description: 'Browse our list of locals who are ready to show you the best of ' + (locationName || 'their cities') + '. With locals, you can get an insider\u2019s view on where to go and what to see.',
          robots: robots
        };
      }],
      foo: resolveGuides.foo
    },
    analyticsName: 'Guides'
  },
  'guides.city': {
    url: '/locals/:country/:city?idlist&r',
    sticky: true,
    views: {
      guides: {
        template: '<sa-guides></sa-guides>'
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ['$stateParams', 'deslug', function meta($stateParams, deslug) {
        'ngInject';

        var city = $stateParams.city;
        var country = $stateParams.country;

        if (country == 'austria') {
          return {
            title: 'Meet Locals in ' + deslug.it(city) + ', ' + deslug.it(country),
            description: 'Browse our list of locals who are ready to show you the best of ' + deslug.it(city) + ', ' + deslug.it(country) + '. With locals, you can get an insider\u2019s view on where to go and what to see.'
          };
        } else if (city == 'kiev') {
          return {
            title: deslug.it(city) + ' tours with local ' + deslug.it(city) + ' guides',
            description: 'Our ' + deslug.it(city) + ' tour guides can provide you with a fun, entertaining, and personalized ' + deslug.it(city) + ' tours. Click here to discover local travel guides who can show you one of the greatest cities in Europe.'
          };
        } else {
          return {
            title: 'Tours with locals in ' + deslug.it(city) + ', private tour guides',
            description: 'Find local guide in ' + deslug.it(city) + ', ' + deslug.it(country) + '. \u2705Find and book the best personal tour in ' + deslug.it(city) + ' from number of locals locals! \u2705Experience ' + deslug.it(city) + ' with Showaround!'
          };
        }
      }],
      foo: resolveGuides.foo
    },
    analyticsName: 'GuidesCity'
  },
  'guides.cityFilter': {
    url: '/locals/:country/:city/:filter?idlist&r',
    sticky: true,
    views: {
      guides: {
        template: '<sa-guides></sa-guides>'
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ['$stateParams', 'languages', 'deslug', 'slug', function meta($stateParams, languages, deslug, slug) {
        'ngInject';

        var filter = slug.it($stateParams.filter);
        var country = slug.it($stateParams.country);
        var city = slug.it($stateParams.city);
        var route = '';
        var title = '';
        var description = '';

        if (['male', 'female', 'couple'].indexOf(filter) !== -1) {
          title = 'Meet ' + deslug.it(filter) + ' Locals in ' + deslug.it(city) + ', ' + deslug.it(country);
          description = 'Find ' + deslug.it(filter) + ' Showaround locals in ' + deslug.it(city) + ', ' + deslug.it(country) + ', and discover the city together.';
          route = 'gender';
        } else if (Object.keys(languages.all).indexOf(filter) !== -1) {
          title = 'Meet Locals in ' + deslug.it(city) + ', ' + deslug.it(country) + ', who speak ' + deslug.it(filter);
          description = '"Find Showaround locals in ' + deslug.it(city) + ', ' + deslug.it(country) + ', who speak ' + deslug.it(filter) + ' and explore the city together.';
          route = 'languages';
        } else {
          title = deslug.it(filter) + ' Tours with Locals in ' + deslug.it(city) + ', ' + deslug.it(country);
          if (country == 'austria') {
            description = 'Are you interested in ' + filter + '? Meet Showaround locals who are ready to show you the best things to do and see in ' + deslug.it(city) + ', ' + deslug.it(country) + '.';
          } else {
            description = 'Local ' + filter + ' guide in ' + deslug.it(city) + ', ' + deslug.it(country) + '. \u2705Find and book a personal Activity tour in ' + deslug.it(city) + ' from number of locals locals! \u2705Experience ' + deslug.it(city) + ' Activity with Showaround!';
          }
          route = 'activities';
        }

        return {
          title: title,
          description: description,
          route: route
        };
      }],
      foo: resolveGuides.foo
    },
    analyticsName: 'GuidesCity'
  },
  'guides.guide': {
    url: '/locals/:guideId' + '?authResult&currency&price&duration&fromTrips&reqRef&isFilledSettings&tripId&r',
    views: {
      guide: {
        template: '<sa-guide></sa-guide>'
      }
    },
    data: {
      navigationScrollThreshold: {
        desktop: 326,
        'tablet-horizontal': 396,
        tablet: 396
      }
    },
    analyticsName: 'Guides.Profile',
    reloadOnSearch: false,
    resolve: {
      join: ['$q', '$previousState', 'userModel', 'join', function ($q, $previousState, userModel, join) {
        var shouldShowModal = !userModel.item.id && $previousState.get();
        return shouldShowModal ? join.showModal().result : $q.resolve();
      }],
      foo: resolveGuides.foo
    }
  },

  'countries': {
    url: '/countries',
    template: '<sa-countries></sa-countries>',
    analyticsName: 'Countries',
    resolve: {
      meta: function meta() {
        return {
          title: 'Browse Showaround Locals from Anywhere in the World',
          description: 'What are the first things you do when you plan a trip? Once you have selected where to go, you plan a city tour with the help of a local insider.'
        };
      },
      foo: ['$q', '$ocLazyLoad', '$translate', function foo($q, $ocLazyLoad, $translate) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(597)]; (function () {
              $ocLazyLoad.load({
                name: 'countries'
              });
              $translate.refresh();
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  'cities': {
    url: '/countries/:name?r',
    template: '<sa-cities></sa-cities>',
    analyticsName: 'Cities',
    resolve: {
      meta: ['$stateParams', 'deslug', function meta($stateParams, deslug) {
        'ngInject';

        var locationName = deslug.it($stateParams.name);

        if (locationName == 'Austria') {
          return {
            title: 'Find Locals in ' + locationName + ' | Book City Tours',
            description: 'Explore ' + locationName + ' with Showaround locals. Showaround will help you to experience a new place like a local.'
          };
        } else {
          return {
            title: 'Tours with locals in ' + locationName + ', private tour guides',
            description: 'Explore ' + locationName + ' with Showaround locals. Showaround will help you to experience a new place like a local.'
          };
        }
      }],
      foo: ['$q', '$ocLazyLoad', '$translate', function foo($q, $ocLazyLoad, $translate) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(598)]; (function () {
              $ocLazyLoad.load({
                name: 'cities'
              });
              $translate.refresh();
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  conversations: {
    abstract: true,
    url: '/conversations',
    template: '\n    <div ui-view sa-keep-scroll-pos ng-show="\'conversations.list\' | isState"></div>\n    <div ui-view="detail" autoscroll ng-show="\'conversations.conversation\' | isState"></div>',
    onEnter: redirectGuestUser,
    onExit: ['conversations', function onExit(conversations) {
      'ngInject';

      conversations.reset();
    }],
    resolve: {
      foo: ['$q', '$ocLazyLoad', '$translate', function foo($q, $ocLazyLoad, $translate) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(599)]; (function () {
              $ocLazyLoad.load({
                name: 'conversations'
              });
              $translate.refresh();
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },
  'conversations.list': {
    url: '',
    sticky: true,
    template: '<conversations></conversations>',
    analyticsName: 'Conversations'
  },
  'conversations.conversation': {
    url: '/:conversationId?authResult',
    data: {
      cssClass: 'is-footerHidden'
    },
    reloadOnSearch: false,
    views: {
      detail: {
        template: '<conversation></conversation>'
      }
    },
    analyticsName: 'Conversations.Conversation'
  },

  myTrips: {
    url: '/my-trips',
    template: '<sa-my-trips></sa-my-trips>',
    params: {
      location: {},
      sex: ''
    },
    onEnter: redirectGuestUser,
    resolve: {
      join: ['$q', '$previousState', 'userModel', 'join', function ($q, $previousState, userModel, join) {
        var shouldShowModal = !userModel.item.id && $previousState.get();
        return shouldShowModal ? join.showModal().result : $q.resolve();
      }],
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(600)]; (function () {
              $ocLazyLoad.load({
                name: 'components.myTrips'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  leaveReview: {
    url: '/leave-review/:revieweeId/:confirmation',
    template: '<sa-leave-review></sa-leave-review>',
    onEnter: redirectGuestUser,
    analyticsName: 'LeaveReview',
    resolve: {
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(601)]; (function () {
              $ocLazyLoad.load({
                name: 'leaveReview'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  becomeGuide: {
    url: '/become-a-local?r',
    template: '<sa-become-guide></sa-become-guide>',
    data: {
      navigationScrollThreshold: {
        desktop: 326,
        'tablet-horizontal': 396,
        tablet: 396
      }
    },
    analyticsName: 'BecomeGuide',
    resolve: {
      meta: function meta() {
        return {
          title: 'Sign Up as a Local'
        };
      }
    }
  },

  forgotPassword: {
    url: '/forgot-password',
    template: '<sa-forgot-password></sa-forgot-password>',
    analyticsName: 'ForgotPassword'
  },
  password: {
    url: '/reset-password?uid&code&email&create',
    template: '<sa-password-form></sa-password-form>',
    analyticsName: 'ResetPassword'
  },

  loginHistory: {
    url: '/login-history',
    template: '<sa-login-history></sa-login-history>',
    analyticsName: 'LoginHistory',
    onEnter: redirectGuestUser
  },
  activation: {
    url: '/activation/email?uid&code&email&redirectUrl',
    controller: 'ActivationController',
    template: '',
    analyticsName: 'AccountActivation'
  },

  settings: {
    url: '/settings?becomeGuide&field',
    template: '<sa-settings></sa-settings>',
    onEnter: redirectGuestUser,
    params: {
      noPhoto: false
    },
    resolve: {
      foo: ['$q', '$ocLazyLoad', '$translate', function foo($q, $ocLazyLoad, $translate) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(602)]; (function () {
              $ocLazyLoad.load({
                name: 'settings'
              });
              $translate.refresh();
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    },
    analyticsName: 'Settings'
  },
  notificationSettings: {
    url: '/notification-settings',
    template: '<sa-notification-settings></sa-notification-settings>',
    onEnter: redirectGuestUser,
    analyticsName: 'NotificationSettings',
    resolve: {
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(603)]; (function () {
              $ocLazyLoad.load({
                name: 'notificationSettings'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  // dashboard: {
  //   url: '/dashboard',
  //   template: '<sa-dashboard></sa-dashboard>',
  //   onEnter: redirectGuestUser,
  //   analyticsName: 'Dashboard',
  //   resolve: {
  //     foo: ($q, $ocLazyLoad) => {
  //       'ngInject';
  //       return $q((resolve) => {
  //         try {
  //           require(['./modules/dashboard'], () => {
  //             $ocLazyLoad.load({
  //               name: 'dashboard'
  //             });
  //             resolve();
  //           });
  //         } catch (e){}
  //       });
  //     }
  //   },
  // },

  membership: {
    url: '/subscription?authResult&currency&price',
    template: '<sa-membership></sa-membership>',
    onEnter: redirectGuestUser,
    analyticsName: 'Membership',
    reloadOnSearch: false
  },
  fbLanding: {
    url: '/intro-fb',
    views: {
      '': {
        template: '<sa-fb-landing></sa-fb-landing>'
      }
    },
    analyticsName: 'Intro-fb',
    resolve: {
      join: ['$q', '$previousState', 'userModel', 'join', function ($q, $previousState, userModel, join) {
        var shouldShowModal = !userModel.item.id && $previousState.get();
        return shouldShowModal ? join.showModal().result : $q.resolve();
      }],
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(604)]; (function () {
              $ocLazyLoad.load({
                name: 'fbLanding'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },
  ios: {
    url: '/ios?r',
    template: '<sa-ios-app></sa-ios-app>',
    analyticsName: 'iosApp',
    resolve: {
      meta: function meta() {
        return {
          title: 'Download the App for iOS',
          description: 'With the Showaround app available on iOS, you can book a local for a private tour on-the-go, wherever your next destination is.'
        };
      },
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(605)]; (function () {
              $ocLazyLoad.load({
                name: 'iosApp'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  android: {
    url: '/android?r',
    template: '<sa-android-app></sa-android-app>',
    analyticsName: 'androidApp',
    resolve: {
      meta: function meta() {
        return {
          title: 'Download the App for Android',
          description: 'With the Showaround app available on Android, you can book customized tours, get a deeper insight into a new city, and meet locals in 194 countries.'
        };
      },
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(606)]; (function () {
              $ocLazyLoad.load({
                name: 'androidApp'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  popularCities: {
    url: '/popular-cities?r',
    template: '<sa-popular-cities></sa-popular-cities>',
    analyticsName: 'PopularCities',
    resolve: {
      meta: function meta() {
        return {
          title: 'Most Popular Cities to Find Locals',
          description: 'Wondering where to go next? Get inspired and check out a list of our most popular destinations and find locals from all around the world.'
        };
      },
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(607)]; (function () {
              $ocLazyLoad.load({
                name: 'popularCities'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  team: {
    url: '/team?r',
    template: '<sa-team></sa-team>',
    analyticsName: 'Team',
    resolve: {
      meta: function meta() {
        return {
          title: 'About Us'
        };
      },
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(608)]; (function () {
              $ocLazyLoad.load({
                name: 'team'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  balcony: {
    abstract: true,
    url: '/balcony-tours?r&fromApp',
    template: '<sa-balcony></sa-balcony>',
    analyticsName: 'Balcony',
    resolve: {
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(609)]; (function () {
              $ocLazyLoad.load({
                name: 'balcony'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },
  'balcony.privacy': {
    url: '/privacy-policy',
    views: {
      balcony: {
        template: '<sa-balcony-privacy></sa-balcony-privacy>'
      }
    },
    analyticsName: 'Balcony.PrivacyPolicy',
    resolve: {
      meta: function meta() {
        return {
          title: 'Privacy Policy'
        };
      }
    }
  },
  'balcony.terms': {
    url: '/terms-of-service',
    views: {
      balcony: {
        template: '<sa-balcony-terms></sa-balcony-terms>'
      }
    },
    analyticsName: 'Balcony.TermsOfService',
    resolve: {
      meta: function meta() {
        return {
          title: 'Terms Of Service'
        };
      }
    }
  },

  info: {
    abstract: true,
    url: '/info?r&fromApp',
    template: '<sa-info></sa-info>',
    analyticsName: 'Info',
    resolve: {
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(610)]; (function () {
              $ocLazyLoad.load({
                name: 'info'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },
  'info.about': {
    url: '/about',
    views: {
      info: {
        template: '<sa-info-about></sa-info-about>'
      }
    },
    analyticsName: 'Info.About',
    resolve: {
      meta: function meta() {
        return {
          title: 'About Us',
          description: 'Showaround is a global marketplace connecting travellers in search of unique travel experiences with locals who provide private city tours.'
        };
      }
    }
  },
  'info.becomeGuide': {
    url: '/become-a-local',
    views: {
      info: {
        template: '<sa-info-become-guide></sa-info-become-guide>'
      }
    },
    analyticsName: 'Info.BecomeGuide',
    resolve: {
      meta: function meta() {
        return {
          title: 'Why Be a Local?'
        };
      }
    }
  },
  'info.bookingAdvice': {
    url: '/booking-advice',
    views: {
      info: {
        template: '<sa-info-booking-advice></sa-info-booking-advice>'
      }
    },
    analyticsName: 'Info.BookingAdvice',
    resolve: {
      meta: function meta() {
        return {
          title: 'Booking Advice'
        };
      }
    }
  },
  'info.adviceForGuide': {
    url: '/advice-for-local',
    views: {
      info: {
        template: '<sa-info-advice-for-guide></sa-info-advice-for-guide>'
      }
    },
    analyticsName: 'Info.AdviceForGuide',
    resolve: {
      meta: function meta() {
        return {
          title: 'Advice For a Local'
        };
      }
    }
  },
  'info.reviews': {
    url: '/reviews',
    views: {
      info: {
        template: '<sa-info-reviews></sa-info-reviews>'
      }
    },
    analyticsName: 'Info.Reviews',
    resolve: {
      meta: function meta() {
        return {
          title: 'Ratings & Reviews'
        };
      }
    }
  },
  'info.contact': {
    url: '/support-and-contact',
    views: {
      info: {
        template: '<sa-info-contact></sa-info-contact>'
      }
    },
    analyticsName: 'Info.Contact',
    resolve: {
      meta: function meta() {
        return {
          title: 'Support & Contact'
        };
      }
    }
  },
  'info.terms': {
    url: '/terms-of-service',
    views: {
      info: {
        template: '<sa-info-terms></sa-info-terms>'
      }
    },
    analyticsName: 'Info.TermsOfService',
    resolve: {
      meta: function meta() {
        return {
          title: 'Terms of Service'
        };
      }
    }
  },
  'info.termsandconditionsgiveaway': {
    url: '/terms-and-conditions-giveaway',
    views: {
      info: {
        template: '<sa-info-terms-and-conditions-giveaway></sa-info-terms-and-conditions-giveaway>'
      }
    },
    analyticsName: 'Info.TermsAndConditionsGiveaway',
    resolve: {
      meta: function meta() {
        return {
          title: 'Terms and Conditions - Giveaway'
        };
      }
    }
  },
  'info.privacy': {
    url: '/privacy-policy',
    views: {
      info: {
        template: '<sa-info-privacy></sa-info-privacy>'
      }
    },
    analyticsName: 'Info.PrivacyPolicy',
    resolve: {
      meta: function meta() {
        return {
          title: 'Privacy Policy'
        };
      }
    }
  },
  'info.paymentsPricing': {
    url: '/payments-and-pricing',
    views: {
      info: {
        template: '<sa-info-payments-pricing></sa-info-payments-pricing>'
      }
    },
    analyticsName: 'Info.PaymentsAndPricing',
    resolve: {
      meta: function meta() {
        return {
          title: 'Payments & Pricing'
        };
      }
    }
  },
  'info.refunds': {
    url: '/cancellation-and-refunds',
    views: {
      info: {
        template: '<sa-info-refunds></sa-info-refunds>'
      }
    },
    analyticsName: 'Info.CancellationAndRefunds',
    resolve: {
      meta: function meta() {
        return {
          title: 'Cancellation & Refunds'
        };
      }
    }

  },
  'info.security': {
    url: '/security',
    views: {
      info: {
        template: '<sa-info-security></sa-info-security>'
      }
    },
    analyticsName: 'Info.Security',
    resolve: {
      meta: function meta() {
        return {
          title: 'Security'
        };
      }
    }
  },

  notFound: {
    url: '/404',
    template: '<sa-not-found></sa-not-found>',
    analyticsName: 'NotFound',
    resolve: {
      meta: function meta() {
        return {
          title: 'Not Found'
        };
      }
    }
  },

  autologin: {
    abstract: true,
    url: '',
    template: '<div ui-view></div>'
  },
  'autologin.verifyEmail': {
    url: '/autologin/verify-email?code&email&uid',
    template: ' ',
    controller: 'VerifyEmailController',
    analyticsName: 'Autologin.VerifyEmail'
  },
  'autologin.email': {
    url: '/autologin/email?code&email&uid&action&conversationId&idlist&loc&lat&lon&name&placeId&countryCode&userId',
    template: ' ',
    controller: 'EmailAutologinController',
    analyticsName: 'Autologin.Email'
  },
  'autologin.sms': {
    url: '/l/:code',
    template: '<sa-autologin></sa-autologin>',
    analyticsName: 'Autologin.SMS'
  },

  mailing: {
    url: '/mailing?page',
    template: ' ',
    controller: 'MailingController',
    analyticsName: 'Mailing'
  },

  userId: {
    url: '/id',
    template: '<sa-user-id></sa-user-id>',
    analyticsName: 'userId',
    onEnter: redirectGuestUser
  },

  vkLogin: {
    url: '/vk-login?code',
    template: '<sa-vk-login></sa-vk-login>',
    analyticsName: 'vkLoginResult'
  },

  requestReference: {
    url: '/request-reference?reqRef',
    template: '<sa-request-reference></sa-request-reference>',
    onEnter: redirectGuestUser,
    resolve: {
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(611)]; (function () {
              $ocLazyLoad.load({
                name: 'components.saRequestReference'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },

  support: {
    url: '/support',
    template: '<sa-support></sa-support>',
    onEnter: redirectGuestUser,
    params: { conversation: null },
    resolve: {
      foo: ['$q', '$ocLazyLoad', function foo($q, $ocLazyLoad) {
        'ngInject';

        return $q(function (resolve) {
          try {
            __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(612)]; (function () {
              $ocLazyLoad.load({
                name: 'support'
              });
              resolve();
            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
          } catch (e) {}
        });
      }]
    }
  },
  'guides.kiev': {
    sticky: false,
    url: '/things-to-do-in-kiev',
    views: {
      guides: {
        template: '<sa-guides-kiev></sa-guides-kiev>'
      }
    },
    data: {
      navigationCssClass: 'Navigation--staticTablet Navigation--searchHidden',
      navigationScrollThreshold: {
        desktop: 167,
        'tablet-horizontal': 167,
        tablet: 167
      }
    },
    resolve: {
      meta: ['$stateParams', 'deslug', function meta($stateParams, deslug) {
        'ngInject';

        var city = 'Kiev';
        var country = 'Ukraine';

        return {
          title: 'Meet Locals in ' + deslug.it(city) + ', ' + deslug.it(country),
          description: 'Browse our list of locals who are ready to show you the best of ' + deslug.it(city) + ', ' + deslug.it(country) + '. With locals, you can get an insider\u2019s view on where to go and what to see.'
        };
      }],
      foo: resolveGuides.foo
    },
    analyticsName: 'CityKievLandingPage'
  },

  suspended: {
    url: '/account-is-suspended',
    template: '<sa-suspended></sa-suspended>'
  }
};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*eslint-disable no-unused-vars */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = appRun;
appRun.$inject = ['analytics', '$rootScope', '$state', '$stateParams', '$window', 'config', 'session', 'tracking', 'userModel', 'marketingId', 'lazysizes', 'stopRemarketing', 'realtime', 'remarketing', 'fbCampaignHandler', 'bodyElement', 'messenger', 'development', 'locationConfirmationService', 'notification', 'sounds', 'systemAlerts', 'listingPrice', 'appBecomeGuideBanner', 'meta', '$location', '$cookies'];
function appRun(analytics, $rootScope, $state, $stateParams, $window, config, session, tracking, userModel, marketingId, lazysizes, stopRemarketing, realtime, remarketing, fbCampaignHandler, bodyElement, messenger, development, locationConfirmationService, notification, sounds, systemAlerts, listingPrice, /*appBanner,*/appBecomeGuideBanner, meta, $location, $cookies) {
  /*eslint-enable no-unused-vars */
  'ngInject';

  // $rootScope.$on('$stateChangeError', console.log.bind(console));

  development.deleteAdminCookieInDevelopment();

  var sessionData;
  // const userIsBlockedEventName = 'Blocked';

  meta.init();
  session.init();
  tracking.init();

  sessionData = session.get();

  realtime.init();

  userModel.initItem(sessionData && sessionData.userId);

  $rootScope.$on('userModel:initialized', function () {

    // if(userModel.item.isSuspended) {
    //   analytics.trackPage($state.current.url, userIsBlockedEventName);
    // }

    if (userModel.item.isSuspended && window.location.pathname !== '/account-is-suspended') {
      window.location.replace('/account-is-suspended');
    }

    sounds.init();
    notification.init();
    var reqRef = $stateParams.reqRef;
    if (!reqRef) {
      locationConfirmationService.checkShow().then(function () {
        //messenger.showModal();
        //recurringMessenger.recur();

        try {
          locationConfirmationService.showModal();
        } catch (e) {
          // $window.Raven.captureException(e);
        }
      });
    }
  });

  if ($cookies.get('disable_cookies_line') === 'disabled') {
    $rootScope.isCookiesLineEnabled = false;
  } else {
    $rootScope.isCookiesLineEnabled = true;
  }

  if ($cookies.get('disable_fb_pixel') === 'disabled') {
    $rootScope.isFbPixelEnabled = false;
    $rootScope.facebookPixel = false;
  } else {
    $rootScope.isFbPixelEnabled = true;
    $rootScope.facebookPixel = true;
  }

  if ($cookies.get('disable_google_analytics') === 'disabled') {
    $rootScope.analytics = false;
  } else {
    $rootScope.analytics = true;
  }

  if ($cookies.get('disable_google_adwords') === 'disabled') {
    $rootScope.isAdWordsEnabled = false;
    $rootScope.adWords = false;
  } else {
    $rootScope.isAdWordsEnabled = true;
    $rootScope.adWords = true;
  }
  if ($cookies.get('disable_taboola') === 'disabled') {
    $rootScope.taboola = false;
  } else {
    $rootScope.taboola = true;
  }

  if (config.env !== 'local' && $rootScope.analytics) {
    $rootScope.$on('$stateChangeSuccess', function () {
      var state = $state.current;
      analytics.pageview($location.url(), state.analyticsName);
    });
  }

  marketingId.init();
  lazysizes.init();
  stopRemarketing.init();
  remarketing.init();
  fbCampaignHandler();
  //appBanner.init();
  appBecomeGuideBanner.init();

  // // Facebook tracking code after 7seconds
  // function sendFacebookTrackingDataAfter7Seconds() {
  //   const cookieName = 'fb7sec';
  //   if (!localStorage.getItem(cookieName)) {
  //     localStorage.setItem(cookieName, 'y');
  //     setTimeout(() => {
  //       if (typeof fbq !== 'undefined') {
  //         fbq('track', 'AddToCart');
  //       }
  //     }, 7000);
  //   }
  // }
  //
  // sendFacebookTrackingDataAfter7Seconds();
}

/***/ }),
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/84de9f41d6e7a8b517e629b1e92b192a.png";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/577191e58e77c83db355c7d980b4f338.png";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/386694d637425b269fe39388b09f0619.png";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/29ef9b489e46cc9e013f25269daaa561.png";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/e64e93d153bbdbe0cf6a4ba5cd797e25.jpg";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/e64e93d153bbdbe0cf6a4ba5cd797e25.jpg";

/***/ })
],[67]);


// WEBPACK FOOTER //
// js/app.b08102954501dfaa72e5.js